// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  function $parcel$import(url) {  url = importMap[url] || url;  return import(distDir + url);}newRequire.load = $parcel$import;function $parcel$extendImportMap(map) {  Object.assign(importMap, map);}newRequire.extendImportMap = $parcel$extendImportMap;

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"bDJZp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// eslint-disable-next-line @typescript-eslint/no-unused-vars
parcelHelpers.export(exports, "BundlerSwitcherItem", ()=>BundlerSwitcherItem);
parcelHelpers.export(exports, "BundlerSwitcher", ()=>BundlerSwitcher);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _s2 = require("@react-spectrum/s2");
'use client';
const container = " gqlRAZb12 Jz12 Gz12 oe12 ne12 ke12 je12 sd12 _ta12";
const switcher = " Jx12 JpA12 Ix12 IpA12";
function BundlerSwitcherItem(_props) {
    return null;
}
function BundlerSwitcher({ children }) {
    const storageKey = 'bundler';
    let items = (0, _react.useMemo)(()=>{
        let arr = (0, _react.Children).toArray(children);
        return arr.filter((el)=>/*#__PURE__*/ (0, _reactDefault.default).isValidElement(el)).map((el)=>({
                id: el.props.id,
                label: el.props.label,
                content: el.props.children
            }));
    }, [
        children
    ]);
    let initial = (0, _react.useMemo)(()=>{
        let stored = null;
        if (storageKey && typeof window !== 'undefined') stored = localStorage.getItem(storageKey);
        let storedValid = items.find((it)=>it.id === stored)?.id;
        if (storedValid) return storedValid;
        return items[0]?.id;
    }, [
        items,
        storageKey
    ]);
    let [selected, setSelected] = (0, _react.useState)(initial);
    (0, _react.useEffect)(()=>{
        // Update selected if items change and current is no longer valid
        if (selected && !items.find((it)=>it.id === selected)) setSelected(items[0]?.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        items
    ]);
    let onSelectionChange = (key)=>{
        let value = String(key);
        setSelected(value);
        if (storageKey && typeof window !== 'undefined') localStorage.setItem(storageKey, value);
    };
    let active = items.find((it)=>it.id === selected) ?? items[0];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: container,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: " _Na12 Zd12 _ub12",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.SegmentedControl), {
                    selectedKey: active?.id,
                    onSelectionChange: onSelectionChange,
                    styles: switcher,
                    children: items.map((it)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.SegmentedControlItem), {
                            id: it.id,
                            children: it.label
                        }, it.id))
                })
            }),
            active?.content
        ]
    });
}
exports.default = BundlerSwitcher;

},{"0":"4oKuc","1":"4oKuc","2":"4oKuc","react/jsx-runtime":"2Is6Z","react":"a1TxN","@react-spectrum/s2":"hnIYG","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4oKuc":[function(require,module,exports,__globalThis) {
var _serverEdge = require("react-server-dom-parcel/server.edge");
exports.__esModule = true;

},{"react-server-dom-parcel/server.edge":"74WJu"}],"74WJu":[function(require,module,exports,__globalThis) {
'use strict';
var s;
s = require("8884f512c685da86");
exports.renderToReadableStream = s.renderToReadableStream;
exports.decodeReply = s.decodeReply;
exports.decodeReplyFromAsyncIterable = s.decodeReplyFromAsyncIterable;
exports.decodeAction = s.decodeAction;
exports.decodeFormState = s.decodeFormState;
exports.createClientReference = s.createClientReference;
exports.registerServerReference = s.registerServerReference;
exports.createTemporaryReferenceSet = s.createTemporaryReferenceSet;
exports.registerServerActions = s.registerServerActions;
exports.loadServerAction = s.loadServerAction;

},{"8884f512c685da86":"iGhi4"}],"iGhi4":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-server-dom-parcel-server.edge.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var ReactDOM = require("2381f0f3ff03ff95"), React = require("6db66a729b66b575"), ReactDOMSharedInternals = ReactDOM.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function resolveServerReference(bundlerConfig, ref) {
    var idx = ref.lastIndexOf("#"), id = ref.slice(0, idx);
    idx = ref.slice(idx + 1);
    bundlerConfig = bundlerConfig[id];
    if (!bundlerConfig) throw Error("Invalid server action: " + ref);
    return [
        id,
        idx,
        bundlerConfig
    ];
}
function preloadModule$1(metadata) {
    metadata[3] && module.bundle.extendImportMap(metadata[3]);
    return 0 === metadata[2].length ? null : Promise.all(metadata[2].map(function(url) {
        return module.bundle.load(url);
    }));
}
function requireModule(metadata) {
    return module.bundle.root(metadata[0])[metadata[1]];
}
var REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.postpone");
var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var ASYNC_ITERATOR = Symbol.asyncIterator;
function handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
var LocalPromise = Promise, scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : function(callback) {
    LocalPromise.resolve(null).then(callback).catch(handleErrorInNextTick);
}, currentView = null, writtenBytes = 0;
function writeChunkAndReturn(destination, chunk) {
    if (0 !== chunk.byteLength) {
        if (2048 < chunk.byteLength) 0 < writtenBytes && (destination.enqueue(new Uint8Array(currentView.buffer, 0, writtenBytes)), currentView = new Uint8Array(2048), writtenBytes = 0), destination.enqueue(chunk);
        else {
            var allowableBytes = currentView.length - writtenBytes;
            allowableBytes < chunk.byteLength && (0 === allowableBytes ? destination.enqueue(currentView) : (currentView.set(chunk.subarray(0, allowableBytes), writtenBytes), destination.enqueue(currentView), chunk = chunk.subarray(allowableBytes)), currentView = new Uint8Array(2048), writtenBytes = 0);
            currentView.set(chunk, writtenBytes);
            writtenBytes += chunk.byteLength;
        }
    }
    return !0;
}
var textEncoder = new TextEncoder();
function stringToChunk(content) {
    return textEncoder.encode(content);
}
function byteLengthOfChunk(chunk) {
    return chunk.byteLength;
}
function closeWithError(destination, error) {
    "function" === typeof destination.error ? destination.error(error) : destination.close();
}
var CLIENT_REFERENCE_TAG$1 = Symbol.for("react.client.reference"), SERVER_REFERENCE_TAG = Symbol.for("react.server.reference"), FunctionBind = Function.prototype.bind, ArraySlice = Array.prototype.slice;
function bind() {
    var newFn = FunctionBind.apply(this, arguments);
    if (this.$$typeof === SERVER_REFERENCE_TAG) {
        var args = ArraySlice.call(arguments, 1), $$typeof = {
            value: SERVER_REFERENCE_TAG
        }, $$id = {
            value: this.$$id
        };
        args = {
            value: this.$$bound ? this.$$bound.concat(args) : args
        };
        return Object.defineProperties(newFn, {
            $$typeof: $$typeof,
            $$id: $$id,
            $$bound: args,
            bind: {
                value: bind,
                configurable: !0
            }
        });
    }
    return newFn;
}
var previousDispatcher = ReactDOMSharedInternals.d;
ReactDOMSharedInternals.d = {
    f: previousDispatcher.f,
    r: previousDispatcher.r,
    D: prefetchDNS,
    C: preconnect,
    L: preload,
    m: preloadModule,
    X: preinitScript,
    S: preinitStyle,
    M: preinitModuleScript
};
function prefetchDNS(href) {
    if ("string" === typeof href && href) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "D|" + href;
            hints.has(key) || (hints.add(key), emitHint(request, "D", href));
        } else previousDispatcher.D(href);
    }
}
function preconnect(href, crossOrigin) {
    if ("string" === typeof href) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "C|" + (null == crossOrigin ? "null" : crossOrigin) + "|" + href;
            hints.has(key) || (hints.add(key), "string" === typeof crossOrigin ? emitHint(request, "C", [
                href,
                crossOrigin
            ]) : emitHint(request, "C", href));
        } else previousDispatcher.C(href, crossOrigin);
    }
}
function preload(href, as, options) {
    if ("string" === typeof href) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "L";
            if ("image" === as && options) {
                var imageSrcSet = options.imageSrcSet, imageSizes = options.imageSizes, uniquePart = "";
                "string" === typeof imageSrcSet && "" !== imageSrcSet ? (uniquePart += "[" + imageSrcSet + "]", "string" === typeof imageSizes && (uniquePart += "[" + imageSizes + "]")) : uniquePart += "[][]" + href;
                key += "[image]" + uniquePart;
            } else key += "[" + as + "]" + href;
            hints.has(key) || (hints.add(key), (options = trimOptions(options)) ? emitHint(request, "L", [
                href,
                as,
                options
            ]) : emitHint(request, "L", [
                href,
                as
            ]));
        } else previousDispatcher.L(href, as, options);
    }
}
function preloadModule(href, options) {
    if ("string" === typeof href) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "m|" + href;
            if (hints.has(key)) return;
            hints.add(key);
            return (options = trimOptions(options)) ? emitHint(request, "m", [
                href,
                options
            ]) : emitHint(request, "m", href);
        }
        previousDispatcher.m(href, options);
    }
}
function preinitStyle(href, precedence, options) {
    if ("string" === typeof href) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "S|" + href;
            if (hints.has(key)) return;
            hints.add(key);
            return (options = trimOptions(options)) ? emitHint(request, "S", [
                href,
                "string" === typeof precedence ? precedence : 0,
                options
            ]) : "string" === typeof precedence ? emitHint(request, "S", [
                href,
                precedence
            ]) : emitHint(request, "S", href);
        }
        previousDispatcher.S(href, precedence, options);
    }
}
function preinitScript(src, options) {
    if ("string" === typeof src) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "X|" + src;
            if (hints.has(key)) return;
            hints.add(key);
            return (options = trimOptions(options)) ? emitHint(request, "X", [
                src,
                options
            ]) : emitHint(request, "X", src);
        }
        previousDispatcher.X(src, options);
    }
}
function preinitModuleScript(src, options) {
    if ("string" === typeof src) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "M|" + src;
            if (hints.has(key)) return;
            hints.add(key);
            return (options = trimOptions(options)) ? emitHint(request, "M", [
                src,
                options
            ]) : emitHint(request, "M", src);
        }
        previousDispatcher.M(src, options);
    }
}
function trimOptions(options) {
    if (null == options) return null;
    var hasProperties = !1, trimmed = {}, key;
    for(key in options)null != options[key] && (hasProperties = !0, trimmed[key] = options[key]);
    return hasProperties ? trimmed : null;
}
var supportsRequestStorage = "function" === typeof AsyncLocalStorage, requestStorage = supportsRequestStorage ? new AsyncLocalStorage() : null, TEMPORARY_REFERENCE_TAG = Symbol.for("react.temporary.reference"), proxyHandlers = {
    get: function(target, name) {
        switch(name){
            case "$$typeof":
                return target.$$typeof;
            case "name":
                return;
            case "displayName":
                return;
            case "defaultProps":
                return;
            case "_debugInfo":
                return;
            case "toJSON":
                return;
            case Symbol.toPrimitive:
                return Object.prototype[Symbol.toPrimitive];
            case Symbol.toStringTag:
                return Object.prototype[Symbol.toStringTag];
            case "Provider":
                throw Error("Cannot render a Client Context Provider on the Server. Instead, you can export a Client Component wrapper that itself renders a Client Context Provider.");
        }
        throw Error("Cannot access " + String(name) + " on the server. You cannot dot into a temporary client reference from a server component. You can only pass the value through to the client.");
    },
    set: function() {
        throw Error("Cannot assign to a temporary client reference from a server module.");
    }
};
function createTemporaryReference(temporaryReferences, id) {
    var reference = Object.defineProperties(function() {
        throw Error("Attempted to call a temporary Client Reference from the server but it is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component.");
    }, {
        $$typeof: {
            value: TEMPORARY_REFERENCE_TAG
        }
    });
    reference = new Proxy(reference, proxyHandlers);
    temporaryReferences.set(reference, id);
    return reference;
}
function noop() {}
var SuspenseException = Error("Suspense Exception: This is not a real error! It's an implementation detail of `use` to interrupt the current render. You must either rethrow it immediately, or move the `use` call outside of the `try/catch` block. Capturing without rethrowing will lead to unexpected behavior.\n\nTo handle async errors, wrap your component in an error boundary, or call the promise's `.catch` method and pass the result to `use`.");
function trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then(noop, noop), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            "string" === typeof thenable.status ? thenable.then(noop, noop) : (thenableState = thenable, thenableState.status = "pending", thenableState.then(function(fulfilledValue) {
                if ("pending" === thenable.status) {
                    var fulfilledThenable = thenable;
                    fulfilledThenable.status = "fulfilled";
                    fulfilledThenable.value = fulfilledValue;
                }
            }, function(error) {
                if ("pending" === thenable.status) {
                    var rejectedThenable = thenable;
                    rejectedThenable.status = "rejected";
                    rejectedThenable.reason = error;
                }
            }));
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
            suspendedThenable = thenable;
            throw SuspenseException;
    }
}
var suspendedThenable = null;
function getSuspendedThenable() {
    if (null === suspendedThenable) throw Error("Expected a suspended thenable. This is a bug in React. Please file an issue.");
    var thenable = suspendedThenable;
    suspendedThenable = null;
    return thenable;
}
var currentRequest$1 = null, thenableIndexCounter = 0, thenableState = null;
function getThenableStateAfterSuspending() {
    var state = thenableState || [];
    thenableState = null;
    return state;
}
var HooksDispatcher = {
    readContext: unsupportedContext,
    use: use,
    useCallback: function(callback) {
        return callback;
    },
    useContext: unsupportedContext,
    useEffect: unsupportedHook,
    useImperativeHandle: unsupportedHook,
    useLayoutEffect: unsupportedHook,
    useInsertionEffect: unsupportedHook,
    useMemo: function(nextCreate) {
        return nextCreate();
    },
    useReducer: unsupportedHook,
    useRef: unsupportedHook,
    useState: unsupportedHook,
    useDebugValue: function() {},
    useDeferredValue: unsupportedHook,
    useTransition: unsupportedHook,
    useSyncExternalStore: unsupportedHook,
    useId: useId,
    useHostTransitionStatus: unsupportedHook,
    useFormState: unsupportedHook,
    useActionState: unsupportedHook,
    useOptimistic: unsupportedHook,
    useMemoCache: function(size) {
        for(var data = Array(size), i = 0; i < size; i++)data[i] = REACT_MEMO_CACHE_SENTINEL;
        return data;
    },
    useCacheRefresh: function() {
        return unsupportedRefresh;
    }
};
function unsupportedHook() {
    throw Error("This Hook is not supported in Server Components.");
}
function unsupportedRefresh() {
    throw Error("Refreshing the cache is not supported in Server Components.");
}
function unsupportedContext() {
    throw Error("Cannot read a Client Context from a Server Component.");
}
function useId() {
    if (null === currentRequest$1) throw Error("useId can only be used while React is rendering");
    var id = currentRequest$1.identifierCount++;
    return "_" + currentRequest$1.identifierPrefix + "S_" + id.toString(32) + "_";
}
function use(usable) {
    if (null !== usable && "object" === typeof usable || "function" === typeof usable) {
        if ("function" === typeof usable.then) {
            var index = thenableIndexCounter;
            thenableIndexCounter += 1;
            null === thenableState && (thenableState = []);
            return trackUsedThenable(thenableState, usable, index);
        }
        usable.$$typeof === REACT_CONTEXT_TYPE && unsupportedContext();
    }
    if (usable.$$typeof === CLIENT_REFERENCE_TAG$1) {
        if (null != usable.value && usable.value.$$typeof === REACT_CONTEXT_TYPE) throw Error("Cannot read a Client Context from a Server Component.");
        throw Error("Cannot use() an already resolved Client Reference.");
    }
    throw Error("An unsupported type was passed to use(): " + String(usable));
}
var DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var JSCompiler_inline_result = (JSCompiler_inline_result = resolveRequest()) ? JSCompiler_inline_result.cache : new Map();
        var entry = JSCompiler_inline_result.get(resourceType);
        void 0 === entry && (entry = resourceType(), JSCompiler_inline_result.set(resourceType, entry));
        return entry;
    },
    cacheSignal: function() {
        var request = resolveRequest();
        return request ? request.cacheController.signal : null;
    }
}, ReactSharedInternalsServer = React.__SERVER_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
if (!ReactSharedInternalsServer) throw Error('The "react" package in this environment is not configured correctly. The "react-server" condition must be enabled in any environment that runs React Server Components.');
var isArrayImpl = Array.isArray, getPrototypeOf = Object.getPrototypeOf;
function objectName(object) {
    object = Object.prototype.toString.call(object);
    return object.slice(8, object.length - 1);
}
function describeValueForErrorMessage(value) {
    switch(typeof value){
        case "string":
            return JSON.stringify(10 >= value.length ? value : value.slice(0, 10) + "...");
        case "object":
            if (isArrayImpl(value)) return "[...]";
            if (null !== value && value.$$typeof === CLIENT_REFERENCE_TAG) return "client";
            value = objectName(value);
            return "Object" === value ? "{...}" : value;
        case "function":
            return value.$$typeof === CLIENT_REFERENCE_TAG ? "client" : (value = value.displayName || value.name) ? "function " + value : "function";
        default:
            return String(value);
    }
}
function describeElementType(type) {
    if ("string" === typeof type) return type;
    switch(type){
        case REACT_SUSPENSE_TYPE:
            return "Suspense";
        case REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case REACT_FORWARD_REF_TYPE:
            return describeElementType(type.render);
        case REACT_MEMO_TYPE:
            return describeElementType(type.type);
        case REACT_LAZY_TYPE:
            var payload = type._payload;
            type = type._init;
            try {
                return describeElementType(type(payload));
            } catch (x) {}
    }
    return "";
}
var CLIENT_REFERENCE_TAG = Symbol.for("react.client.reference");
function describeObjectForErrorMessage(objectOrArray, expandedName) {
    var objKind = objectName(objectOrArray);
    if ("Object" !== objKind && "Array" !== objKind) return objKind;
    objKind = -1;
    var length = 0;
    if (isArrayImpl(objectOrArray)) {
        var str = "[";
        for(var i = 0; i < objectOrArray.length; i++){
            0 < i && (str += ", ");
            var value = objectOrArray[i];
            value = "object" === typeof value && null !== value ? describeObjectForErrorMessage(value) : describeValueForErrorMessage(value);
            "" + i === expandedName ? (objKind = str.length, length = value.length, str += value) : str = 10 > value.length && 40 > str.length + value.length ? str + value : str + "...";
        }
        str += "]";
    } else if (objectOrArray.$$typeof === REACT_ELEMENT_TYPE) str = "<" + describeElementType(objectOrArray.type) + "/>";
    else {
        if (objectOrArray.$$typeof === CLIENT_REFERENCE_TAG) return "client";
        str = "{";
        i = Object.keys(objectOrArray);
        for(value = 0; value < i.length; value++){
            0 < value && (str += ", ");
            var name = i[value], encodedKey = JSON.stringify(name);
            str += ('"' + name + '"' === encodedKey ? name : encodedKey) + ": ";
            encodedKey = objectOrArray[name];
            encodedKey = "object" === typeof encodedKey && null !== encodedKey ? describeObjectForErrorMessage(encodedKey) : describeValueForErrorMessage(encodedKey);
            name === expandedName ? (objKind = str.length, length = encodedKey.length, str += encodedKey) : str = 10 > encodedKey.length && 40 > str.length + encodedKey.length ? str + encodedKey : str + "...";
        }
        str += "}";
    }
    return void 0 === expandedName ? str : -1 < objKind && 0 < length ? (objectOrArray = " ".repeat(objKind) + "^".repeat(length), "\n  " + str + "\n  " + objectOrArray) : "\n  " + str;
}
var hasOwnProperty = Object.prototype.hasOwnProperty, ObjectPrototype = Object.prototype, stringify = JSON.stringify;
function defaultErrorHandler(error) {
    console.error(error);
}
function RequestInstance(type, model, bundlerConfig, onError, onPostpone, onAllReady, onFatalError, identifierPrefix, temporaryReferences) {
    if (null !== ReactSharedInternalsServer.A && ReactSharedInternalsServer.A !== DefaultAsyncDispatcher) throw Error("Currently React only supports one RSC renderer at a time.");
    ReactSharedInternalsServer.A = DefaultAsyncDispatcher;
    var abortSet = new Set(), pingedTasks = [], hints = new Set();
    this.type = type;
    this.status = 10;
    this.flushScheduled = !1;
    this.destination = this.fatalError = null;
    this.bundlerConfig = bundlerConfig;
    this.cache = new Map();
    this.cacheController = new AbortController();
    this.pendingChunks = this.nextChunkId = 0;
    this.hints = hints;
    this.abortableTasks = abortSet;
    this.pingedTasks = pingedTasks;
    this.completedImportChunks = [];
    this.completedHintChunks = [];
    this.completedRegularChunks = [];
    this.completedErrorChunks = [];
    this.writtenSymbols = new Map();
    this.writtenClientReferences = new Map();
    this.writtenServerReferences = new Map();
    this.writtenObjects = new WeakMap();
    this.temporaryReferences = temporaryReferences;
    this.identifierPrefix = identifierPrefix || "";
    this.identifierCount = 1;
    this.taintCleanupQueue = [];
    this.onError = void 0 === onError ? defaultErrorHandler : onError;
    this.onPostpone = void 0 === onPostpone ? noop : onPostpone;
    this.onAllReady = onAllReady;
    this.onFatalError = onFatalError;
    type = createTask(this, model, null, !1, abortSet);
    pingedTasks.push(type);
}
var currentRequest = null;
function resolveRequest() {
    if (currentRequest) return currentRequest;
    if (supportsRequestStorage) {
        var store = requestStorage.getStore();
        if (store) return store;
    }
    return null;
}
function serializeThenable(request, task, thenable) {
    var newTask = createTask(request, thenable, task.keyPath, task.implicitSlot, request.abortableTasks);
    switch(thenable.status){
        case "fulfilled":
            return newTask.model = thenable.value, pingTask(request, newTask), newTask.id;
        case "rejected":
            return erroredTask(request, newTask, thenable.reason), newTask.id;
        default:
            if (12 === request.status) return request.abortableTasks.delete(newTask), task = request.fatalError, abortTask(newTask), finishAbortedTask(newTask, request, task), newTask.id;
            "string" !== typeof thenable.status && (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            }));
    }
    thenable.then(function(value) {
        newTask.model = value;
        pingTask(request, newTask);
    }, function(reason) {
        0 === newTask.status && (erroredTask(request, newTask, reason), enqueueFlush(request));
    });
    return newTask.id;
}
function serializeReadableStream(request, task, stream) {
    function progress(entry) {
        if (0 === streamTask.status) {
            if (entry.done) streamTask.status = 1, entry = streamTask.id.toString(16) + ":C\n", request.completedRegularChunks.push(stringToChunk(entry)), request.abortableTasks.delete(streamTask), request.cacheController.signal.removeEventListener("abort", abortStream), enqueueFlush(request), callOnAllReadyIfReady(request);
            else try {
                streamTask.model = entry.value, request.pendingChunks++, tryStreamTask(request, streamTask), enqueueFlush(request), reader.read().then(progress, error);
            } catch (x$8) {
                error(x$8);
            }
        }
    }
    function error(reason) {
        0 === streamTask.status && (request.cacheController.signal.removeEventListener("abort", abortStream), erroredTask(request, streamTask, reason), enqueueFlush(request), reader.cancel(reason).then(error, error));
    }
    function abortStream() {
        if (0 === streamTask.status) {
            var signal = request.cacheController.signal;
            signal.removeEventListener("abort", abortStream);
            signal = signal.reason;
            erroredTask(request, streamTask, signal);
            enqueueFlush(request);
            reader.cancel(signal).then(error, error);
        }
    }
    var supportsBYOB = stream.supportsBYOB;
    if (void 0 === supportsBYOB) try {
        stream.getReader({
            mode: "byob"
        }).releaseLock(), supportsBYOB = !0;
    } catch (x) {
        supportsBYOB = !1;
    }
    var reader = stream.getReader(), streamTask = createTask(request, task.model, task.keyPath, task.implicitSlot, request.abortableTasks);
    request.pendingChunks++;
    task = streamTask.id.toString(16) + ":" + (supportsBYOB ? "r" : "R") + "\n";
    request.completedRegularChunks.push(stringToChunk(task));
    request.cacheController.signal.addEventListener("abort", abortStream);
    reader.read().then(progress, error);
    return serializeByValueID(streamTask.id);
}
function serializeAsyncIterable(request, task, iterable, iterator) {
    function progress(entry) {
        if (0 === streamTask.status) {
            if (entry.done) {
                streamTask.status = 1;
                if (void 0 === entry.value) var endStreamRow = streamTask.id.toString(16) + ":C\n";
                else try {
                    var chunkId = outlineModel(request, entry.value);
                    endStreamRow = streamTask.id.toString(16) + ":C" + stringify(serializeByValueID(chunkId)) + "\n";
                } catch (x) {
                    error(x);
                    return;
                }
                request.completedRegularChunks.push(stringToChunk(endStreamRow));
                request.abortableTasks.delete(streamTask);
                request.cacheController.signal.removeEventListener("abort", abortIterable);
                enqueueFlush(request);
                callOnAllReadyIfReady(request);
            } else try {
                streamTask.model = entry.value, request.pendingChunks++, tryStreamTask(request, streamTask), enqueueFlush(request), iterator.next().then(progress, error);
            } catch (x$9) {
                error(x$9);
            }
        }
    }
    function error(reason) {
        0 === streamTask.status && (request.cacheController.signal.removeEventListener("abort", abortIterable), erroredTask(request, streamTask, reason), enqueueFlush(request), "function" === typeof iterator.throw && iterator.throw(reason).then(error, error));
    }
    function abortIterable() {
        if (0 === streamTask.status) {
            var signal = request.cacheController.signal;
            signal.removeEventListener("abort", abortIterable);
            var reason = signal.reason;
            erroredTask(request, streamTask, signal.reason);
            enqueueFlush(request);
            "function" === typeof iterator.throw && iterator.throw(reason).then(error, error);
        }
    }
    iterable = iterable === iterator;
    var streamTask = createTask(request, task.model, task.keyPath, task.implicitSlot, request.abortableTasks);
    request.pendingChunks++;
    task = streamTask.id.toString(16) + ":" + (iterable ? "x" : "X") + "\n";
    request.completedRegularChunks.push(stringToChunk(task));
    request.cacheController.signal.addEventListener("abort", abortIterable);
    iterator.next().then(progress, error);
    return serializeByValueID(streamTask.id);
}
function emitHint(request, code, model) {
    model = stringify(model);
    code = stringToChunk(":H" + code + model + "\n");
    request.completedHintChunks.push(code);
    enqueueFlush(request);
}
function readThenable(thenable) {
    if ("fulfilled" === thenable.status) return thenable.value;
    if ("rejected" === thenable.status) throw thenable.reason;
    throw thenable;
}
function createLazyWrapperAroundWakeable(request, task, wakeable) {
    switch(wakeable.status){
        case "fulfilled":
            return wakeable.value;
        case "rejected":
            break;
        default:
            "string" !== typeof wakeable.status && (wakeable.status = "pending", wakeable.then(function(fulfilledValue) {
                "pending" === wakeable.status && (wakeable.status = "fulfilled", wakeable.value = fulfilledValue);
            }, function(error) {
                "pending" === wakeable.status && (wakeable.status = "rejected", wakeable.reason = error);
            }));
    }
    return {
        $$typeof: REACT_LAZY_TYPE,
        _payload: wakeable,
        _init: readThenable
    };
}
function voidHandler() {}
function processServerComponentReturnValue(request, task, Component, result) {
    if ("object" !== typeof result || null === result || result.$$typeof === CLIENT_REFERENCE_TAG$1) return result;
    if ("function" === typeof result.then) return createLazyWrapperAroundWakeable(request, task, result);
    var iteratorFn = getIteratorFn(result);
    return iteratorFn ? (request = {}, request[Symbol.iterator] = function() {
        return iteratorFn.call(result);
    }, request) : "function" !== typeof result[ASYNC_ITERATOR] || "function" === typeof ReadableStream && result instanceof ReadableStream ? result : (request = {}, request[ASYNC_ITERATOR] = function() {
        return result[ASYNC_ITERATOR]();
    }, request);
}
function renderFunctionComponent(request, task, key, Component, props) {
    var prevThenableState = task.thenableState;
    task.thenableState = null;
    thenableIndexCounter = 0;
    thenableState = prevThenableState;
    props = Component(props, void 0);
    if (12 === request.status) throw "object" === typeof props && null !== props && "function" === typeof props.then && props.$$typeof !== CLIENT_REFERENCE_TAG$1 && props.then(voidHandler, voidHandler), null;
    props = processServerComponentReturnValue(request, task, Component, props);
    Component = task.keyPath;
    prevThenableState = task.implicitSlot;
    null !== key ? task.keyPath = null === Component ? key : Component + "," + key : null === Component && (task.implicitSlot = !0);
    request = renderModelDestructive(request, task, emptyRoot, "", props);
    task.keyPath = Component;
    task.implicitSlot = prevThenableState;
    return request;
}
function renderFragment(request, task, children) {
    return null !== task.keyPath ? (request = [
        REACT_ELEMENT_TYPE,
        REACT_FRAGMENT_TYPE,
        task.keyPath,
        {
            children: children
        }
    ], task.implicitSlot ? [
        request
    ] : request) : children;
}
var serializedSize = 0;
function deferTask(request, task) {
    task = createTask(request, task.model, task.keyPath, task.implicitSlot, request.abortableTasks);
    pingTask(request, task);
    return "$L" + task.id.toString(16);
}
function renderElement(request, task, type, key, ref, props) {
    if (null !== ref && void 0 !== ref) throw Error("Refs cannot be used in Server Components, nor passed to Client Components.");
    if ("function" === typeof type && type.$$typeof !== CLIENT_REFERENCE_TAG$1 && type.$$typeof !== TEMPORARY_REFERENCE_TAG) return renderFunctionComponent(request, task, key, type, props);
    if (type === REACT_FRAGMENT_TYPE && null === key) return type = task.implicitSlot, null === task.keyPath && (task.implicitSlot = !0), props = renderModelDestructive(request, task, emptyRoot, "", props.children), task.implicitSlot = type, props;
    if (null != type && "object" === typeof type && type.$$typeof !== CLIENT_REFERENCE_TAG$1) switch(type.$$typeof){
        case REACT_LAZY_TYPE:
            var init = type._init;
            type = init(type._payload);
            if (12 === request.status) throw null;
            return renderElement(request, task, type, key, ref, props);
        case REACT_FORWARD_REF_TYPE:
            return renderFunctionComponent(request, task, key, type.render, props);
        case REACT_MEMO_TYPE:
            return renderElement(request, task, type.type, key, ref, props);
    }
    request = key;
    key = task.keyPath;
    null === request ? request = key : null !== key && (request = key + "," + request);
    props = [
        REACT_ELEMENT_TYPE,
        type,
        request,
        props
    ];
    task = task.implicitSlot && null !== request ? [
        props
    ] : props;
    return task;
}
function pingTask(request, task) {
    var pingedTasks = request.pingedTasks;
    pingedTasks.push(task);
    1 === pingedTasks.length && (request.flushScheduled = null !== request.destination, 21 === request.type || 10 === request.status ? scheduleMicrotask(function() {
        return performWork(request);
    }) : setTimeout(function() {
        return performWork(request);
    }, 0));
}
function createTask(request, model, keyPath, implicitSlot, abortSet) {
    request.pendingChunks++;
    var id = request.nextChunkId++;
    "object" !== typeof model || null === model || null !== keyPath || implicitSlot || request.writtenObjects.set(model, serializeByValueID(id));
    var task = {
        id: id,
        status: 0,
        model: model,
        keyPath: keyPath,
        implicitSlot: implicitSlot,
        ping: function() {
            return pingTask(request, task);
        },
        toJSON: function(parentPropertyName, value) {
            serializedSize += parentPropertyName.length;
            var prevKeyPath = task.keyPath, prevImplicitSlot = task.implicitSlot;
            try {
                var JSCompiler_inline_result = renderModelDestructive(request, task, this, parentPropertyName, value);
            } catch (thrownValue) {
                if (parentPropertyName = task.model, parentPropertyName = "object" === typeof parentPropertyName && null !== parentPropertyName && (parentPropertyName.$$typeof === REACT_ELEMENT_TYPE || parentPropertyName.$$typeof === REACT_LAZY_TYPE), 12 === request.status) task.status = 3, prevKeyPath = request.fatalError, JSCompiler_inline_result = parentPropertyName ? "$L" + prevKeyPath.toString(16) : serializeByValueID(prevKeyPath);
                else if (value = thrownValue === SuspenseException ? getSuspendedThenable() : thrownValue, "object" === typeof value && null !== value && "function" === typeof value.then) {
                    JSCompiler_inline_result = createTask(request, task.model, task.keyPath, task.implicitSlot, request.abortableTasks);
                    var ping = JSCompiler_inline_result.ping;
                    value.then(ping, ping);
                    JSCompiler_inline_result.thenableState = getThenableStateAfterSuspending();
                    task.keyPath = prevKeyPath;
                    task.implicitSlot = prevImplicitSlot;
                    JSCompiler_inline_result = parentPropertyName ? "$L" + JSCompiler_inline_result.id.toString(16) : serializeByValueID(JSCompiler_inline_result.id);
                } else task.keyPath = prevKeyPath, task.implicitSlot = prevImplicitSlot, request.pendingChunks++, prevKeyPath = request.nextChunkId++, prevImplicitSlot = logRecoverableError(request, value, task), emitErrorChunk(request, prevKeyPath, prevImplicitSlot), JSCompiler_inline_result = parentPropertyName ? "$L" + prevKeyPath.toString(16) : serializeByValueID(prevKeyPath);
            }
            return JSCompiler_inline_result;
        },
        thenableState: null
    };
    abortSet.add(task);
    return task;
}
function serializeByValueID(id) {
    return "$" + id.toString(16);
}
function encodeReferenceChunk(request, id, reference) {
    request = stringify(reference);
    id = id.toString(16) + ":" + request + "\n";
    return stringToChunk(id);
}
function serializeClientReference(request, parent, parentPropertyName, clientReference) {
    var clientReferenceKey = clientReference.$$id + "#" + clientReference.$$name, writtenClientReferences = request.writtenClientReferences, existingId = writtenClientReferences.get(clientReferenceKey);
    if (void 0 !== existingId) return parent[0] === REACT_ELEMENT_TYPE && "1" === parentPropertyName ? "$L" + existingId.toString(16) : serializeByValueID(existingId);
    try {
        var JSCompiler_inline_result = clientReference.$$importMap ? [
            clientReference.$$id,
            clientReference.$$name,
            clientReference.$$bundles,
            clientReference.$$importMap
        ] : [
            clientReference.$$id,
            clientReference.$$name,
            clientReference.$$bundles
        ];
        request.pendingChunks++;
        var importId = request.nextChunkId++, json = stringify(JSCompiler_inline_result), row = importId.toString(16) + ":I" + json + "\n", processedChunk = stringToChunk(row);
        request.completedImportChunks.push(processedChunk);
        writtenClientReferences.set(clientReferenceKey, importId);
        return parent[0] === REACT_ELEMENT_TYPE && "1" === parentPropertyName ? "$L" + importId.toString(16) : serializeByValueID(importId);
    } catch (x) {
        return request.pendingChunks++, parent = request.nextChunkId++, parentPropertyName = logRecoverableError(request, x, null), emitErrorChunk(request, parent, parentPropertyName), serializeByValueID(parent);
    }
}
function outlineModel(request, value) {
    value = createTask(request, value, null, !1, request.abortableTasks);
    retryTask(request, value);
    return value.id;
}
function serializeTypedArray(request, tag, typedArray) {
    request.pendingChunks++;
    var bufferId = request.nextChunkId++;
    emitTypedArrayChunk(request, bufferId, tag, typedArray, !1);
    return serializeByValueID(bufferId);
}
function serializeBlob(request, blob) {
    function progress(entry) {
        if (0 === newTask.status) {
            if (entry.done) request.cacheController.signal.removeEventListener("abort", abortBlob), pingTask(request, newTask);
            else return model.push(entry.value), reader.read().then(progress).catch(error);
        }
    }
    function error(reason) {
        0 === newTask.status && (request.cacheController.signal.removeEventListener("abort", abortBlob), erroredTask(request, newTask, reason), enqueueFlush(request), reader.cancel(reason).then(error, error));
    }
    function abortBlob() {
        if (0 === newTask.status) {
            var signal = request.cacheController.signal;
            signal.removeEventListener("abort", abortBlob);
            signal = signal.reason;
            erroredTask(request, newTask, signal);
            enqueueFlush(request);
            reader.cancel(signal).then(error, error);
        }
    }
    var model = [
        blob.type
    ], newTask = createTask(request, model, null, !1, request.abortableTasks), reader = blob.stream().getReader();
    request.cacheController.signal.addEventListener("abort", abortBlob);
    reader.read().then(progress).catch(error);
    return "$B" + newTask.id.toString(16);
}
var modelRoot = !1;
function renderModelDestructive(request, task, parent, parentPropertyName, value) {
    task.model = value;
    if (value === REACT_ELEMENT_TYPE) return "$";
    if (null === value) return null;
    if ("object" === typeof value) {
        switch(value.$$typeof){
            case REACT_ELEMENT_TYPE:
                var elementReference = null, writtenObjects = request.writtenObjects;
                if (null === task.keyPath && !task.implicitSlot) {
                    var existingReference = writtenObjects.get(value);
                    if (void 0 !== existingReference) {
                        if (modelRoot === value) modelRoot = null;
                        else return existingReference;
                    } else -1 === parentPropertyName.indexOf(":") && (parent = writtenObjects.get(parent), void 0 !== parent && (elementReference = parent + ":" + parentPropertyName, writtenObjects.set(value, elementReference)));
                }
                if (3200 < serializedSize) return deferTask(request, task);
                parentPropertyName = value.props;
                parent = parentPropertyName.ref;
                request = renderElement(request, task, value.type, value.key, void 0 !== parent ? parent : null, parentPropertyName);
                "object" === typeof request && null !== request && null !== elementReference && (writtenObjects.has(request) || writtenObjects.set(request, elementReference));
                return request;
            case REACT_LAZY_TYPE:
                if (3200 < serializedSize) return deferTask(request, task);
                task.thenableState = null;
                parentPropertyName = value._init;
                value = parentPropertyName(value._payload);
                if (12 === request.status) throw null;
                return renderModelDestructive(request, task, emptyRoot, "", value);
            case REACT_LEGACY_ELEMENT_TYPE:
                throw Error('A React Element from an older version of React was rendered. This is not supported. It can happen if:\n- Multiple copies of the "react" package is used.\n- A library pre-bundled an old copy of "react" or "react/jsx-runtime".\n- A compiler tries to "inline" JSX instead of using the runtime.');
        }
        if (value.$$typeof === CLIENT_REFERENCE_TAG$1) return serializeClientReference(request, parent, parentPropertyName, value);
        if (void 0 !== request.temporaryReferences && (elementReference = request.temporaryReferences.get(value), void 0 !== elementReference)) return "$T" + elementReference;
        elementReference = request.writtenObjects;
        writtenObjects = elementReference.get(value);
        if ("function" === typeof value.then) {
            if (void 0 !== writtenObjects) {
                if (null !== task.keyPath || task.implicitSlot) return "$@" + serializeThenable(request, task, value).toString(16);
                if (modelRoot === value) modelRoot = null;
                else return writtenObjects;
            }
            request = "$@" + serializeThenable(request, task, value).toString(16);
            elementReference.set(value, request);
            return request;
        }
        if (void 0 !== writtenObjects) {
            if (modelRoot === value) {
                if (writtenObjects !== serializeByValueID(task.id)) return writtenObjects;
                modelRoot = null;
            } else return writtenObjects;
        } else if (-1 === parentPropertyName.indexOf(":") && (writtenObjects = elementReference.get(parent), void 0 !== writtenObjects)) {
            existingReference = parentPropertyName;
            if (isArrayImpl(parent) && parent[0] === REACT_ELEMENT_TYPE) switch(parentPropertyName){
                case "1":
                    existingReference = "type";
                    break;
                case "2":
                    existingReference = "key";
                    break;
                case "3":
                    existingReference = "props";
                    break;
                case "4":
                    existingReference = "_owner";
            }
            elementReference.set(value, writtenObjects + ":" + existingReference);
        }
        if (isArrayImpl(value)) return renderFragment(request, task, value);
        if (value instanceof Map) return value = Array.from(value), "$Q" + outlineModel(request, value).toString(16);
        if (value instanceof Set) return value = Array.from(value), "$W" + outlineModel(request, value).toString(16);
        if ("function" === typeof FormData && value instanceof FormData) return value = Array.from(value.entries()), "$K" + outlineModel(request, value).toString(16);
        if (value instanceof Error) return "$Z";
        if (value instanceof ArrayBuffer) return serializeTypedArray(request, "A", new Uint8Array(value));
        if (value instanceof Int8Array) return serializeTypedArray(request, "O", value);
        if (value instanceof Uint8Array) return serializeTypedArray(request, "o", value);
        if (value instanceof Uint8ClampedArray) return serializeTypedArray(request, "U", value);
        if (value instanceof Int16Array) return serializeTypedArray(request, "S", value);
        if (value instanceof Uint16Array) return serializeTypedArray(request, "s", value);
        if (value instanceof Int32Array) return serializeTypedArray(request, "L", value);
        if (value instanceof Uint32Array) return serializeTypedArray(request, "l", value);
        if (value instanceof Float32Array) return serializeTypedArray(request, "G", value);
        if (value instanceof Float64Array) return serializeTypedArray(request, "g", value);
        if (value instanceof BigInt64Array) return serializeTypedArray(request, "M", value);
        if (value instanceof BigUint64Array) return serializeTypedArray(request, "m", value);
        if (value instanceof DataView) return serializeTypedArray(request, "V", value);
        if ("function" === typeof Blob && value instanceof Blob) return serializeBlob(request, value);
        if (elementReference = getIteratorFn(value)) return parentPropertyName = elementReference.call(value), parentPropertyName === value ? "$i" + outlineModel(request, Array.from(parentPropertyName)).toString(16) : renderFragment(request, task, Array.from(parentPropertyName));
        if ("function" === typeof ReadableStream && value instanceof ReadableStream) return serializeReadableStream(request, task, value);
        elementReference = value[ASYNC_ITERATOR];
        if ("function" === typeof elementReference) return null !== task.keyPath ? (request = [
            REACT_ELEMENT_TYPE,
            REACT_FRAGMENT_TYPE,
            task.keyPath,
            {
                children: value
            }
        ], request = task.implicitSlot ? [
            request
        ] : request) : (parentPropertyName = elementReference.call(value), request = serializeAsyncIterable(request, task, value, parentPropertyName)), request;
        if (value instanceof Date) return "$D" + value.toJSON();
        request = getPrototypeOf(value);
        if (request !== ObjectPrototype && (null === request || null !== getPrototypeOf(request))) throw Error("Only plain objects, and a few built-ins, can be passed to Client Components from Server Components. Classes or null prototypes are not supported." + describeObjectForErrorMessage(parent, parentPropertyName));
        return value;
    }
    if ("string" === typeof value) {
        serializedSize += value.length;
        if ("Z" === value[value.length - 1] && parent[parentPropertyName] instanceof Date) return "$D" + value;
        if (1024 <= value.length && null !== byteLengthOfChunk) return request.pendingChunks++, task = request.nextChunkId++, emitTextChunk(request, task, value, !1), serializeByValueID(task);
        request = "$" === value[0] ? "$" + value : value;
        return request;
    }
    if ("boolean" === typeof value) return value;
    if ("number" === typeof value) return Number.isFinite(value) ? 0 === value && -Infinity === 1 / value ? "$-0" : value : Infinity === value ? "$Infinity" : -Infinity === value ? "$-Infinity" : "$NaN";
    if ("undefined" === typeof value) return "$undefined";
    if ("function" === typeof value) {
        if (value.$$typeof === CLIENT_REFERENCE_TAG$1) return serializeClientReference(request, parent, parentPropertyName, value);
        if (value.$$typeof === SERVER_REFERENCE_TAG) return task = request.writtenServerReferences, parentPropertyName = task.get(value), void 0 !== parentPropertyName ? request = "$F" + parentPropertyName.toString(16) : (parentPropertyName = value.$$bound, parentPropertyName = null === parentPropertyName ? null : Promise.resolve(parentPropertyName), request = outlineModel(request, {
            id: value.$$id,
            bound: parentPropertyName
        }), task.set(value, request), request = "$F" + request.toString(16)), request;
        if (void 0 !== request.temporaryReferences && (request = request.temporaryReferences.get(value), void 0 !== request)) return "$T" + request;
        if (value.$$typeof === TEMPORARY_REFERENCE_TAG) throw Error("Could not reference an opaque temporary reference. This is likely due to misconfiguring the temporaryReferences options on the server.");
        if (/^on[A-Z]/.test(parentPropertyName)) throw Error("Event handlers cannot be passed to Client Component props." + describeObjectForErrorMessage(parent, parentPropertyName) + "\nIf you need interactivity, consider converting part of this to a Client Component.");
        throw Error('Functions cannot be passed directly to Client Components unless you explicitly expose it by marking it with "use server". Or maybe you meant to call this function rather than return it.' + describeObjectForErrorMessage(parent, parentPropertyName));
    }
    if ("symbol" === typeof value) {
        task = request.writtenSymbols;
        elementReference = task.get(value);
        if (void 0 !== elementReference) return serializeByValueID(elementReference);
        elementReference = value.description;
        if (Symbol.for(elementReference) !== value) throw Error("Only global symbols received from Symbol.for(...) can be passed to Client Components. The symbol Symbol.for(" + (value.description + ") cannot be found among global symbols.") + describeObjectForErrorMessage(parent, parentPropertyName));
        request.pendingChunks++;
        parentPropertyName = request.nextChunkId++;
        parent = encodeReferenceChunk(request, parentPropertyName, "$S" + elementReference);
        request.completedImportChunks.push(parent);
        task.set(value, parentPropertyName);
        return serializeByValueID(parentPropertyName);
    }
    if ("bigint" === typeof value) return "$n" + value.toString(10);
    throw Error("Type " + typeof value + " is not supported in Client Component props." + describeObjectForErrorMessage(parent, parentPropertyName));
}
function logRecoverableError(request, error) {
    var prevRequest = currentRequest;
    currentRequest = null;
    try {
        var onError = request.onError;
        var errorDigest = supportsRequestStorage ? requestStorage.run(void 0, onError, error) : onError(error);
    } finally{
        currentRequest = prevRequest;
    }
    if (null != errorDigest && "string" !== typeof errorDigest) throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof errorDigest + '" instead');
    return errorDigest || "";
}
function fatalError(request, error) {
    var onFatalError = request.onFatalError;
    onFatalError(error);
    null !== request.destination ? (request.status = 14, closeWithError(request.destination, error)) : (request.status = 13, request.fatalError = error);
    request.cacheController.abort(Error("The render was aborted due to a fatal error.", {
        cause: error
    }));
}
function emitErrorChunk(request, id, digest) {
    digest = {
        digest: digest
    };
    id = id.toString(16) + ":E" + stringify(digest) + "\n";
    id = stringToChunk(id);
    request.completedErrorChunks.push(id);
}
function emitModelChunk(request, id, json) {
    id = id.toString(16) + ":" + json + "\n";
    id = stringToChunk(id);
    request.completedRegularChunks.push(id);
}
function emitTypedArrayChunk(request, id, tag, typedArray, debug) {
    debug ? request.pendingDebugChunks++ : request.pendingChunks++;
    debug = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
    typedArray = 2048 < typedArray.byteLength ? debug.slice() : debug;
    debug = typedArray.byteLength;
    id = id.toString(16) + ":" + tag + debug.toString(16) + ",";
    id = stringToChunk(id);
    request.completedRegularChunks.push(id, typedArray);
}
function emitTextChunk(request, id, text, debug) {
    if (null === byteLengthOfChunk) throw Error("Existence of byteLengthOfChunk should have already been checked. This is a bug in React.");
    debug ? request.pendingDebugChunks++ : request.pendingChunks++;
    text = stringToChunk(text);
    debug = text.byteLength;
    id = id.toString(16) + ":T" + debug.toString(16) + ",";
    id = stringToChunk(id);
    request.completedRegularChunks.push(id, text);
}
function emitChunk(request, task, value) {
    var id = task.id;
    "string" === typeof value && null !== byteLengthOfChunk ? emitTextChunk(request, id, value, !1) : value instanceof ArrayBuffer ? emitTypedArrayChunk(request, id, "A", new Uint8Array(value), !1) : value instanceof Int8Array ? emitTypedArrayChunk(request, id, "O", value, !1) : value instanceof Uint8Array ? emitTypedArrayChunk(request, id, "o", value, !1) : value instanceof Uint8ClampedArray ? emitTypedArrayChunk(request, id, "U", value, !1) : value instanceof Int16Array ? emitTypedArrayChunk(request, id, "S", value, !1) : value instanceof Uint16Array ? emitTypedArrayChunk(request, id, "s", value, !1) : value instanceof Int32Array ? emitTypedArrayChunk(request, id, "L", value, !1) : value instanceof Uint32Array ? emitTypedArrayChunk(request, id, "l", value, !1) : value instanceof Float32Array ? emitTypedArrayChunk(request, id, "G", value, !1) : value instanceof Float64Array ? emitTypedArrayChunk(request, id, "g", value, !1) : value instanceof BigInt64Array ? emitTypedArrayChunk(request, id, "M", value, !1) : value instanceof BigUint64Array ? emitTypedArrayChunk(request, id, "m", value, !1) : value instanceof DataView ? emitTypedArrayChunk(request, id, "V", value, !1) : (value = stringify(value, task.toJSON), emitModelChunk(request, task.id, value));
}
function erroredTask(request, task, error) {
    task.status = 4;
    error = logRecoverableError(request, error, task);
    emitErrorChunk(request, task.id, error);
    request.abortableTasks.delete(task);
    callOnAllReadyIfReady(request);
}
var emptyRoot = {};
function retryTask(request, task) {
    if (0 === task.status) {
        task.status = 5;
        var parentSerializedSize = serializedSize;
        try {
            modelRoot = task.model;
            var resolvedModel = renderModelDestructive(request, task, emptyRoot, "", task.model);
            modelRoot = resolvedModel;
            task.keyPath = null;
            task.implicitSlot = !1;
            if ("object" === typeof resolvedModel && null !== resolvedModel) request.writtenObjects.set(resolvedModel, serializeByValueID(task.id)), emitChunk(request, task, resolvedModel);
            else {
                var json = stringify(resolvedModel);
                emitModelChunk(request, task.id, json);
            }
            task.status = 1;
            request.abortableTasks.delete(task);
            callOnAllReadyIfReady(request);
        } catch (thrownValue) {
            if (12 === request.status) {
                request.abortableTasks.delete(task);
                task.status = 0;
                var errorId = request.fatalError;
                abortTask(task);
                finishAbortedTask(task, request, errorId);
            } else {
                var x = thrownValue === SuspenseException ? getSuspendedThenable() : thrownValue;
                if ("object" === typeof x && null !== x && "function" === typeof x.then) {
                    task.status = 0;
                    task.thenableState = getThenableStateAfterSuspending();
                    var ping = task.ping;
                    x.then(ping, ping);
                } else erroredTask(request, task, x);
            }
        } finally{
            serializedSize = parentSerializedSize;
        }
    }
}
function tryStreamTask(request, task) {
    var parentSerializedSize = serializedSize;
    try {
        emitChunk(request, task, task.model);
    } finally{
        serializedSize = parentSerializedSize;
    }
}
function performWork(request) {
    var prevDispatcher = ReactSharedInternalsServer.H;
    ReactSharedInternalsServer.H = HooksDispatcher;
    var prevRequest = currentRequest;
    currentRequest$1 = currentRequest = request;
    try {
        var pingedTasks = request.pingedTasks;
        request.pingedTasks = [];
        for(var i = 0; i < pingedTasks.length; i++)retryTask(request, pingedTasks[i]);
        flushCompletedChunks(request);
    } catch (error) {
        logRecoverableError(request, error, null), fatalError(request, error);
    } finally{
        ReactSharedInternalsServer.H = prevDispatcher, currentRequest$1 = null, currentRequest = prevRequest;
    }
}
function abortTask(task) {
    0 === task.status && (task.status = 3);
}
function finishAbortedTask(task, request, errorId) {
    3 === task.status && (errorId = serializeByValueID(errorId), task = encodeReferenceChunk(request, task.id, errorId), request.completedErrorChunks.push(task));
}
function flushCompletedChunks(request) {
    var destination = request.destination;
    if (null !== destination) {
        currentView = new Uint8Array(2048);
        writtenBytes = 0;
        try {
            for(var importsChunks = request.completedImportChunks, i = 0; i < importsChunks.length; i++)request.pendingChunks--, writeChunkAndReturn(destination, importsChunks[i]);
            importsChunks.splice(0, i);
            var hintChunks = request.completedHintChunks;
            for(i = 0; i < hintChunks.length; i++)writeChunkAndReturn(destination, hintChunks[i]);
            hintChunks.splice(0, i);
            var regularChunks = request.completedRegularChunks;
            for(i = 0; i < regularChunks.length; i++)request.pendingChunks--, writeChunkAndReturn(destination, regularChunks[i]);
            regularChunks.splice(0, i);
            var errorChunks = request.completedErrorChunks;
            for(i = 0; i < errorChunks.length; i++)request.pendingChunks--, writeChunkAndReturn(destination, errorChunks[i]);
            errorChunks.splice(0, i);
        } finally{
            request.flushScheduled = !1, currentView && 0 < writtenBytes && (destination.enqueue(new Uint8Array(currentView.buffer, 0, writtenBytes)), currentView = null, writtenBytes = 0);
        }
    }
    0 === request.pendingChunks && (12 > request.status && request.cacheController.abort(Error("This render completed successfully. All cacheSignals are now aborted to allow clean up of any unused resources.")), null !== request.destination && (request.status = 14, request.destination.close(), request.destination = null));
}
function startWork(request) {
    request.flushScheduled = null !== request.destination;
    supportsRequestStorage ? scheduleMicrotask(function() {
        requestStorage.run(request, performWork, request);
    }) : scheduleMicrotask(function() {
        return performWork(request);
    });
    setTimeout(function() {
        10 === request.status && (request.status = 11);
    }, 0);
}
function enqueueFlush(request) {
    !1 === request.flushScheduled && 0 === request.pingedTasks.length && null !== request.destination && (request.flushScheduled = !0, setTimeout(function() {
        request.flushScheduled = !1;
        flushCompletedChunks(request);
    }, 0));
}
function callOnAllReadyIfReady(request) {
    0 === request.abortableTasks.size && (request = request.onAllReady, request());
}
function startFlowing(request, destination) {
    if (13 === request.status) request.status = 14, closeWithError(destination, request.fatalError);
    else if (14 !== request.status && null === request.destination) {
        request.destination = destination;
        try {
            flushCompletedChunks(request);
        } catch (error) {
            logRecoverableError(request, error, null), fatalError(request, error);
        }
    }
}
function finishAbort(request, abortedTasks, errorId) {
    try {
        abortedTasks.forEach(function(task) {
            return finishAbortedTask(task, request, errorId);
        });
        var onAllReady = request.onAllReady;
        onAllReady();
        flushCompletedChunks(request);
    } catch (error) {
        logRecoverableError(request, error, null), fatalError(request, error);
    }
}
function abort(request, reason) {
    if (!(11 < request.status)) try {
        request.status = 12;
        request.cacheController.abort(reason);
        var abortableTasks = request.abortableTasks;
        if (0 < abortableTasks.size) {
            var error = void 0 === reason ? Error("The render was aborted by the server without a reason.") : "object" === typeof reason && null !== reason && "function" === typeof reason.then ? Error("The render was aborted by the server with a promise.") : reason, digest = logRecoverableError(request, error, null), errorId = request.nextChunkId++;
            request.fatalError = errorId;
            request.pendingChunks++;
            emitErrorChunk(request, errorId, digest, error, !1);
            abortableTasks.forEach(function(task) {
                return abortTask(task, request, errorId);
            });
            setTimeout(function() {
                return finishAbort(request, abortableTasks, errorId);
            }, 0);
        } else {
            var onAllReady = request.onAllReady;
            onAllReady();
            flushCompletedChunks(request);
        }
    } catch (error$23) {
        logRecoverableError(request, error$23, null), fatalError(request, error$23);
    }
}
function Chunk(status, value, reason, response) {
    this.status = status;
    this.value = value;
    this.reason = reason;
    this._response = response;
}
Chunk.prototype = Object.create(Promise.prototype);
Chunk.prototype.then = function(resolve, reject) {
    switch(this.status){
        case "resolved_model":
            initializeModelChunk(this);
    }
    switch(this.status){
        case "fulfilled":
            resolve(this.value);
            break;
        case "pending":
        case "blocked":
        case "cyclic":
            resolve && (null === this.value && (this.value = []), this.value.push(resolve));
            reject && (null === this.reason && (this.reason = []), this.reason.push(reject));
            break;
        default:
            reject(this.reason);
    }
};
function createPendingChunk(response) {
    return new Chunk("pending", null, null, response);
}
function wakeChunk(listeners, value) {
    for(var i = 0; i < listeners.length; i++)(0, listeners[i])(value);
}
function triggerErrorOnChunk(chunk, error) {
    if ("pending" !== chunk.status && "blocked" !== chunk.status) chunk.reason.error(error);
    else {
        var listeners = chunk.reason;
        chunk.status = "rejected";
        chunk.reason = error;
        null !== listeners && wakeChunk(listeners, error);
    }
}
function resolveModelChunk(chunk, value, id) {
    if ("pending" !== chunk.status) chunk = chunk.reason, "C" === value[0] ? chunk.close("C" === value ? '"$undefined"' : value.slice(1)) : chunk.enqueueModel(value);
    else {
        var resolveListeners = chunk.value, rejectListeners = chunk.reason;
        chunk.status = "resolved_model";
        chunk.value = value;
        chunk.reason = id;
        if (null !== resolveListeners) switch(initializeModelChunk(chunk), chunk.status){
            case "fulfilled":
                wakeChunk(resolveListeners, chunk.value);
                break;
            case "pending":
            case "blocked":
            case "cyclic":
                if (chunk.value) for(value = 0; value < resolveListeners.length; value++)chunk.value.push(resolveListeners[value]);
                else chunk.value = resolveListeners;
                if (chunk.reason) {
                    if (rejectListeners) for(value = 0; value < rejectListeners.length; value++)chunk.reason.push(rejectListeners[value]);
                } else chunk.reason = rejectListeners;
                break;
            case "rejected":
                rejectListeners && wakeChunk(rejectListeners, chunk.reason);
        }
    }
}
function createResolvedIteratorResultChunk(response, value, done) {
    return new Chunk("resolved_model", (done ? '{"done":true,"value":' : '{"done":false,"value":') + value + "}", -1, response);
}
function resolveIteratorResultChunk(chunk, value, done) {
    resolveModelChunk(chunk, (done ? '{"done":true,"value":' : '{"done":false,"value":') + value + "}", -1);
}
function loadServerReference$1(response, id, bound, parentChunk, parentObject, key) {
    var serverReference = resolveServerReference(response._bundlerConfig, id);
    id = preloadModule$1(serverReference);
    if (bound) bound = Promise.all([
        bound,
        id
    ]).then(function(_ref) {
        _ref = _ref[0];
        var fn = requireModule(serverReference);
        return fn.bind.apply(fn, [
            null
        ].concat(_ref));
    });
    else if (id) bound = Promise.resolve(id).then(function() {
        return requireModule(serverReference);
    });
    else return requireModule(serverReference);
    bound.then(createModelResolver(parentChunk, parentObject, key, !1, response, createModel, []), createModelReject(parentChunk));
    return null;
}
function reviveModel(response, parentObj, parentKey, value, reference) {
    if ("string" === typeof value) return parseModelString(response, parentObj, parentKey, value, reference);
    if ("object" === typeof value && null !== value) {
        if (void 0 !== reference && void 0 !== response._temporaryReferences && response._temporaryReferences.set(value, reference), Array.isArray(value)) for(var i = 0; i < value.length; i++)value[i] = reviveModel(response, value, "" + i, value[i], void 0 !== reference ? reference + ":" + i : void 0);
        else for(i in value)hasOwnProperty.call(value, i) && (parentObj = void 0 !== reference && -1 === i.indexOf(":") ? reference + ":" + i : void 0, parentObj = reviveModel(response, value, i, value[i], parentObj), void 0 !== parentObj ? value[i] = parentObj : delete value[i]);
    }
    return value;
}
var initializingChunk = null, initializingChunkBlockedModel = null;
function initializeModelChunk(chunk) {
    var prevChunk = initializingChunk, prevBlocked = initializingChunkBlockedModel;
    initializingChunk = chunk;
    initializingChunkBlockedModel = null;
    var rootReference = -1 === chunk.reason ? void 0 : chunk.reason.toString(16), resolvedModel = chunk.value;
    chunk.status = "cyclic";
    chunk.value = null;
    chunk.reason = null;
    try {
        var rawModel = JSON.parse(resolvedModel), value = reviveModel(chunk._response, {
            "": rawModel
        }, "", rawModel, rootReference);
        if (null !== initializingChunkBlockedModel && 0 < initializingChunkBlockedModel.deps) initializingChunkBlockedModel.value = value, chunk.status = "blocked";
        else {
            var resolveListeners = chunk.value;
            chunk.status = "fulfilled";
            chunk.value = value;
            null !== resolveListeners && wakeChunk(resolveListeners, value);
        }
    } catch (error) {
        chunk.status = "rejected", chunk.reason = error;
    } finally{
        initializingChunk = prevChunk, initializingChunkBlockedModel = prevBlocked;
    }
}
function reportGlobalError(response, error) {
    response._closed = !0;
    response._closedReason = error;
    response._chunks.forEach(function(chunk) {
        "pending" === chunk.status && triggerErrorOnChunk(chunk, error);
    });
}
function getChunk(response, id) {
    var chunks = response._chunks, chunk = chunks.get(id);
    chunk || (chunk = response._formData.get(response._prefix + id), chunk = null != chunk ? new Chunk("resolved_model", chunk, id, response) : response._closed ? new Chunk("rejected", null, response._closedReason, response) : createPendingChunk(response), chunks.set(id, chunk));
    return chunk;
}
function createModelResolver(chunk, parentObject, key, cyclic, response, map, path) {
    if (initializingChunkBlockedModel) {
        var blocked = initializingChunkBlockedModel;
        cyclic || blocked.deps++;
    } else blocked = initializingChunkBlockedModel = {
        deps: cyclic ? 0 : 1,
        value: null
    };
    return function(value) {
        for(var i = 1; i < path.length; i++)value = value[path[i]];
        parentObject[key] = map(response, value);
        "" === key && null === blocked.value && (blocked.value = parentObject[key]);
        blocked.deps--;
        0 === blocked.deps && "blocked" === chunk.status && (value = chunk.value, chunk.status = "fulfilled", chunk.value = blocked.value, null !== value && wakeChunk(value, blocked.value));
    };
}
function createModelReject(chunk) {
    return function(error) {
        return triggerErrorOnChunk(chunk, error);
    };
}
function getOutlinedModel(response, reference, parentObject, key, map) {
    reference = reference.split(":");
    var id = parseInt(reference[0], 16);
    id = getChunk(response, id);
    switch(id.status){
        case "resolved_model":
            initializeModelChunk(id);
    }
    switch(id.status){
        case "fulfilled":
            parentObject = id.value;
            for(key = 1; key < reference.length; key++)parentObject = parentObject[reference[key]];
            return map(response, parentObject);
        case "pending":
        case "blocked":
        case "cyclic":
            var parentChunk = initializingChunk;
            id.then(createModelResolver(parentChunk, parentObject, key, "cyclic" === id.status, response, map, reference), createModelReject(parentChunk));
            return null;
        default:
            throw id.reason;
    }
}
function createMap(response, model) {
    return new Map(model);
}
function createSet(response, model) {
    return new Set(model);
}
function extractIterator(response, model) {
    return model[Symbol.iterator]();
}
function createModel(response, model) {
    return model;
}
function parseTypedArray(response, reference, constructor, bytesPerElement, parentObject, parentKey) {
    reference = parseInt(reference.slice(2), 16);
    reference = response._formData.get(response._prefix + reference);
    reference = constructor === ArrayBuffer ? reference.arrayBuffer() : reference.arrayBuffer().then(function(buffer) {
        return new constructor(buffer);
    });
    bytesPerElement = initializingChunk;
    reference.then(createModelResolver(bytesPerElement, parentObject, parentKey, !1, response, createModel, []), createModelReject(bytesPerElement));
    return null;
}
function resolveStream(response, id, stream, controller) {
    var chunks = response._chunks;
    stream = new Chunk("fulfilled", stream, controller, response);
    chunks.set(id, stream);
    response = response._formData.getAll(response._prefix + id);
    for(id = 0; id < response.length; id++)chunks = response[id], "C" === chunks[0] ? controller.close("C" === chunks ? '"$undefined"' : chunks.slice(1)) : controller.enqueueModel(chunks);
}
function parseReadableStream(response, reference, type) {
    reference = parseInt(reference.slice(2), 16);
    var controller = null;
    type = new ReadableStream({
        type: type,
        start: function(c) {
            controller = c;
        }
    });
    var previousBlockedChunk = null;
    resolveStream(response, reference, type, {
        enqueueModel: function(json) {
            if (null === previousBlockedChunk) {
                var chunk = new Chunk("resolved_model", json, -1, response);
                initializeModelChunk(chunk);
                "fulfilled" === chunk.status ? controller.enqueue(chunk.value) : (chunk.then(function(v) {
                    return controller.enqueue(v);
                }, function(e) {
                    return controller.error(e);
                }), previousBlockedChunk = chunk);
            } else {
                chunk = previousBlockedChunk;
                var chunk$26 = createPendingChunk(response);
                chunk$26.then(function(v) {
                    return controller.enqueue(v);
                }, function(e) {
                    return controller.error(e);
                });
                previousBlockedChunk = chunk$26;
                chunk.then(function() {
                    previousBlockedChunk === chunk$26 && (previousBlockedChunk = null);
                    resolveModelChunk(chunk$26, json, -1);
                });
            }
        },
        close: function() {
            if (null === previousBlockedChunk) controller.close();
            else {
                var blockedChunk = previousBlockedChunk;
                previousBlockedChunk = null;
                blockedChunk.then(function() {
                    return controller.close();
                });
            }
        },
        error: function(error) {
            if (null === previousBlockedChunk) controller.error(error);
            else {
                var blockedChunk = previousBlockedChunk;
                previousBlockedChunk = null;
                blockedChunk.then(function() {
                    return controller.error(error);
                });
            }
        }
    });
    return type;
}
function asyncIterator() {
    return this;
}
function createIterator(next) {
    next = {
        next: next
    };
    next[ASYNC_ITERATOR] = asyncIterator;
    return next;
}
function parseAsyncIterable(response, reference, iterator) {
    reference = parseInt(reference.slice(2), 16);
    var buffer = [], closed = !1, nextWriteIndex = 0, $jscomp$compprop2 = {};
    $jscomp$compprop2 = ($jscomp$compprop2[ASYNC_ITERATOR] = function() {
        var nextReadIndex = 0;
        return createIterator(function(arg) {
            if (void 0 !== arg) throw Error("Values cannot be passed to next() of AsyncIterables passed to Client Components.");
            if (nextReadIndex === buffer.length) {
                if (closed) return new Chunk("fulfilled", {
                    done: !0,
                    value: void 0
                }, null, response);
                buffer[nextReadIndex] = createPendingChunk(response);
            }
            return buffer[nextReadIndex++];
        });
    }, $jscomp$compprop2);
    iterator = iterator ? $jscomp$compprop2[ASYNC_ITERATOR]() : $jscomp$compprop2;
    resolveStream(response, reference, iterator, {
        enqueueModel: function(value) {
            nextWriteIndex === buffer.length ? buffer[nextWriteIndex] = createResolvedIteratorResultChunk(response, value, !1) : resolveIteratorResultChunk(buffer[nextWriteIndex], value, !1);
            nextWriteIndex++;
        },
        close: function(value) {
            closed = !0;
            nextWriteIndex === buffer.length ? buffer[nextWriteIndex] = createResolvedIteratorResultChunk(response, value, !0) : resolveIteratorResultChunk(buffer[nextWriteIndex], value, !0);
            for(nextWriteIndex++; nextWriteIndex < buffer.length;)resolveIteratorResultChunk(buffer[nextWriteIndex++], '"$undefined"', !0);
        },
        error: function(error) {
            closed = !0;
            for(nextWriteIndex === buffer.length && (buffer[nextWriteIndex] = createPendingChunk(response)); nextWriteIndex < buffer.length;)triggerErrorOnChunk(buffer[nextWriteIndex++], error);
        }
    });
    return iterator;
}
function parseModelString(response, obj, key, value, reference) {
    if ("$" === value[0]) {
        switch(value[1]){
            case "$":
                return value.slice(1);
            case "@":
                return obj = parseInt(value.slice(2), 16), getChunk(response, obj);
            case "F":
                return value = value.slice(2), value = getOutlinedModel(response, value, obj, key, createModel), loadServerReference$1(response, value.id, value.bound, initializingChunk, obj, key);
            case "T":
                if (void 0 === reference || void 0 === response._temporaryReferences) throw Error("Could not reference an opaque temporary reference. This is likely due to misconfiguring the temporaryReferences options on the server.");
                return createTemporaryReference(response._temporaryReferences, reference);
            case "Q":
                return value = value.slice(2), getOutlinedModel(response, value, obj, key, createMap);
            case "W":
                return value = value.slice(2), getOutlinedModel(response, value, obj, key, createSet);
            case "K":
                obj = value.slice(2);
                var formPrefix = response._prefix + obj + "_", data = new FormData();
                response._formData.forEach(function(entry, entryKey) {
                    entryKey.startsWith(formPrefix) && data.append(entryKey.slice(formPrefix.length), entry);
                });
                return data;
            case "i":
                return value = value.slice(2), getOutlinedModel(response, value, obj, key, extractIterator);
            case "I":
                return Infinity;
            case "-":
                return "$-0" === value ? -0 : -Infinity;
            case "N":
                return NaN;
            case "u":
                return;
            case "D":
                return new Date(Date.parse(value.slice(2)));
            case "n":
                return BigInt(value.slice(2));
        }
        switch(value[1]){
            case "A":
                return parseTypedArray(response, value, ArrayBuffer, 1, obj, key);
            case "O":
                return parseTypedArray(response, value, Int8Array, 1, obj, key);
            case "o":
                return parseTypedArray(response, value, Uint8Array, 1, obj, key);
            case "U":
                return parseTypedArray(response, value, Uint8ClampedArray, 1, obj, key);
            case "S":
                return parseTypedArray(response, value, Int16Array, 2, obj, key);
            case "s":
                return parseTypedArray(response, value, Uint16Array, 2, obj, key);
            case "L":
                return parseTypedArray(response, value, Int32Array, 4, obj, key);
            case "l":
                return parseTypedArray(response, value, Uint32Array, 4, obj, key);
            case "G":
                return parseTypedArray(response, value, Float32Array, 4, obj, key);
            case "g":
                return parseTypedArray(response, value, Float64Array, 8, obj, key);
            case "M":
                return parseTypedArray(response, value, BigInt64Array, 8, obj, key);
            case "m":
                return parseTypedArray(response, value, BigUint64Array, 8, obj, key);
            case "V":
                return parseTypedArray(response, value, DataView, 1, obj, key);
            case "B":
                return obj = parseInt(value.slice(2), 16), response._formData.get(response._prefix + obj);
        }
        switch(value[1]){
            case "R":
                return parseReadableStream(response, value, void 0);
            case "r":
                return parseReadableStream(response, value, "bytes");
            case "X":
                return parseAsyncIterable(response, value, !1);
            case "x":
                return parseAsyncIterable(response, value, !0);
        }
        value = value.slice(1);
        return getOutlinedModel(response, value, obj, key, createModel);
    }
    return value;
}
function createResponse(bundlerConfig, formFieldPrefix, temporaryReferences) {
    var backingFormData = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : new FormData(), chunks = new Map();
    return {
        _bundlerConfig: bundlerConfig,
        _prefix: formFieldPrefix,
        _formData: backingFormData,
        _chunks: chunks,
        _closed: !1,
        _closedReason: null,
        _temporaryReferences: temporaryReferences
    };
}
function close(response) {
    reportGlobalError(response, Error("Connection closed."));
}
function loadServerReference(bundlerConfig, id, bound) {
    var serverReference = resolveServerReference(bundlerConfig, id);
    bundlerConfig = preloadModule$1(serverReference);
    return bound ? Promise.all([
        bound,
        bundlerConfig
    ]).then(function(_ref) {
        _ref = _ref[0];
        var fn = requireModule(serverReference);
        return fn.bind.apply(fn, [
            null
        ].concat(_ref));
    }) : bundlerConfig ? Promise.resolve(bundlerConfig).then(function() {
        return requireModule(serverReference);
    }) : Promise.resolve(requireModule(serverReference));
}
function decodeBoundActionMetaData(body, serverManifest, formFieldPrefix) {
    body = createResponse(serverManifest, formFieldPrefix, void 0, body);
    close(body);
    body = getChunk(body, 0);
    body.then(function() {});
    if ("fulfilled" !== body.status) throw body.reason;
    return body.value;
}
function decodeAction$1(body, serverManifest) {
    var formData = new FormData(), action = null;
    body.forEach(function(value, key) {
        key.startsWith("$ACTION_") ? key.startsWith("$ACTION_REF_") ? (value = "$ACTION_" + key.slice(12) + ":", value = decodeBoundActionMetaData(body, serverManifest, value), action = loadServerReference(serverManifest, value.id, value.bound)) : key.startsWith("$ACTION_ID_") && (value = key.slice(11), action = loadServerReference(serverManifest, value, null)) : formData.append(key, value);
    });
    return null === action ? null : action.then(function(fn) {
        return fn.bind(null, formData);
    });
}
function decodeFormState$1(actionResult, body, serverManifest) {
    var keyPath = body.get("$ACTION_KEY");
    if ("string" !== typeof keyPath) return Promise.resolve(null);
    var metaData = null;
    body.forEach(function(value, key) {
        key.startsWith("$ACTION_REF_") && (value = "$ACTION_" + key.slice(12) + ":", metaData = decodeBoundActionMetaData(body, serverManifest, value));
    });
    if (null === metaData) return Promise.resolve(null);
    var referenceId = metaData.id;
    return Promise.resolve(metaData.bound).then(function(bound) {
        return null === bound ? null : [
            actionResult,
            keyPath,
            referenceId,
            bound.length - 1
        ];
    });
}
var serverManifest = {};
exports.createClientReference = function(id, exportName, bundles, importMap) {
    return {
        $$typeof: CLIENT_REFERENCE_TAG$1,
        $$id: id,
        $$name: exportName,
        $$bundles: bundles,
        $$importMap: importMap
    };
};
exports.createTemporaryReferenceSet = function() {
    return new WeakMap();
};
exports.decodeAction = function(body) {
    return decodeAction$1(body, serverManifest);
};
exports.decodeFormState = function(actionResult, body) {
    return decodeFormState$1(actionResult, body, serverManifest);
};
exports.decodeReply = function(body, options) {
    if ("string" === typeof body) {
        var form = new FormData();
        form.append("0", body);
        body = form;
    }
    body = createResponse(serverManifest, "", options ? options.temporaryReferences : void 0, body);
    options = getChunk(body, 0);
    close(body);
    return options;
};
exports.decodeReplyFromAsyncIterable = function(iterable, options) {
    function progress(entry) {
        if (entry.done) close(response);
        else {
            entry = entry.value;
            var name = entry[0];
            entry = entry[1];
            if ("string" === typeof entry) {
                response._formData.append(name, entry);
                var prefix = response._prefix;
                if (name.startsWith(prefix)) {
                    var chunks = response._chunks;
                    name = +name.slice(prefix.length);
                    (chunks = chunks.get(name)) && resolveModelChunk(chunks, entry, name);
                }
            } else response._formData.append(name, entry);
            iterator.next().then(progress, error);
        }
    }
    function error(reason) {
        reportGlobalError(response, reason);
        "function" === typeof iterator.throw && iterator.throw(reason).then(error, error);
    }
    var iterator = iterable[ASYNC_ITERATOR](), response = createResponse(serverManifest, "", options ? options.temporaryReferences : void 0);
    iterator.next().then(progress, error);
    return getChunk(response, 0);
};
exports.loadServerAction = function(id) {
    var reference = resolveServerReference(serverManifest, id);
    return Promise.resolve(reference).then(function() {
        return preloadModule$1(reference);
    }).then(function() {
        var fn = requireModule(reference);
        if ("function" !== typeof fn) throw Error("Server actions must be functions");
        return fn;
    });
};
exports.registerServerActions = function(manifest) {
    serverManifest = manifest;
};
exports.registerServerReference = function(reference, id, exportName) {
    return Object.defineProperties(reference, {
        $$typeof: {
            value: SERVER_REFERENCE_TAG
        },
        $$id: {
            value: id + "#" + exportName,
            configurable: !0
        },
        $$bound: {
            value: null,
            configurable: !0
        },
        bind: {
            value: bind,
            configurable: !0
        }
    });
};
exports.renderToReadableStream = function(model, options) {
    var request = new RequestInstance(20, model, null, options ? options.onError : void 0, options ? options.onPostpone : void 0, noop, noop, options ? options.identifierPrefix : void 0, options ? options.temporaryReferences : void 0);
    if (options && options.signal) {
        var signal = options.signal;
        if (signal.aborted) abort(request, signal.reason);
        else {
            var listener = function() {
                abort(request, signal.reason);
                signal.removeEventListener("abort", listener);
            };
            signal.addEventListener("abort", listener);
        }
    }
    return new ReadableStream({
        type: "bytes",
        start: function() {
            startWork(request);
        },
        pull: function(controller) {
            startFlowing(request, controller);
        },
        cancel: function(reason) {
            request.destination = null;
            abort(request, reason);
        }
    }, {
        highWaterMark: 0
    });
};
exports.unstable_prerender = function(model, options) {
    return new Promise(function(resolve, reject) {
        var request = new RequestInstance(21, model, null, options ? options.onError : void 0, options ? options.onPostpone : void 0, function() {
            var stream = new ReadableStream({
                type: "bytes",
                pull: function(controller) {
                    startFlowing(request, controller);
                },
                cancel: function(reason) {
                    request.destination = null;
                    abort(request, reason);
                }
            }, {
                highWaterMark: 0
            });
            resolve({
                prelude: stream
            });
        }, reject, options ? options.identifierPrefix : void 0, options ? options.temporaryReferences : void 0);
        if (options && options.signal) {
            var signal = options.signal;
            if (signal.aborted) abort(request, signal.reason);
            else {
                var listener = function() {
                    abort(request, signal.reason);
                    signal.removeEventListener("abort", listener);
                };
                signal.addEventListener("abort", listener);
            }
        }
        startWork(request);
    });
};

},{"2381f0f3ff03ff95":"gC2PC","6db66a729b66b575":"a1TxN"}],"gC2PC":[function(require,module,exports,__globalThis) {
'use strict';
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("b657abac8afb5bb8");

},{"b657abac8afb5bb8":"c4Fud"}],"c4Fud":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var React = require("6a05e75e64e4f862");
function formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function noop() {}
var Internals = {
    d: {
        f: noop,
        r: function() {
            throw Error(formatProdErrorMessage(522));
        },
        D: noop,
        C: noop,
        L: noop,
        m: noop,
        X: noop,
        S: noop,
        M: noop
    },
    p: 0,
    findDOMNode: null
}, REACT_PORTAL_TYPE = Symbol.for("react.portal");
function createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var ReactSharedInternals = React.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
exports.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = Internals;
exports.createPortal = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error(formatProdErrorMessage(299));
    return createPortal$1(children, container, null, key);
};
exports.flushSync = function(fn) {
    var previousTransition = ReactSharedInternals.T, previousUpdatePriority = Internals.p;
    try {
        if (ReactSharedInternals.T = null, Internals.p = 2, fn) return fn();
    } finally{
        ReactSharedInternals.T = previousTransition, Internals.p = previousUpdatePriority, Internals.d.f();
    }
};
exports.preconnect = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, Internals.d.C(href, options));
};
exports.prefetchDNS = function(href) {
    "string" === typeof href && Internals.d.D(href);
};
exports.preinit = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
exports.preinitModule = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = getCrossOriginStringAs(options.as, options.crossOrigin);
                Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && Internals.d.M(href);
    }
};
exports.preload = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = getCrossOriginStringAs(as, options.crossOrigin);
        Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
exports.preloadModule = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = getCrossOriginStringAs(options.as, options.crossOrigin);
            Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else Internals.d.m(href);
    }
};
exports.requestFormReset = function(form) {
    Internals.d.r(form);
};
exports.unstable_batchedUpdates = function(fn, a) {
    return fn(a);
};
exports.useFormState = function(action, initialState, permalink) {
    return ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
exports.useFormStatus = function() {
    return ReactSharedInternals.H.useHostTransitionStatus();
};
exports.version = "19.1.0";

},{"6a05e75e64e4f862":"a1TxN"}],"a1TxN":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("1803ac46c34b822c");

},{"1803ac46c34b822c":"4tF2f"}],"4tF2f":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, assign = Object.assign, emptyObject = {};
function Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = emptyObject;
    this.updater = updater || ReactNoopUpdateQueue;
}
Component.prototype.isReactComponent = {};
Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function ComponentDummy() {}
ComponentDummy.prototype = Component.prototype;
function PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = emptyObject;
    this.updater = updater || ReactNoopUpdateQueue;
}
var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
pureComponentPrototype.constructor = PureComponent;
assign(pureComponentPrototype, Component.prototype);
pureComponentPrototype.isPureReactComponent = !0;
var isArrayImpl = Array.isArray, ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null,
    V: null
}, hasOwnProperty = Object.prototype.hasOwnProperty;
function ReactElement(type, key, self, source, owner, props) {
    self = props.ref;
    return {
        $$typeof: REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== self ? self : null,
        props: props
    };
}
function cloneAndReplaceKey(oldElement, newKey) {
    return ReactElement(oldElement.type, newKey, void 0, void 0, void 0, oldElement.props);
}
function isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
}
function escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var userProvidedKeyEscapeRegex = /\/+/g;
function getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? escape("" + element.key) : index.toString(36);
}
function noop$1() {}
function resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then(noop$1, noop$1) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case REACT_ELEMENT_TYPE:
                case REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case REACT_LAZY_TYPE:
                    return invokeCallback = children._init, mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + getElementKey(children, 0) : nameSoFar, isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace(userProvidedKeyEscapeRegex, "$&/") + "/"), mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && (isValidElement(callback) && (callback = cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace(userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if (isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + getElementKey(nameSoFar, i), invokeCallback += mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + getElementKey(nameSoFar, i++), invokeCallback += mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return mapIntoArray(resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function noop() {}
exports.Children = {
    map: mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
exports.Component = Component;
exports.Fragment = REACT_FRAGMENT_TYPE;
exports.Profiler = REACT_PROFILER_TYPE;
exports.PureComponent = PureComponent;
exports.StrictMode = REACT_STRICT_MODE_TYPE;
exports.Suspense = REACT_SUSPENSE_TYPE;
exports.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = ReactSharedInternals;
exports.__COMPILER_RUNTIME = {
    __proto__: null,
    c: function(size) {
        return ReactSharedInternals.H.useMemoCache(size);
    }
};
exports.cache = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
exports.cloneElement = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = assign({}, element.props), key = element.key, owner = void 0;
    if (null != config) for(propName in void 0 !== config.ref && (owner = void 0), void 0 !== config.key && (key = "" + config.key), config)!hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return ReactElement(element.type, key, void 0, void 0, owner, props);
};
exports.createContext = function(defaultValue) {
    defaultValue = {
        $$typeof: REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
exports.createElement = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return ReactElement(type, key, void 0, void 0, null, props);
};
exports.createRef = function() {
    return {
        current: null
    };
};
exports.forwardRef = function(render) {
    return {
        $$typeof: REACT_FORWARD_REF_TYPE,
        render: render
    };
};
exports.isValidElement = isValidElement;
exports.lazy = function(ctor) {
    return {
        $$typeof: REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: lazyInitializer
    };
};
exports.memo = function(type, compare) {
    return {
        $$typeof: REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
exports.startTransition = function(scope) {
    var prevTransition = ReactSharedInternals.T, currentTransition = {};
    ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then(noop, reportGlobalError);
    } catch (error) {
        reportGlobalError(error);
    } finally{
        ReactSharedInternals.T = prevTransition;
    }
};
exports.unstable_useCacheRefresh = function() {
    return ReactSharedInternals.H.useCacheRefresh();
};
exports.use = function(usable) {
    return ReactSharedInternals.H.use(usable);
};
exports.useActionState = function(action, initialState, permalink) {
    return ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
exports.useCallback = function(callback, deps) {
    return ReactSharedInternals.H.useCallback(callback, deps);
};
exports.useContext = function(Context) {
    return ReactSharedInternals.H.useContext(Context);
};
exports.useDebugValue = function() {};
exports.useDeferredValue = function(value, initialValue) {
    return ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
exports.useEffect = function(create, createDeps, update) {
    var dispatcher = ReactSharedInternals.H;
    if ("function" === typeof update) throw Error("useEffect CRUD overload is not enabled in this build of React.");
    return dispatcher.useEffect(create, createDeps);
};
exports.useId = function() {
    return ReactSharedInternals.H.useId();
};
exports.useImperativeHandle = function(ref, create, deps) {
    return ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
exports.useInsertionEffect = function(create, deps) {
    return ReactSharedInternals.H.useInsertionEffect(create, deps);
};
exports.useLayoutEffect = function(create, deps) {
    return ReactSharedInternals.H.useLayoutEffect(create, deps);
};
exports.useMemo = function(create, deps) {
    return ReactSharedInternals.H.useMemo(create, deps);
};
exports.useOptimistic = function(passthrough, reducer) {
    return ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
exports.useReducer = function(reducer, initialArg, init) {
    return ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
exports.useRef = function(initialValue) {
    return ReactSharedInternals.H.useRef(initialValue);
};
exports.useState = function(initialState) {
    return ReactSharedInternals.H.useState(initialState);
};
exports.useSyncExternalStore = function(subscribe, getSnapshot, getServerSnapshot) {
    return ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
exports.useTransition = function() {
    return ReactSharedInternals.H.useTransition();
};
exports.version = "19.1.0";

},{}],"5lOkR":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SearchFieldContext", ()=>SearchFieldContext);
parcelHelpers.export(exports, "SearchField", ()=>SearchField);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _centerBaseline = require("./CenterBaseline");
var _clearButton = require("./ClearButton");
var _react = require("react");
var _utils = require("@react-spectrum/utils");
var _field = require("./Field");
var _form = require("./Form");
var _icon = require("./Icon");
var _s2IconSearch20NSvg = require("../s2wf-icons/S2_Icon_Search_20_N.svg");
var _s2IconSearch20NSvgDefault = parcelHelpers.interopDefault(_s2IconSearch20NSvg);
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const SearchFieldContext = /*#__PURE__*/ (0, _react.createContext)(null);
const SearchField = /*#__PURE__*/ (0, _react.forwardRef)(function SearchField(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, SearchFieldContext);
    let formContext = (0, _react.useContext)((0, _form.FormContext));
    props = (0, _form.useFormProps)(props);
    let { label, description, errorMessage, necessityIndicator, labelPosition = 'top', labelAlign = 'start', UNSAFE_className = '', UNSAFE_style, ...searchFieldProps } = props;
    let domRef = (0, _react.useRef)(null);
    let inputRef = (0, _react.useRef)(null);
    // Expose imperative interface for ref
    (0, _react.useImperativeHandle)(ref, ()=>({
            ...(0, _utils.createFocusableRef)(domRef, inputRef),
            select () {
                if (inputRef.current) inputRef.current.select();
            },
            getInputElement () {
                return inputRef.current;
            }
        }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.SearchField), {
        ...searchFieldProps,
        ref: domRef,
        style: UNSAFE_style,
        className: UNSAFE_className + function anonymous(props, overrides) {
            let rules = " ", currentRules = {};
            let gridColumnStart = false;
            let gridColumnEnd = false;
            let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L|-macro\$)[^\s]+/g);
            for (let p of matches){
                if (p[1] === "z") gridColumnStart = true;
                if (p[1] === "y") gridColumnEnd = true;
                rules += p[0];
            }
            rules += ' se12';
            currentRules["display"] = "grid";
            if (props.isInForm) {
                if (!gridColumnStart) rules += ' z2mU12';
                currentRules["gridColumnStart"] = typeof currentRules["gridColumnStart"] === 'object' ? currentRules["gridColumnStart"] : {
                    "default": currentRules["gridColumnStart"]
                };
                currentRules["gridColumnStart"]["isInForm"] = 1;
            }
            if (props.isInForm) {
                if (props.labelPosition === "side") {
                    if (!gridColumnEnd) rules += ' yvoofG12';
                    currentRules["gridColumnEnd"] = typeof currentRules["gridColumnEnd"] === 'object' ? currentRules["gridColumnEnd"] : {
                        "default": currentRules["gridColumnEnd"]
                    };
                    currentRules["gridColumnEnd"]["isInForm && labelPosition === \"side\""] = "span 2";
                }
            }
            if (props.isInForm) {
                rules += ' DLwlgod12';
                currentRules["gridTemplateColumns"] = typeof currentRules["gridTemplateColumns"] === 'object' ? currentRules["gridTemplateColumns"] : {
                    "default": currentRules["gridTemplateColumns"]
                };
                currentRules["gridTemplateColumns"]["isInForm"] = "subgrid";
            } else {
                if (props.labelPosition === "side") {
                    rules += ' DPlN5qb12';
                    currentRules["gridTemplateColumns"] = typeof currentRules["gridTemplateColumns"] === 'object' ? currentRules["gridTemplateColumns"] : {
                        "default": currentRules["gridTemplateColumns"]
                    };
                    currentRules["gridTemplateColumns"]["labelPosition === \"side\""] = [
                        "auto",
                        "1fr"
                    ];
                } else if (props.labelPosition === "top") {
                    rules += ' DM8Mfn12';
                    currentRules["gridTemplateColumns"] = typeof currentRules["gridTemplateColumns"] === 'object' ? currentRules["gridTemplateColumns"] : {
                        "default": currentRules["gridTemplateColumns"]
                    };
                    currentRules["gridTemplateColumns"]["labelPosition === \"top\""] = [
                        "1fr"
                    ];
                }
            }
            if (props.labelPosition === "side") {
                rules += ' EPlN5qb12';
                currentRules["gridTemplateRows"] = typeof currentRules["gridTemplateRows"] === 'object' ? currentRules["gridTemplateRows"] : {
                    "default": currentRules["gridTemplateRows"]
                };
                currentRules["gridTemplateRows"]["labelPosition === \"side\""] = [
                    "auto",
                    "1fr"
                ];
            } else if (props.labelPosition === "top") {
                rules += ' E4w1sLc12';
                currentRules["gridTemplateRows"] = typeof currentRules["gridTemplateRows"] === 'object' ? currentRules["gridTemplateRows"] : {
                    "default": currentRules["gridTemplateRows"]
                };
                currentRules["gridTemplateRows"]["labelPosition === \"top\""] = [
                    "auto",
                    "1fr",
                    "auto"
                ];
            }
            if (props.labelPosition === "side") {
                rules += ' CbRM95c12';
                currentRules["gridTemplateAreas"] = typeof currentRules["gridTemplateAreas"] === 'object' ? currentRules["gridTemplateAreas"] : {
                    "default": currentRules["gridTemplateAreas"]
                };
                currentRules["gridTemplateAreas"]["labelPosition === \"side\""] = [
                    "label input",
                    "label helptext"
                ];
            } else if (props.labelPosition === "top") {
                rules += ' Cxaocre12';
                currentRules["gridTemplateAreas"] = typeof currentRules["gridTemplateAreas"] === 'object' ? currentRules["gridTemplateAreas"] : {
                    "default": currentRules["gridTemplateAreas"]
                };
                currentRules["gridTemplateAreas"]["labelPosition === \"top\""] = [
                    "label",
                    "input",
                    "helptext"
                ];
            }
            if (props.size === "XL") {
                rules += ' -_6BNtrc-e12';
                currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
                    "default": currentRules["fontSize"]
                };
                currentRules["fontSize"]["size === \"XL\""] = "ui-xl";
                rules += ' vx12';
                currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
                    "default": currentRules["fontSize"]
                };
                currentRules["fontSize"]["size === \"XL\""] = "ui-xl";
            } else if (props.size === "L") {
                rules += ' -_6BNtrc-d12';
                currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
                    "default": currentRules["fontSize"]
                };
                currentRules["fontSize"]["size === \"L\""] = "ui-lg";
                rules += ' vx12';
                currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
                    "default": currentRules["fontSize"]
                };
                currentRules["fontSize"]["size === \"L\""] = "ui-lg";
            } else if (props.size === "S") {
                rules += ' -_6BNtrc-b12';
                currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
                    "default": currentRules["fontSize"]
                };
                currentRules["fontSize"]["size === \"S\""] = "ui-sm";
                rules += ' vx12';
                currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
                    "default": currentRules["fontSize"]
                };
                currentRules["fontSize"]["size === \"S\""] = "ui-sm";
            } else if (props.size === "XS") {
                rules += ' -_6BNtrc-a12';
                currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
                    "default": currentRules["fontSize"]
                };
                currentRules["fontSize"]["size === \"XS\""] = "ui-xs";
                rules += ' vx12';
                currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
                    "default": currentRules["fontSize"]
                };
                currentRules["fontSize"]["size === \"XS\""] = "ui-xs";
            } else {
                rules += ' -_6BNtrc-c12';
                currentRules["fontSize"] = "ui";
                rules += ' vx12';
                currentRules["fontSize"] = "ui";
            }
            rules += ' ea12';
            currentRules["alignItems"] = "baseline";
            rules += ' _Fd12';
            currentRules["lineHeight"] = "ui";
            rules += ' _FezxGHba12';
            currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
                "default": currentRules["lineHeight"]
            };
            currentRules["lineHeight"][":lang(ar, he)"] = "ui";
            rules += ' _FnuYUweb12';
            currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
                "default": currentRules["lineHeight"]
            };
            currentRules["lineHeight"][":lang(ja, ko, zh, zh-Hant, zh-Hans, zh-CN, zh-SG)"] = "ui";
            if (props.size === "XL") {
                rules += ' -BhX7R-Fz12';
                currentRules["--field-height"] = typeof currentRules["--field-height"] === 'object' ? currentRules["--field-height"] : {
                    "default": currentRules["--field-height"]
                };
                currentRules["--field-height"]["size === \"XL\""] = 48;
            } else if (props.size === "L") {
                rules += ' -BhX7R-Fv12';
                currentRules["--field-height"] = typeof currentRules["--field-height"] === 'object' ? currentRules["--field-height"] : {
                    "default": currentRules["--field-height"]
                };
                currentRules["--field-height"]["size === \"L\""] = 40;
            } else if (props.size === "S") {
                rules += ' -BhX7R-Fp12';
                currentRules["--field-height"] = typeof currentRules["--field-height"] === 'object' ? currentRules["--field-height"] : {
                    "default": currentRules["--field-height"]
                };
                currentRules["--field-height"]["size === \"S\""] = 24;
            } else if (props.size === "XS") {
                rules += ' -BhX7R-Fn12';
                currentRules["--field-height"] = typeof currentRules["--field-height"] === 'object' ? currentRules["--field-height"] : {
                    "default": currentRules["--field-height"]
                };
                currentRules["--field-height"]["size === \"XS\""] = 20;
            } else {
                rules += ' -BhX7R-Fx12';
                currentRules["--field-height"] = 32;
            }
            rules += ' -AJjOLd-UVkF0Db12';
            currentRules["--field-gap"] = "[calc((var(--field-height) - self(borderTopWidth, 0px) - self(borderBottomWidth, 0px) - 1lh) / 2)]";
            rules += ' qg12';
            currentRules["columnGap"] = 12;
            rules += ' __ca12';
            currentRules["disableTapHighlight"] = true;
            rules += ' -Qg41Lb-JAxCW0c12';
            currentRules["--iconMargin"] = "[-0.14285714285714285em]";
            if (props.isDisabled) {
                rules += ' pp12';
                currentRules["color"] = typeof currentRules["color"] === 'object' ? currentRules["color"] : {
                    "default": currentRules["color"]
                };
                currentRules["color"]["isDisabled"] = "disabled";
                rules += ' plc12';
                currentRules["color"] = typeof currentRules["color"] === 'object' ? currentRules["color"] : {
                    "default": currentRules["color"]
                };
                currentRules["color"]["isDisabled && forcedColors"] = "GrayText";
            } else {
                if (props.isPressed) {
                    rules += ' po12';
                    currentRules["color"] = typeof currentRules["color"] === 'object' ? currentRules["color"] : {
                        "default": currentRules["color"]
                    };
                    currentRules["color"]["isPressed"] = "neutral:pressed";
                } else if (props.isFocusVisible) {
                    rules += ' po12';
                    currentRules["color"] = typeof currentRules["color"] === 'object' ? currentRules["color"] : {
                        "default": currentRules["color"]
                    };
                    currentRules["color"]["isFocusVisible"] = "neutral:focused";
                } else if (props.isHovered) {
                    rules += ' po12';
                    currentRules["color"] = typeof currentRules["color"] === 'object' ? currentRules["color"] : {
                        "default": currentRules["color"]
                    };
                    currentRules["color"]["isHovered"] = "neutral:hovered";
                } else {
                    rules += ' pt12';
                    currentRules["color"] = "neutral";
                }
            }
            return rules;
        }({
            size: props.size,
            labelPosition,
            isInForm: !!formContext
        }, props.styles),
        children: ({ isDisabled, isInvalid, isEmpty })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    label && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldLabel), {
                        isDisabled: isDisabled,
                        isRequired: props.isRequired,
                        size: props.size,
                        labelPosition: labelPosition,
                        labelAlign: labelAlign,
                        necessityIndicator: necessityIndicator,
                        contextualHelp: props.contextualHelp,
                        children: label
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _field.FieldGroup), {
                        isDisabled: isDisabled,
                        size: props.size,
                        styles: " og12 ng12 kg12 jg12 Sw12 Rd12",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
                                values: [
                                    [
                                        (0, _icon.IconContext),
                                        {
                                            render: (0, _centerBaseline.centerBaseline)({
                                                slot: 'icon',
                                                styles: " _va12 Ht12 Hsu12 -_8sjo0b-t5ZbAob12"
                                            }),
                                            styles: " ZuUmpre12 FuUmpre12 I67logd12"
                                        }
                                    ]
                                ],
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2IconSearch20NSvgDefault.default), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Input), {
                                ref: inputRef,
                                UNSAFE_className: "zc3JFe"
                            }),
                            !isEmpty && !searchFieldProps.isReadOnly && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clearButton.ClearButton), {
                                size: props.size
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.HelpText), {
                        size: props.size,
                        isDisabled: isDisabled,
                        isInvalid: isInvalid,
                        description: description,
                        children: errorMessage
                    })
                ]
            })
    });
});

},{"0":"b77Dk","1":"jMp7P","2":"9bOYc","3":"fRszU","4":"28cig","react/jsx-runtime":"2Is6Z","react-aria-components":[["Provider","bA6Cz"],["SearchField","Uk5yj"]],"./CenterBaseline":"1vpL9","./ClearButton":"iQ1Sx","react":"a1TxN","@react-spectrum/utils":"jqfrX","./Field":"eI7CE","./Form":"cHqN4","./Icon":"jQAJE","../s2wf-icons/S2_Icon_Search_20_N.svg":"cSREm","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"b77Dk":[function() {},{}],"jMp7P":[function() {},{}],"9bOYc":[function() {},{}],"fRszU":[function() {},{}],"28cig":[function() {},{}],"Uk5yj":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SearchFieldContext", ()=>SearchFieldContext);
parcelHelpers.export(exports, "SearchField", ()=>SearchField);
var _reactAria = require("react-aria");
var _button = require("./Button");
var _utils = require("./utils");
var _collections = require("@react-aria/collections");
var _fieldError = require("./FieldError");
var _rspcontexts = require("./RSPContexts");
var _utils1 = require("@react-aria/utils");
var _form = require("./Form");
var _group = require("./Group");
var _input = require("./Input");
var _label = require("./Label");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactStately = require("react-stately");
var _text = require("./Text");
const SearchFieldContext = /*#__PURE__*/ (0, _react.createContext)(null);
const SearchField = /*#__PURE__*/ (0, _collections.createHideableComponent)(function SearchField(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, SearchFieldContext);
    let { validationBehavior: formValidationBehavior } = (0, _utils.useSlottedContext)((0, _form.FormContext)) || {};
    let validationBehavior = props.validationBehavior ?? formValidationBehavior ?? 'native';
    let inputRef = (0, _react.useRef)(null);
    [props, inputRef] = (0, _utils.useContextProps)(props, inputRef, (0, _rspcontexts.FieldInputContext));
    let [labelRef, label] = (0, _utils.useSlot)(!props['aria-label'] && !props['aria-labelledby']);
    let state = (0, _reactStately.useSearchFieldState)({
        ...props,
        validationBehavior
    });
    let { labelProps, inputProps, clearButtonProps, descriptionProps, errorMessageProps, ...validation } = (0, _reactAria.useSearchField)({
        ...(0, _utils.removeDataAttributes)(props),
        label,
        validationBehavior
    }, state, inputRef);
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        values: {
            isEmpty: state.value === '',
            isDisabled: props.isDisabled || false,
            isInvalid: validation.isInvalid || false,
            isReadOnly: props.isReadOnly || false,
            isRequired: props.isRequired || false,
            state
        },
        defaultClassName: 'react-aria-SearchField'
    });
    let DOMProps = (0, _utils1.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...DOMProps,
        ...renderProps,
        ref: ref,
        slot: props.slot || undefined,
        "data-empty": state.value === '' || undefined,
        "data-disabled": props.isDisabled || undefined,
        "data-invalid": validation.isInvalid || undefined,
        "data-readonly": props.isReadOnly || undefined,
        "data-required": props.isRequired || undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                (0, _label.LabelContext),
                {
                    ...labelProps,
                    ref: labelRef
                }
            ],
            [
                (0, _input.InputContext),
                {
                    ...inputProps,
                    ref: inputRef
                }
            ],
            [
                (0, _button.ButtonContext),
                clearButtonProps
            ],
            [
                (0, _text.TextContext),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ],
            [
                (0, _group.GroupContext),
                {
                    isInvalid: validation.isInvalid,
                    isDisabled: props.isDisabled || false
                }
            ],
            [
                (0, _fieldError.FieldErrorContext),
                validation
            ]
        ]
    }, renderProps.children));
});

},{"react-aria":"2czfR","./Button":"9G5XO","./utils":"bA6Cz","@react-aria/collections":"jY1vZ","./FieldError":"algyu","./RSPContexts":"lIerG","@react-aria/utils":"3upVm","./Form":"g7RKA","./Group":"6UspO","./Input":"jU9y1","./Label":"fjKq6","react":"a1TxN","react-stately":"fG7Zj","./Text":"jt9fm","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2czfR":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a search field.
 * @param props - Props for the search field.
 * @param state - State for the search field, as returned by `useSearchFieldState`.
 * @param inputRef - A ref to the input element.
 */ parcelHelpers.export(exports, "useSearchField", ()=>useSearchField);
var _utils = require("@react-aria/utils");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _i18N = require("@react-aria/i18n");
var _textfield = require("@react-aria/textfield");
function useSearchField(props, state, inputRef) {
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-aria/searchfield');
    let { isDisabled, isReadOnly, onSubmit, onClear, type = 'search' } = props;
    let onKeyDown = (e)=>{
        const key = e.key;
        if (key === 'Enter' && (isDisabled || isReadOnly)) e.preventDefault();
        if (isDisabled || isReadOnly) return;
        // for backward compatibility;
        // otherwise, "Enter" on an input would trigger a form submit, the default browser behavior
        if (key === 'Enter' && onSubmit) {
            e.preventDefault();
            onSubmit(state.value);
        }
        if (key === 'Escape') {
            // Also check the inputRef value for the case where the value was set directly on the input element instead of going through
            // the hook
            if (state.value === '' && (!inputRef.current || inputRef.current.value === '')) e.continuePropagation();
            else {
                e.preventDefault();
                state.setValue('');
                if (onClear) onClear();
            }
        }
    };
    let onClearButtonClick = ()=>{
        state.setValue('');
        if (onClear) onClear();
    };
    let onPressStart = ()=>{
        // this is in PressStart for mobile so that touching the clear button doesn't remove focus from
        // the input and close the keyboard
        inputRef.current?.focus();
    };
    let { labelProps, inputProps, descriptionProps, errorMessageProps, ...validation } = (0, _textfield.useTextField)({
        ...props,
        value: state.value,
        onChange: state.setValue,
        onKeyDown: !isReadOnly ? (0, _utils.chain)(onKeyDown, props.onKeyDown) : props.onKeyDown,
        type
    }, inputRef);
    return {
        labelProps,
        inputProps: {
            ...inputProps,
            // already handled by useSearchFieldState
            defaultValue: undefined
        },
        clearButtonProps: {
            'aria-label': stringFormatter.format('Clear search'),
            excludeFromTabOrder: true,
            preventFocusOnPress: true,
            isDisabled: isDisabled || isReadOnly,
            onPress: onClearButtonClick,
            onPressStart
        },
        descriptionProps,
        errorMessageProps,
        ...validation
    };
}

},{"@react-aria/utils":"ij7eS","../intl/*.json":"9Ekzk","@react-aria/i18n":"7lxyl","@react-aria/textfield":"j6sGd","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9Ekzk":[function(require,module,exports,__globalThis) {
const _temp0 = require("ecfc0164cdafbc11");
const _temp1 = require("533820a702a6cc4d");
const _temp2 = require("adc1d07960abb370");
const _temp3 = require("959d90d2e1b8754d");
const _temp4 = require("c7bcb7c68ae4d133");
const _temp5 = require("7592b3baca1e1ab7");
const _temp6 = require("377509ed67276db9");
const _temp7 = require("bcdffd9a74290826");
const _temp8 = require("66f96fbb9c6f57b3");
const _temp9 = require("96660d96c61006f6");
const _temp10 = require("e42562491f0a003a");
const _temp11 = require("b2e319db05a47686");
const _temp12 = require("8c2f9a8959ebc6d8");
const _temp13 = require("5d3c12b049cdb778");
const _temp14 = require("11cc1fb3d7f8c195");
const _temp15 = require("c7097d1ca0fc0d82");
const _temp16 = require("6a0de05d519cdbf5");
const _temp17 = require("9741ebd533b2078c");
const _temp18 = require("406b77d2f3fc3437");
const _temp19 = require("53d9d9bd8feb82b1");
const _temp20 = require("7b20791f74309e10");
const _temp21 = require("d06b6fc5dda02e88");
const _temp22 = require("a28a6945ed983bd6");
const _temp23 = require("ebef8b25fee90b36");
const _temp24 = require("84e709af2309f7d7");
const _temp25 = require("2526519e9c0d0e8b");
const _temp26 = require("441fee45de55b70c");
const _temp27 = require("190818b45cb371e");
const _temp28 = require("929004f2e45d5643");
const _temp29 = require("77e5fd88fe39459e");
const _temp30 = require("bbe929569218677b");
const _temp31 = require("d3b3389f28451bb4");
const _temp32 = require("6b83a28d69d9848f");
const _temp33 = require("7fb75107a926411e");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"ecfc0164cdafbc11":"ctpKo","533820a702a6cc4d":"ctpKo","adc1d07960abb370":"ctpKo","959d90d2e1b8754d":"ctpKo","c7bcb7c68ae4d133":"ctpKo","7592b3baca1e1ab7":"ctpKo","377509ed67276db9":"dIYmL","bcdffd9a74290826":"ctpKo","66f96fbb9c6f57b3":"ctpKo","96660d96c61006f6":"ctpKo","e42562491f0a003a":"ctpKo","b2e319db05a47686":"ctpKo","8c2f9a8959ebc6d8":"ctpKo","5d3c12b049cdb778":"ctpKo","11cc1fb3d7f8c195":"ctpKo","c7097d1ca0fc0d82":"ctpKo","6a0de05d519cdbf5":"ctpKo","9741ebd533b2078c":"ctpKo","406b77d2f3fc3437":"ctpKo","53d9d9bd8feb82b1":"ctpKo","7b20791f74309e10":"ctpKo","d06b6fc5dda02e88":"ctpKo","a28a6945ed983bd6":"ctpKo","ebef8b25fee90b36":"ctpKo","84e709af2309f7d7":"ctpKo","2526519e9c0d0e8b":"ctpKo","441fee45de55b70c":"ctpKo","190818b45cb371e":"ctpKo","929004f2e45d5643":"ctpKo","77e5fd88fe39459e":"ctpKo","bbe929569218677b":"ctpKo","d3b3389f28451bb4":"ctpKo","6b83a28d69d9848f":"ctpKo","7fb75107a926411e":"ctpKo"}],"dIYmL":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `Clear search`
};

},{}],"fG7Zj":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides state management for a search field.
 */ parcelHelpers.export(exports, "useSearchFieldState", ()=>useSearchFieldState);
var _utils = require("@react-stately/utils");
function useSearchFieldState(props) {
    let [value, setValue] = (0, _utils.useControlledState)(toString(props.value), toString(props.defaultValue) || '', props.onChange);
    return {
        value,
        setValue
    };
}
function toString(val) {
    if (val == null) return;
    return val.toString();
}

},{"@react-stately/utils":"4Nj6T","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"iQ1Sx":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClearButton", ()=>ClearButton);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _cross = require("../ui-icons/Cross");
var _crossDefault = parcelHelpers.interopDefault(_cross);
var _react = require("react");
var _pressScale = require("./pressScale");
var _utils = require("@react-spectrum/utils");
const focusRingStyles = {
    outlineStyle: {
        "default": "none",
        isFocusVisible: "solid"
    },
    outlineColor: "focus-ring",
    outlineWidth: 2,
    outlineOffset: 2
};
const visibleClearButton = function anonymous(props) {
    let rules = " ", currentRules = {};
    if (props.isFocusVisible) {
        rules += ' _Lf12';
        currentRules["outlineStyle"] = typeof currentRules["outlineStyle"] === 'object' ? currentRules["outlineStyle"] : {
            "default": currentRules["outlineStyle"]
        };
        currentRules["outlineStyle"]["isFocusVisible"] = "solid";
    } else {
        rules += ' _Le12';
        currentRules["outlineStyle"] = "none";
    }
    if (props.isStaticColor) {
        rules += ' Ok12';
        currentRules["outlineColor"] = typeof currentRules["outlineColor"] === 'object' ? currentRules["outlineColor"] : {
            "default": currentRules["outlineColor"]
        };
        currentRules["outlineColor"]["isStaticColor"] = "white";
    } else {
        rules += ' Oh12';
        currentRules["outlineColor"] = "focus-ring";
    }
    rules += ' _Mc12';
    currentRules["outlineWidth"] = 2;
    rules += ' _Kc12';
    currentRules["outlineOffset"] = -4;
    rules += ' sd12';
    currentRules["display"] = "flex";
    rules += ' eb12';
    currentRules["alignItems"] = "center";
    rules += ' _Ca12';
    currentRules["justifyContent"] = "center";
    rules += ' Fb12';
    currentRules["height"] = "full";
    if (props.size === "XL") {
        rules += ' ZF12';
        currentRules["width"] = typeof currentRules["width"] === 'object' ? currentRules["width"] : {
            "default": currentRules["width"]
        };
        currentRules["width"]["size === \"XL\""] = 48;
    } else if (props.size === "L") {
        rules += ' Zw12';
        currentRules["width"] = typeof currentRules["width"] === 'object' ? currentRules["width"] : {
            "default": currentRules["width"]
        };
        currentRules["width"]["size === \"L\""] = 40;
    } else if (props.size === "S") {
        rules += ' Zo12';
        currentRules["width"] = typeof currentRules["width"] === 'object' ? currentRules["width"] : {
            "default": currentRules["width"]
        };
        currentRules["width"]["size === \"S\""] = 24;
    } else if (props.size === "XS") {
        rules += ' Zm12';
        currentRules["width"] = typeof currentRules["width"] === 'object' ? currentRules["width"] : {
            "default": currentRules["width"]
        };
        currentRules["width"]["size === \"XS\""] = 20;
    } else {
        rules += ' ZC12';
        currentRules["width"] = 32;
    }
    rules += ' _va12';
    currentRules["flexShrink"] = 0;
    rules += ' og12';
    currentRules["borderTopStartRadius"] = "full";
    rules += ' ng12';
    currentRules["borderTopEndRadius"] = "full";
    rules += ' kg12';
    currentRules["borderBottomStartRadius"] = "full";
    rules += ' jg12';
    currentRules["borderBottomEndRadius"] = "full";
    rules += ' _je12';
    currentRules["borderStyle"] = "none";
    rules += ' g912';
    currentRules["backgroundColor"] = "transparent";
    rules += ' _oa12';
    currentRules["boxSizing"] = "border-box";
    rules += ' Td12';
    currentRules["paddingTop"] = 0;
    rules += ' Qd12';
    currentRules["paddingBottom"] = 0;
    rules += ' Sd12';
    currentRules["paddingStart"] = 0;
    rules += ' Rd12';
    currentRules["paddingEnd"] = 0;
    rules += ' p40ub4c12';
    currentRules["color"] = "inherit";
    rules += ' -_8sjo0b-t5ZbAob12';
    currentRules["--iconPrimary"] = "currentColor";
    return rules;
};
const ClearButton = /*#__PURE__*/ (0, _react.forwardRef)(function ClearButton(props, ref) {
    let { size = 'M', isStaticColor = false, ...rest } = props;
    let domRef = (0, _utils.useFocusableRef)(ref);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Button), {
        ...rest,
        ref: domRef,
        style: (0, _pressScale.pressScale)(domRef),
        className: (renderProps)=>visibleClearButton({
                ...renderProps,
                size,
                isStaticColor
            }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _crossDefault.default), {
            size: props.size
        })
    });
});

},{"0":"jHckW","react/jsx-runtime":"2Is6Z","react-aria-components":"9G5XO","../ui-icons/Cross":"5E2vn","react":"a1TxN","./pressScale":"8Ufux","@react-spectrum/utils":"jqfrX","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jHckW":[function() {},{}],"cSREm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "m18.53 17.47-5.083-5.084C14.417 11.186 15 9.66 15 8c0-3.86-3.14-7-7-7S1 4.14 1 8s3.14 7 7 7c1.66 0 3.185-.584 4.386-1.553l5.084 5.083c.146.147.338.22.53.22s.384-.073.53-.22c.293-.293.293-.767 0-1.06M8 13.5c-3.032 0-5.5-2.468-5.5-5.5S4.968 2.5 8 2.5s5.5 2.468 5.5 5.5-2.468 5.5-5.5 5.5"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hMlI1":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * GridLayout is a virtualizer Layout implementation
 * that arranges its items in a grid.
 * The items are sized between a minimum and maximum size
 * depending on the width of the container.
 */ parcelHelpers.export(exports, "GridLayout", ()=>GridLayout);
var _virtualizer = require("@react-stately/virtualizer");
const DEFAULT_OPTIONS = {
    minItemSize: new (0, _virtualizer.Size)(200, 200),
    maxItemSize: new (0, _virtualizer.Size)(Infinity, Infinity),
    preserveAspectRatio: false,
    minSpace: new (0, _virtualizer.Size)(18, 18),
    maxSpace: Infinity,
    maxColumns: Infinity,
    dropIndicatorThickness: 2
};
class GridLayout extends (0, _virtualizer.Layout) {
    shouldInvalidateLayoutOptions(newOptions, oldOptions) {
        return newOptions.maxColumns !== oldOptions.maxColumns || newOptions.dropIndicatorThickness !== oldOptions.dropIndicatorThickness || newOptions.preserveAspectRatio !== oldOptions.preserveAspectRatio || !(newOptions.minItemSize || DEFAULT_OPTIONS.minItemSize).equals(oldOptions.minItemSize || DEFAULT_OPTIONS.minItemSize) || !(newOptions.maxItemSize || DEFAULT_OPTIONS.maxItemSize).equals(oldOptions.maxItemSize || DEFAULT_OPTIONS.maxItemSize) || !(newOptions.minSpace || DEFAULT_OPTIONS.minSpace).equals(oldOptions.minSpace || DEFAULT_OPTIONS.minSpace) || newOptions.maxHorizontalSpace !== oldOptions.maxHorizontalSpace;
    }
    update(invalidationContext) {
        let { minItemSize = DEFAULT_OPTIONS.minItemSize, maxItemSize = DEFAULT_OPTIONS.maxItemSize, preserveAspectRatio = DEFAULT_OPTIONS.preserveAspectRatio, minSpace = DEFAULT_OPTIONS.minSpace, maxHorizontalSpace = DEFAULT_OPTIONS.maxSpace, maxColumns = DEFAULT_OPTIONS.maxColumns, dropIndicatorThickness = DEFAULT_OPTIONS.dropIndicatorThickness } = invalidationContext.layoutOptions || {};
        this.dropIndicatorThickness = dropIndicatorThickness;
        let visibleWidth = this.virtualizer.visibleRect.width;
        // The max item width is always the entire viewport.
        // If the max item height is infinity, scale in proportion to the max width.
        let maxItemWidth = Math.min(maxItemSize.width, visibleWidth);
        let maxItemHeight = Number.isFinite(maxItemSize.height) ? maxItemSize.height : Math.floor(minItemSize.height / minItemSize.width * maxItemWidth);
        // Compute the number of rows and columns needed to display the content
        let columns = Math.floor(visibleWidth / (minItemSize.width + minSpace.width));
        let numColumns = Math.max(1, Math.min(maxColumns, columns));
        this.numColumns = numColumns;
        // Compute the available width (minus the space between items)
        let width = visibleWidth - minSpace.width * Math.max(0, numColumns);
        // Compute the item width based on the space available
        let itemWidth = Math.floor(width / numColumns);
        itemWidth = Math.max(minItemSize.width, Math.min(maxItemWidth, itemWidth));
        // Compute the item height, which is proportional to the item width
        let t = (itemWidth - minItemSize.width) / Math.max(1, maxItemWidth - minItemSize.width);
        let itemHeight = minItemSize.height + Math.floor((maxItemHeight - minItemSize.height) * t);
        itemHeight = Math.max(minItemSize.height, Math.min(maxItemHeight, itemHeight));
        // Compute the horizontal spacing, content height and horizontal margin
        let horizontalSpacing = Math.min(Math.max(maxHorizontalSpace, minSpace.width), Math.floor((visibleWidth - numColumns * itemWidth) / (numColumns + 1)));
        this.gap = new (0, _virtualizer.Size)(horizontalSpacing, minSpace.height);
        this.margin = Math.floor((visibleWidth - numColumns * itemWidth - horizontalSpacing * (numColumns + 1)) / 2);
        // If there is a skeleton loader within the last 2 items in the collection, increment the collection size
        // so that an additional row is added for the skeletons.
        let collection = this.virtualizer.collection;
        let collectionSize = collection.size;
        let lastKey = collection.getLastKey();
        for(let i = 0; i < 2 && lastKey != null; i++){
            let item = collection.getItem(lastKey);
            if (item?.type === 'skeleton') {
                collectionSize++;
                break;
            }
            lastKey = collection.getKeyBefore(lastKey);
        }
        let rows = Math.ceil(collectionSize / numColumns);
        let iterator = collection[Symbol.iterator]();
        let y = rows > 0 ? minSpace.height : 0;
        let newLayoutInfos = new Map();
        let skeleton = null;
        let skeletonCount = 0;
        for(let row = 0; row < rows; row++){
            let maxHeight = 0;
            let rowLayoutInfos = [];
            for(let col = 0; col < numColumns; col++){
                // Repeat skeleton until the end of the current row.
                let node = skeleton || iterator.next().value;
                if (!node) break;
                // We will add the loader after the skeletons so skip here
                if (node.type === 'loader') continue;
                if (node.type === 'skeleton') skeleton = node;
                let key = skeleton ? `${skeleton.key}-${skeletonCount++}` : node.key;
                let oldLayoutInfo = this.layoutInfos.get(key);
                let content = node;
                if (skeleton) content = oldLayoutInfo && oldLayoutInfo.content.key === key ? oldLayoutInfo.content : {
                    ...skeleton,
                    key
                };
                let x = horizontalSpacing + col * (itemWidth + horizontalSpacing) + this.margin;
                let height = itemHeight;
                let estimatedSize = !preserveAspectRatio;
                if (oldLayoutInfo && estimatedSize) {
                    height = oldLayoutInfo.rect.height;
                    estimatedSize = invalidationContext.layoutOptionsChanged || invalidationContext.sizeChanged || oldLayoutInfo.estimatedSize || oldLayoutInfo.content !== content;
                }
                let rect = new (0, _virtualizer.Rect)(x, y, itemWidth, height);
                let layoutInfo = new (0, _virtualizer.LayoutInfo)(node.type, key, rect);
                layoutInfo.estimatedSize = estimatedSize;
                layoutInfo.allowOverflow = true;
                layoutInfo.content = content;
                newLayoutInfos.set(key, layoutInfo);
                rowLayoutInfos.push(layoutInfo);
                maxHeight = Math.max(maxHeight, layoutInfo.rect.height);
            }
            for (let layoutInfo of rowLayoutInfos)layoutInfo.rect.height = maxHeight;
            y += maxHeight + minSpace.height;
            // Keep adding skeleton rows until we fill the viewport
            if (skeleton && row === rows - 1 && y < this.virtualizer.visibleRect.height) rows++;
        }
        // Always add the loader sentinel if present in the collection so we can make sure it is never virtualized out.
        let lastNode = collection.getItem(collection.getLastKey());
        if (lastNode?.type === 'loader') {
            let rect = new (0, _virtualizer.Rect)(horizontalSpacing, y, itemWidth, 0);
            let layoutInfo = new (0, _virtualizer.LayoutInfo)('loader', lastNode.key, rect);
            newLayoutInfos.set(lastNode.key, layoutInfo);
        }
        this.layoutInfos = newLayoutInfos;
        this.contentSize = new (0, _virtualizer.Size)(this.virtualizer.visibleRect.width, y);
    }
    getLayoutInfo(key) {
        return this.layoutInfos.get(key) || null;
    }
    getContentSize() {
        return this.contentSize;
    }
    getVisibleLayoutInfos(rect) {
        let layoutInfos = [];
        for (let layoutInfo of this.layoutInfos.values())if (layoutInfo.rect.intersects(rect) || this.virtualizer.isPersistedKey(layoutInfo.key) || layoutInfo.type === 'loader') layoutInfos.push(layoutInfo);
        return layoutInfos;
    }
    updateItemSize(key, size) {
        let layoutInfo = this.layoutInfos.get(key);
        if (!size || !layoutInfo) return false;
        if (size.height !== layoutInfo.rect.height) {
            let newLayoutInfo = layoutInfo.copy();
            newLayoutInfo.rect.height = size.height;
            newLayoutInfo.estimatedSize = false;
            this.layoutInfos.set(key, newLayoutInfo);
            return true;
        }
        return false;
    }
    getDropTargetFromPoint(x, y, isValidDropTarget) {
        if (this.layoutInfos.size === 0) return {
            type: 'root'
        };
        x += this.virtualizer.visibleRect.x;
        y += this.virtualizer.visibleRect.y;
        // Find the closest item within on either side of the point using the gap width.
        let key = null;
        if (this.numColumns === 1) {
            let searchRect = new (0, _virtualizer.Rect)(x, Math.max(0, y - this.gap.height), 1, Math.max(1, this.gap.height * 2));
            let candidates = this.getVisibleLayoutInfos(searchRect);
            let minDistance = Infinity;
            for (let candidate of candidates){
                // Ignore items outside the search rect, e.g. persisted keys.
                if (!candidate.rect.intersects(searchRect)) continue;
                let yDist = Math.abs(candidate.rect.y - y);
                let maxYDist = Math.abs(candidate.rect.maxY - y);
                let dist = Math.min(yDist, maxYDist);
                if (dist < minDistance) {
                    minDistance = dist;
                    key = candidate.key;
                }
            }
        } else {
            let searchRect = new (0, _virtualizer.Rect)(Math.max(0, x - this.gap.width), y, this.gap.width * 2, 1);
            let candidates = this.getVisibleLayoutInfos(searchRect);
            let minDistance = Infinity;
            for (let candidate of candidates){
                // Ignore items outside the search rect, e.g. persisted keys.
                if (!candidate.rect.intersects(searchRect)) continue;
                let xDist = Math.abs(candidate.rect.x - x);
                let maxXDist = Math.abs(candidate.rect.maxX - x);
                let dist = Math.min(xDist, maxXDist);
                if (dist < minDistance) {
                    minDistance = dist;
                    key = candidate.key;
                }
            }
        }
        let layoutInfo = key != null ? this.getLayoutInfo(key) : null;
        if (!layoutInfo) return {
            type: 'root'
        };
        let target = {
            type: 'item',
            key: layoutInfo.key,
            dropPosition: 'on'
        };
        let pos = this.numColumns === 1 ? y : x;
        let layoutInfoPos = this.numColumns === 1 ? layoutInfo.rect.y : layoutInfo.rect.x;
        let size = this.numColumns === 1 ? layoutInfo.rect.height : layoutInfo.rect.width;
        if (isValidDropTarget(target)) {
            // If dropping on the item is accepted, try the before/after positions
            // if within 5px of the start or end of the item.
            if (pos < layoutInfoPos + 5) target.dropPosition = 'before';
            else if (pos > layoutInfoPos + size - 5) target.dropPosition = 'after';
        } else {
            // If dropping on the item isn't accepted, try the target before or after depending on the position.
            let mid = layoutInfoPos + size / 2;
            if (pos <= mid && isValidDropTarget({
                ...target,
                dropPosition: 'before'
            })) target.dropPosition = 'before';
            else if (pos >= mid && isValidDropTarget({
                ...target,
                dropPosition: 'after'
            })) target.dropPosition = 'after';
        }
        return target;
    }
    getDropTargetLayoutInfo(target) {
        let layoutInfo = this.getLayoutInfo(target.key);
        let rect;
        if (this.numColumns === 1) // Flip from vertical to horizontal if only one column is visible.
        rect = new (0, _virtualizer.Rect)(layoutInfo.rect.x, target.dropPosition === 'before' ? layoutInfo.rect.y - this.gap.height / 2 - this.dropIndicatorThickness / 2 : layoutInfo.rect.maxY + this.gap.height / 2 - this.dropIndicatorThickness / 2, layoutInfo.rect.width, this.dropIndicatorThickness);
        else rect = new (0, _virtualizer.Rect)(target.dropPosition === 'before' ? layoutInfo.rect.x - this.gap.width / 2 - this.dropIndicatorThickness / 2 : layoutInfo.rect.maxX + this.gap.width / 2 - this.dropIndicatorThickness / 2, layoutInfo.rect.y, this.dropIndicatorThickness, layoutInfo.rect.height);
        return new (0, _virtualizer.LayoutInfo)('dropIndicator', target.key + ':' + target.dropPosition, rect);
    }
    constructor(...args){
        super(...args), this.gap = DEFAULT_OPTIONS.minSpace, this.dropIndicatorThickness = 2, this.numColumns = 0, this.contentSize = new (0, _virtualizer.Size)(), this.layoutInfos = new Map(), this.margin = 0;
    }
}

},{"@react-stately/virtualizer":[["Layout","fnAag"],["LayoutInfo","6H2VJ"],["Rect","l3p76"],["Size","F8cca"]],"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"921LY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10 18.795c-.601 0-1.166-.234-1.591-.66l-6.545-6.544c-.876-.877-.876-2.305 0-3.182l6.545-6.545c.849-.85 2.333-.85 3.182 0l6.545 6.545c.876.877.876 2.305 0 3.182l-6.545 6.545c-.425.425-.99.659-1.591.659m0-16.09c-.2 0-.389.078-.53.22L2.925 9.47c-.292.292-.292.768 0 1.06l6.545 6.545c.283.283.778.283 1.06 0l6.545-6.545c.292-.292.292-.768 0-1.06L10.53 2.925c-.141-.142-.33-.22-.53-.22"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10 14.998c-.231.008-.456-.073-.627-.228-.33-.365-.33-.92 0-1.285.17-.158.395-.242.626-.234.237-.01.466.08.633.247.162.168.25.394.242.627.012.235-.07.465-.228.639-.174.164-.408.25-.647.234M10 11.625c-.414 0-.75-.336-.75-.75v-5c0-.414.336-.75.75-.75s.75.336.75.75v5c0 .414-.336.75-.75.75"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2370J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M13 2.5H7c-.414 0-.75-.336-.75-.75S6.586 1 7 1h6c.414 0 .75.336.75.75s-.336.75-.75.75M16.773 14.48q-.022-.046-.05-.09L12.49 7.78V5.493h.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-1.25c-.414 0-.75.336-.75.75V8c0 .144.041.284.119.404l1.171 1.83-5.686 1.743 2.279-3.574c.076-.12.117-.26.117-.403V4.743c0-.414-.336-.75-.75-.75H6.99c-.414 0-.75.336-.75.75s.336.75.75.75h.5v2.288l-4.213 6.61q-.028.043-.049.09c-.351.761-.29 1.638.164 2.346C3.86 17.562 4.67 18 5.558 18h8.884c.887 0 1.697-.438 2.167-1.173.453-.708.515-1.585.164-2.347m-1.427 1.539c-.193.301-.531.481-.904.481H5.558c-.373 0-.71-.18-.904-.481-.171-.268-.2-.582-.082-.87l.779-1.222 7.768-2.383 2.31 3.604c.117.29.088.604-.083.87"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kmqkh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M7.75 16.465c-.187 0-.374-.07-.52-.21-.298-.287-.308-.762-.02-1.06l4.999-5.197-4.986-5.184c-.288-.297-.279-.772.02-1.06.296-.286.774-.278 1.06.021L13.79 9.48c.28.29.28.749 0 1.039l-5.5 5.716c-.146.154-.344.23-.54.23"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bneuv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M16.25 14H3.75c-.414 0-.75.336-.75.75s.336.75.75.75h12.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75M3.75 5.5h12.5c.414 0 .75-.336.75-.75S16.664 4 16.25 4H3.75c-.414 0-.75.336-.75.75s.336.75.75.75M16.25 9H3.75c-.414 0-.75.336-.75.75s.336.75.75.75h12.5c.414 0 .75-.336.75-.75S16.664 9 16.25 9"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"3yrCq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M15.75 3h-2V2c0-.414-.336-.75-.75-.75s-.75.336-.75.75v1h-4.5V2c0-.414-.336-.75-.75-.75s-.75.336-.75.75v1h-2C3.01 3 2 4.01 2 5.25v10.5C2 16.99 3.01 18 4.25 18h11.5c1.24 0 2.25-1.01 2.25-2.25V5.25C18 4.01 16.99 3 15.75 3M4.25 4.5h2V5c0 .414.336.75.75.75s.75-.336.75-.75v-.5h4.5V5c0 .414.336.75.75.75s.75-.336.75-.75v-.5h2c.414 0 .75.337.75.75V7h-13V5.25c0-.413.336-.75.75-.75m11.5 12H4.25c-.414 0-.75-.337-.75-.75V8.5h13v7.25c0 .413-.336.75-.75.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 2,
                height: 2,
                x: 5,
                y: 10,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                rx: 1,
                ry: 1
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 2,
                height: 2,
                x: 9,
                y: 10,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                rx: 1,
                ry: 1
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 2,
                height: 2,
                x: 13,
                y: 10,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                rx: 1,
                ry: 1
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 2,
                height: 2,
                x: 5,
                y: 13,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                rx: 1,
                ry: 1
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 2,
                height: 2,
                x: 9,
                y: 13,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                rx: 1,
                ry: 1
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 2,
                height: 2,
                x: 13,
                y: 13,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                rx: 1,
                ry: 1
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1QXwE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M7.864 15.734c-.222 0-.433-.098-.576-.27l-3.747-4.497c-.266-.319-.222-.792.096-1.057.317-.265.79-.223 1.056.096l3.154 3.786 7.44-9.469c.255-.326.728-.382 1.052-.127.326.256.383.728.127 1.053L8.454 15.447c-.14.179-.352.284-.579.287z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"ipfe6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M18.28 13.22c-.293-.293-.767-.293-1.06 0L16 14.44V3.75c0-.414-.336-.75-.75-.75s-.75.336-.75.75v10.69l-1.22-1.22c-.293-.293-.767-.293-1.06 0s-.293.767 0 1.06l2.5 2.5q.105.105.243.162c.138.057.19.058.287.058s.195-.02.287-.058.174-.093.243-.162l2.5-2.5c.293-.293.293-.767 0-1.06M7.25 14.5h-4.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h4.5c.414 0 .75.336.75.75s-.336.75-.75.75M9.25 10.5h-6.5c-.414 0-.75-.336-.75-.75S2.336 9 2.75 9h6.5c.414 0 .75.336.75.75s-.336.75-.75.75M11.25 6.5h-8.5c-.414 0-.75-.336-.75-.75S2.336 5 2.75 5h8.5c.414 0 .75.336.75.75s-.336.75-.75.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9pN2c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "m18.28 5.72-2.5-2.5q-.105-.105-.243-.162c-.184-.076-.39-.076-.574 0q-.138.058-.243.162l-2.5 2.5c-.293.293-.293.767 0 1.06s.767.293 1.06 0l1.22-1.22v10.69c0 .414.336.75.75.75s.75-.336.75-.75V5.56l1.22 1.22c.146.147.338.22.53.22s.384-.073.53-.22c.293-.293.293-.767 0-1.06M7.25 6.5h-4.5c-.414 0-.75-.336-.75-.75S2.336 5 2.75 5h4.5c.414 0 .75.336.75.75s-.336.75-.75.75M9.25 10.5h-6.5c-.414 0-.75-.336-.75-.75S2.336 9 2.75 9h6.5c.414 0 .75.336.75.75s-.336.75-.75.75M11.25 14.5h-8.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h8.5c.414 0 .75.336.75.75s-.336.75-.75.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"erT5A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M3.755 7.243c.287-.299.762-.308 1.06-.02l5.183 4.986 5.197-4.999c.298-.288.773-.278 1.06.02.287.297.278.773-.02 1.06l-5.717 5.5c-.29.28-.75.28-1.04 0L3.776 8.303c-.153-.147-.23-.344-.23-.54 0-.188.07-.375.21-.52"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5jnVm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M12.237 16.455c-.196 0-.393-.077-.54-.23L6.21 10.52c-.28-.29-.28-.749 0-1.039l5.5-5.716c.287-.3.763-.308 1.06-.02.298.286.308.76.02 1.059l-4.999 5.197 4.986 5.184c.288.297.279.772-.02 1.06-.145.14-.332.21-.52.21"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"aI18O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "m11.06 10 5.207-5.206c.293-.293.293-.768 0-1.06s-.767-.294-1.06 0L10 8.938 4.793 3.733c-.293-.293-.767-.293-1.06 0s-.293.768 0 1.06L8.939 10l-5.206 5.206c-.293.293-.293.768 0 1.06.146.147.338.22.53.22s.384-.073.53-.22L10 11.062l5.207 5.206c.146.146.338.22.53.22s.384-.074.53-.22c.293-.293.293-.768 0-1.06z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1PPGS":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a list component with interactive children.
 * A grid list displays data in a single column and enables a user to navigate its contents via directional navigation keys.
 * @param props - Props for the list.
 * @param state - State for the list, as returned by `useListState`.
 * @param ref - The ref attached to the list element.
 */ parcelHelpers.export(exports, "useGridList", ()=>useGridList);
var _utils = require("@react-aria/utils");
var _utils1 = require("./utils");
var _grid = require("@react-aria/grid");
var _focus = require("@react-aria/focus");
var _selection = require("@react-aria/selection");
function useGridList(props, state, ref) {
    let { isVirtualized, keyboardDelegate, layoutDelegate, onAction, disallowTypeAhead, linkBehavior = 'action', keyboardNavigationBehavior = 'arrow', escapeKeyBehavior = 'clearSelection', shouldSelectOnPressUp } = props;
    if (!props['aria-label'] && !props['aria-labelledby']) console.warn('An aria-label or aria-labelledby prop is required for accessibility.');
    let { listProps } = (0, _selection.useSelectableList)({
        selectionManager: state.selectionManager,
        collection: state.collection,
        disabledKeys: state.disabledKeys,
        ref,
        keyboardDelegate,
        layoutDelegate,
        isVirtualized,
        selectOnFocus: state.selectionManager.selectionBehavior === 'replace',
        shouldFocusWrap: props.shouldFocusWrap,
        linkBehavior,
        disallowTypeAhead,
        autoFocus: props.autoFocus,
        escapeKeyBehavior
    });
    let id = (0, _utils.useId)(props.id);
    (0, _utils1.listMap).set(state, {
        id,
        onAction,
        linkBehavior,
        keyboardNavigationBehavior,
        shouldSelectOnPressUp
    });
    let descriptionProps = (0, _grid.useHighlightSelectionDescription)({
        selectionManager: state.selectionManager,
        hasItemActions: !!onAction
    });
    let hasTabbableChild = (0, _focus.useHasTabbableChild)(ref, {
        isDisabled: state.collection.size !== 0
    });
    let domProps = (0, _utils.filterDOMProps)(props, {
        labelable: true
    });
    let gridProps = (0, _utils.mergeProps)(domProps, {
        role: 'grid',
        id,
        'aria-multiselectable': state.selectionManager.selectionMode === 'multiple' ? 'true' : undefined
    }, // If collection is empty, make sure the grid is tabbable unless there is a child tabbable element.
    state.collection.size === 0 ? {
        tabIndex: hasTabbableChild ? -1 : 0
    } : listProps, descriptionProps);
    if (isVirtualized) {
        gridProps['aria-rowcount'] = state.collection.size;
        gridProps['aria-colcount'] = 1;
    }
    (0, _grid.useGridSelectionAnnouncement)({}, state);
    return {
        gridProps
    };
}

},{"@react-aria/utils":[["filterDOMProps","3upVm"],["mergeProps","aNvcY"],["useId","jbI4Y"]],"./utils":"aJkqW","@react-aria/grid":[["useGridSelectionAnnouncement","deyzk"],["useHighlightSelectionDescription","eO4Xt"]],"@react-aria/focus":"eSQu0","@react-aria/selection":"ldksp","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"aJkqW":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "listMap", ()=>listMap);
parcelHelpers.export(exports, "getRowId", ()=>getRowId);
parcelHelpers.export(exports, "normalizeKey", ()=>normalizeKey);
const listMap = new WeakMap();
function getRowId(state, key) {
    let { id } = listMap.get(state) ?? {};
    if (!id) throw new Error('Unknown list');
    return `${id}-${normalizeKey(key)}`;
}
function normalizeKey(key) {
    if (typeof key === 'string') return key.replace(/\s*/g, '');
    return '' + key;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"deyzk":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGridSelectionAnnouncement", ()=>useGridSelectionAnnouncement);
var _liveAnnouncer = require("@react-aria/live-announcer");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _react = require("react");
var _i18N = require("@react-aria/i18n");
var _utils = require("@react-aria/utils");
function useGridSelectionAnnouncement(props, state) {
    let { getRowText = (key)=>state.collection.getTextValue?.(key) ?? state.collection.getItem(key)?.textValue } = props;
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-aria/grid');
    // Many screen readers do not announce when items in a grid are selected/deselected.
    // We do this using an ARIA live region.
    let selection = state.selectionManager.rawSelection;
    let lastSelection = (0, _react.useRef)(selection);
    let announceSelectionChange = (0, _react.useCallback)(()=>{
        if (!state.selectionManager.isFocused || selection === lastSelection.current) {
            lastSelection.current = selection;
            return;
        }
        let addedKeys = diffSelection(selection, lastSelection.current);
        let removedKeys = diffSelection(lastSelection.current, selection);
        // If adding or removing a single row from the selection, announce the name of that item.
        let isReplace = state.selectionManager.selectionBehavior === 'replace';
        let messages = [];
        if (state.selectionManager.selectedKeys.size === 1 && isReplace) {
            let firstKey = state.selectionManager.selectedKeys.keys().next().value;
            if (firstKey != null && state.collection.getItem(firstKey)) {
                let currentSelectionText = getRowText(firstKey);
                if (currentSelectionText) messages.push(stringFormatter.format('selectedItem', {
                    item: currentSelectionText
                }));
            }
        } else if (addedKeys.size === 1 && removedKeys.size === 0) {
            let firstKey = addedKeys.keys().next().value;
            if (firstKey != null) {
                let addedText = getRowText(firstKey);
                if (addedText) messages.push(stringFormatter.format('selectedItem', {
                    item: addedText
                }));
            }
        } else if (removedKeys.size === 1 && addedKeys.size === 0) {
            let firstKey = removedKeys.keys().next().value;
            if (firstKey != null && state.collection.getItem(firstKey)) {
                let removedText = getRowText(firstKey);
                if (removedText) messages.push(stringFormatter.format('deselectedItem', {
                    item: removedText
                }));
            }
        }
        // Announce how many items are selected, except when selecting the first item.
        if (state.selectionManager.selectionMode === 'multiple') {
            if (messages.length === 0 || selection === 'all' || selection.size > 1 || lastSelection.current === 'all' || lastSelection.current?.size > 1) messages.push(selection === 'all' ? stringFormatter.format('selectedAll') : stringFormatter.format('selectedCount', {
                count: selection.size
            }));
        }
        if (messages.length > 0) (0, _liveAnnouncer.announce)(messages.join(' '));
        lastSelection.current = selection;
    }, [
        selection,
        state.selectionManager.selectedKeys,
        state.selectionManager.isFocused,
        state.selectionManager.selectionBehavior,
        state.selectionManager.selectionMode,
        state.collection,
        getRowText,
        stringFormatter
    ]);
    // useUpdateEffect will handle using useEffectEvent, no need to stabilize anything on this end
    (0, _utils.useUpdateEffect)(()=>{
        if (state.selectionManager.isFocused) announceSelectionChange();
        else {
            // Wait a frame in case the collection is about to become focused (e.g. on mouse down).
            let raf = requestAnimationFrame(announceSelectionChange);
            return ()=>cancelAnimationFrame(raf);
        }
    }, [
        selection,
        state.selectionManager.isFocused
    ]);
}
function diffSelection(a, b) {
    let res = new Set();
    if (a === 'all' || b === 'all') return res;
    for (let key of a.keys())if (!b.has(key)) res.add(key);
    return res;
}

},{"@react-aria/live-announcer":"3nbSW","../intl/*.json":"hdtsN","react":"a1TxN","@react-aria/i18n":"7lxyl","@react-aria/utils":"ekc37","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hdtsN":[function(require,module,exports,__globalThis) {
const _temp0 = require("549f76802fea3145");
const _temp1 = require("99e711b09beafbae");
const _temp2 = require("d822d49a9f50f8f2");
const _temp3 = require("62716c14c7ab3b19");
const _temp4 = require("f993c3bd895f4a55");
const _temp5 = require("87ba517e0d2284cb");
const _temp6 = require("9959e6866268baa2");
const _temp7 = require("a5d29cf49321ccbd");
const _temp8 = require("d4a263166a379f7");
const _temp9 = require("adb7cef23c3e7915");
const _temp10 = require("b85e649d4f0c8fa0");
const _temp11 = require("669dff92f11c15b2");
const _temp12 = require("56a3bfdc95a3af99");
const _temp13 = require("92bd2be1c2e45a26");
const _temp14 = require("ac7b779e60091ebf");
const _temp15 = require("7350c7eb30e615e3");
const _temp16 = require("3260bfccae03c79c");
const _temp17 = require("e01abdb08e203859");
const _temp18 = require("5551bd334b751799");
const _temp19 = require("a555cf93e0917ba2");
const _temp20 = require("f519d273a2594a58");
const _temp21 = require("2ab2dc559350f8cb");
const _temp22 = require("aa7f9e578044416a");
const _temp23 = require("7828f13f1de12a9c");
const _temp24 = require("b776cb1c3588783c");
const _temp25 = require("b2c037c8f99b4b1d");
const _temp26 = require("3656d7d096e21208");
const _temp27 = require("64de068ffd5db517");
const _temp28 = require("6afb03c6be24a7db");
const _temp29 = require("fac4d0e10b154d11");
const _temp30 = require("5207f24182fa30c9");
const _temp31 = require("6c177c75c6c9f015");
const _temp32 = require("1c95bec940ff1fe8");
const _temp33 = require("736ec483e330f374");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"549f76802fea3145":"ctpKo","99e711b09beafbae":"ctpKo","d822d49a9f50f8f2":"ctpKo","62716c14c7ab3b19":"ctpKo","f993c3bd895f4a55":"ctpKo","87ba517e0d2284cb":"ctpKo","9959e6866268baa2":"3Tpgz","a5d29cf49321ccbd":"ctpKo","d4a263166a379f7":"ctpKo","adb7cef23c3e7915":"ctpKo","b85e649d4f0c8fa0":"ctpKo","669dff92f11c15b2":"ctpKo","56a3bfdc95a3af99":"ctpKo","92bd2be1c2e45a26":"ctpKo","ac7b779e60091ebf":"ctpKo","7350c7eb30e615e3":"ctpKo","3260bfccae03c79c":"ctpKo","e01abdb08e203859":"ctpKo","5551bd334b751799":"ctpKo","a555cf93e0917ba2":"ctpKo","f519d273a2594a58":"ctpKo","2ab2dc559350f8cb":"ctpKo","aa7f9e578044416a":"ctpKo","7828f13f1de12a9c":"ctpKo","b776cb1c3588783c":"ctpKo","b2c037c8f99b4b1d":"ctpKo","3656d7d096e21208":"ctpKo","64de068ffd5db517":"ctpKo","6afb03c6be24a7db":"ctpKo","fac4d0e10b154d11":"ctpKo","5207f24182fa30c9":"ctpKo","6c177c75c6c9f015":"ctpKo","1c95bec940ff1fe8":"ctpKo","736ec483e330f374":"ctpKo"}],"3Tpgz":[function(require,module,exports,__globalThis) {
module.exports = {
    "deselectedItem": (args)=>`${args.item} not selected.`,
    "select": `Select`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `No items selected`,
            one: ()=>`${formatter.number(args.count)} item selected`,
            other: ()=>`${formatter.number(args.count)} items selected`
        })}.`,
    "selectedAll": `All items selected.`,
    "selectedItem": (args)=>`${args.item} selected.`,
    "longPressToSelect": `Long press to enter selection mode.`
};

},{}],"eO4Xt":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Computes the description for a grid selectable collection.
 * @param props
 */ parcelHelpers.export(exports, "useHighlightSelectionDescription", ()=>useHighlightSelectionDescription);
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _utils = require("@react-aria/utils");
var _interactions = require("@react-aria/interactions");
var _i18N = require("@react-aria/i18n");
var _react = require("react");
function useHighlightSelectionDescription(props) {
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-aria/grid');
    let modality = (0, _interactions.useInteractionModality)();
    // null is the default if the user hasn't interacted with the table at all yet or the rest of the page
    let shouldLongPress = (modality === 'pointer' || modality === 'virtual' || modality == null) && typeof window !== 'undefined' && 'ontouchstart' in window;
    let interactionDescription = (0, _react.useMemo)(()=>{
        let selectionMode = props.selectionManager.selectionMode;
        let selectionBehavior = props.selectionManager.selectionBehavior;
        let message;
        if (shouldLongPress) message = stringFormatter.format('longPressToSelect');
        return selectionBehavior === 'replace' && selectionMode !== 'none' && props.hasItemActions ? message : undefined;
    }, [
        props.selectionManager.selectionMode,
        props.selectionManager.selectionBehavior,
        props.hasItemActions,
        stringFormatter,
        shouldLongPress
    ]);
    let descriptionProps = (0, _utils.useDescription)(interactionDescription);
    return descriptionProps;
}

},{"../intl/*.json":"hdtsN","@react-aria/utils":"h4qnk","@react-aria/interactions":"dkfxW","@react-aria/i18n":"7lxyl","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fNHH4":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a row in a grid list.
 * @param props - Props for the row.
 * @param state - State of the parent list, as returned by `useListState`.
 * @param ref - The ref attached to the row element.
 */ parcelHelpers.export(exports, "useGridListItem", ()=>useGridListItem);
var _utils = require("@react-aria/utils");
var _focus = require("@react-aria/focus");
var _utils1 = require("./utils");
var _react = require("react");
var _interactions = require("@react-aria/interactions");
var _selection = require("@react-aria/selection");
var _i18N = require("@react-aria/i18n");
const EXPANSION_KEYS = {
    'expand': {
        ltr: 'ArrowRight',
        rtl: 'ArrowLeft'
    },
    'collapse': {
        ltr: 'ArrowLeft',
        rtl: 'ArrowRight'
    }
};
function useGridListItem(props, state, ref) {
    // Copied from useGridCell + some modifications to make it not so grid specific
    let { node, isVirtualized } = props;
    // let stringFormatter = useLocalizedStringFormatter(intlMessages, '@react-aria/gridlist');
    let { direction } = (0, _i18N.useLocale)();
    let { onAction, linkBehavior, keyboardNavigationBehavior, shouldSelectOnPressUp } = (0, _utils1.listMap).get(state);
    let descriptionId = (0, _utils.useSlotId)();
    // We need to track the key of the item at the time it was last focused so that we force
    // focus to go to the item when the DOM node is reused for a different item in a virtualizer.
    let keyWhenFocused = (0, _react.useRef)(null);
    let focus = ()=>{
        // Don't shift focus to the row if the active element is a element within the row already
        // (e.g. clicking on a row button)
        if (ref.current !== null && (keyWhenFocused.current != null && node.key !== keyWhenFocused.current || !ref.current?.contains(document.activeElement))) (0, _focus.focusSafely)(ref.current);
    };
    let treeGridRowProps = {};
    let hasChildRows = props.hasChildItems;
    let hasLink = state.selectionManager.isLink(node.key);
    if (node != null && 'expandedKeys' in state) {
        // TODO: ideally node.hasChildNodes would be a way to tell if a row has child nodes, but the row's contents make it so that value is always
        // true...
        let children = state.collection.getChildren?.(node.key);
        hasChildRows = hasChildRows || [
            ...children ?? []
        ].length > 1;
        if (onAction == null && !hasLink && state.selectionManager.selectionMode === 'none' && hasChildRows) onAction = ()=>state.toggleKey(node.key);
        let isExpanded = hasChildRows ? state.expandedKeys.has(node.key) : undefined;
        let setSize = 1;
        if (node.level > 0 && node?.parentKey != null) {
            let parent = state.collection.getItem(node.parentKey);
            if (parent) {
                // siblings must exist because our original node exists
                let siblings = state.collection.getChildren?.(parent.key);
                setSize = [
                    ...siblings
                ].filter((row)=>row.type === 'item').length;
            }
        } else setSize = [
            ...state.collection
        ].filter((row)=>row.level === 0 && row.type === 'item').length;
        treeGridRowProps = {
            'aria-expanded': isExpanded,
            'aria-level': node.level + 1,
            'aria-posinset': node?.index + 1,
            'aria-setsize': setSize
        };
    }
    let { itemProps, ...itemStates } = (0, _selection.useSelectableItem)({
        selectionManager: state.selectionManager,
        key: node.key,
        ref,
        isVirtualized,
        shouldSelectOnPressUp: props.shouldSelectOnPressUp || shouldSelectOnPressUp,
        onAction: onAction || node.props?.onAction ? (0, _utils.chain)(node.props?.onAction, onAction ? ()=>onAction(node.key) : undefined) : undefined,
        focus,
        linkBehavior
    });
    let onKeyDownCapture = (e)=>{
        if (!e.currentTarget.contains(e.target) || !ref.current || !document.activeElement) return;
        let walker = (0, _focus.getFocusableTreeWalker)(ref.current);
        walker.currentNode = document.activeElement;
        if ('expandedKeys' in state && document.activeElement === ref.current) {
            if (e.key === EXPANSION_KEYS['expand'][direction] && state.selectionManager.focusedKey === node.key && hasChildRows && !state.expandedKeys.has(node.key)) {
                state.toggleKey(node.key);
                e.stopPropagation();
                return;
            } else if (e.key === EXPANSION_KEYS['collapse'][direction] && state.selectionManager.focusedKey === node.key && hasChildRows && state.expandedKeys.has(node.key)) {
                state.toggleKey(node.key);
                e.stopPropagation();
                return;
            }
        }
        switch(e.key){
            case 'ArrowLeft':
                if (keyboardNavigationBehavior === 'arrow') {
                    // Find the next focusable element within the row.
                    let focusable = direction === 'rtl' ? walker.nextNode() : walker.previousNode();
                    if (focusable) {
                        e.preventDefault();
                        e.stopPropagation();
                        (0, _focus.focusSafely)(focusable);
                        (0, _utils.scrollIntoViewport)(focusable, {
                            containingElement: (0, _utils.getScrollParent)(ref.current)
                        });
                    } else {
                        // If there is no next focusable child, then return focus back to the row
                        e.preventDefault();
                        e.stopPropagation();
                        if (direction === 'rtl') {
                            (0, _focus.focusSafely)(ref.current);
                            (0, _utils.scrollIntoViewport)(ref.current, {
                                containingElement: (0, _utils.getScrollParent)(ref.current)
                            });
                        } else {
                            walker.currentNode = ref.current;
                            let lastElement = last(walker);
                            if (lastElement) {
                                (0, _focus.focusSafely)(lastElement);
                                (0, _utils.scrollIntoViewport)(lastElement, {
                                    containingElement: (0, _utils.getScrollParent)(ref.current)
                                });
                            }
                        }
                    }
                }
                break;
            case 'ArrowRight':
                if (keyboardNavigationBehavior === 'arrow') {
                    let focusable = direction === 'rtl' ? walker.previousNode() : walker.nextNode();
                    if (focusable) {
                        e.preventDefault();
                        e.stopPropagation();
                        (0, _focus.focusSafely)(focusable);
                        (0, _utils.scrollIntoViewport)(focusable, {
                            containingElement: (0, _utils.getScrollParent)(ref.current)
                        });
                    } else {
                        e.preventDefault();
                        e.stopPropagation();
                        if (direction === 'ltr') {
                            (0, _focus.focusSafely)(ref.current);
                            (0, _utils.scrollIntoViewport)(ref.current, {
                                containingElement: (0, _utils.getScrollParent)(ref.current)
                            });
                        } else {
                            walker.currentNode = ref.current;
                            let lastElement = last(walker);
                            if (lastElement) {
                                (0, _focus.focusSafely)(lastElement);
                                (0, _utils.scrollIntoViewport)(lastElement, {
                                    containingElement: (0, _utils.getScrollParent)(ref.current)
                                });
                            }
                        }
                    }
                }
                break;
            case 'ArrowUp':
            case 'ArrowDown':
                // Prevent this event from reaching row children, e.g. menu buttons. We want arrow keys to navigate
                // to the row above/below instead. We need to re-dispatch the event from a higher parent so it still
                // bubbles and gets handled by useSelectableCollection.
                if (!e.altKey && ref.current.contains(e.target)) {
                    e.stopPropagation();
                    e.preventDefault();
                    ref.current.parentElement?.dispatchEvent(new KeyboardEvent(e.nativeEvent.type, e.nativeEvent));
                }
                break;
        }
    };
    let onFocus = (e)=>{
        keyWhenFocused.current = node.key;
        if (e.target !== ref.current) {
            // useSelectableItem only handles setting the focused key when
            // the focused element is the row itself. We also want to
            // set the focused key when a child element receives focus.
            // If focus is currently visible (e.g. the user is navigating with the keyboard),
            // then skip this. We want to restore focus to the previously focused row
            // in that case since the list should act like a single tab stop.
            if (!(0, _interactions.isFocusVisible)()) state.selectionManager.setFocusedKey(node.key);
            return;
        }
    };
    let onKeyDown = (e)=>{
        if (!e.currentTarget.contains(e.target) || !ref.current || !document.activeElement) return;
        switch(e.key){
            case 'Tab':
                if (keyboardNavigationBehavior === 'tab') {
                    // If there is another focusable element within this item, stop propagation so the tab key
                    // is handled by the browser and not by useSelectableCollection (which would take us out of the list).
                    let walker = (0, _focus.getFocusableTreeWalker)(ref.current, {
                        tabbable: true
                    });
                    walker.currentNode = document.activeElement;
                    let next = e.shiftKey ? walker.previousNode() : walker.nextNode();
                    if (next) e.stopPropagation();
                }
        }
    };
    let syntheticLinkProps = (0, _utils.useSyntheticLinkProps)(node.props);
    let linkProps = itemStates.hasAction ? syntheticLinkProps : {};
    // TODO: re-add when we get translations and fix this for iOS VO
    // let rowAnnouncement;
    // if (onAction) {
    //   rowAnnouncement = stringFormatter.format('hasActionAnnouncement');
    // } else if (hasLink) {
    //   rowAnnouncement = stringFormatter.format('hasLinkAnnouncement', {
    //     link: node.props.href
    //   });
    // }
    let rowProps = (0, _utils.mergeProps)(itemProps, linkProps, {
        role: 'row',
        onKeyDownCapture,
        onKeyDown,
        onFocus,
        // 'aria-label': [(node.textValue || undefined), rowAnnouncement].filter(Boolean).join(', '),
        'aria-label': node.textValue || undefined,
        'aria-selected': state.selectionManager.canSelectItem(node.key) ? state.selectionManager.isSelected(node.key) : undefined,
        'aria-disabled': state.selectionManager.isDisabled(node.key) || undefined,
        'aria-labelledby': descriptionId && node.textValue ? `${(0, _utils1.getRowId)(state, node.key)} ${descriptionId}` : undefined,
        id: (0, _utils1.getRowId)(state, node.key)
    });
    if (isVirtualized) {
        let { collection } = state;
        let nodes = [
            ...collection
        ];
        // TODO: refactor ListCollection to store an absolute index of a node's position?
        rowProps['aria-rowindex'] = nodes.find((node)=>node.type === 'section') ? [
            ...collection.getKeys()
        ].filter((key)=>collection.getItem(key)?.type !== 'section').findIndex((key)=>key === node.key) + 1 : node.index + 1;
    }
    let gridCellProps = {
        role: 'gridcell',
        'aria-colindex': 1
    };
    // TODO: should isExpanded and hasChildRows be a item state that gets returned by the hook?
    return {
        rowProps: {
            ...(0, _utils.mergeProps)(rowProps, treeGridRowProps)
        },
        gridCellProps,
        descriptionProps: {
            id: descriptionId
        },
        ...itemStates
    };
}
function last(walker) {
    let next = null;
    let last = null;
    do {
        last = walker.lastChild();
        if (last) next = last;
    }while (last);
    return next;
}

},{"@react-aria/utils":[["chain","ij7eS"],["getScrollParent","1Tu7U"],["mergeProps","aNvcY"],["scrollIntoViewport","1lzpw"],["useSlotId","jbI4Y"],["useSyntheticLinkProps","4FGnT"]],"@react-aria/focus":[["focusSafely","2ysUy"],["getFocusableTreeWalker","9oPIl"]],"./utils":"aJkqW","react":"a1TxN","@react-aria/interactions":"dkfxW","@react-aria/selection":"cJdJS","@react-aria/i18n":"4k4z8","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"7Sr64":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CardViewContext", ()=>CardViewContext);
parcelHelpers.export(exports, "CardView", ()=>CardView);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _card = require("./Card");
var _react = require("react");
var _imageCoordinator = require("./ImageCoordinator");
var _actionBar = require("./ActionBar");
var _utils = require("@react-spectrum/utils");
var _utils1 = require("@react-aria/utils");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const layoutOptions = {
    XS: {
        compact: {
            minSpace: new (0, _reactAriaComponents.Size)(6, 6),
            minItemSize: new (0, _reactAriaComponents.Size)(100, 100),
            maxItemSize: new (0, _reactAriaComponents.Size)(140, 140)
        },
        regular: {
            minSpace: new (0, _reactAriaComponents.Size)(8, 8),
            minItemSize: new (0, _reactAriaComponents.Size)(100, 100),
            maxItemSize: new (0, _reactAriaComponents.Size)(140, 140)
        },
        spacious: {
            minSpace: new (0, _reactAriaComponents.Size)(12, 12),
            minItemSize: new (0, _reactAriaComponents.Size)(100, 100),
            maxItemSize: new (0, _reactAriaComponents.Size)(140, 140)
        }
    },
    S: {
        compact: {
            minSpace: new (0, _reactAriaComponents.Size)(8, 8),
            minItemSize: new (0, _reactAriaComponents.Size)(150, 150),
            maxItemSize: new (0, _reactAriaComponents.Size)(210, 210)
        },
        regular: {
            minSpace: new (0, _reactAriaComponents.Size)(12, 12),
            minItemSize: new (0, _reactAriaComponents.Size)(150, 150),
            maxItemSize: new (0, _reactAriaComponents.Size)(210, 210)
        },
        spacious: {
            minSpace: new (0, _reactAriaComponents.Size)(16, 16),
            minItemSize: new (0, _reactAriaComponents.Size)(150, 150),
            maxItemSize: new (0, _reactAriaComponents.Size)(210, 210)
        }
    },
    M: {
        compact: {
            minSpace: new (0, _reactAriaComponents.Size)(12, 12),
            minItemSize: new (0, _reactAriaComponents.Size)(200, 200),
            maxItemSize: new (0, _reactAriaComponents.Size)(280, 280)
        },
        regular: {
            minSpace: new (0, _reactAriaComponents.Size)(16, 16),
            minItemSize: new (0, _reactAriaComponents.Size)(200, 200),
            maxItemSize: new (0, _reactAriaComponents.Size)(280, 280)
        },
        spacious: {
            minSpace: new (0, _reactAriaComponents.Size)(20, 20),
            minItemSize: new (0, _reactAriaComponents.Size)(200, 200),
            maxItemSize: new (0, _reactAriaComponents.Size)(280, 280)
        }
    },
    L: {
        compact: {
            minSpace: new (0, _reactAriaComponents.Size)(16, 16),
            minItemSize: new (0, _reactAriaComponents.Size)(270, 270),
            maxItemSize: new (0, _reactAriaComponents.Size)(370, 370)
        },
        regular: {
            minSpace: new (0, _reactAriaComponents.Size)(20, 20),
            minItemSize: new (0, _reactAriaComponents.Size)(270, 270),
            maxItemSize: new (0, _reactAriaComponents.Size)(370, 370)
        },
        spacious: {
            minSpace: new (0, _reactAriaComponents.Size)(24, 24),
            minItemSize: new (0, _reactAriaComponents.Size)(270, 270),
            maxItemSize: new (0, _reactAriaComponents.Size)(370, 370)
        }
    },
    XL: {
        compact: {
            minSpace: new (0, _reactAriaComponents.Size)(20, 20),
            minItemSize: new (0, _reactAriaComponents.Size)(340, 340),
            maxItemSize: new (0, _reactAriaComponents.Size)(460, 460)
        },
        regular: {
            minSpace: new (0, _reactAriaComponents.Size)(24, 24),
            minItemSize: new (0, _reactAriaComponents.Size)(340, 340),
            maxItemSize: new (0, _reactAriaComponents.Size)(460, 460)
        },
        spacious: {
            minSpace: new (0, _reactAriaComponents.Size)(28, 28),
            minItemSize: new (0, _reactAriaComponents.Size)(340, 340),
            maxItemSize: new (0, _reactAriaComponents.Size)(460, 460)
        }
    }
};
const SIZES = [
    'XS',
    'S',
    'M',
    'L',
    'XL'
];
const cardViewStyles = function anonymous(props, overrides) {
    let rules = " ", currentRules = {};
    let height = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L|F|M|K|-macro\$)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "F") height = true;
        rules += p[0];
    }
    if (props.isLoading) {
        rules += ' Pc12';
        currentRules["overflowY"] = typeof currentRules["overflowY"] === 'object' ? currentRules["overflowY"] : {
            "default": currentRules["overflowY"]
        };
        currentRules["overflowY"]["isLoading"] = "hidden";
    } else {
        rules += ' Pa12';
        currentRules["overflowY"] = "auto";
    }
    if (props.isEmpty) {
        rules += ' sd12';
        currentRules["display"] = typeof currentRules["display"] === 'object' ? currentRules["display"] : {
            "default": currentRules["display"]
        };
        currentRules["display"]["isEmpty"] = "flex";
    }
    rules += ' _oa12';
    currentRules["boxSizing"] = "border-box";
    rules += ' _ta12';
    currentRules["flexDirection"] = "column";
    rules += ' eb12';
    currentRules["alignItems"] = "center";
    rules += ' _Ca12';
    currentRules["justifyContent"] = "center";
    if (props.isEmpty) {
        if (props.isFocusVisible) {
            rules += ' _Lf12';
            currentRules["outlineStyle"] = typeof currentRules["outlineStyle"] === 'object' ? currentRules["outlineStyle"] : {
                "default": currentRules["outlineStyle"]
            };
            currentRules["outlineStyle"]["isEmpty && isFocusVisible"] = "solid";
        }
    } else {
        rules += ' _Le12';
        currentRules["outlineStyle"] = "none";
    }
    rules += ' Oh12';
    currentRules["outlineColor"] = "focus-ring";
    rules += ' _Mc12';
    currentRules["outlineWidth"] = 2;
    rules += ' _Kb12';
    currentRules["outlineOffset"] = -2;
    if (props.isActionBar) {
        if (!height) rules += ' Fb12';
        currentRules["height"] = typeof currentRules["height"] === 'object' ? currentRules["height"] : {
            "default": currentRules["height"]
        };
        currentRules["height"]["isActionBar"] = "full";
    }
    return rules;
};
const wrapperStyles = function anonymous(props, overrides) {
    let rules = " ", currentRules = {};
    let position = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L|F|M|K|-macro\$)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "_P") position = true;
        rules += p[0];
    }
    if (!position) rules += ' _Pc12';
    currentRules["position"] = "relative";
    rules += ' _Nb12';
    currentRules["overflowX"] = "clip";
    rules += ' Pb12';
    currentRules["overflowY"] = "clip";
    return rules;
};
const CardViewContext = /*#__PURE__*/ (0, _react.createContext)(null);
const CardView = /*#__PURE__*/ (0, _react.forwardRef)(function CardView(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, CardViewContext);
    let { children, layout: layoutName = 'grid', size: sizeProp = 'M', density = 'regular', variant = 'primary', selectionStyle = 'checkbox', UNSAFE_className = '', UNSAFE_style, styles, loadingState, onLoadMore, items, renderEmptyState: renderEmptyStateProp, ...otherProps } = props;
    let domRef = (0, _utils.useDOMRef)(ref);
    let innerRef = (0, _react.useRef)(null);
    let scrollRef = props.renderActionBar ? innerRef : domRef;
    // This calculates the maximum t-shirt size where at least two columns fit in the available width.
    let [maxSizeIndex, setMaxSizeIndex] = (0, _react.useState)(SIZES.length - 1);
    let updateSize = (0, _react.useCallback)(()=>{
        let w = scrollRef.current?.clientWidth ?? 0;
        let i = SIZES.length - 1;
        while(i > 0){
            let opts = layoutOptions[SIZES[i]][density];
            if (w >= opts.minItemSize.width * 2 + opts.minSpace.width * 3) break;
            i--;
        }
        setMaxSizeIndex(i);
    }, [
        scrollRef,
        density
    ]);
    let updateSizeEvent = (0, _utils1.useEffectEvent)(updateSize);
    (0, _utils1.useResizeObserver)({
        ref: scrollRef,
        box: 'border-box',
        onResize: updateSize
    });
    (0, _utils1.useLayoutEffect)(()=>{
        updateSizeEvent();
    }, []);
    // The actual rendered t-shirt size is the minimum between the size prop and the maximum possible size.
    let size = SIZES[Math.min(maxSizeIndex, SIZES.indexOf(sizeProp))];
    let layout = layoutName === 'waterfall' ? (0, _reactAriaComponents.WaterfallLayout) : (0, _reactAriaComponents.GridLayout);
    let options = layoutOptions[size][density];
    let ctx = (0, _react.useMemo)(()=>({
            size,
            variant
        }), [
        size,
        variant
    ]);
    let { selectedKeys, onSelectionChange, actionBar, actionBarHeight } = (0, _actionBar.useActionBarContainer)({
        ...props,
        scrollRef
    });
    let isLoading = loadingState === 'loading' || loadingState === 'loadingMore';
    let renderer;
    let cardLoadingSentinel = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.GridListLoadMoreItem), {
        isLoading: isLoading,
        onLoadMore: onLoadMore
    });
    if (typeof children === 'function' && items) renderer = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Collection), {
                items: items,
                dependencies: props.dependencies,
                children: children
            }),
            cardLoadingSentinel
        ]
    });
    else renderer = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            children,
            cardLoadingSentinel
        ]
    });
    // Wrap the renderEmptyState function so that it is not called when there is a skeleton loader.
    let renderEmptyState = renderEmptyStateProp ? (renderProps)=>{
        let collection = renderProps.state.collection;
        let firstKey = collection.getFirstKey();
        if (firstKey == null || collection.getItem(firstKey)?.type !== 'skeleton') return renderEmptyStateProp(renderProps);
    } : undefined;
    let cardViewCtx = (0, _react.useMemo)(()=>({
            layout: layoutName,
            ElementType: (0, _reactAriaComponents.GridListItem)
        }), [
        layoutName
    ]);
    let cardView = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Virtualizer), {
        layout: layout,
        layoutOptions: options,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.InternalCardViewContext).Provider, {
            value: cardViewCtx,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.CardContext).Provider, {
                value: ctx,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _imageCoordinator.ImageCoordinator), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.GridList), {
                        ref: scrollRef,
                        ...otherProps,
                        renderEmptyState: renderEmptyState,
                        items: items,
                        layout: "grid",
                        selectionBehavior: selectionStyle === 'highlight' ? 'replace' : 'toggle',
                        selectedKeys: selectedKeys,
                        defaultSelectedKeys: undefined,
                        onSelectionChange: onSelectionChange,
                        style: {
                            ...!props.renderActionBar ? UNSAFE_style : {},
                            // Add padding at the bottom when the action bar is visible so users can scroll to the last items.
                            // Also add scroll padding so keyboard navigating preserves the padding.
                            paddingBottom: actionBarHeight > 0 ? actionBarHeight + options.minSpace.height : 0,
                            scrollPadding: options.minSpace.height,
                            scrollPaddingBottom: actionBarHeight + options.minSpace.height
                        },
                        className: (renderProps)=>(!props.renderActionBar ? UNSAFE_className : '') + cardViewStyles({
                                ...renderProps,
                                isLoading: props.loadingState === 'loading',
                                isActionBar: !!props.renderActionBar
                            }, !props.renderActionBar ? styles : undefined),
                        children: renderer
                    })
                })
            })
        })
    });
    // Add extra wrapper if there is an action bar so we can position relative to it.
    // ActionBar cannot be inside the GridList due to ARIA and focus management requirements.
    if (props.renderActionBar) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        ref: domRef,
        className: UNSAFE_className + wrapperStyles(null, styles),
        style: UNSAFE_style,
        children: [
            cardView,
            actionBar
        ]
    });
    return cardView;
});

},{"0":"fCS7D","1":"iHGCr","react/jsx-runtime":"2Is6Z","react-aria-components":[["Collection","2Jd0Q"],["GridLayout","hMlI1"],["GridList","8bLgh"],["GridListItem","8bLgh"],["GridListLoadMoreItem","8bLgh"],["Size","F8cca"],["Virtualizer","2WSF6"],["WaterfallLayout","jREgn"]],"./Card":"jxfoI","react":"a1TxN","./ImageCoordinator":"3PQZz","./ActionBar":"gU4lG","@react-spectrum/utils":"jqfrX","@react-aria/utils":[["useEffectEvent","eg4dC"],["useLayoutEffect","2ViQu"],["useResizeObserver","7OAb4"]],"./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fCS7D":[function() {},{}],"iHGCr":[function() {},{}],"8bLgh":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridListContext", ()=>GridListContext);
parcelHelpers.export(exports, "GridList", ()=>GridList);
parcelHelpers.export(exports, "GridListItem", ()=>GridListItem);
parcelHelpers.export(exports, "GridListLoadMoreItem", ()=>GridListLoadMoreItem);
parcelHelpers.export(exports, "GridListSection", ()=>GridListSection);
parcelHelpers.export(exports, "GridListHeaderContext", ()=>GridListHeaderContext);
parcelHelpers.export(exports, "GridListHeader", ()=>GridListHeader);
var _reactAria = require("react-aria");
var _button = require("./Button");
var _rspcontexts = require("./RSPContexts");
var _utils = require("./utils");
var _collections = require("@react-aria/collections");
var _collection = require("./Collection");
var _dragAndDrop = require("./DragAndDrop");
var _reactStately = require("react-stately");
var _utils1 = require("@react-aria/utils");
var _listBox = require("./ListBox");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _selectionIndicator = require("./SelectionIndicator");
var _sharedElementTransition = require("./SharedElementTransition");
var _text = require("./Text");
const GridListContext = /*#__PURE__*/ (0, _react.createContext)(null);
const GridList = /*#__PURE__*/ (0, _react.forwardRef)(function GridList(props, ref) {
    // Render the portal first so that we have the collection by the time we render the DOM in SSR.
    [props, ref] = (0, _utils.useContextProps)(props, ref, GridListContext);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.CollectionBuilder), {
        content: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Collection), props)
    }, (collection)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(GridListInner, {
            props: props,
            collection: collection,
            gridListRef: ref
        }));
});
function GridListInner({ props, collection, gridListRef: ref }) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, (0, _rspcontexts.SelectableCollectionContext));
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let { shouldUseVirtualFocus, filter, disallowTypeAhead, ...DOMCollectionProps } = props;
    let { dragAndDropHooks, keyboardNavigationBehavior = 'arrow', layout = 'stack' } = props;
    let { CollectionRoot, isVirtualized, layoutDelegate, dropTargetDelegate: ctxDropTargetDelegate } = (0, _react.useContext)((0, _collection.CollectionRendererContext));
    let gridlistState = (0, _reactStately.useListState)({
        ...DOMCollectionProps,
        collection,
        children: undefined,
        layoutDelegate
    });
    let filteredState = (0, _reactStately.UNSTABLE_useFilteredListState)(gridlistState, filter);
    let collator = (0, _reactAria.useCollator)({
        usage: 'search',
        sensitivity: 'base'
    });
    let { disabledBehavior, disabledKeys } = filteredState.selectionManager;
    let { direction } = (0, _reactAria.useLocale)();
    let keyboardDelegate = (0, _react.useMemo)(()=>new (0, _reactAria.ListKeyboardDelegate)({
            collection: filteredState.collection,
            collator,
            ref,
            disabledKeys,
            disabledBehavior,
            layoutDelegate,
            layout,
            direction
        }), [
        filteredState.collection,
        ref,
        layout,
        disabledKeys,
        disabledBehavior,
        layoutDelegate,
        collator,
        direction
    ]);
    let { gridProps } = (0, _reactAria.useGridList)({
        ...DOMCollectionProps,
        keyboardDelegate,
        // Only tab navigation is supported in grid layout.
        keyboardNavigationBehavior: layout === 'grid' ? 'tab' : keyboardNavigationBehavior,
        isVirtualized,
        shouldSelectOnPressUp: props.shouldSelectOnPressUp
    }, filteredState, ref);
    let selectionManager = filteredState.selectionManager;
    let isListDraggable = !!dragAndDropHooks?.useDraggableCollectionState;
    let isListDroppable = !!dragAndDropHooks?.useDroppableCollectionState;
    let dragHooksProvided = (0, _react.useRef)(isListDraggable);
    let dropHooksProvided = (0, _react.useRef)(isListDroppable);
    (0, _react.useEffect)(()=>{
        return;
    }, [
        isListDraggable,
        isListDroppable
    ]);
    let dragState = undefined;
    let dropState = undefined;
    let droppableCollection = undefined;
    let isRootDropTarget = false;
    let dragPreview = null;
    let preview = (0, _react.useRef)(null);
    if (isListDraggable && dragAndDropHooks) {
        dragState = dragAndDropHooks.useDraggableCollectionState({
            collection: filteredState.collection,
            selectionManager,
            preview: dragAndDropHooks.renderDragPreview ? preview : undefined
        });
        dragAndDropHooks.useDraggableCollection({}, dragState, ref);
        let DragPreview = dragAndDropHooks.DragPreview;
        dragPreview = dragAndDropHooks.renderDragPreview ? /*#__PURE__*/ (0, _reactDefault.default).createElement(DragPreview, {
            ref: preview
        }, dragAndDropHooks.renderDragPreview) : null;
    }
    if (isListDroppable && dragAndDropHooks) {
        dropState = dragAndDropHooks.useDroppableCollectionState({
            collection: filteredState.collection,
            selectionManager
        });
        let keyboardDelegate = new (0, _reactAria.ListKeyboardDelegate)({
            collection: filteredState.collection,
            disabledKeys: selectionManager.disabledKeys,
            disabledBehavior: selectionManager.disabledBehavior,
            ref
        });
        let dropTargetDelegate = dragAndDropHooks.dropTargetDelegate || ctxDropTargetDelegate || new dragAndDropHooks.ListDropTargetDelegate(collection, ref, {
            layout,
            direction
        });
        droppableCollection = dragAndDropHooks.useDroppableCollection({
            keyboardDelegate,
            dropTargetDelegate
        }, dropState, ref);
        isRootDropTarget = dropState.isDropTarget({
            type: 'root'
        });
    }
    let { focusProps, isFocused, isFocusVisible } = (0, _reactAria.useFocusRing)();
    let isEmpty = filteredState.collection.size === 0;
    let renderValues = {
        isDropTarget: isRootDropTarget,
        isEmpty,
        isFocused,
        isFocusVisible,
        layout,
        state: filteredState
    };
    let renderProps = (0, _utils.useRenderProps)({
        className: props.className,
        style: props.style,
        defaultClassName: 'react-aria-GridList',
        values: renderValues
    });
    let emptyState = null;
    let emptyStatePropOverrides = null;
    if (isEmpty && props.renderEmptyState) {
        let content = props.renderEmptyState(renderValues);
        emptyState = /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            role: "row",
            "aria-rowindex": 1,
            style: {
                display: 'contents'
            }
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            role: "gridcell",
            style: {
                display: 'contents'
            }
        }, content));
    }
    let DOMProps = (0, _utils1.filterDOMProps)(props, {
        global: true
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAria.FocusScope), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _reactAria.mergeProps)(DOMProps, renderProps, gridProps, focusProps, droppableCollection?.collectionProps, emptyStatePropOverrides),
        ref: ref,
        slot: props.slot || undefined,
        onScroll: props.onScroll,
        "data-drop-target": isRootDropTarget || undefined,
        "data-empty": isEmpty || undefined,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-layout": layout
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                (0, _listBox.ListStateContext),
                filteredState
            ],
            [
                (0, _dragAndDrop.DragAndDropContext),
                {
                    dragAndDropHooks,
                    dragState,
                    dropState
                }
            ],
            [
                (0, _dragAndDrop.DropIndicatorContext),
                {
                    render: GridListDropIndicatorWrapper
                }
            ]
        ]
    }, isListDroppable && /*#__PURE__*/ (0, _reactDefault.default).createElement(RootDropIndicator, null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _sharedElementTransition.SharedElementTransition), null, /*#__PURE__*/ (0, _reactDefault.default).createElement(CollectionRoot, {
        collection: filteredState.collection,
        scrollRef: ref,
        persistedKeys: (0, _dragAndDrop.useDndPersistedKeys)(selectionManager, dragAndDropHooks, dropState),
        renderDropIndicator: (0, _dragAndDrop.useRenderDropIndicator)(dragAndDropHooks, dropState)
    }))), emptyState, dragPreview));
}
const GridListItem = /*#__PURE__*/ (0, _collections.createLeafComponent)((0, _collections.ItemNode), function GridListItem(props, forwardedRef, item) {
    let state = (0, _react.useContext)((0, _listBox.ListStateContext));
    let { dragAndDropHooks, dragState, dropState } = (0, _react.useContext)((0, _dragAndDrop.DragAndDropContext));
    let ref = (0, _utils1.useObjectRef)(forwardedRef);
    let { isVirtualized } = (0, _react.useContext)((0, _collection.CollectionRendererContext));
    let { rowProps, gridCellProps, descriptionProps, ...states } = (0, _reactAria.useGridListItem)({
        node: item,
        shouldSelectOnPressUp: !!dragState,
        isVirtualized
    }, state, ref);
    let { hoverProps, isHovered } = (0, _reactAria.useHover)({
        isDisabled: !states.allowsSelection && !states.hasAction,
        onHoverStart: item.props.onHoverStart,
        onHoverChange: item.props.onHoverChange,
        onHoverEnd: item.props.onHoverEnd
    });
    let { isFocusVisible, focusProps } = (0, _reactAria.useFocusRing)();
    let { checkboxProps } = (0, _reactAria.useGridListSelectionCheckbox)({
        key: item.key
    }, state);
    let buttonProps = state.selectionManager.disabledBehavior === 'all' && states.isDisabled ? {
        isDisabled: true
    } : {};
    let draggableItem = null;
    if (dragState && dragAndDropHooks) draggableItem = dragAndDropHooks.useDraggableItem({
        key: item.key,
        hasDragButton: true
    }, dragState);
    let dropIndicator = null;
    let dropIndicatorRef = (0, _react.useRef)(null);
    let { visuallyHiddenProps } = (0, _reactAria.useVisuallyHidden)();
    if (dropState && dragAndDropHooks) dropIndicator = dragAndDropHooks.useDropIndicator({
        target: {
            type: 'item',
            key: item.key,
            dropPosition: 'on'
        }
    }, dropState, dropIndicatorRef);
    let isDragging = dragState && dragState.isDragging(item.key);
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        id: undefined,
        children: item.rendered,
        defaultClassName: 'react-aria-GridListItem',
        values: {
            ...states,
            isHovered,
            isFocusVisible,
            selectionMode: state.selectionManager.selectionMode,
            selectionBehavior: state.selectionManager.selectionBehavior,
            allowsDragging: !!dragState,
            isDragging,
            isDropTarget: dropIndicator?.isDropTarget
        }
    });
    let dragButtonRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        if (dragState && !dragButtonRef.current) console.warn('Draggable items in a GridList must contain a <Button slot="drag"> element so that keyboard and screen reader users can drag them.');
    // eslint-disable-next-line
    }, []);
    (0, _react.useEffect)(()=>{
        item.textValue;
    }, [
        item.textValue
    ]);
    let DOMProps = (0, _utils1.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    delete DOMProps.onClick;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, dropIndicator && !dropIndicator.isHidden && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "row",
        style: {
            position: 'absolute'
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "gridcell"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "button",
        ...visuallyHiddenProps,
        ...dropIndicator?.dropIndicatorProps,
        ref: dropIndicatorRef
    }))), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _reactAria.mergeProps)(DOMProps, renderProps, rowProps, focusProps, hoverProps, draggableItem?.dragProps),
        ref: ref,
        "data-selected": states.isSelected || undefined,
        "data-disabled": states.isDisabled || undefined,
        "data-hovered": isHovered || undefined,
        "data-focused": states.isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-pressed": states.isPressed || undefined,
        "data-allows-dragging": !!dragState || undefined,
        "data-dragging": isDragging || undefined,
        "data-drop-target": dropIndicator?.isDropTarget || undefined,
        "data-selection-mode": state.selectionManager.selectionMode === 'none' ? undefined : state.selectionManager.selectionMode
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...gridCellProps,
        style: {
            display: 'contents'
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                (0, _rspcontexts.CheckboxContext),
                {
                    slots: {
                        [(0, _utils.DEFAULT_SLOT)]: {},
                        selection: checkboxProps
                    }
                }
            ],
            [
                (0, _button.ButtonContext),
                {
                    slots: {
                        [(0, _utils.DEFAULT_SLOT)]: buttonProps,
                        drag: {
                            ...draggableItem?.dragButtonProps,
                            ref: dragButtonRef,
                            style: {
                                pointerEvents: 'none'
                            }
                        }
                    }
                }
            ],
            [
                (0, _text.TextContext),
                {
                    slots: {
                        [(0, _utils.DEFAULT_SLOT)]: {},
                        description: descriptionProps
                    }
                }
            ],
            [
                (0, _collection.CollectionRendererContext),
                (0, _collection.DefaultCollectionRenderer)
            ],
            [
                (0, _listBox.ListStateContext),
                null
            ],
            [
                (0, _rspcontexts.SelectableCollectionContext),
                null
            ],
            [
                (0, _rspcontexts.FieldInputContext),
                null
            ],
            [
                (0, _selectionIndicator.SelectionIndicatorContext),
                {
                    isSelected: states.isSelected
                }
            ]
        ]
    }, renderProps.children))));
});
function GridListDropIndicatorWrapper(props, ref) {
    ref = (0, _utils1.useObjectRef)(ref);
    let { dragAndDropHooks, dropState } = (0, _react.useContext)((0, _dragAndDrop.DragAndDropContext));
    let buttonRef = (0, _react.useRef)(null);
    let { dropIndicatorProps, isHidden, isDropTarget } = dragAndDropHooks.useDropIndicator(props, dropState, buttonRef);
    if (isHidden) return null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(GridListDropIndicatorForwardRef, {
        ...props,
        dropIndicatorProps: dropIndicatorProps,
        isDropTarget: isDropTarget,
        buttonRef: buttonRef,
        ref: ref
    });
}
function GridListDropIndicator(props, ref) {
    let { dropIndicatorProps, isDropTarget, buttonRef, ...otherProps } = props;
    let { visuallyHiddenProps } = (0, _reactAria.useVisuallyHidden)();
    let renderProps = (0, _utils.useRenderProps)({
        ...otherProps,
        defaultClassName: 'react-aria-DropIndicator',
        values: {
            isDropTarget
        }
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...renderProps,
        role: "row",
        ref: ref,
        "data-drop-target": isDropTarget || undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "gridcell"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...visuallyHiddenProps,
        role: "button",
        ...dropIndicatorProps,
        ref: buttonRef
    }), renderProps.children));
}
const GridListDropIndicatorForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(GridListDropIndicator);
function RootDropIndicator() {
    let { dragAndDropHooks, dropState } = (0, _react.useContext)((0, _dragAndDrop.DragAndDropContext));
    let ref = (0, _react.useRef)(null);
    let { dropIndicatorProps } = dragAndDropHooks.useDropIndicator({
        target: {
            type: 'root'
        }
    }, dropState, ref);
    let isDropTarget = dropState.isDropTarget({
        type: 'root'
    });
    let { visuallyHiddenProps } = (0, _reactAria.useVisuallyHidden)();
    if (!isDropTarget && dropIndicatorProps['aria-hidden']) return null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "row",
        "aria-hidden": dropIndicatorProps['aria-hidden'],
        style: {
            position: 'absolute'
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "gridcell"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "button",
        ...visuallyHiddenProps,
        ...dropIndicatorProps,
        ref: ref
    })));
}
const GridListLoadMoreItem = (0, _collections.createLeafComponent)((0, _collections.LoaderNode), function GridListLoadingIndicator(props, ref, item) {
    let state = (0, _react.useContext)((0, _listBox.ListStateContext));
    let { isVirtualized } = (0, _react.useContext)((0, _collection.CollectionRendererContext));
    let { isLoading, onLoadMore, scrollOffset, ...otherProps } = props;
    let sentinelRef = (0, _react.useRef)(null);
    let memoedLoadMoreProps = (0, _react.useMemo)(()=>({
            onLoadMore,
            collection: state?.collection,
            sentinelRef,
            scrollOffset
        }), [
        onLoadMore,
        scrollOffset,
        state?.collection
    ]);
    (0, _utils1.useLoadMoreSentinel)(memoedLoadMoreProps, sentinelRef);
    let renderProps = (0, _utils.useRenderProps)({
        ...otherProps,
        id: undefined,
        children: item.rendered,
        defaultClassName: 'react-aria-GridListLoadingIndicator',
        values: null
    });
    // For now don't include aria-posinset and aria-setsize on loader since they aren't keyboard focusable
    // Arguably shouldn't include them ever since it might be confusing to the user to include the loaders as part of the
    // item count
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            position: 'relative',
            width: 0,
            height: 0
        },
        inert: (0, _utils1.inertValue)(true)
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        "data-testid": "loadMoreSentinel",
        ref: sentinelRef,
        style: {
            position: 'absolute',
            height: 1,
            width: 1
        }
    })), isLoading && renderProps.children && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...renderProps,
        ...(0, _utils1.filterDOMProps)(props, {
            global: true
        }),
        role: "row",
        ref: ref
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        "aria-colindex": isVirtualized ? 1 : undefined,
        role: "gridcell"
    }, renderProps.children)));
});
const GridListSection = /*#__PURE__*/ (0, _collections.createBranchComponent)((0, _collections.SectionNode), (props, ref, item)=>{
    let state = (0, _react.useContext)((0, _listBox.ListStateContext));
    let { CollectionBranch } = (0, _react.useContext)((0, _collection.CollectionRendererContext));
    let headingRef = (0, _react.useRef)(null);
    ref = (0, _utils1.useObjectRef)(ref);
    let { rowHeaderProps, rowProps, rowGroupProps } = (0, _reactAria.useGridListSection)({
        'aria-label': props['aria-label'] ?? undefined
    }, state, ref);
    let renderProps = (0, _utils.useRenderProps)({
        defaultClassName: 'react-aria-GridListSection',
        className: props.className,
        style: props.style,
        values: {}
    });
    let DOMProps = (0, _utils1.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _reactAria.mergeProps)(DOMProps, renderProps, rowGroupProps),
        ref: ref
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                GridListHeaderContext,
                {
                    ...rowProps,
                    ref: headingRef
                }
            ],
            [
                GridListHeaderInnerContext,
                {
                    ...rowHeaderProps
                }
            ]
        ]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(CollectionBranch, {
        collection: state.collection,
        parent: item
    })));
});
const GridListHeaderContext = /*#__PURE__*/ (0, _react.createContext)({});
const GridListHeaderInnerContext = /*#__PURE__*/ (0, _react.createContext)(null);
const GridListHeader = /*#__PURE__*/ (0, _collections.createLeafComponent)((0, _collections.HeaderNode), function Header(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, GridListHeaderContext);
    let rowHeaderProps = (0, _react.useContext)(GridListHeaderInnerContext);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "react-aria-GridListHeader",
        ref: ref,
        ...props
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...rowHeaderProps,
        style: {
            display: 'contents'
        }
    }, props.children));
});

},{"react-aria":[["FocusScope","9oPIl"],["ListKeyboardDelegate","gVeiB"],["mergeProps","aNvcY"],["useCollator","aohjl"],["useFocusRing","6TXyU"],["useGridList","1PPGS"],["useGridListItem","fNHH4"],["useGridListSection","8sW90"],["useGridListSelectionCheckbox","hH0ym"],["useHover","k6FLA"],["useLocale","4k4z8"],["useVisuallyHidden","7zrGr"]],"./Button":"9G5XO","./RSPContexts":"lIerG","./utils":"bA6Cz","@react-aria/collections":[["Collection","2Jd0Q"],["CollectionBuilder","2Jd0Q"],["createBranchComponent","2Jd0Q"],["createLeafComponent","2Jd0Q"],["HeaderNode","ab6Rh"],["ItemNode","ab6Rh"],["LoaderNode","ab6Rh"],["SectionNode","ab6Rh"]],"./Collection":"7QyMy","./DragAndDrop":"kft18","react-stately":"hjoHP","@react-aria/utils":[["filterDOMProps","3upVm"],["inertValue","aL0AK"],["useLoadMoreSentinel","aBVY3"],["useObjectRef","laqO5"]],"./ListBox":"dNdIK","react":"a1TxN","./SelectionIndicator":"dgQU7","./SharedElementTransition":"iVZnk","./Text":"jt9fm","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8sW90":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a section in a grid list.
 * See `useGridList` for more details about grid list.
 * @param props - Props for the section.
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
parcelHelpers.export(exports, "useGridListSection", ()=>useGridListSection);
var _utils = require("@react-aria/utils");
function useGridListSection(props, state, ref) {
    let { 'aria-label': ariaLabel } = props;
    let headingId = (0, _utils.useSlotId)();
    let labelProps = (0, _utils.useLabels)({
        'aria-label': ariaLabel,
        'aria-labelledby': headingId
    });
    return {
        rowProps: {
            role: 'row'
        },
        rowHeaderProps: {
            id: headingId,
            role: 'rowheader'
        },
        rowGroupProps: {
            role: 'rowgroup',
            ...labelProps
        }
    };
}

},{"@react-aria/utils":[["useLabels","7Uhyw"],["useSlotId","jbI4Y"]],"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hH0ym":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a selection checkbox in a grid list.
 * @param props - Props for the selection checkbox.
 * @param state - State of the list, as returned by `useListState`.
 */ parcelHelpers.export(exports, "useGridListSelectionCheckbox", ()=>useGridListSelectionCheckbox);
var _grid = require("@react-aria/grid");
var _utils = require("./utils");
function useGridListSelectionCheckbox(props, state) {
    let { key } = props;
    const { checkboxProps } = (0, _grid.useGridSelectionCheckbox)(props, state);
    return {
        checkboxProps: {
            ...checkboxProps,
            'aria-labelledby': `${checkboxProps.id} ${(0, _utils.getRowId)(state, key)}`
        }
    };
}

},{"@react-aria/grid":"8WxyV","./utils":"aJkqW","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8WxyV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a selection checkbox in a grid.
 * @param props - Props for the selection checkbox.
 * @param state - State of the grid, as returned by `useGridState`.
 */ parcelHelpers.export(exports, "useGridSelectionCheckbox", ()=>useGridSelectionCheckbox);
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _utils = require("@react-aria/utils");
var _i18N = require("@react-aria/i18n");
function useGridSelectionCheckbox(props, state) {
    let { key } = props;
    let manager = state.selectionManager;
    let checkboxId = (0, _utils.useId)();
    let isDisabled = !state.selectionManager.canSelectItem(key);
    let isSelected = state.selectionManager.isSelected(key);
    // Checkbox should always toggle selection, regardless of selectionBehavior.
    let onChange = ()=>manager.toggleSelection(key);
    const stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-aria/grid');
    return {
        checkboxProps: {
            id: checkboxId,
            'aria-label': stringFormatter.format('select'),
            isSelected,
            isDisabled,
            onChange
        }
    };
}

},{"../intl/*.json":"hdtsN","@react-aria/utils":"jbI4Y","@react-aria/i18n":"7lxyl","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jREgn":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WaterfallLayout", ()=>WaterfallLayout);
var _virtualizer = require("@react-stately/virtualizer");
class WaterfallLayoutInfo extends (0, _virtualizer.LayoutInfo) {
    copy() {
        let res = super.copy();
        res.column = this.column;
        res.index = this.index;
        return res;
    }
    constructor(...args){
        super(...args), this.column = 0, this.index = 0;
    }
}
const DEFAULT_OPTIONS = {
    minItemSize: new (0, _virtualizer.Size)(200, 200),
    maxItemSize: new (0, _virtualizer.Size)(Infinity, Infinity),
    minSpace: new (0, _virtualizer.Size)(18, 18),
    maxSpace: Infinity,
    maxColumns: Infinity,
    dropIndicatorThickness: 2
};
class WaterfallLayout extends (0, _virtualizer.Layout) {
    shouldInvalidateLayoutOptions(newOptions, oldOptions) {
        return newOptions.maxColumns !== oldOptions.maxColumns || newOptions.dropIndicatorThickness !== oldOptions.dropIndicatorThickness || !(newOptions.minItemSize || DEFAULT_OPTIONS.minItemSize).equals(oldOptions.minItemSize || DEFAULT_OPTIONS.minItemSize) || !(newOptions.maxItemSize || DEFAULT_OPTIONS.maxItemSize).equals(oldOptions.maxItemSize || DEFAULT_OPTIONS.maxItemSize) || !(newOptions.minSpace || DEFAULT_OPTIONS.minSpace).equals(oldOptions.minSpace || DEFAULT_OPTIONS.minSpace) || newOptions.maxHorizontalSpace !== oldOptions.maxHorizontalSpace;
    }
    update(invalidationContext) {
        let { minItemSize = DEFAULT_OPTIONS.minItemSize, maxItemSize = DEFAULT_OPTIONS.maxItemSize, minSpace = DEFAULT_OPTIONS.minSpace, maxHorizontalSpace = DEFAULT_OPTIONS.maxSpace, maxColumns = DEFAULT_OPTIONS.maxColumns, dropIndicatorThickness = DEFAULT_OPTIONS.dropIndicatorThickness } = invalidationContext.layoutOptions || {};
        this.dropIndicatorThickness = dropIndicatorThickness;
        let visibleWidth = this.virtualizer.visibleRect.width;
        // The max item width is always the entire viewport.
        // If the max item height is infinity, scale in proportion to the max width.
        let maxItemWidth = Math.min(maxItemSize.width, visibleWidth);
        let maxItemHeight = Number.isFinite(maxItemSize.height) ? maxItemSize.height : Math.floor(minItemSize.height / minItemSize.width * maxItemWidth);
        // Compute the number of rows and columns needed to display the content
        let columns = Math.floor(visibleWidth / (minItemSize.width + minSpace.width));
        let numColumns = Math.max(1, Math.min(maxColumns, columns));
        // Compute the available width (minus the space between items)
        let width = visibleWidth - minSpace.width * Math.max(0, numColumns);
        // Compute the item width based on the space available
        let itemWidth = Math.floor(width / numColumns);
        itemWidth = Math.max(minItemSize.width, Math.min(maxItemWidth, itemWidth));
        // Compute the item height, which is proportional to the item width
        let t = (itemWidth - minItemSize.width) / Math.max(1, maxItemWidth - minItemSize.width);
        let itemHeight = minItemSize.height + Math.floor((maxItemHeight - minItemSize.height) * t);
        itemHeight = Math.max(minItemSize.height, Math.min(maxItemHeight, itemHeight));
        // Compute the horizontal spacing, content height and horizontal margin
        let horizontalSpacing = Math.min(Math.max(maxHorizontalSpace, minSpace.width), Math.floor((visibleWidth - numColumns * itemWidth) / (numColumns + 1)));
        this.margin = Math.floor((visibleWidth - numColumns * itemWidth - horizontalSpacing * (numColumns + 1)) / 2);
        // Setup an array of column heights
        let columnHeights = Array(numColumns).fill(minSpace.height);
        let newLayoutInfos = new Map();
        let index = 0;
        let addNode = (key, node)=>{
            let oldLayoutInfo = this.layoutInfos.get(key);
            let height = itemHeight;
            let estimatedSize = true;
            if (oldLayoutInfo) {
                height = oldLayoutInfo.rect.height / oldLayoutInfo.rect.width * itemWidth;
                estimatedSize = invalidationContext.sizeChanged || oldLayoutInfo.estimatedSize || oldLayoutInfo.content !== node;
            }
            // Figure out which column to place the item in, and compute its position.
            // Preserve the previous column index so items don't jump around during resizing unless the number of columns changed.
            let prevColumn = numColumns === this.numColumns && oldLayoutInfo && oldLayoutInfo.index === index && oldLayoutInfo.rect.y < this.virtualizer.visibleRect.maxY ? oldLayoutInfo.column : undefined;
            let column = prevColumn ?? columnHeights.reduce((minIndex, h, i)=>h < columnHeights[minIndex] ? i : minIndex, 0);
            let x = horizontalSpacing + column * (itemWidth + horizontalSpacing) + this.margin;
            let y = columnHeights[column];
            let rect = new (0, _virtualizer.Rect)(x, y, itemWidth, height);
            let layoutInfo = new WaterfallLayoutInfo(node.type, key, rect);
            layoutInfo.estimatedSize = estimatedSize;
            layoutInfo.allowOverflow = true;
            layoutInfo.content = node;
            layoutInfo.column = column;
            layoutInfo.index = index++;
            newLayoutInfos.set(key, layoutInfo);
            columnHeights[column] += layoutInfo.rect.height + minSpace.height;
        };
        let collection = this.virtualizer.collection;
        let skeletonCount = 0;
        for (let node of collection){
            if (node.type === 'skeleton') {
                // Add skeleton cards until every column has at least one, and we fill the viewport.
                let startingHeights = [
                    ...columnHeights
                ];
                while(!columnHeights.every((h, i)=>h !== startingHeights[i]) || Math.min(...columnHeights) < this.virtualizer.visibleRect.height){
                    let key = `${node.key}-${skeletonCount++}`;
                    let content = this.layoutInfos.get(key)?.content || {
                        ...node
                    };
                    addNode(key, content);
                }
                break;
            } else if (node.type !== 'loader') addNode(node.key, node);
        }
        // Always add the loader sentinel if present in the collection so we can make sure it is never virtualized out.
        // Add it under the first column for simplicity
        let lastNode = collection.getItem(collection.getLastKey());
        if (lastNode?.type === 'loader') {
            let rect = new (0, _virtualizer.Rect)(horizontalSpacing, columnHeights[0], itemWidth, 0);
            let layoutInfo = new (0, _virtualizer.LayoutInfo)('loader', lastNode.key, rect);
            newLayoutInfos.set(lastNode.key, layoutInfo);
        }
        // Reset all columns to the maximum for the next section. If loading, set to 0 so virtualizer doesn't render its body since there aren't items to render,
        // except if we are performing skeleton loading
        let isEmptyOrLoading = collection?.size === 0 && collection.getItem(collection.getFirstKey())?.type !== 'skeleton';
        let maxHeight = isEmptyOrLoading ? 0 : Math.max(...columnHeights);
        this.contentSize = new (0, _virtualizer.Size)(this.virtualizer.visibleRect.width, maxHeight);
        this.layoutInfos = newLayoutInfos;
        this.numColumns = numColumns;
    }
    getLayoutInfo(key) {
        return this.layoutInfos.get(key);
    }
    getContentSize() {
        return this.contentSize;
    }
    getVisibleLayoutInfos(rect) {
        let layoutInfos = [];
        for (let layoutInfo of this.layoutInfos.values())if (layoutInfo.rect.intersects(rect) || this.virtualizer.isPersistedKey(layoutInfo.key) || layoutInfo.type === 'loader') layoutInfos.push(layoutInfo);
        return layoutInfos;
    }
    updateItemSize(key, size) {
        let layoutInfo = this.layoutInfos.get(key);
        if (!size || !layoutInfo) return false;
        if (size.height !== layoutInfo.rect.height) {
            let newLayoutInfo = layoutInfo.copy();
            newLayoutInfo.rect.height = size.height;
            newLayoutInfo.estimatedSize = false;
            this.layoutInfos.set(key, newLayoutInfo);
            return true;
        }
        return false;
    }
    // Override keyboard navigation to work spatially.
    getKeyRightOf(key) {
        let layoutInfo = this.getLayoutInfo(key);
        if (!layoutInfo) return null;
        let rect = new (0, _virtualizer.Rect)(layoutInfo.rect.maxX, layoutInfo.rect.y, this.virtualizer.visibleRect.maxX - layoutInfo.rect.maxX, layoutInfo.rect.height);
        let layoutInfos = this.getVisibleLayoutInfos(rect);
        let bestKey = null;
        let bestDistance = Infinity;
        for (let candidate of layoutInfos){
            if (candidate.key === key) continue;
            // Find the closest item in the x direction with the most overlap in the y direction.
            let deltaX = candidate.rect.x - rect.x;
            let overlapY = Math.min(candidate.rect.maxY, rect.maxY) - Math.max(candidate.rect.y, rect.y);
            let distance = deltaX - overlapY;
            if (distance < bestDistance) {
                bestDistance = distance;
                bestKey = candidate.key;
            }
        }
        return bestKey;
    }
    getKeyLeftOf(key) {
        let layoutInfo = this.getLayoutInfo(key);
        if (!layoutInfo) return null;
        let rect = new (0, _virtualizer.Rect)(0, layoutInfo.rect.y, layoutInfo.rect.x, layoutInfo.rect.height);
        let layoutInfos = this.getVisibleLayoutInfos(rect);
        let bestKey = null;
        let bestDistance = Infinity;
        for (let candidate of layoutInfos){
            if (candidate.key === key) continue;
            // Find the closest item in the x direction with the most overlap in the y direction.
            let deltaX = rect.maxX - candidate.rect.maxX;
            let overlapY = Math.min(candidate.rect.maxY, rect.maxY) - Math.max(candidate.rect.y, rect.y);
            let distance = deltaX - overlapY;
            if (distance < bestDistance) {
                bestDistance = distance;
                bestKey = candidate.key;
            }
        }
        return bestKey;
    }
    // This overrides the default behavior of shift selection to work spatially
    // rather than following the order of the items in the collection (which may appear unpredictable).
    getKeyRange(from, to) {
        let fromLayoutInfo = this.getLayoutInfo(from);
        let toLayoutInfo = this.getLayoutInfo(to);
        if (!fromLayoutInfo || !toLayoutInfo) return [];
        // Find items where half of the area intersects the rectangle
        // formed from the first item to the last item in the range.
        let rect = fromLayoutInfo.rect.union(toLayoutInfo.rect);
        let keys = [];
        for (let layoutInfo of this.layoutInfos.values())if (rect.intersection(layoutInfo.rect).area > layoutInfo.rect.area / 2) keys.push(layoutInfo.key);
        return keys;
    }
    getDropTargetFromPoint(x, y) {
        if (this.layoutInfos.size === 0) return {
            type: 'root'
        };
        x += this.virtualizer.visibleRect.x;
        y += this.virtualizer.visibleRect.y;
        let key = this.virtualizer.keyAtPoint(new (0, _virtualizer.Point)(x, y));
        if (key == null) return {
            type: 'root'
        };
        // Only support "on" drop position in waterfall layout.
        // Reordering doesn't make sense because the items don't have a deterministic order.
        return {
            type: 'item',
            key,
            dropPosition: 'on'
        };
    }
    constructor(...args){
        super(...args), this.contentSize = new (0, _virtualizer.Size)(), this.layoutInfos = new Map(), this.numColumns = 0, this.dropIndicatorThickness = 2, this.margin = 0;
    }
}

},{"@react-stately/virtualizer":[["Layout","fnAag"],["LayoutInfo","6H2VJ"],["Point","iFQcF"],["Rect","l3p76"],["Size","F8cca"]],"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gU4lG":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActionBarContext", ()=>ActionBarContext);
parcelHelpers.export(exports, "ActionBar", ()=>ActionBar);
parcelHelpers.export(exports, "useActionBarContainer", ()=>useActionBarContainer);
var _jsxRuntime = require("react/jsx-runtime");
var _actionButtonGroup = require("./ActionButtonGroup");
var _liveAnnouncer = require("@react-aria/live-announcer");
var _closeButton = require("./CloseButton");
var _react = require("react");
var _reactAria = require("react-aria");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _utils = require("@react-stately/utils");
var _utils1 = require("@react-spectrum/utils");
var _utils2 = require("@react-aria/utils");
var _i18N = require("@react-aria/i18n");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const actionBarStyles = function anonymous(props) {
    let rules = " ", currentRules = {};
    rules += ' oc12';
    currentRules["borderTopStartRadius"] = "lg";
    rules += ' nc12';
    currentRules["borderTopEndRadius"] = "lg";
    rules += ' kc12';
    currentRules["borderBottomStartRadius"] = "lg";
    rules += ' jc12';
    currentRules["borderBottomEndRadius"] = "lg";
    if (props.isEmphasized) {
        rules += ' -Ovbhqd-g012';
        currentRules["--s2-container-bg"] = typeof currentRules["--s2-container-bg"] === 'object' ? currentRules["--s2-container-bg"] : {
            "default": currentRules["--s2-container-bg"]
        };
        currentRules["--s2-container-bg"]["isEmphasized"] = "neutral";
    } else {
        rules += ' -Ovbhqd-g_g12';
        currentRules["--s2-container-bg"] = "elevated";
    }
    rules += ' gEzkoQe12';
    currentRules["backgroundColor"] = "--s2-container-bg";
    rules += ' _nLeasBb12';
    currentRules["boxShadow"] = "elevated";
    rules += ' _oa12';
    currentRules["boxSizing"] = "border-box";
    rules += ' _Lf12';
    currentRules["outlineStyle"] = "solid";
    rules += ' _Mb12';
    currentRules["outlineWidth"] = 1;
    if (props.isEmphasized) {
        rules += ' Oj12';
        currentRules["outlineColor"] = typeof currentRules["outlineColor"] === 'object' ? currentRules["outlineColor"] : {
            "default": currentRules["outlineColor"]
        };
        currentRules["outlineColor"]["isEmphasized"] = "transparent";
    } else {
        rules += ' Oye39g12';
        currentRules["outlineColor"] = "[light-dark(rgba(255, 255, 255, 0), light-dark(rgb(225, 225, 225), rgb(50, 50, 50)))]";
    }
    rules += ' Ola12';
    currentRules["outlineColor"] = typeof currentRules["outlineColor"] === 'object' ? currentRules["outlineColor"] : {
        "default": currentRules["outlineColor"]
    };
    currentRules["outlineColor"]["forcedColors"] = "ButtonBorder";
    rules += ' St12';
    currentRules["paddingStart"] = 8;
    rules += ' Rt12';
    currentRules["paddingEnd"] = 8;
    rules += ' Te12';
    currentRules["paddingTop"] = 12;
    rules += ' Qe12';
    currentRules["paddingBottom"] = 12;
    rules += ' sd12';
    currentRules["display"] = "flex";
    rules += ' Ul12';
    currentRules["rowGap"] = 16;
    rules += ' ql12';
    currentRules["columnGap"] = 16;
    rules += ' eb12';
    currentRules["alignItems"] = "center";
    if (props.isInContainer) {
        rules += ' _Pa12';
        currentRules["position"] = typeof currentRules["position"] === 'object' ? currentRules["position"] : {
            "default": currentRules["position"]
        };
        currentRules["position"]["isInContainer"] = "absolute";
    }
    rules += ' _lr12';
    currentRules["bottom"] = 0;
    rules += ' _AI12';
    currentRules["insetStart"] = 8;
    rules += ' -F3Iohc-_zI12';
    currentRules["--insetEnd"] = 8;
    if (props.isInContainer) {
        rules += ' Zd12';
        currentRules["width"] = typeof currentRules["width"] === 'object' ? currentRules["width"] : {
            "default": currentRules["width"]
        };
        currentRules["width"]["isInContainer"] = "auto";
    } else {
        rules += ' Za12';
        currentRules["width"] = "full";
    }
    rules += ' IM12';
    currentRules["marginStart"] = "auto";
    rules += ' HM12';
    currentRules["marginEnd"] = "auto";
    rules += ' Ll12';
    currentRules["maxWidth"] = 960;
    rules += ' Yg12';
    currentRules["transition"] = "transform";
    rules += ' Xc12';
    currentRules["transitionDuration"] = 200;
    rules += ' _2b12';
    currentRules["transitionTimingFunction"] = "default";
    if (props.isExiting) {
        rules += ' -_8PloMd-t12';
        currentRules["translateY"] = typeof currentRules["translateY"] === 'object' ? currentRules["translateY"] : {
            "default": currentRules["translateY"]
        };
        currentRules["translateY"]["isExiting"] = "full";
        rules += ' __Ya12';
        currentRules["translateY"] = typeof currentRules["translateY"] === 'object' ? currentRules["translateY"] : {
            "default": currentRules["translateY"]
        };
        currentRules["translateY"]["isExiting"] = "full";
    } else if (props.isEntering) {
        rules += ' -_8PloMd-t12';
        currentRules["translateY"] = typeof currentRules["translateY"] === 'object' ? currentRules["translateY"] : {
            "default": currentRules["translateY"]
        };
        currentRules["translateY"]["isEntering"] = "full";
        rules += ' __Ya12';
        currentRules["translateY"] = typeof currentRules["translateY"] === 'object' ? currentRules["translateY"] : {
            "default": currentRules["translateY"]
        };
        currentRules["translateY"]["isEntering"] = "full";
    } else {
        rules += ' -_8PloMd-q12';
        currentRules["translateY"] = -8;
        rules += ' __Ya12';
        currentRules["translateY"] = -8;
    }
    return rules;
};
const ActionBarContext = /*#__PURE__*/ (0, _react.createContext)(null);
const ActionBar = /*#__PURE__*/ (0, _react.forwardRef)(function ActionBar(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, ActionBarContext);
    let domRef = (0, _utils1.useDOMRef)(ref);
    let isOpen = props.selectedItemCount !== 0;
    let isExiting = (0, _utils2.useExitAnimation)(domRef, isOpen && props.scrollRef != null);
    if (!isOpen && !isExiting) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ActionBarInner, {
        ...props,
        ref: domRef,
        isExiting: isExiting
    });
});
const ActionBarInner = /*#__PURE__*/ (0, _react.forwardRef)(function ActionBarInner(props1, ref) {
    let { isEmphasized, selectedItemCount = 0, children, onClearSelection, isExiting } = props1;
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-spectrum/s2');
    // Store the last count greater than zero so that we can retain it while rendering the fade-out animation.
    let [lastCount, setLastCount] = (0, _react.useState)(selectedItemCount);
    if ((selectedItemCount === 'all' || selectedItemCount > 0) && selectedItemCount !== lastCount) setLastCount(selectedItemCount);
    // Measure the width of the collection's scrollbar and offset the action bar by that amount.
    let scrollRef = props1.scrollRef;
    let [scrollbarWidth, setScrollbarWidth] = (0, _react.useState)(0);
    let updateScrollbarWidth = (0, _react.useCallback)(()=>{
        let el = scrollRef?.current;
        if (el) {
            let w = el.offsetWidth - el.clientWidth;
            setScrollbarWidth(w);
        }
    }, [
        scrollRef
    ]);
    (0, _utils2.useResizeObserver)({
        ref: scrollRef,
        onResize: updateScrollbarWidth
    });
    let { keyboardProps } = (0, _reactAria.useKeyboard)({
        onKeyDown (e) {
            if (e.key === 'Escape') {
                e.preventDefault();
                onClearSelection?.();
            } else e.continuePropagation();
        }
    });
    // Announce "actions available" on mount.
    let isInitial = (0, _react.useRef)(true);
    (0, _react.useEffect)(()=>{
        if (isInitial.current && scrollRef) {
            isInitial.current = false;
            (0, _liveAnnouncer.announce)(stringFormatter.format('actionbar.actionsAvailable'));
        }
    }, [
        stringFormatter,
        scrollRef
    ]);
    let objectRef = (0, _utils2.useObjectRef)(ref);
    let isEntering = (0, _utils2.useEnterAnimation)(objectRef, !!scrollRef);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAria.FocusScope), {
        restoreFocus: true,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            ref: objectRef,
            ...keyboardProps,
            className: actionBarStyles({
                isEmphasized,
                isInContainer: !!scrollRef,
                isEntering,
                isExiting
            }),
            style: {
                insetInlineEnd: `calc(var(--insetEnd) + ${scrollbarWidth}px)`
            },
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: " _Jb12 IM12",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionButtonGroup.ActionButtonGroup), {
                        staticColor: isEmphasized ? 'auto' : undefined,
                        isQuiet: true,
                        "aria-label": stringFormatter.format('actionbar.actions'),
                        children: children
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: " _Ja12 sd12 eb12 Ub12 qb12",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeButton.CloseButton), {
                            staticColor: isEmphasized ? 'auto' : undefined,
                            "aria-label": stringFormatter.format('actionbar.clearSelection'),
                            onPress: ()=>onClearSelection?.()
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: function anonymous(props) {
                                let rules = " ", currentRules = {};
                                rules += ' uk12';
                                currentRules["fontFamily"] = "sans";
                                rules += ' uch12';
                                currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
                                    "default": currentRules["fontFamily"]
                                };
                                currentRules["fontFamily"][":lang(ar)"] = "sans";
                                rules += ' udi12';
                                currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
                                    "default": currentRules["fontFamily"]
                                };
                                currentRules["fontFamily"][":lang(he)"] = "sans";
                                rules += ' uea12';
                                currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
                                    "default": currentRules["fontFamily"]
                                };
                                currentRules["fontFamily"][":lang(ja)"] = "sans";
                                rules += ' ugb12';
                                currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
                                    "default": currentRules["fontFamily"]
                                };
                                currentRules["fontFamily"][":lang(ko)"] = "sans";
                                rules += ' uhd12';
                                currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
                                    "default": currentRules["fontFamily"]
                                };
                                currentRules["fontFamily"][":lang(zh)"] = "sans";
                                rules += ' uje12';
                                currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
                                    "default": currentRules["fontFamily"]
                                };
                                currentRules["fontFamily"][":lang(zh-hant)"] = "sans";
                                rules += ' u2NhKxcl12';
                                currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
                                    "default": currentRules["fontFamily"]
                                };
                                currentRules["fontFamily"][":lang(zh-HK)"] = "sans";
                                rules += ' uic12';
                                currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
                                    "default": currentRules["fontFamily"]
                                };
                                currentRules["fontFamily"][":lang(zh-Hans, zh-CN, zh-SG)"] = "sans";
                                rules += ' -_6BNtrc-c12';
                                currentRules["fontSize"] = "ui";
                                rules += ' vx12';
                                currentRules["fontSize"] = "ui";
                                rules += ' xb12';
                                currentRules["fontWeight"] = "normal";
                                rules += ' _xa12';
                                currentRules["fontWeight"] = "normal";
                                rules += ' _Fd12';
                                currentRules["lineHeight"] = "ui";
                                rules += ' _FezxGHba12';
                                currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
                                    "default": currentRules["lineHeight"]
                                };
                                currentRules["lineHeight"][":lang(ar, he)"] = "ui";
                                rules += ' _FnuYUweb12';
                                currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
                                    "default": currentRules["lineHeight"]
                                };
                                currentRules["lineHeight"][":lang(ja, ko, zh, zh-Hant, zh-Hans, zh-CN, zh-SG)"] = "ui";
                                if (props.isEmphasized) {
                                    rules += ' pr12';
                                    currentRules["color"] = typeof currentRules["color"] === 'object' ? currentRules["color"] : {
                                        "default": currentRules["color"]
                                    };
                                    currentRules["color"]["isEmphasized"] = "gray-25";
                                } else {
                                    rules += ' pt12';
                                    currentRules["color"] = "neutral";
                                }
                                return rules;
                            }({
                                isEmphasized
                            }),
                            children: lastCount === 'all' ? stringFormatter.format('actionbar.selectedAll') : stringFormatter.format('actionbar.selected', {
                                count: lastCount
                            })
                        })
                    ]
                })
            ]
        })
    });
});
function useActionBarContainer(props) {
    let { renderActionBar, scrollRef } = props;
    let [selectedKeys, setSelectedKeys] = (0, _utils.useControlledState)(props.selectedKeys, props.defaultSelectedKeys || new Set(), props.onSelectionChange);
    let selectedKeysSet = (0, _react.useMemo)(()=>selectedKeys === 'all' ? selectedKeys : new Set(selectedKeys), [
        selectedKeys
    ]);
    let actionBar = (0, _react.useMemo)(()=>renderActionBar?.(selectedKeysSet), [
        renderActionBar,
        selectedKeysSet
    ]);
    let selectedItemCount = selectedKeysSet === 'all' ? 'all' : selectedKeysSet.size;
    let [actionBarHeight, setActionBarHeight] = (0, _react.useState)(0);
    let actionBarRef = (0, _react.useCallback)((ref)=>{
        let actionBar = ref?.UNSAFE_getDOMNode();
        if (actionBar) setActionBarHeight(actionBar.offsetHeight + 8);
        else setActionBarHeight(0);
    }, []);
    let actionBarContext = (0, _react.useMemo)(()=>({
            ref: actionBarRef,
            scrollRef,
            selectedItemCount,
            onClearSelection: ()=>setSelectedKeys(new Set())
        }), [
        scrollRef,
        actionBarRef,
        selectedItemCount,
        setSelectedKeys
    ]);
    let wrappedActionBar = (0, _react.useMemo)(()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(ActionBarContext.Provider, {
            value: actionBarContext,
            children: actionBar
        }), [
        actionBarContext,
        actionBar
    ]);
    return {
        selectedKeys,
        onSelectionChange: setSelectedKeys,
        actionBar: wrappedActionBar,
        actionBarHeight
    };
}

},{"0":"frYaX","1":"jeYGC","2":"bRL5Y","3":"2YRKv","react/jsx-runtime":"2Is6Z","./ActionButtonGroup":"1RyqL","@react-aria/live-announcer":"3nbSW","./CloseButton":"8LP64","react":"a1TxN","react-aria":[["FocusScope","9oPIl"],["useKeyboard","vsbUl"]],"../intl/*.json":"gDH3q","@react-stately/utils":"4Nj6T","@react-spectrum/utils":"jqfrX","@react-aria/utils":[["useEnterAnimation","a1dBG"],["useExitAnimation","a1dBG"],["useObjectRef","laqO5"],["useResizeObserver","7OAb4"]],"@react-aria/i18n":"7lxyl","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"frYaX":[function() {},{}],"jeYGC":[function() {},{}],"bRL5Y":[function() {},{}],"2YRKv":[function() {},{}],"bl35P":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccordionContext", ()=>AccordionContext);
parcelHelpers.export(exports, "Accordion", ()=>Accordion);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _disclosure = require("./Disclosure");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _utils = require("@react-spectrum/utils");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const accordion = function anonymous(props, overrides) {
    let rules = " ", currentRules = {};
    rules += (String(overrides || '').match(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L|F|M|K|-macro\$)[^\s]+/g) || []).join('');
    rules += ' sd12';
    currentRules["display"] = "flex";
    rules += ' _ta12';
    currentRules["flexDirection"] = "column";
    return rules;
};
const AccordionContext = /*#__PURE__*/ (0, _react.createContext)(null);
const Accordion = /*#__PURE__*/ (0, _react.forwardRef)(function Accordion(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, AccordionContext);
    let domRef = (0, _utils.useDOMRef)(ref);
    let { UNSAFE_style, UNSAFE_className = '', size = 'M', density = 'regular', isQuiet } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _disclosure.DisclosureContext).Provider, {
        value: {
            size,
            isQuiet,
            density
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.DisclosureGroup), {
            ...props,
            ref: domRef,
            style: UNSAFE_style,
            className: (UNSAFE_className ?? '') + accordion(null, props.styles),
            children: props.children
        })
    });
});

},{"0":"btVHi","react/jsx-runtime":"2Is6Z","react-aria-components":"hRrWd","./Disclosure":"jAvgn","react":"a1TxN","@react-spectrum/utils":"jqfrX","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"btVHi":[function() {},{}],"jAvgn":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DisclosureContext", ()=>DisclosureContext);
parcelHelpers.export(exports, "Disclosure", ()=>Disclosure);
parcelHelpers.export(exports, "DisclosureHeader", ()=>DisclosureHeader);
parcelHelpers.export(exports, "DisclosureTitle", ()=>DisclosureTitle);
parcelHelpers.export(exports, "DisclosurePanel", ()=>DisclosurePanel);
var _jsxRuntime = require("react/jsx-runtime");
var _actionButton = require("./ActionButton");
var _reactAriaComponents = require("react-aria-components");
var _centerBaseline = require("./CenterBaseline");
var _chevron = require("../ui-icons/Chevron");
var _chevronDefault = parcelHelpers.interopDefault(_chevron);
var _utils = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _utils1 = require("@react-spectrum/utils");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const DisclosureContext = /*#__PURE__*/ (0, _react.createContext)(null);
const disclosure = function anonymous(props, overrides) {
    let rules = " ", currentRules = {};
    let minWidth = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L|-macro\$)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "N") minWidth = true;
        rules += p[0];
    }
    rules += ' po12';
    currentRules["color"] = "heading";
    if (props.isQuiet) {
        rules += ' _ka12';
        currentRules["borderTopWidth"] = typeof currentRules["borderTopWidth"] === 'object' ? currentRules["borderTopWidth"] : {
            "default": currentRules["borderTopWidth"]
        };
        currentRules["borderTopWidth"]["isQuiet"] = 0;
    } else {
        rules += ' _kb12';
        currentRules["borderTopWidth"] = 1;
    }
    if (props.isInGroup) {
        rules += ' ha12';
        currentRules["borderBottomWidth"] = typeof currentRules["borderBottomWidth"] === 'object' ? currentRules["borderBottomWidth"] : {
            "default": currentRules["borderBottomWidth"]
        };
        currentRules["borderBottomWidth"]["isInGroup"] = 0;
        if (props.isQuiet) {
            rules += ' hka12';
            currentRules["borderBottomWidth"] = typeof currentRules["borderBottomWidth"] === 'object' ? currentRules["borderBottomWidth"] : {
                "default": currentRules["borderBottomWidth"]
            };
            currentRules["borderBottomWidth"]["isInGroup && isQuiet && :last-child"] = 0;
        } else {
            rules += ' hkb12';
            currentRules["borderBottomWidth"] = typeof currentRules["borderBottomWidth"] === 'object' ? currentRules["borderBottomWidth"] : {
                "default": currentRules["borderBottomWidth"]
            };
            currentRules["borderBottomWidth"]["isInGroup && :last-child"] = 1;
        }
    } else if (props.isQuiet) {
        rules += ' ha12';
        currentRules["borderBottomWidth"] = typeof currentRules["borderBottomWidth"] === 'object' ? currentRules["borderBottomWidth"] : {
            "default": currentRules["borderBottomWidth"]
        };
        currentRules["borderBottomWidth"]["isQuiet"] = 0;
    } else {
        rules += ' hb12';
        currentRules["borderBottomWidth"] = 1;
    }
    rules += ' ma12';
    currentRules["borderStartWidth"] = 0;
    rules += ' la12';
    currentRules["borderEndWidth"] = 0;
    rules += ' _jf12';
    currentRules["borderStyle"] = "solid";
    rules += ' ir12';
    currentRules["borderColor"] = "gray-200";
    if (!minWidth) rules += ' Ng12';
    currentRules["minWidth"] = 200;
    return rules;
};
const Disclosure = /*#__PURE__*/ (0, _react.forwardRef)(function Disclosure(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, DisclosureContext);
    let { size = 'M', density = 'regular', isQuiet, UNSAFE_style, UNSAFE_className = '' } = props;
    let domRef = (0, _utils1.useDOMRef)(ref);
    let isInGroup = (0, _react.useContext)(DisclosureContext) !== null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
        values: [
            [
                DisclosureContext,
                {
                    size,
                    isQuiet,
                    density
                }
            ]
        ],
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Disclosure), {
            ...props,
            ref: domRef,
            style: UNSAFE_style,
            className: (UNSAFE_className ?? '') + disclosure({
                isQuiet,
                isInGroup
            }, props.styles),
            children: props.children
        })
    });
});
const headingStyle = " Jy12 Gy12 Iy12 Hy12 _ub12 sd12 _vb12 Na12";
const buttonStyles = function anonymous(props) {
    let rules = " ", currentRules = {};
    if (props.isFocusVisible) {
        rules += ' _Lf12';
        currentRules["outlineStyle"] = typeof currentRules["outlineStyle"] === 'object' ? currentRules["outlineStyle"] : {
            "default": currentRules["outlineStyle"]
        };
        currentRules["outlineStyle"]["isFocusVisible"] = "solid";
    } else {
        rules += ' _Le12';
        currentRules["outlineStyle"] = "none";
    }
    rules += ' Oh12';
    currentRules["outlineColor"] = "focus-ring";
    rules += ' _Mc12';
    currentRules["outlineWidth"] = 2;
    rules += ' _Kb12';
    currentRules["outlineOffset"] = -2;
    rules += ' uk12';
    currentRules["fontFamily"] = "sans";
    rules += ' uch12';
    currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
        "default": currentRules["fontFamily"]
    };
    currentRules["fontFamily"][":lang(ar)"] = "sans";
    rules += ' udi12';
    currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
        "default": currentRules["fontFamily"]
    };
    currentRules["fontFamily"][":lang(he)"] = "sans";
    rules += ' uea12';
    currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
        "default": currentRules["fontFamily"]
    };
    currentRules["fontFamily"][":lang(ja)"] = "sans";
    rules += ' ugb12';
    currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
        "default": currentRules["fontFamily"]
    };
    currentRules["fontFamily"][":lang(ko)"] = "sans";
    rules += ' uhd12';
    currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
        "default": currentRules["fontFamily"]
    };
    currentRules["fontFamily"][":lang(zh)"] = "sans";
    rules += ' uje12';
    currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
        "default": currentRules["fontFamily"]
    };
    currentRules["fontFamily"][":lang(zh-hant)"] = "sans";
    rules += ' u2NhKxcl12';
    currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
        "default": currentRules["fontFamily"]
    };
    currentRules["fontFamily"][":lang(zh-HK)"] = "sans";
    rules += ' uic12';
    currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
        "default": currentRules["fontFamily"]
    };
    currentRules["fontFamily"][":lang(zh-Hans, zh-CN, zh-SG)"] = "sans";
    if (props.size === "XL") {
        rules += ' -_6BNtrc-f12';
        currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
            "default": currentRules["fontSize"]
        };
        currentRules["fontSize"]["size === \"XL\""] = "title-xl";
        rules += ' vx12';
        currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
            "default": currentRules["fontSize"]
        };
        currentRules["fontSize"]["size === \"XL\""] = "title-xl";
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-e12';
        currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
            "default": currentRules["fontSize"]
        };
        currentRules["fontSize"]["size === \"L\""] = "title-lg";
        rules += ' vx12';
        currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
            "default": currentRules["fontSize"]
        };
        currentRules["fontSize"]["size === \"L\""] = "title-lg";
    } else if (props.size === "M") {
        rules += ' -_6BNtrc-d12';
        currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
            "default": currentRules["fontSize"]
        };
        currentRules["fontSize"]["size === \"M\""] = "title";
        rules += ' vx12';
        currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
            "default": currentRules["fontSize"]
        };
        currentRules["fontSize"]["size === \"M\""] = "title";
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-c12';
        currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
            "default": currentRules["fontSize"]
        };
        currentRules["fontSize"]["size === \"S\""] = "title-sm";
        rules += ' vx12';
        currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
            "default": currentRules["fontSize"]
        };
        currentRules["fontSize"]["size === \"S\""] = "title-sm";
    }
    rules += ' xd12';
    currentRules["fontWeight"] = "bold";
    rules += ' _xa12';
    currentRules["fontWeight"] = "bold";
    rules += ' xX0cczbc12';
    currentRules["fontWeight"] = typeof currentRules["fontWeight"] === 'object' ? currentRules["fontWeight"] : {
        "default": currentRules["fontWeight"]
    };
    currentRules["fontWeight"][":lang(ja, ko, zh)"] = "bold";
    rules += ' _xX0cczba12';
    currentRules["fontWeight"] = typeof currentRules["fontWeight"] === 'object' ? currentRules["fontWeight"] : {
        "default": currentRules["fontWeight"]
    };
    currentRules["fontWeight"][":lang(ja, ko, zh)"] = "bold";
    rules += ' _Fd12';
    currentRules["lineHeight"] = "ui";
    rules += ' _FezxGHba12';
    currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
        "default": currentRules["lineHeight"]
    };
    currentRules["lineHeight"][":lang(ar, he)"] = "ui";
    rules += ' _FnuYUweb12';
    currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
        "default": currentRules["lineHeight"]
    };
    currentRules["lineHeight"][":lang(ja, ko, zh, zh-Hant, zh-Hans, zh-CN, zh-SG)"] = "ui";
    if (props.isDisabled) {
        rules += ' pp12';
        currentRules["color"] = typeof currentRules["color"] === 'object' ? currentRules["color"] : {
            "default": currentRules["color"]
        };
        currentRules["color"]["isDisabled"] = "disabled";
    } else {
        if (props.isPressed) {
            rules += ' po12';
            currentRules["color"] = typeof currentRules["color"] === 'object' ? currentRules["color"] : {
                "default": currentRules["color"]
            };
            currentRules["color"]["isPressed"] = "neutral:pressed";
        } else if (props.isFocusVisible) {
            rules += ' po12';
            currentRules["color"] = typeof currentRules["color"] === 'object' ? currentRules["color"] : {
                "default": currentRules["color"]
            };
            currentRules["color"]["isFocusVisible"] = "neutral:focused";
        } else if (props.isHovered) {
            rules += ' po12';
            currentRules["color"] = typeof currentRules["color"] === 'object' ? currentRules["color"] : {
                "default": currentRules["color"]
            };
            currentRules["color"]["isHovered"] = "neutral:hovered";
        } else {
            rules += ' pt12';
            currentRules["color"] = "neutral";
        }
    }
    rules += ' sd12';
    currentRules["display"] = "flex";
    rules += ' _ub12';
    currentRules["flexGrow"] = 1;
    rules += ' ea12';
    currentRules["alignItems"] = "baseline";
    rules += ' S6FcKR12';
    currentRules["paddingStart"] = "calc(self(minHeight) * 3/8 - 1px)";
    rules += ' R6FcKR12';
    currentRules["paddingEnd"] = "calc(self(minHeight) * 3/8 - 1px)";
    rules += ' Tu7Fubd12';
    currentRules["paddingTop"] = "[calc((self(minHeight) - self(borderTopWidth, 0px) - self(borderBottomWidth, 0px) - 1lh) / 2)]";
    rules += ' Qu7Fubd12';
    currentRules["paddingBottom"] = "[calc((self(minHeight) - self(borderTopWidth, 0px) - self(borderBottomWidth, 0px) - 1lh) / 2)]";
    rules += ' U6FcKR12';
    currentRules["rowGap"] = "calc(self(minHeight) * 3/8 - 1px)";
    rules += ' q6FcKR12';
    currentRules["columnGap"] = "calc(self(minHeight) * 3/8 - 1px)";
    rules += ' MAyFGYc12';
    rules += ' Za12';
    currentRules["width"] = "full";
    if (props.isPressed) {
        rules += ' gnSjEFb12';
        currentRules["backgroundColor"] = typeof currentRules["backgroundColor"] === 'object' ? currentRules["backgroundColor"] : {
            "default": currentRules["backgroundColor"]
        };
        currentRules["backgroundColor"]["isPressed"] = "[light-dark(rgba(0, 0, 0, 0.15), rgba(255, 255, 255, 0.17))]";
    } else if (props.isHovered) {
        rules += ' gabY4te12';
        currentRules["backgroundColor"] = typeof currentRules["backgroundColor"] === 'object' ? currentRules["backgroundColor"] : {
            "default": currentRules["backgroundColor"]
        };
        currentRules["backgroundColor"]["isHovered"] = "[light-dark(rgba(0, 0, 0, 0.09), rgba(255, 255, 255, 0.11))]";
    } else if (props.isFocusVisible) {
        rules += ' gabY4te12';
        currentRules["backgroundColor"] = typeof currentRules["backgroundColor"] === 'object' ? currentRules["backgroundColor"] : {
            "default": currentRules["backgroundColor"]
        };
        currentRules["backgroundColor"]["isFocusVisible"] = "[light-dark(rgba(0, 0, 0, 0.09), rgba(255, 255, 255, 0.11))]";
    } else {
        rules += ' g912';
        currentRules["backgroundColor"] = "transparent";
    }
    rules += ' Yd12';
    currentRules["transition"] = "default";
    rules += ' Xb12';
    currentRules["transitionDuration"] = 150;
    rules += ' _2b12';
    currentRules["transitionTimingFunction"] = "default";
    rules += ' _kJ8iPYd12';
    rules += ' hXMFGYc12';
    rules += ' ma12';
    currentRules["borderStartWidth"] = 0;
    rules += ' la12';
    currentRules["borderEndWidth"] = 0;
    if (props.isQuiet) {
        rules += ' ob12';
        currentRules["borderTopStartRadius"] = typeof currentRules["borderTopStartRadius"] === 'object' ? currentRules["borderTopStartRadius"] : {
            "default": currentRules["borderTopStartRadius"]
        };
        currentRules["borderTopStartRadius"]["isQuiet"] = "default";
    } else if (props.isFocusVisible) {
        rules += ' ob12';
        currentRules["borderTopStartRadius"] = typeof currentRules["borderTopStartRadius"] === 'object' ? currentRules["borderTopStartRadius"] : {
            "default": currentRules["borderTopStartRadius"]
        };
        currentRules["borderTopStartRadius"]["isFocusVisible"] = "default";
    } else {
        rules += ' od12';
        currentRules["borderTopStartRadius"] = "none";
    }
    if (props.isQuiet) {
        rules += ' nb12';
        currentRules["borderTopEndRadius"] = typeof currentRules["borderTopEndRadius"] === 'object' ? currentRules["borderTopEndRadius"] : {
            "default": currentRules["borderTopEndRadius"]
        };
        currentRules["borderTopEndRadius"]["isQuiet"] = "default";
    } else if (props.isFocusVisible) {
        rules += ' nb12';
        currentRules["borderTopEndRadius"] = typeof currentRules["borderTopEndRadius"] === 'object' ? currentRules["borderTopEndRadius"] : {
            "default": currentRules["borderTopEndRadius"]
        };
        currentRules["borderTopEndRadius"]["isFocusVisible"] = "default";
    } else {
        rules += ' nd12';
        currentRules["borderTopEndRadius"] = "none";
    }
    if (props.isQuiet) {
        rules += ' kb12';
        currentRules["borderBottomStartRadius"] = typeof currentRules["borderBottomStartRadius"] === 'object' ? currentRules["borderBottomStartRadius"] : {
            "default": currentRules["borderBottomStartRadius"]
        };
        currentRules["borderBottomStartRadius"]["isQuiet"] = "default";
    } else if (props.isFocusVisible) {
        rules += ' kb12';
        currentRules["borderBottomStartRadius"] = typeof currentRules["borderBottomStartRadius"] === 'object' ? currentRules["borderBottomStartRadius"] : {
            "default": currentRules["borderBottomStartRadius"]
        };
        currentRules["borderBottomStartRadius"]["isFocusVisible"] = "default";
    } else {
        rules += ' kd12';
        currentRules["borderBottomStartRadius"] = "none";
    }
    if (props.isQuiet) {
        rules += ' jb12';
        currentRules["borderBottomEndRadius"] = typeof currentRules["borderBottomEndRadius"] === 'object' ? currentRules["borderBottomEndRadius"] : {
            "default": currentRules["borderBottomEndRadius"]
        };
        currentRules["borderBottomEndRadius"]["isQuiet"] = "default";
    } else if (props.isFocusVisible) {
        rules += ' jb12';
        currentRules["borderBottomEndRadius"] = typeof currentRules["borderBottomEndRadius"] === 'object' ? currentRules["borderBottomEndRadius"] : {
            "default": currentRules["borderBottomEndRadius"]
        };
        currentRules["borderBottomEndRadius"]["isFocusVisible"] = "default";
    } else {
        rules += ' jd12';
        currentRules["borderBottomEndRadius"] = "none";
    }
    rules += ' _Wd12';
    currentRules["textAlign"] = "start";
    rules += ' __ca12';
    currentRules["disableTapHighlight"] = true;
    if (props.size === "XL") {
        if (props.density === "spacious") {
            rules += ' -M_-Mj12';
            currentRules["minHeight"] = typeof currentRules["minHeight"] === 'object' ? currentRules["minHeight"] : {
                "default": currentRules["minHeight"]
            };
            currentRules["minHeight"]["size === \"XL\" && density === \"spacious\""] = 56;
        } else if (props.density === "regular") {
            rules += ' -M_-Mk12';
            currentRules["minHeight"] = typeof currentRules["minHeight"] === 'object' ? currentRules["minHeight"] : {
                "default": currentRules["minHeight"]
            };
            currentRules["minHeight"]["size === \"XL\" && density === \"regular\""] = 48;
        } else if (props.density === "compact") {
            rules += ' -M_-Mh12';
            currentRules["minHeight"] = typeof currentRules["minHeight"] === 'object' ? currentRules["minHeight"] : {
                "default": currentRules["minHeight"]
            };
            currentRules["minHeight"]["size === \"XL\" && density === \"compact\""] = 40;
        }
    } else if (props.size === "L") {
        if (props.density === "spacious") {
            rules += ' -M_-Mk12';
            currentRules["minHeight"] = typeof currentRules["minHeight"] === 'object' ? currentRules["minHeight"] : {
                "default": currentRules["minHeight"]
            };
            currentRules["minHeight"]["size === \"L\" && density === \"spacious\""] = 48;
        } else if (props.density === "regular") {
            rules += ' -M_-Mh12';
            currentRules["minHeight"] = typeof currentRules["minHeight"] === 'object' ? currentRules["minHeight"] : {
                "default": currentRules["minHeight"]
            };
            currentRules["minHeight"]["size === \"L\" && density === \"regular\""] = 40;
        } else if (props.density === "compact") {
            rules += ' -M_-Mi12';
            currentRules["minHeight"] = typeof currentRules["minHeight"] === 'object' ? currentRules["minHeight"] : {
                "default": currentRules["minHeight"]
            };
            currentRules["minHeight"]["size === \"L\" && density === \"compact\""] = 32;
        }
    } else if (props.size === "M") {
        if (props.density === "spacious") {
            rules += ' -M_-Mh12';
            currentRules["minHeight"] = typeof currentRules["minHeight"] === 'object' ? currentRules["minHeight"] : {
                "default": currentRules["minHeight"]
            };
            currentRules["minHeight"]["size === \"M\" && density === \"spacious\""] = 40;
        } else if (props.density === "regular") {
            rules += ' -M_-Mi12';
            currentRules["minHeight"] = typeof currentRules["minHeight"] === 'object' ? currentRules["minHeight"] : {
                "default": currentRules["minHeight"]
            };
            currentRules["minHeight"]["size === \"M\" && density === \"regular\""] = 32;
        } else if (props.density === "compact") {
            rules += ' -M_-Mg12';
            currentRules["minHeight"] = typeof currentRules["minHeight"] === 'object' ? currentRules["minHeight"] : {
                "default": currentRules["minHeight"]
            };
            currentRules["minHeight"]["size === \"M\" && density === \"compact\""] = 24;
        }
    } else if (props.size === "S") {
        if (props.density === "spacious") {
            rules += ' -M_-Mi12';
            currentRules["minHeight"] = typeof currentRules["minHeight"] === 'object' ? currentRules["minHeight"] : {
                "default": currentRules["minHeight"]
            };
            currentRules["minHeight"]["size === \"S\" && density === \"spacious\""] = 32;
        } else if (props.density === "regular") {
            rules += ' -M_-Mg12';
            currentRules["minHeight"] = typeof currentRules["minHeight"] === 'object' ? currentRules["minHeight"] : {
                "default": currentRules["minHeight"]
            };
            currentRules["minHeight"]["size === \"S\" && density === \"regular\""] = 24;
        } else if (props.density === "compact") {
            rules += ' -M_-Me12';
            currentRules["minHeight"] = typeof currentRules["minHeight"] === 'object' ? currentRules["minHeight"] : {
                "default": currentRules["minHeight"]
            };
            currentRules["minHeight"]["size === \"S\" && density === \"compact\""] = 18;
        }
    }
    rules += ' -_k_-_ka12';
    currentRules["borderTopWidth"] = 0;
    rules += ' -h_-ha12';
    currentRules["borderBottomWidth"] = 0;
    return rules;
};
const chevronStyles = function anonymous(props) {
    let rules = " ", currentRules = {};
    if (props.isExpanded) {
        rules += ' _Sd12';
        currentRules["rotate"] = typeof currentRules["rotate"] === 'object' ? currentRules["rotate"] : {
            "default": currentRules["rotate"]
        };
        currentRules["rotate"]["isExpanded"] = 90;
    } else if (props.isRTL) {
        rules += ' _Sc12';
        currentRules["rotate"] = typeof currentRules["rotate"] === 'object' ? currentRules["rotate"] : {
            "default": currentRules["rotate"]
        };
        currentRules["rotate"]["isRTL"] = 180;
    }
    rules += ' Yd12';
    currentRules["transition"] = "default";
    rules += ' Xb12';
    currentRules["transitionDuration"] = 150;
    rules += ' _2b12';
    currentRules["transitionTimingFunction"] = "default";
    rules += ' -_8sjo0b-t5ZbAob12';
    currentRules["--iconPrimary"] = "currentColor";
    rules += ' _va12';
    currentRules["flexShrink"] = 0;
    return rules;
};
const InternalDisclosureHeader = /*#__PURE__*/ (0, _react.createContext)(null);
function DisclosureHeaderWithForwardRef(props, ref) {
    let { UNSAFE_className, UNSAFE_style, children } = props;
    let domRef = (0, _utils1.useDOMRef)(ref);
    let { size, isQuiet, density } = (0, _reactAriaComponents.useSlottedContext)(DisclosureContext);
    // Shift button size down by 2 for compact density, 1 for regular/spacious to ensure there is space between the top and bottom of the action button and container
    let newSize = size;
    const sizes = [
        'XS',
        'S',
        'M',
        'L',
        'XL'
    ];
    const currentIndex = sizes.indexOf(size ?? 'M');
    const shift = density === 'compact' ? 2 : 1;
    newSize = sizes[Math.max(0, currentIndex - shift)];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
        values: [
            [
                (0, _actionButton.ActionButtonContext),
                {
                    size: newSize,
                    isQuiet
                }
            ],
            [
                InternalDisclosureHeader,
                {}
            ]
        ],
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            style: UNSAFE_style,
            className: (UNSAFE_className ?? '') + " sd12 eb12 Ub12 qb12",
            ref: domRef,
            children: children
        })
    });
}
const DisclosureHeader = /*#__PURE__*/ (0, _react.forwardRef)(DisclosureHeaderWithForwardRef);
const DisclosureTitle = /*#__PURE__*/ (0, _react.forwardRef)(function DisclosureTitle(props, ref) {
    let { level = 3, UNSAFE_style, UNSAFE_className = '', ...otherProps } = props;
    let domRef = (0, _utils1.useDOMRef)(ref);
    const domProps = (0, _utils.filterDOMProps)(otherProps);
    let { direction } = (0, _reactAriaComponents.useLocale)();
    let { isExpanded } = (0, _react.useContext)((0, _reactAriaComponents.DisclosureStateContext));
    let { size, density, isQuiet } = (0, _reactAriaComponents.useSlottedContext)(DisclosureContext);
    let isRTL = direction === 'rtl';
    let buttonTrigger = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Heading), {
        ...domProps,
        level: level,
        ref: domRef,
        style: UNSAFE_style,
        className: (UNSAFE_className ?? '') + headingStyle,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.Button), {
            className: (renderProps)=>buttonStyles({
                    ...renderProps,
                    size,
                    density,
                    isQuiet
                }),
            slot: "trigger",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _centerBaseline.CenterBaseline), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chevronDefault.default), {
                        size: size,
                        className: chevronStyles({
                            isExpanded,
                            isRTL
                        }),
                        "aria-hidden": "true"
                    })
                }),
                props.children
            ]
        })
    });
    let ctx = (0, _react.useContext)(InternalDisclosureHeader);
    if (ctx) return buttonTrigger;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DisclosureHeader, {
        children: buttonTrigger
    });
});
const panelStyles = " uk12 uch12 udi12 uea12 ugb12 uhd12 uje12 u2NhKxcl12 uic12 -_6BNtrc-d12 vx12 xb12 _xa12 _Fb12 _FnuYUwec12 pt12 FfwmW1d12 _Nb12 Pb12 Ysgyfc12 Ydklsgce12 Xb12 Xdklsgcb12 _2b12 _2dklsgcb12";
const panelInner = function anonymous(props) {
    let rules = " ", currentRules = {};
    rules += ' Tt12';
    currentRules["paddingTop"] = 8;
    rules += ' Qf12';
    currentRules["paddingBottom"] = 16;
    if (props.size === "XL") {
        rules += ' Sz5EUbe12';
        currentRules["paddingStart"] = typeof currentRules["paddingStart"] === 'object' ? currentRules["paddingStart"] : {
            "default": currentRules["paddingStart"]
        };
        currentRules["paddingStart"]["size === \"XL\""] = "[0.9375rem]";
    } else if (props.size === "L") {
        rules += ' Se12';
        currentRules["paddingStart"] = typeof currentRules["paddingStart"] === 'object' ? currentRules["paddingStart"] : {
            "default": currentRules["paddingStart"]
        };
        currentRules["paddingStart"]["size === \"L\""] = 12;
    } else if (props.size === "M") {
        rules += ' SLabwmd12';
        currentRules["paddingStart"] = typeof currentRules["paddingStart"] === 'object' ? currentRules["paddingStart"] : {
            "default": currentRules["paddingStart"]
        };
        currentRules["paddingStart"]["size === \"M\""] = "[0.5625rem]";
    } else if (props.size === "S") {
        rules += ' St12';
        currentRules["paddingStart"] = typeof currentRules["paddingStart"] === 'object' ? currentRules["paddingStart"] : {
            "default": currentRules["paddingStart"]
        };
        currentRules["paddingStart"]["size === \"S\""] = 8;
    }
    if (props.size === "XL") {
        rules += ' Rz5EUbe12';
        currentRules["paddingEnd"] = typeof currentRules["paddingEnd"] === 'object' ? currentRules["paddingEnd"] : {
            "default": currentRules["paddingEnd"]
        };
        currentRules["paddingEnd"]["size === \"XL\""] = "[0.9375rem]";
    } else if (props.size === "L") {
        rules += ' Re12';
        currentRules["paddingEnd"] = typeof currentRules["paddingEnd"] === 'object' ? currentRules["paddingEnd"] : {
            "default": currentRules["paddingEnd"]
        };
        currentRules["paddingEnd"]["size === \"L\""] = 12;
    } else if (props.size === "M") {
        rules += ' RLabwmd12';
        currentRules["paddingEnd"] = typeof currentRules["paddingEnd"] === 'object' ? currentRules["paddingEnd"] : {
            "default": currentRules["paddingEnd"]
        };
        currentRules["paddingEnd"]["size === \"M\""] = "[0.5625rem]";
    } else if (props.size === "S") {
        rules += ' Rt12';
        currentRules["paddingEnd"] = typeof currentRules["paddingEnd"] === 'object' ? currentRules["paddingEnd"] : {
            "default": currentRules["paddingEnd"]
        };
        currentRules["paddingEnd"]["size === \"S\""] = 8;
    }
    return rules;
};
const DisclosurePanel = /*#__PURE__*/ (0, _react.forwardRef)(function DisclosurePanel(props, ref) {
    let { UNSAFE_style, UNSAFE_className = '', ...otherProps } = props;
    const domProps = (0, _utils.filterDOMProps)(otherProps);
    let { size } = (0, _reactAriaComponents.useSlottedContext)(DisclosureContext);
    let panelRef = (0, _utils1.useDOMRef)(ref);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.DisclosurePanel), {
        ...domProps,
        ref: panelRef,
        style: UNSAFE_style,
        className: (UNSAFE_className ?? '') + panelStyles,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: panelInner({
                size
            }),
            children: props.children
        })
    });
});

},{"0":"6bQOr","1":"9pGVA","2":"6TvtT","3":"c9UcY","4":"9hOLE","5":"gxTTv","6":"kAlQQ","react/jsx-runtime":"2Is6Z","./ActionButton":"lNDRs","react-aria-components":[["Button","9G5XO"],["Disclosure","hRrWd"],["DisclosurePanel","hRrWd"],["DisclosureStateContext","hRrWd"],["Heading","2f4nH"],["Provider","bA6Cz"],["useSlottedContext","bA6Cz"],["useLocale","4k4z8"]],"./CenterBaseline":"1vpL9","../ui-icons/Chevron":"1904U","@react-aria/utils":"3upVm","react":"a1TxN","@react-spectrum/utils":"jqfrX","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6bQOr":[function() {},{}],"9pGVA":[function() {},{}],"6TvtT":[function() {},{}],"c9UcY":[function() {},{}],"9hOLE":[function() {},{}],"gxTTv":[function() {},{}],"kAlQQ":[function() {},{}],"4wrNa":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CheckboxGroupContext", ()=>CheckboxGroupContext);
parcelHelpers.export(exports, "CheckboxGroup", ()=>CheckboxGroup);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _checkbox = require("./Checkbox");
var _react = require("react");
var _field = require("./Field");
var _form = require("./Form");
var _utils = require("@react-spectrum/utils");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const CheckboxGroupContext = /*#__PURE__*/ (0, _react.createContext)(null);
const CheckboxGroup = /*#__PURE__*/ (0, _react.forwardRef)(function CheckboxGroup(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, CheckboxGroupContext);
    let formContext = (0, _react.useContext)((0, _form.FormContext));
    props = (0, _form.useFormProps)(props);
    let { label, description, errorMessage, children, labelPosition = 'top', labelAlign = 'start', necessityIndicator = 'icon', size = 'M', orientation = 'vertical', UNSAFE_className = '', UNSAFE_style, isEmphasized, ...groupProps } = props;
    let domRef = (0, _utils.useDOMRef)(ref);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.CheckboxGroup), {
        ...groupProps,
        ref: domRef,
        style: UNSAFE_style,
        className: UNSAFE_className + function anonymous(props, overrides) {
            let rules = " ", currentRules = {};
            let gridColumnStart = false;
            let gridColumnEnd = false;
            let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L|-macro\$)[^\s]+/g);
            for (let p of matches){
                if (p[1] === "z") gridColumnStart = true;
                if (p[1] === "y") gridColumnEnd = true;
                rules += p[0];
            }
            rules += ' se12';
            currentRules["display"] = "grid";
            if (props.isInForm) {
                if (!gridColumnStart) rules += ' z2mU12';
                currentRules["gridColumnStart"] = typeof currentRules["gridColumnStart"] === 'object' ? currentRules["gridColumnStart"] : {
                    "default": currentRules["gridColumnStart"]
                };
                currentRules["gridColumnStart"]["isInForm"] = 1;
            }
            if (props.isInForm) {
                if (props.labelPosition === "side") {
                    if (!gridColumnEnd) rules += ' yvoofG12';
                    currentRules["gridColumnEnd"] = typeof currentRules["gridColumnEnd"] === 'object' ? currentRules["gridColumnEnd"] : {
                        "default": currentRules["gridColumnEnd"]
                    };
                    currentRules["gridColumnEnd"]["isInForm && labelPosition === \"side\""] = "span 2";
                }
            }
            if (props.isInForm) {
                rules += ' DLwlgod12';
                currentRules["gridTemplateColumns"] = typeof currentRules["gridTemplateColumns"] === 'object' ? currentRules["gridTemplateColumns"] : {
                    "default": currentRules["gridTemplateColumns"]
                };
                currentRules["gridTemplateColumns"]["isInForm"] = "subgrid";
            } else {
                if (props.labelPosition === "side") {
                    rules += ' DPlN5qb12';
                    currentRules["gridTemplateColumns"] = typeof currentRules["gridTemplateColumns"] === 'object' ? currentRules["gridTemplateColumns"] : {
                        "default": currentRules["gridTemplateColumns"]
                    };
                    currentRules["gridTemplateColumns"]["labelPosition === \"side\""] = [
                        "auto",
                        "1fr"
                    ];
                } else if (props.labelPosition === "top") {
                    rules += ' DM8Mfn12';
                    currentRules["gridTemplateColumns"] = typeof currentRules["gridTemplateColumns"] === 'object' ? currentRules["gridTemplateColumns"] : {
                        "default": currentRules["gridTemplateColumns"]
                    };
                    currentRules["gridTemplateColumns"]["labelPosition === \"top\""] = [
                        "1fr"
                    ];
                }
            }
            if (props.labelPosition === "side") {
                rules += ' EPlN5qb12';
                currentRules["gridTemplateRows"] = typeof currentRules["gridTemplateRows"] === 'object' ? currentRules["gridTemplateRows"] : {
                    "default": currentRules["gridTemplateRows"]
                };
                currentRules["gridTemplateRows"]["labelPosition === \"side\""] = [
                    "auto",
                    "1fr"
                ];
            } else if (props.labelPosition === "top") {
                rules += ' E4w1sLc12';
                currentRules["gridTemplateRows"] = typeof currentRules["gridTemplateRows"] === 'object' ? currentRules["gridTemplateRows"] : {
                    "default": currentRules["gridTemplateRows"]
                };
                currentRules["gridTemplateRows"]["labelPosition === \"top\""] = [
                    "auto",
                    "1fr",
                    "auto"
                ];
            }
            if (props.labelPosition === "side") {
                rules += ' CbRM95c12';
                currentRules["gridTemplateAreas"] = typeof currentRules["gridTemplateAreas"] === 'object' ? currentRules["gridTemplateAreas"] : {
                    "default": currentRules["gridTemplateAreas"]
                };
                currentRules["gridTemplateAreas"]["labelPosition === \"side\""] = [
                    "label input",
                    "label helptext"
                ];
            } else if (props.labelPosition === "top") {
                rules += ' Cxaocre12';
                currentRules["gridTemplateAreas"] = typeof currentRules["gridTemplateAreas"] === 'object' ? currentRules["gridTemplateAreas"] : {
                    "default": currentRules["gridTemplateAreas"]
                };
                currentRules["gridTemplateAreas"]["labelPosition === \"top\""] = [
                    "label",
                    "input",
                    "helptext"
                ];
            }
            if (props.size === "XL") {
                rules += ' -_6BNtrc-e12';
                currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
                    "default": currentRules["fontSize"]
                };
                currentRules["fontSize"]["size === \"XL\""] = "ui-xl";
                rules += ' vx12';
                currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
                    "default": currentRules["fontSize"]
                };
                currentRules["fontSize"]["size === \"XL\""] = "ui-xl";
            } else if (props.size === "L") {
                rules += ' -_6BNtrc-d12';
                currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
                    "default": currentRules["fontSize"]
                };
                currentRules["fontSize"]["size === \"L\""] = "ui-lg";
                rules += ' vx12';
                currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
                    "default": currentRules["fontSize"]
                };
                currentRules["fontSize"]["size === \"L\""] = "ui-lg";
            } else if (props.size === "S") {
                rules += ' -_6BNtrc-b12';
                currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
                    "default": currentRules["fontSize"]
                };
                currentRules["fontSize"]["size === \"S\""] = "ui-sm";
                rules += ' vx12';
                currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
                    "default": currentRules["fontSize"]
                };
                currentRules["fontSize"]["size === \"S\""] = "ui-sm";
            } else if (props.size === "XS") {
                rules += ' -_6BNtrc-a12';
                currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
                    "default": currentRules["fontSize"]
                };
                currentRules["fontSize"]["size === \"XS\""] = "ui-xs";
                rules += ' vx12';
                currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
                    "default": currentRules["fontSize"]
                };
                currentRules["fontSize"]["size === \"XS\""] = "ui-xs";
            } else {
                rules += ' -_6BNtrc-c12';
                currentRules["fontSize"] = "ui";
                rules += ' vx12';
                currentRules["fontSize"] = "ui";
            }
            rules += ' ea12';
            currentRules["alignItems"] = "baseline";
            rules += ' _Fd12';
            currentRules["lineHeight"] = "ui";
            rules += ' _FezxGHba12';
            currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
                "default": currentRules["lineHeight"]
            };
            currentRules["lineHeight"][":lang(ar, he)"] = "ui";
            rules += ' _FnuYUweb12';
            currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
                "default": currentRules["lineHeight"]
            };
            currentRules["lineHeight"][":lang(ja, ko, zh, zh-Hant, zh-Hans, zh-CN, zh-SG)"] = "ui";
            if (props.size === "XL") {
                rules += ' -BhX7R-Fz12';
                currentRules["--field-height"] = typeof currentRules["--field-height"] === 'object' ? currentRules["--field-height"] : {
                    "default": currentRules["--field-height"]
                };
                currentRules["--field-height"]["size === \"XL\""] = 48;
            } else if (props.size === "L") {
                rules += ' -BhX7R-Fv12';
                currentRules["--field-height"] = typeof currentRules["--field-height"] === 'object' ? currentRules["--field-height"] : {
                    "default": currentRules["--field-height"]
                };
                currentRules["--field-height"]["size === \"L\""] = 40;
            } else if (props.size === "S") {
                rules += ' -BhX7R-Fp12';
                currentRules["--field-height"] = typeof currentRules["--field-height"] === 'object' ? currentRules["--field-height"] : {
                    "default": currentRules["--field-height"]
                };
                currentRules["--field-height"]["size === \"S\""] = 24;
            } else if (props.size === "XS") {
                rules += ' -BhX7R-Fn12';
                currentRules["--field-height"] = typeof currentRules["--field-height"] === 'object' ? currentRules["--field-height"] : {
                    "default": currentRules["--field-height"]
                };
                currentRules["--field-height"]["size === \"XS\""] = 20;
            } else {
                rules += ' -BhX7R-Fx12';
                currentRules["--field-height"] = 32;
            }
            rules += ' -AJjOLd-UVxyPec12';
            currentRules["--field-gap"] = "calc(var(--field-height) - 1lh)";
            rules += ' qg12';
            currentRules["columnGap"] = 12;
            rules += ' __ca12';
            currentRules["disableTapHighlight"] = true;
            return rules;
        }({
            size: props.size,
            labelPosition,
            isInForm: !!formContext
        }, props.styles),
        children: ({ isDisabled, isInvalid })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldLabel), {
                        isDisabled: isDisabled,
                        isRequired: props.isRequired,
                        size: size,
                        labelPosition: labelPosition,
                        labelAlign: labelAlign,
                        necessityIndicator: necessityIndicator,
                        contextualHelp: props.contextualHelp,
                        children: label
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: function anonymous(props) {
                            let rules = " ", currentRules = {};
                            rules += ' zXcEWr12';
                            currentRules["gridColumnStart"] = "input";
                            rules += ' yXcEWr12';
                            currentRules["gridColumnEnd"] = "input";
                            rules += ' BXcEWr12';
                            currentRules["gridRowStart"] = "input";
                            rules += ' AXcEWr12';
                            currentRules["gridRowEnd"] = "input";
                            rules += ' sd12';
                            currentRules["display"] = "flex";
                            if (props.orientation === "horizontal") {
                                rules += ' _tc12';
                                currentRules["flexDirection"] = typeof currentRules["flexDirection"] === 'object' ? currentRules["flexDirection"] : {
                                    "default": currentRules["flexDirection"]
                                };
                                currentRules["flexDirection"]["orientation === \"horizontal\""] = "row";
                            } else if (props.orientation === "vertical") {
                                rules += ' _ta12';
                                currentRules["flexDirection"] = typeof currentRules["flexDirection"] === 'object' ? currentRules["flexDirection"] : {
                                    "default": currentRules["flexDirection"]
                                };
                                currentRules["flexDirection"]["orientation === \"vertical\""] = "column";
                            }
                            rules += ' _Fd12';
                            currentRules["lineHeight"] = "ui";
                            rules += ' _FezxGHba12';
                            currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
                                "default": currentRules["lineHeight"]
                            };
                            currentRules["lineHeight"][":lang(ar, he)"] = "ui";
                            rules += ' _FnuYUweb12';
                            currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
                                "default": currentRules["lineHeight"]
                            };
                            currentRules["lineHeight"][":lang(ja, ko, zh, zh-Hant, zh-Hans, zh-CN, zh-SG)"] = "ui";
                            rules += ' UgOnRt12';
                            currentRules["rowGap"] = "--field-gap";
                            rules += ' ql12';
                            currentRules["columnGap"] = 16;
                            rules += ' _wb12';
                            currentRules["flexWrap"] = "wrap";
                            return rules;
                        }({
                            orientation
                        }),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.FormContext).Provider, {
                            value: {
                                ...formContext,
                                size,
                                isRequired: undefined
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkbox.CheckboxContext).Provider, {
                                value: {
                                    isEmphasized
                                },
                                children: children
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.HelpText), {
                        size: size,
                        isDisabled: isDisabled,
                        isInvalid: isInvalid,
                        description: description,
                        showErrorIcon: true,
                        children: errorMessage
                    })
                ]
            })
    });
});

},{"0":"6Mhfo","1":"4uOnx","react/jsx-runtime":"2Is6Z","react-aria-components":"9jC2J","./Checkbox":"jdSVu","react":"a1TxN","./Field":"eI7CE","./Form":"cHqN4","@react-spectrum/utils":"jqfrX","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6Mhfo":[function() {},{}],"4uOnx":[function() {},{}],"6EZwV":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColorAreaContext", ()=>ColorAreaContext);
parcelHelpers.export(exports, "ColorArea", ()=>ColorArea);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _colorHandle = require("./ColorHandle");
var _react = require("react");
var _utils = require("@react-spectrum/utils");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const ColorAreaContext = /*#__PURE__*/ (0, _react.createContext)(null);
const ColorArea = /*#__PURE__*/ (0, _react.forwardRef)(function ColorArea(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, ColorAreaContext);
    let { UNSAFE_className = '', UNSAFE_style, styles } = props;
    let containerRef = (0, _utils.useDOMRef)(ref);
    let { direction } = (0, _reactAriaComponents.useLocale)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ColorArea), {
        ...props,
        ref: containerRef,
        style: ({ defaultStyle, isDisabled })=>({
                ...defaultStyle,
                background: isDisabled ? undefined : defaultStyle.background,
                // Move position: relative to style macro so it can be overridden.
                position: undefined,
                ...UNSAFE_style
            }),
        className: (renderProps)=>UNSAFE_className + function anonymous(props, overrides) {
                let rules = " ", currentRules = {};
                let position = false;
                let width = false;
                let height = false;
                let minWidth = false;
                let minHeight = false;
                let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L|F|M|K|-macro\$)[^\s]+/g);
                for (let p of matches){
                    if (p[1] === "_P") position = true;
                    if (p[1] === "Z") width = true;
                    if (p[1] === "F") height = true;
                    if (p[1] === "N") minWidth = true;
                    if (p[1] === "M") minHeight = true;
                    rules += p[0];
                }
                if (!position) rules += ' _Pc12';
                currentRules["position"] = "relative";
                if (!width) rules += ' Zr12';
                currentRules["width"] = 192;
                if (!height) rules += ' Fs12';
                currentRules["height"] = 192;
                if (!minWidth) rules += ' Nm12';
                currentRules["minWidth"] = 64;
                if (!minHeight) rules += ' Ml12';
                currentRules["minHeight"] = 64;
                rules += ' ob12';
                currentRules["borderTopStartRadius"] = "default";
                rules += ' nb12';
                currentRules["borderTopEndRadius"] = "default";
                rules += ' kb12';
                currentRules["borderBottomStartRadius"] = "default";
                rules += ' jb12';
                currentRules["borderBottomEndRadius"] = "default";
                rules += ' Oi12';
                currentRules["outlineColor"] = "gray-1000/10";
                rules += ' Ola12';
                currentRules["outlineColor"] = typeof currentRules["outlineColor"] === 'object' ? currentRules["outlineColor"] : {
                    "default": currentRules["outlineColor"]
                };
                currentRules["outlineColor"]["forcedColors"] = "ButtonBorder";
                rules += ' _Mb12';
                currentRules["outlineWidth"] = 1;
                rules += ' _Ka12';
                currentRules["outlineOffset"] = -1;
                if (props.isDisabled) {
                    rules += ' _Le12';
                    currentRules["outlineStyle"] = typeof currentRules["outlineStyle"] === 'object' ? currentRules["outlineStyle"] : {
                        "default": currentRules["outlineStyle"]
                    };
                    currentRules["outlineStyle"]["isDisabled"] = "none";
                } else {
                    rules += ' _Lf12';
                    currentRules["outlineStyle"] = "solid";
                }
                if (props.isDisabled) {
                    rules += ' gH12';
                    currentRules["backgroundColor"] = typeof currentRules["backgroundColor"] === 'object' ? currentRules["backgroundColor"] : {
                        "default": currentRules["backgroundColor"]
                    };
                    currentRules["backgroundColor"]["isDisabled"] = "disabled";
                }
                return rules;
            }(renderProps, styles),
        children: ({ state })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _colorHandle.ColorHandle), {
                containerRef: containerRef,
                getPosition: ()=>{
                    let { x, y } = state.getThumbPosition();
                    return {
                        x: direction === 'ltr' ? x : 1 - x,
                        y
                    };
                }
            })
    });
});

},{"0":"dIMNQ","react/jsx-runtime":"2Is6Z","react-aria-components":[["ColorArea","8DzAH"],["useLocale","4k4z8"]],"./ColorHandle":"5r9wJ","react":"a1TxN","@react-spectrum/utils":"jqfrX","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"dIMNQ":[function() {},{}],"8DzAH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColorAreaStateContext", ()=>ColorAreaStateContext);
parcelHelpers.export(exports, "ColorArea", ()=>ColorArea);
var _reactAria = require("react-aria");
var _utils = require("./utils");
var _rspcontexts = require("./RSPContexts");
var _reactStately = require("react-stately");
var _utils1 = require("@react-aria/utils");
var _colorThumb = require("./ColorThumb");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const ColorAreaStateContext = /*#__PURE__*/ (0, _react.createContext)(null);
const ColorArea = /*#__PURE__*/ (0, _react.forwardRef)(function ColorArea(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, (0, _rspcontexts.ColorAreaContext));
    let inputXRef = (0, _react.useRef)(null);
    let inputYRef = (0, _react.useRef)(null);
    let state = (0, _reactStately.useColorAreaState)(props);
    let { colorAreaProps, xInputProps, yInputProps, thumbProps } = (0, _reactAria.useColorArea)({
        ...props,
        inputXRef,
        inputYRef,
        containerRef: ref
    }, state);
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        defaultClassName: 'react-aria-ColorArea',
        defaultStyle: colorAreaProps.style,
        values: {
            state,
            isDisabled: props.isDisabled || false
        }
    });
    let DOMProps = (0, _utils1.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ref: ref,
        ...(0, _utils1.mergeProps)(DOMProps, colorAreaProps, renderProps),
        slot: props.slot || undefined,
        "data-disabled": props.isDisabled || undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                ColorAreaStateContext,
                state
            ],
            [
                (0, _colorThumb.InternalColorThumbContext),
                {
                    state,
                    thumbProps,
                    inputXRef,
                    xInputProps,
                    inputYRef,
                    yInputProps,
                    isDisabled: props.isDisabled
                }
            ]
        ]
    }, renderProps.children));
});

},{"react-aria":"9fqQK","./utils":"bA6Cz","./RSPContexts":"lIerG","react-stately":"9Zz1j","@react-aria/utils":[["filterDOMProps","3upVm"],["mergeProps","aNvcY"]],"./ColorThumb":"gcXiK","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9fqQK":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a color area component.
 * Color area allows users to adjust two channels of an RGB, HSL or HSB color value against a two-dimensional gradient background.
 */ parcelHelpers.export(exports, "useColorArea", ()=>useColorArea);
var _utils = require("@react-aria/utils");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _react = require("react");
var _useColorAreaGradient = require("./useColorAreaGradient");
var _interactions = require("@react-aria/interactions");
var _i18N = require("@react-aria/i18n");
var _visuallyHidden = require("@react-aria/visually-hidden");
function useColorArea(props, state) {
    let { isDisabled, inputXRef, inputYRef, containerRef, 'aria-label': ariaLabel, xName, yName, form } = props;
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-aria/color');
    let { addGlobalListener, removeGlobalListener } = (0, _utils.useGlobalListeners)();
    let { direction, locale } = (0, _i18N.useLocale)();
    let [focusedInput, setFocusedInput] = (0, _react.useState)(null);
    let focusInput = (0, _react.useCallback)((inputRef = inputXRef)=>{
        if (inputRef.current) (0, _utils.focusWithoutScrolling)(inputRef.current);
    }, [
        inputXRef
    ]);
    (0, _utils.useFormReset)(inputXRef, state.defaultValue, state.setValue);
    let [valueChangedViaKeyboard, setValueChangedViaKeyboard] = (0, _react.useState)(false);
    let [valueChangedViaInputChangeEvent, setValueChangedViaInputChangeEvent] = (0, _react.useState)(false);
    let { xChannel, yChannel, zChannel } = state.channels;
    let xChannelStep = state.xChannelStep;
    let yChannelStep = state.yChannelStep;
    let currentPosition = (0, _react.useRef)(null);
    let { keyboardProps } = (0, _interactions.useKeyboard)({
        onKeyDown (e) {
            // these are the cases that useMove doesn't handle
            if (!/^(PageUp|PageDown|Home|End)$/.test(e.key)) {
                e.continuePropagation();
                return;
            }
            // same handling as useMove, don't need to stop propagation, useKeyboard will do that for us
            e.preventDefault();
            // remember to set this and unset it so that onChangeEnd is fired
            state.setDragging(true);
            setValueChangedViaKeyboard(true);
            let dir;
            switch(e.key){
                case 'PageUp':
                    state.incrementY(state.yChannelPageStep);
                    dir = 'y';
                    break;
                case 'PageDown':
                    state.decrementY(state.yChannelPageStep);
                    dir = 'y';
                    break;
                case 'Home':
                    direction === 'rtl' ? state.incrementX(state.xChannelPageStep) : state.decrementX(state.xChannelPageStep);
                    dir = 'x';
                    break;
                case 'End':
                    direction === 'rtl' ? state.decrementX(state.xChannelPageStep) : state.incrementX(state.xChannelPageStep);
                    dir = 'x';
                    break;
            }
            state.setDragging(false);
            if (dir) {
                let input = dir === 'x' ? inputXRef : inputYRef;
                focusInput(input);
                setFocusedInput(dir);
            }
        }
    });
    let moveHandler = {
        onMoveStart () {
            currentPosition.current = null;
            state.setDragging(true);
        },
        onMove ({ deltaX, deltaY, pointerType, shiftKey }) {
            let { incrementX, decrementX, incrementY, decrementY, xChannelPageStep, xChannelStep, yChannelPageStep, yChannelStep, getThumbPosition, setColorFromPoint } = state;
            if (currentPosition.current == null) currentPosition.current = getThumbPosition();
            let { width, height } = containerRef.current?.getBoundingClientRect() || {
                width: 0,
                height: 0
            };
            let valueChanged = deltaX !== 0 || deltaY !== 0;
            if (pointerType === 'keyboard') {
                let deltaXValue = shiftKey && xChannelPageStep > xChannelStep ? xChannelPageStep : xChannelStep;
                let deltaYValue = shiftKey && yChannelPageStep > yChannelStep ? yChannelPageStep : yChannelStep;
                if (deltaX > 0 && direction === 'ltr' || deltaX < 0 && direction === 'rtl') incrementX(deltaXValue);
                else if (deltaX < 0 && direction === 'ltr' || deltaX > 0 && direction === 'rtl') decrementX(deltaXValue);
                else if (deltaY > 0) decrementY(deltaYValue);
                else if (deltaY < 0) incrementY(deltaYValue);
                setValueChangedViaKeyboard(valueChanged);
                // set the focused input based on which axis has the greater delta
                focusedInput = valueChanged && Math.abs(deltaY) > Math.abs(deltaX) ? 'y' : 'x';
                setFocusedInput(focusedInput);
            } else {
                currentPosition.current.x += (direction === 'rtl' ? -1 : 1) * deltaX / width;
                currentPosition.current.y += deltaY / height;
                setColorFromPoint(currentPosition.current.x, currentPosition.current.y);
            }
        },
        onMoveEnd () {
            isOnColorArea.current = false;
            state.setDragging(false);
            let input = focusedInput === 'x' ? inputXRef : inputYRef;
            focusInput(input);
        }
    };
    let { moveProps: movePropsThumb } = (0, _interactions.useMove)(moveHandler);
    let { focusWithinProps } = (0, _interactions.useFocusWithin)({
        onFocusWithinChange: (focusWithin)=>{
            if (!focusWithin) {
                setValueChangedViaKeyboard(false);
                setValueChangedViaInputChangeEvent(false);
            }
        }
    });
    let currentPointer = (0, _react.useRef)(undefined);
    let isOnColorArea = (0, _react.useRef)(false);
    let { moveProps: movePropsContainer } = (0, _interactions.useMove)({
        onMoveStart () {
            if (isOnColorArea.current) moveHandler.onMoveStart();
        },
        onMove (e) {
            if (isOnColorArea.current) moveHandler.onMove(e);
        },
        onMoveEnd () {
            if (isOnColorArea.current) moveHandler.onMoveEnd();
        }
    });
    let onThumbDown = (id)=>{
        if (!state.isDragging) {
            currentPointer.current = id;
            setValueChangedViaKeyboard(false);
            focusInput();
            state.setDragging(true);
            if (typeof PointerEvent !== 'undefined') addGlobalListener(window, 'pointerup', onThumbUp, false);
            else {
                addGlobalListener(window, 'mouseup', onThumbUp, false);
                addGlobalListener(window, 'touchend', onThumbUp, false);
            }
        }
    };
    let onThumbUp = (e)=>{
        let id = e.pointerId ?? e.changedTouches?.[0].identifier;
        if (id === currentPointer.current) {
            setValueChangedViaKeyboard(false);
            focusInput();
            state.setDragging(false);
            currentPointer.current = undefined;
            isOnColorArea.current = false;
            if (typeof PointerEvent !== 'undefined') removeGlobalListener(window, 'pointerup', onThumbUp, false);
            else {
                removeGlobalListener(window, 'mouseup', onThumbUp, false);
                removeGlobalListener(window, 'touchend', onThumbUp, false);
            }
        }
    };
    let onColorAreaDown = (colorArea, id, clientX, clientY)=>{
        let rect = colorArea.getBoundingClientRect();
        let { width, height } = rect;
        let x = (clientX - rect.x) / width;
        let y = (clientY - rect.y) / height;
        if (direction === 'rtl') x = 1 - x;
        if (x >= 0 && x <= 1 && y >= 0 && y <= 1 && !state.isDragging && currentPointer.current === undefined) {
            isOnColorArea.current = true;
            setValueChangedViaKeyboard(false);
            currentPointer.current = id;
            state.setColorFromPoint(x, y);
            focusInput();
            state.setDragging(true);
            if (typeof PointerEvent !== 'undefined') addGlobalListener(window, 'pointerup', onColorAreaUp, false);
            else {
                addGlobalListener(window, 'mouseup', onColorAreaUp, false);
                addGlobalListener(window, 'touchend', onColorAreaUp, false);
            }
        }
    };
    let onColorAreaUp = (e)=>{
        let id = e.pointerId ?? e.changedTouches?.[0].identifier;
        if (isOnColorArea.current && id === currentPointer.current) {
            isOnColorArea.current = false;
            setValueChangedViaKeyboard(false);
            currentPointer.current = undefined;
            state.setDragging(false);
            focusInput();
            if (typeof PointerEvent !== 'undefined') removeGlobalListener(window, 'pointerup', onColorAreaUp, false);
            else {
                removeGlobalListener(window, 'mouseup', onColorAreaUp, false);
                removeGlobalListener(window, 'touchend', onColorAreaUp, false);
            }
        }
    };
    let colorAreaInteractions = isDisabled ? {} : (0, _utils.mergeProps)({
        ...typeof PointerEvent !== 'undefined' ? {
            onPointerDown: (e)=>{
                if (e.pointerType === 'mouse' && (e.button !== 0 || e.altKey || e.ctrlKey || e.metaKey)) return;
                onColorAreaDown(e.currentTarget, e.pointerId, e.clientX, e.clientY);
            }
        } : {
            onMouseDown: (e)=>{
                if (e.button !== 0 || e.altKey || e.ctrlKey || e.metaKey) return;
                onColorAreaDown(e.currentTarget, undefined, e.clientX, e.clientY);
            },
            onTouchStart: (e)=>{
                onColorAreaDown(e.currentTarget, e.changedTouches[0].identifier, e.changedTouches[0].clientX, e.changedTouches[0].clientY);
            }
        }
    }, movePropsContainer);
    let thumbInteractions = isDisabled ? {} : (0, _utils.mergeProps)({
        ...typeof PointerEvent !== 'undefined' ? {
            onPointerDown: (e)=>{
                if (e.pointerType === 'mouse' && (e.button !== 0 || e.altKey || e.ctrlKey || e.metaKey)) return;
                onThumbDown(e.pointerId);
            }
        } : {
            onMouseDown: (e)=>{
                if (e.button !== 0 || e.altKey || e.ctrlKey || e.metaKey) return;
                onThumbDown(undefined);
            },
            onTouchStart: (e)=>{
                onThumbDown(e.changedTouches[0].identifier);
            }
        }
    }, focusWithinProps, keyboardProps, movePropsThumb);
    let { focusProps: xInputFocusProps } = (0, _interactions.useFocus)({
        onFocus: ()=>{
            setFocusedInput('x');
        }
    });
    let { focusProps: yInputFocusProps } = (0, _interactions.useFocus)({
        onFocus: ()=>{
            setFocusedInput('y');
        }
    });
    const onChange = (e)=>{
        const { target } = e;
        setValueChangedViaInputChangeEvent(true);
        if (target === inputXRef.current) state.setXValue(parseFloat(target.value));
        else if (target === inputYRef.current) state.setYValue(parseFloat(target.value));
    };
    let isMobile = (0, _utils.isIOS)() || (0, _utils.isAndroid)();
    let value = state.getDisplayColor();
    const getAriaValueTextForChannel = (0, _react.useCallback)((channel)=>{
        const isAfterInput = valueChangedViaInputChangeEvent || valueChangedViaKeyboard;
        return `${isAfterInput ? stringFormatter.format('colorNameAndValue', {
            name: value.getChannelName(channel, locale),
            value: value.formatChannelValue(channel, locale)
        }) : [
            stringFormatter.format('colorNameAndValue', {
                name: value.getChannelName(channel, locale),
                value: value.formatChannelValue(channel, locale)
            }),
            stringFormatter.format('colorNameAndValue', {
                name: value.getChannelName(channel === yChannel ? xChannel : yChannel, locale),
                value: value.formatChannelValue(channel === yChannel ? xChannel : yChannel, locale)
            }),
            stringFormatter.format('colorNameAndValue', {
                name: value.getChannelName(zChannel, locale),
                value: value.formatChannelValue(zChannel, locale)
            })
        ].join(', ')}, ${value.getColorName(locale)}`;
    }, [
        locale,
        value,
        stringFormatter,
        valueChangedViaInputChangeEvent,
        valueChangedViaKeyboard,
        xChannel,
        yChannel,
        zChannel
    ]);
    let colorPickerLabel = stringFormatter.format('colorPicker');
    let xInputLabellingProps = (0, _utils.useLabels)({
        ...props,
        'aria-label': ariaLabel ? stringFormatter.format('colorInputLabel', {
            label: ariaLabel,
            channelLabel: colorPickerLabel
        }) : colorPickerLabel
    });
    let yInputLabellingProps = (0, _utils.useLabels)({
        ...props,
        'aria-label': ariaLabel ? stringFormatter.format('colorInputLabel', {
            label: ariaLabel,
            channelLabel: colorPickerLabel
        }) : colorPickerLabel
    });
    let colorAreaLabellingProps = (0, _utils.useLabels)({
        ...props,
        'aria-label': ariaLabel ? `${ariaLabel}, ${colorPickerLabel}` : undefined
    }, isMobile ? colorPickerLabel : undefined);
    let ariaRoleDescription = stringFormatter.format('twoDimensionalSlider');
    let { visuallyHiddenProps } = (0, _visuallyHidden.useVisuallyHidden)({
        style: {
            opacity: '0.0001',
            width: '100%',
            height: '100%',
            pointerEvents: 'none'
        }
    });
    let { colorAreaStyleProps, thumbStyleProps } = (0, _useColorAreaGradient.useColorAreaGradient)({
        direction,
        state,
        xChannel,
        yChannel,
        zChannel
    });
    return {
        colorAreaProps: {
            ...colorAreaLabellingProps,
            ...colorAreaInteractions,
            ...colorAreaStyleProps,
            role: 'group'
        },
        thumbProps: {
            ...thumbInteractions,
            ...thumbStyleProps,
            role: 'presentation'
        },
        xInputProps: {
            ...xInputLabellingProps,
            ...visuallyHiddenProps,
            ...xInputFocusProps,
            type: 'range',
            min: state.value.getChannelRange(xChannel).minValue,
            max: state.value.getChannelRange(xChannel).maxValue,
            step: xChannelStep,
            'aria-roledescription': ariaRoleDescription,
            'aria-valuetext': getAriaValueTextForChannel(xChannel),
            'aria-orientation': 'horizontal',
            'aria-describedby': props['aria-describedby'],
            'aria-details': props['aria-details'],
            disabled: isDisabled,
            value: state.value.getChannelValue(xChannel),
            name: xName,
            form,
            tabIndex: isMobile || !focusedInput || focusedInput === 'x' ? undefined : -1,
            /*
        So that only a single "2d slider" control shows up when listing form elements for screen readers,
        add aria-hidden="true" to the unfocused control when the value has not changed via the keyboard,
        but remove aria-hidden to reveal the input for each channel when the value has changed with the keyboard.
      */ 'aria-hidden': isMobile || !focusedInput || focusedInput === 'x' || valueChangedViaKeyboard ? undefined : 'true',
            onChange
        },
        yInputProps: {
            ...yInputLabellingProps,
            ...visuallyHiddenProps,
            ...yInputFocusProps,
            type: 'range',
            min: state.value.getChannelRange(yChannel).minValue,
            max: state.value.getChannelRange(yChannel).maxValue,
            step: yChannelStep,
            'aria-roledescription': ariaRoleDescription,
            'aria-valuetext': getAriaValueTextForChannel(yChannel),
            'aria-orientation': 'vertical',
            'aria-describedby': props['aria-describedby'],
            'aria-details': props['aria-details'],
            disabled: isDisabled,
            value: state.value.getChannelValue(yChannel),
            name: yName,
            form,
            tabIndex: isMobile || focusedInput === 'y' ? undefined : -1,
            /*
        So that only a single "2d slider" control shows up when listing form elements for screen readers,
        add aria-hidden="true" to the unfocused input when the value has not changed via the keyboard,
        but remove aria-hidden to reveal the input for each channel when the value has changed with the keyboard.
      */ 'aria-hidden': isMobile || focusedInput === 'y' || valueChangedViaKeyboard ? undefined : 'true',
            onChange
        }
    };
}

},{"@react-aria/utils":[["focusWithoutScrolling","81NOP"],["isAndroid","7AGiA"],["isIOS","7AGiA"],["mergeProps","aNvcY"],["useFormReset","dwBOx"],["useGlobalListeners","ceyTG"],["useLabels","7Uhyw"]],"../intl/*.json":"jzrzz","react":"a1TxN","./useColorAreaGradient":"7Cp8h","@react-aria/interactions":[["useFocus","j8nkn"],["useFocusWithin","8bxuk"],["useKeyboard","vsbUl"],["useMove","kqQMp"]],"@react-aria/i18n":[["useLocale","4k4z8"],["useLocalizedStringFormatter","7lxyl"]],"@react-aria/visually-hidden":"7zrGr","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jzrzz":[function(require,module,exports,__globalThis) {
const _temp0 = require("fd28ab3e583acafd");
const _temp1 = require("720e216cab7b7ba4");
const _temp2 = require("559eade6dcf6b87f");
const _temp3 = require("a64b39c5672cb431");
const _temp4 = require("9627d39939a4f914");
const _temp5 = require("24dbd639d50b4c1e");
const _temp6 = require("fdac0e02a6b5e974");
const _temp7 = require("fda5450887291c48");
const _temp8 = require("5aca092ec289a424");
const _temp9 = require("a349443c27cc24b");
const _temp10 = require("f06b391bb60aabc5");
const _temp11 = require("bd6ecba6fc38678c");
const _temp12 = require("fb55d76cd9577ef3");
const _temp13 = require("537b8d68ca377245");
const _temp14 = require("69634f88892bf7a6");
const _temp15 = require("2476a83dd8e96270");
const _temp16 = require("c15b084353944e05");
const _temp17 = require("45e43b3e4ad04dc5");
const _temp18 = require("f9a7b68bade50467");
const _temp19 = require("e2c45d24bec52af6");
const _temp20 = require("3bf956af919a4704");
const _temp21 = require("52b4b6cbdcb7256e");
const _temp22 = require("c2cf7e258991288e");
const _temp23 = require("f8aadecdd6ea9625");
const _temp24 = require("117e123ddf42950a");
const _temp25 = require("4957a53d28558e32");
const _temp26 = require("97e281451329f6f1");
const _temp27 = require("9abddc99aba1c250");
const _temp28 = require("624350b3d08a89d4");
const _temp29 = require("518283df38737bfd");
const _temp30 = require("63d39172fc4d210");
const _temp31 = require("8e0126357fd569f2");
const _temp32 = require("974d3ec6a91141b4");
const _temp33 = require("6aab64caa5acfbe8");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"fd28ab3e583acafd":"ctpKo","720e216cab7b7ba4":"ctpKo","559eade6dcf6b87f":"ctpKo","a64b39c5672cb431":"ctpKo","9627d39939a4f914":"ctpKo","24dbd639d50b4c1e":"ctpKo","fdac0e02a6b5e974":"21Kvp","fda5450887291c48":"ctpKo","5aca092ec289a424":"ctpKo","a349443c27cc24b":"ctpKo","f06b391bb60aabc5":"ctpKo","bd6ecba6fc38678c":"ctpKo","fb55d76cd9577ef3":"ctpKo","537b8d68ca377245":"ctpKo","69634f88892bf7a6":"ctpKo","2476a83dd8e96270":"ctpKo","c15b084353944e05":"ctpKo","45e43b3e4ad04dc5":"ctpKo","f9a7b68bade50467":"ctpKo","e2c45d24bec52af6":"ctpKo","3bf956af919a4704":"ctpKo","52b4b6cbdcb7256e":"ctpKo","c2cf7e258991288e":"ctpKo","f8aadecdd6ea9625":"ctpKo","117e123ddf42950a":"ctpKo","4957a53d28558e32":"ctpKo","97e281451329f6f1":"ctpKo","9abddc99aba1c250":"ctpKo","624350b3d08a89d4":"ctpKo","518283df38737bfd":"ctpKo","63d39172fc4d210":"ctpKo","8e0126357fd569f2":"ctpKo","974d3ec6a91141b4":"ctpKo","6aab64caa5acfbe8":"ctpKo"}],"21Kvp":[function(require,module,exports,__globalThis) {
module.exports = {
    "colorPicker": `Color picker`,
    "twoDimensionalSlider": `2D slider`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorSwatch": `color swatch`,
    "transparent": `transparent`
};

},{}],"7Cp8h":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useColorAreaGradient", ()=>useColorAreaGradient);
var _color = require("@react-stately/color");
var _react = require("react");
const hue = (color)=>[
        0,
        60,
        120,
        180,
        240,
        300,
        360
    ].map((hue)=>color.withChannelValue('hue', hue).toString('css')).join(', ');
const saturation = (color)=>`${color.withChannelValue('saturation', 0)}, transparent`;
const hslChannels = {
    hue,
    saturation,
    lightness: ()=>'black, transparent, white'
};
const hsbChannels = {
    hue,
    saturation,
    brightness: ()=>'black, transparent'
};
function useColorAreaGradient({ direction, state, zChannel, xChannel, yChannel }) {
    let returnVal = (0, _react.useMemo)(()=>{
        let end = direction === 'rtl' ? 'left' : 'right';
        let colorAreaStyles = {};
        let zValue = state.value.getChannelValue(zChannel);
        switch(state.value.getColorSpace()){
            case 'rgb':
                {
                    let rgb = (0, _color.parseColor)('rgb(0, 0, 0)');
                    colorAreaStyles = {
                        background: [
                            // The screen blend mode multiplies the inverse of each channel, e.g. 1 - (1 - a) * (1 - b).
                            // Create a layer for each channel, with the other channels as 0. After blending, this should
                            // result in the gradients being combined channel by channel.
                            `linear-gradient(to ${end}, ${rgb.withChannelValue(xChannel, 0)}, ${rgb.withChannelValue(xChannel, 255)})`,
                            `linear-gradient(to top, ${rgb.withChannelValue(yChannel, 0)}, ${rgb.withChannelValue(yChannel, 255)})`,
                            rgb.withChannelValue(zChannel, zValue)
                        ].join(','),
                        backgroundBlendMode: 'screen'
                    };
                    break;
                }
            case 'hsl':
                {
                    let channels = state.value.getColorChannels();
                    let value = (0, _color.parseColor)('hsl(0, 100%, 50%)').withChannelValue(zChannel, zValue);
                    let bg = channels.filter((c)=>c !== zChannel).map((c)=>`linear-gradient(to ${c === xChannel ? end : 'top'}, ${hslChannels[c](value)})`).reverse();
                    if (zChannel === 'hue') bg.push(value.toString('css'));
                    colorAreaStyles = {
                        background: bg.join(', ')
                    };
                    break;
                }
            case 'hsb':
                {
                    let channels = state.value.getColorChannels();
                    let value = (0, _color.parseColor)('hsb(0, 100%, 100%)').withChannelValue(zChannel, zValue);
                    let bg = channels.filter((c)=>c !== zChannel).map((c)=>`linear-gradient(to ${c === xChannel ? end : 'top'}, ${hsbChannels[c](value)})`).reverse();
                    if (zChannel === 'hue') bg.push(value.toString('css'));
                    colorAreaStyles = {
                        background: bg.join(', ')
                    };
                    break;
                }
        }
        let { x, y } = state.getThumbPosition();
        if (direction === 'rtl') x = 1 - x;
        let forcedColorAdjustNoneStyle = {
            forcedColorAdjust: 'none'
        };
        return {
            colorAreaStyleProps: {
                style: {
                    position: 'relative',
                    touchAction: 'none',
                    ...forcedColorAdjustNoneStyle,
                    ...colorAreaStyles
                }
            },
            thumbStyleProps: {
                style: {
                    position: 'absolute',
                    left: `${x * 100}%`,
                    top: `${y * 100}%`,
                    transform: 'translate(-50%, -50%)',
                    touchAction: 'none',
                    ...forcedColorAdjustNoneStyle
                }
            }
        };
    }, [
        direction,
        state,
        zChannel,
        xChannel,
        yChannel
    ]);
    return returnVal;
}

},{"@react-stately/color":"71wqN","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9Zz1j":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides state management for a color area component.
 * Color area allows users to adjust two channels of an HSL, HSB or RGB color value against a two-dimensional gradient background.
 */ parcelHelpers.export(exports, "useColorAreaState", ()=>useColorAreaState);
var _utils = require("@react-stately/utils");
var _color = require("./Color");
var _react = require("react");
const DEFAULT_COLOR = (0, _color.parseColor)('#ffffff');
function useColorAreaState(props) {
    let { value, defaultValue, colorSpace, xChannel, yChannel, onChange, onChangeEnd } = props;
    if (!value && !defaultValue) defaultValue = DEFAULT_COLOR;
    if (value) value = (0, _color.normalizeColor)(value);
    if (defaultValue) defaultValue = (0, _color.normalizeColor)(defaultValue);
    // safe to cast value and defaultValue to Color, one of them will always be defined because if neither are, we assign a default
    let [colorValue, setColorState] = (0, _utils.useControlledState)(value, defaultValue, onChange);
    let [initialValue] = (0, _react.useState)(colorValue);
    let color = (0, _react.useMemo)(()=>colorSpace && colorValue ? colorValue.toFormat(colorSpace) : colorValue, [
        colorValue,
        colorSpace
    ]);
    let valueRef = (0, _react.useRef)(color);
    let setColor = (color)=>{
        valueRef.current = color;
        setColorState(color);
    };
    let channels = (0, _react.useMemo)(()=>color.getColorSpaceAxes({
            xChannel,
            yChannel
        }), [
        color,
        xChannel,
        yChannel
    ]);
    let xChannelRange = color.getChannelRange(channels.xChannel);
    let yChannelRange = color.getChannelRange(channels.yChannel);
    let { minValue: minValueX, maxValue: maxValueX, step: stepX, pageSize: pageSizeX } = xChannelRange;
    let { minValue: minValueY, maxValue: maxValueY, step: stepY, pageSize: pageSizeY } = yChannelRange;
    let [isDragging, setDragging] = (0, _react.useState)(false);
    let isDraggingRef = (0, _react.useRef)(false);
    let xValue = color.getChannelValue(channels.xChannel);
    let yValue = color.getChannelValue(channels.yChannel);
    let setXValue = (v)=>{
        if (v === xValue) return;
        let newColor = color.withChannelValue(channels.xChannel, v);
        setColor(newColor);
    };
    let setYValue = (v)=>{
        if (v === yValue) return;
        let newColor = color.withChannelValue(channels.yChannel, v);
        setColor(newColor);
    };
    return {
        channels,
        xChannelStep: stepX,
        yChannelStep: stepY,
        xChannelPageStep: pageSizeX,
        yChannelPageStep: pageSizeY,
        value: color,
        defaultValue: value !== undefined ? initialValue : defaultValue,
        setValue (value) {
            setColor((0, _color.normalizeColor)(value));
        },
        xValue,
        setXValue,
        yValue,
        setYValue,
        setColorFromPoint (x, y) {
            let newXValue = minValueX + (0, _utils.clamp)(x, 0, 1) * (maxValueX - minValueX);
            let newYValue = minValueY + (1 - (0, _utils.clamp)(y, 0, 1)) * (maxValueY - minValueY);
            let newColor;
            if (newXValue !== xValue) {
                // Round new value to multiple of step, clamp value between min and max
                newXValue = (0, _utils.snapValueToStep)(newXValue, minValueX, maxValueX, stepX);
                newColor = color.withChannelValue(channels.xChannel, newXValue);
            }
            if (newYValue !== yValue) {
                // Round new value to multiple of step, clamp value between min and max
                newYValue = (0, _utils.snapValueToStep)(newYValue, minValueY, maxValueY, stepY);
                newColor = (newColor || color).withChannelValue(channels.yChannel, newYValue);
            }
            if (newColor) setColor(newColor);
        },
        getThumbPosition () {
            let x = (xValue - minValueX) / (maxValueX - minValueX);
            let y = 1 - (yValue - minValueY) / (maxValueY - minValueY);
            return {
                x,
                y
            };
        },
        incrementX (stepSize = 1) {
            setXValue(xValue + stepSize > maxValueX ? maxValueX : (0, _utils.snapValueToStep)(xValue + stepSize, minValueX, maxValueX, stepX));
        },
        incrementY (stepSize = 1) {
            setYValue(yValue + stepSize > maxValueY ? maxValueY : (0, _utils.snapValueToStep)(yValue + stepSize, minValueY, maxValueY, stepY));
        },
        decrementX (stepSize = 1) {
            setXValue((0, _utils.snapValueToStep)(xValue - stepSize, minValueX, maxValueX, stepX));
        },
        decrementY (stepSize = 1) {
            setYValue((0, _utils.snapValueToStep)(yValue - stepSize, minValueY, maxValueY, stepY));
        },
        setDragging (isDragging) {
            let wasDragging = isDraggingRef.current;
            isDraggingRef.current = isDragging;
            if (onChangeEnd && !isDragging && wasDragging) onChangeEnd(valueRef.current);
            setDragging(isDragging);
        },
        isDragging,
        getDisplayColor () {
            return color.withChannelValue('alpha', 1);
        }
    };
}

},{"@react-stately/utils":[["clamp","kO94U"],["snapValueToStep","kO94U"],["useControlledState","4Nj6T"]],"./Color":"71wqN","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gcXiK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InternalColorThumbContext", ()=>InternalColorThumbContext);
parcelHelpers.export(exports, "ColorThumb", ()=>ColorThumb);
var _utils = require("./utils");
var _utils1 = require("@react-aria/utils");
var _reactAria = require("react-aria");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const InternalColorThumbContext = /*#__PURE__*/ (0, _react.createContext)(null);
const ColorThumb = /*#__PURE__*/ (0, _react.forwardRef)(function ColorThumb(props, ref) {
    let { state, thumbProps, inputXRef, inputYRef, xInputProps, yInputProps, isDisabled = false } = (0, _react.useContext)(InternalColorThumbContext);
    let { focusProps, isFocused, isFocusVisible } = (0, _reactAria.useFocusRing)();
    let { hoverProps, isHovered } = (0, _reactAria.useHover)(props);
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        defaultClassName: 'react-aria-ColorThumb',
        defaultStyle: {
            ...thumbProps.style,
            backgroundColor: state.getDisplayColor().toString()
        },
        values: {
            color: state.getDisplayColor(),
            isHovered,
            isDragging: state.isDragging,
            isFocused,
            isFocusVisible,
            isDisabled
        }
    });
    let DOMProps = (0, _utils1.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _reactAria.mergeProps)(thumbProps, hoverProps, DOMProps),
        ...renderProps,
        ref: ref,
        "data-hovered": isHovered || undefined,
        "data-dragging": state.isDragging || undefined,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-disabled": isDisabled || undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        ref: inputXRef,
        ...xInputProps,
        ...focusProps
    }), yInputProps && /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        ref: inputYRef,
        ...yInputProps,
        ...focusProps
    }), renderProps.children);
});

},{"./utils":"bA6Cz","@react-aria/utils":"3upVm","react-aria":[["mergeProps","aNvcY"],["useFocusRing","6TXyU"],["useHover","k6FLA"]],"react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5r9wJ":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColorHandle", ()=>ColorHandle);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactAriaComponents = require("react-aria-components");
var _reactDom = require("react-dom");
var _utils = require("@react-aria/utils");
const HANDLE_SIZE = 16;
const LOUPE_HEIGHT = 64; // Does not include borders
const LOUPE_WIDTH = 48;
const LOUPE_BORDER_WIDTH = 1;
const LOUPE_OFFSET = 12; // Offset from handle to loupe
function ColorHandle({ containerRef, getPosition }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ColorThumb), {
        className: function anonymous(props) {
            let rules = " ", currentRules = {};
            rules += ' YEw2M9d12';
            currentRules["transition"] = "[width, height]";
            rules += ' Xb12';
            currentRules["transitionDuration"] = 150;
            rules += ' _2b12';
            currentRules["transitionTimingFunction"] = "default";
            if (props.isFocusVisible) {
                rules += ' ZC12';
                currentRules["width"] = typeof currentRules["width"] === 'object' ? currentRules["width"] : {
                    "default": currentRules["width"]
                };
                currentRules["width"]["isFocusVisible"] = 32;
            } else {
                rules += ' Zu12';
                currentRules["width"] = 16;
            }
            if (props.isFocusVisible) {
                rules += ' Fx12';
                currentRules["height"] = typeof currentRules["height"] === 'object' ? currentRules["height"] : {
                    "default": currentRules["height"]
                };
                currentRules["height"]["isFocusVisible"] = 32;
            } else {
                rules += ' Ft12';
                currentRules["height"] = 16;
            }
            if (props.isDisabled) {
                rules += ' gH12';
                currentRules["backgroundColor"] = typeof currentRules["backgroundColor"] === 'object' ? currentRules["backgroundColor"] : {
                    "default": currentRules["backgroundColor"]
                };
                currentRules["backgroundColor"]["isDisabled"] = "disabled";
            }
            rules += ' og12';
            currentRules["borderTopStartRadius"] = "full";
            rules += ' ng12';
            currentRules["borderTopEndRadius"] = "full";
            rules += ' kg12';
            currentRules["borderBottomStartRadius"] = "full";
            rules += ' jg12';
            currentRules["borderBottomEndRadius"] = "full";
            rules += ' _oa12';
            currentRules["boxSizing"] = "border-box";
            rules += ' _jf12';
            currentRules["borderStyle"] = "solid";
            rules += ' _kc12';
            currentRules["borderTopWidth"] = 2;
            rules += ' hc12';
            currentRules["borderBottomWidth"] = 2;
            rules += ' mc12';
            currentRules["borderStartWidth"] = 2;
            rules += ' lc12';
            currentRules["borderEndWidth"] = 2;
            if (props.isDisabled) {
                rules += ' iq12';
                currentRules["borderColor"] = typeof currentRules["borderColor"] === 'object' ? currentRules["borderColor"] : {
                    "default": currentRules["borderColor"]
                };
                currentRules["borderColor"]["isDisabled"] = "disabled";
            } else {
                rules += ' iB12';
                currentRules["borderColor"] = "white";
            }
            rules += ' _Lf12';
            currentRules["outlineStyle"] = "solid";
            rules += ' _Mb12';
            currentRules["outlineWidth"] = 1;
            rules += ' O1lWhre12';
            currentRules["outlineColor"] = "black/42";
            rules += ' Ola12';
            currentRules["outlineColor"] = typeof currentRules["outlineColor"] === 'object' ? currentRules["outlineColor"] : {
                "default": currentRules["outlineColor"]
            };
            currentRules["outlineColor"]["forcedColors"] = "ButtonBorder";
            return rules;
        },
        style: ({ defaultStyle, isDisabled })=>({
                background: isDisabled ? undefined : `linear-gradient(${defaultStyle.backgroundColor}, ${defaultStyle.backgroundColor}), repeating-conic-gradient(#E1E1E1 0% 25%, white 0% 50%) 50% / 16px 16px`,
                backgroundColor: undefined,
                top: defaultStyle.top || '50%',
                left: defaultStyle.left || '50%'
            }),
        children: ({ isDragging, color })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: " Za12 Fb12 og12 ng12 kg12 jg12 _oa12 _jf12 _kb12 hb12 mb12 lb12 i1lWhre12 ila12"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(ColorLoupePortal, {
                        isOpen: isDragging,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ColorLoupe, {
                            containerRef: containerRef,
                            color: color,
                            getPosition: getPosition
                        })
                    })
                ]
            })
    });
}
// ColorLoupe is rendered in a portal so that it breaks out of clipped/scrolling containers (e.g. popovers).
function ColorLoupePortal({ isOpen, children }) {
    let [state, setState] = (0, _react.useState)(isOpen ? 'open' : 'closed');
    if (isOpen && state === 'closed') setState('open');
    if (!isOpen && state === 'open') setState('exiting');
    if (isOpen || state === 'exiting') return /*#__PURE__*/ (0, _reactDom.createPortal)(/*#__PURE__*/ (0, _react.cloneElement)(children, {
        isExiting: state === 'exiting',
        onExited: ()=>setState('closed')
    }), document.body);
    return null;
}
function ColorLoupe({ isExiting, onExited, containerRef, loupeRef, getPosition, color }) {
    let patternId = (0, _utils.useId)();
    // Get the bounding rectangle of the container (e.g. ColorArea/ColorSlider).
    let [containerRect, setContainerRect] = (0, _react.useState)({
        top: 0,
        left: 0,
        width: 0,
        height: 0
    });
    (0, _utils.useLayoutEffect)(()=>{
        let rect = containerRef.current?.getBoundingClientRect();
        setContainerRect({
            top: rect?.top || 0,
            left: rect?.left || 0,
            width: rect?.width || 0,
            height: rect?.height || 0
        });
    }, [
        containerRef
    ]);
    // Compute the pixel position of the thumb.
    let { x: thumbLeft, y: thumbTop } = getPosition();
    thumbTop *= containerRect.height;
    thumbLeft *= containerRect.width;
    let enterAnimation = "AmkoXc";
    let exitAnimation = "HaKxcb";
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        style: {
            // Position relative to the viewport.
            position: 'fixed',
            top: containerRect.top + thumbTop,
            left: containerRect.left + thumbLeft,
            marginTop: -LOUPE_HEIGHT - LOUPE_BORDER_WIDTH * 2 - HANDLE_SIZE / 2 - LOUPE_OFFSET,
            marginLeft: -LOUPE_WIDTH / 2 - LOUPE_BORDER_WIDTH,
            animationName: isExiting ? exitAnimation : enterAnimation
        },
        className: " _rgr5H3d12 _Ob12 _eb12 _fc12 _hb12 _Bb12",
        onAnimationEnd: (e)=>{
            if (e.animationName === exitAnimation) onExited();
        },
        width: LOUPE_WIDTH + LOUPE_BORDER_WIDTH * 2,
        height: LOUPE_HEIGHT + LOUPE_BORDER_WIDTH * 2,
        ref: loupeRef,
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("pattern", {
                id: patternId,
                x: "0",
                y: "0",
                width: "16",
                height: "16",
                patternUnits: "userSpaceOnUse",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        fill: "white",
                        x: "0",
                        y: "0",
                        width: "16",
                        height: "16"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        fill: "#E1E1E1",
                        x: "0",
                        y: "0",
                        width: "8",
                        height: "8"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        fill: "#E1E1E1",
                        x: "8",
                        y: "8",
                        width: "8",
                        height: "8"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M25 1a24 24 0 0124 24c0 16.255-24 40-24 40S1 41.255 1 25A24 24 0 0125 1z",
                fill: `url(#${patternId})`
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M25 1a24 24 0 0124 24c0 16.255-24 40-24 40S1 41.255 1 25A24 24 0 0125 1z",
                fill: color.toString()
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: " _Vb12 Vi12 Vlb12 tw12",
                d: "M25 3A21.98 21.98 0 003 25c0 6.2 4 14.794 11.568 24.853A144.233 144.233 0 0025 62.132a144.085 144.085 0 0010.4-12.239C42.99 39.816 47 31.209 47 25A21.98 21.98 0 0025 3m0-2a24 24 0 0124 24c0 16.255-24 40-24 40S1 41.255 1 25A24 24 0 0125 1z"
            })
        ]
    });
}

},{"0":"fnHJO","1":"doaBg","2":"l9cD1","3":"884xI","4":"5TA8D","5":"aZYmV","react/jsx-runtime":"2Is6Z","react":"a1TxN","react-aria-components":"gcXiK","react-dom":"gC2PC","@react-aria/utils":[["useId","jbI4Y"],["useLayoutEffect","2ViQu"]],"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fnHJO":[function() {},{}],"doaBg":[function() {},{}],"l9cD1":[function() {},{}],"884xI":[function() {},{}],"5TA8D":[function() {},{}],"aZYmV":[function() {},{}],"9Yb5R":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColorFieldContext", ()=>ColorFieldContext);
parcelHelpers.export(exports, "ColorField", ()=>ColorField);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _utils = require("@react-spectrum/utils");
var _field = require("./Field");
var _form = require("./Form");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const ColorFieldContext = /*#__PURE__*/ (0, _react.createContext)(null);
const ColorField = /*#__PURE__*/ (0, _react.forwardRef)(function ColorField(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, ColorFieldContext);
    let formContext = (0, _react.useContext)((0, _form.FormContext));
    props = (0, _form.useFormProps)(props);
    let { label, description, errorMessage, necessityIndicator, labelPosition = 'top', labelAlign = 'start', UNSAFE_style, UNSAFE_className = '', styles, ...fieldProps } = props;
    // Expose imperative interface for ref
    let domRef = (0, _react.useRef)(null);
    let inputRef = (0, _react.useRef)(null);
    (0, _react.useImperativeHandle)(ref, ()=>({
            ...(0, _utils.createFocusableRef)(domRef, inputRef),
            select () {
                if (inputRef.current) inputRef.current.select();
            },
            getInputElement () {
                return inputRef.current;
            }
        }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ColorField), {
        ...fieldProps,
        ref: domRef,
        style: UNSAFE_style,
        className: UNSAFE_className + function anonymous(props, overrides) {
            let rules = " ", currentRules = {};
            let gridColumnStart = false;
            let gridColumnEnd = false;
            let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L|-macro\$)[^\s]+/g);
            for (let p of matches){
                if (p[1] === "z") gridColumnStart = true;
                if (p[1] === "y") gridColumnEnd = true;
                rules += p[0];
            }
            rules += ' se12';
            currentRules["display"] = "grid";
            if (props.isInForm) {
                if (!gridColumnStart) rules += ' z2mU12';
                currentRules["gridColumnStart"] = typeof currentRules["gridColumnStart"] === 'object' ? currentRules["gridColumnStart"] : {
                    "default": currentRules["gridColumnStart"]
                };
                currentRules["gridColumnStart"]["isInForm"] = 1;
            }
            if (props.isInForm) {
                if (props.labelPosition === "side") {
                    if (!gridColumnEnd) rules += ' yvoofG12';
                    currentRules["gridColumnEnd"] = typeof currentRules["gridColumnEnd"] === 'object' ? currentRules["gridColumnEnd"] : {
                        "default": currentRules["gridColumnEnd"]
                    };
                    currentRules["gridColumnEnd"]["isInForm && labelPosition === \"side\""] = "span 2";
                }
            }
            if (props.isInForm) {
                rules += ' DLwlgod12';
                currentRules["gridTemplateColumns"] = typeof currentRules["gridTemplateColumns"] === 'object' ? currentRules["gridTemplateColumns"] : {
                    "default": currentRules["gridTemplateColumns"]
                };
                currentRules["gridTemplateColumns"]["isInForm"] = "subgrid";
            } else {
                if (props.labelPosition === "side") {
                    rules += ' DPlN5qb12';
                    currentRules["gridTemplateColumns"] = typeof currentRules["gridTemplateColumns"] === 'object' ? currentRules["gridTemplateColumns"] : {
                        "default": currentRules["gridTemplateColumns"]
                    };
                    currentRules["gridTemplateColumns"]["labelPosition === \"side\""] = [
                        "auto",
                        "1fr"
                    ];
                } else if (props.labelPosition === "top") {
                    rules += ' DM8Mfn12';
                    currentRules["gridTemplateColumns"] = typeof currentRules["gridTemplateColumns"] === 'object' ? currentRules["gridTemplateColumns"] : {
                        "default": currentRules["gridTemplateColumns"]
                    };
                    currentRules["gridTemplateColumns"]["labelPosition === \"top\""] = [
                        "1fr"
                    ];
                }
            }
            if (props.labelPosition === "side") {
                rules += ' EPlN5qb12';
                currentRules["gridTemplateRows"] = typeof currentRules["gridTemplateRows"] === 'object' ? currentRules["gridTemplateRows"] : {
                    "default": currentRules["gridTemplateRows"]
                };
                currentRules["gridTemplateRows"]["labelPosition === \"side\""] = [
                    "auto",
                    "1fr"
                ];
            } else if (props.labelPosition === "top") {
                rules += ' E4w1sLc12';
                currentRules["gridTemplateRows"] = typeof currentRules["gridTemplateRows"] === 'object' ? currentRules["gridTemplateRows"] : {
                    "default": currentRules["gridTemplateRows"]
                };
                currentRules["gridTemplateRows"]["labelPosition === \"top\""] = [
                    "auto",
                    "1fr",
                    "auto"
                ];
            }
            if (props.labelPosition === "side") {
                rules += ' CbRM95c12';
                currentRules["gridTemplateAreas"] = typeof currentRules["gridTemplateAreas"] === 'object' ? currentRules["gridTemplateAreas"] : {
                    "default": currentRules["gridTemplateAreas"]
                };
                currentRules["gridTemplateAreas"]["labelPosition === \"side\""] = [
                    "label input",
                    "label helptext"
                ];
            } else if (props.labelPosition === "top") {
                rules += ' Cxaocre12';
                currentRules["gridTemplateAreas"] = typeof currentRules["gridTemplateAreas"] === 'object' ? currentRules["gridTemplateAreas"] : {
                    "default": currentRules["gridTemplateAreas"]
                };
                currentRules["gridTemplateAreas"]["labelPosition === \"top\""] = [
                    "label",
                    "input",
                    "helptext"
                ];
            }
            if (props.size === "XL") {
                rules += ' -_6BNtrc-e12';
                currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
                    "default": currentRules["fontSize"]
                };
                currentRules["fontSize"]["size === \"XL\""] = "ui-xl";
                rules += ' vx12';
                currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
                    "default": currentRules["fontSize"]
                };
                currentRules["fontSize"]["size === \"XL\""] = "ui-xl";
            } else if (props.size === "L") {
                rules += ' -_6BNtrc-d12';
                currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
                    "default": currentRules["fontSize"]
                };
                currentRules["fontSize"]["size === \"L\""] = "ui-lg";
                rules += ' vx12';
                currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
                    "default": currentRules["fontSize"]
                };
                currentRules["fontSize"]["size === \"L\""] = "ui-lg";
            } else if (props.size === "S") {
                rules += ' -_6BNtrc-b12';
                currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
                    "default": currentRules["fontSize"]
                };
                currentRules["fontSize"]["size === \"S\""] = "ui-sm";
                rules += ' vx12';
                currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
                    "default": currentRules["fontSize"]
                };
                currentRules["fontSize"]["size === \"S\""] = "ui-sm";
            } else if (props.size === "XS") {
                rules += ' -_6BNtrc-a12';
                currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
                    "default": currentRules["fontSize"]
                };
                currentRules["fontSize"]["size === \"XS\""] = "ui-xs";
                rules += ' vx12';
                currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
                    "default": currentRules["fontSize"]
                };
                currentRules["fontSize"]["size === \"XS\""] = "ui-xs";
            } else {
                rules += ' -_6BNtrc-c12';
                currentRules["fontSize"] = "ui";
                rules += ' vx12';
                currentRules["fontSize"] = "ui";
            }
            rules += ' ea12';
            currentRules["alignItems"] = "baseline";
            rules += ' _Fd12';
            currentRules["lineHeight"] = "ui";
            rules += ' _FezxGHba12';
            currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
                "default": currentRules["lineHeight"]
            };
            currentRules["lineHeight"][":lang(ar, he)"] = "ui";
            rules += ' _FnuYUweb12';
            currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
                "default": currentRules["lineHeight"]
            };
            currentRules["lineHeight"][":lang(ja, ko, zh, zh-Hant, zh-Hans, zh-CN, zh-SG)"] = "ui";
            if (props.size === "XL") {
                rules += ' -BhX7R-Fz12';
                currentRules["--field-height"] = typeof currentRules["--field-height"] === 'object' ? currentRules["--field-height"] : {
                    "default": currentRules["--field-height"]
                };
                currentRules["--field-height"]["size === \"XL\""] = 48;
            } else if (props.size === "L") {
                rules += ' -BhX7R-Fv12';
                currentRules["--field-height"] = typeof currentRules["--field-height"] === 'object' ? currentRules["--field-height"] : {
                    "default": currentRules["--field-height"]
                };
                currentRules["--field-height"]["size === \"L\""] = 40;
            } else if (props.size === "S") {
                rules += ' -BhX7R-Fp12';
                currentRules["--field-height"] = typeof currentRules["--field-height"] === 'object' ? currentRules["--field-height"] : {
                    "default": currentRules["--field-height"]
                };
                currentRules["--field-height"]["size === \"S\""] = 24;
            } else if (props.size === "XS") {
                rules += ' -BhX7R-Fn12';
                currentRules["--field-height"] = typeof currentRules["--field-height"] === 'object' ? currentRules["--field-height"] : {
                    "default": currentRules["--field-height"]
                };
                currentRules["--field-height"]["size === \"XS\""] = 20;
            } else {
                rules += ' -BhX7R-Fx12';
                currentRules["--field-height"] = 32;
            }
            rules += ' -AJjOLd-UVkF0Db12';
            currentRules["--field-gap"] = "[calc((var(--field-height) - self(borderTopWidth, 0px) - self(borderBottomWidth, 0px) - 1lh) / 2)]";
            rules += ' qg12';
            currentRules["columnGap"] = 12;
            rules += ' __ca12';
            currentRules["disableTapHighlight"] = true;
            return rules;
        }({
            size: props.size,
            labelPosition,
            isInForm: !!formContext
        }, styles),
        children: ({ isDisabled, isInvalid })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldLabel), {
                        isDisabled: isDisabled,
                        isRequired: props.isRequired,
                        size: props.size,
                        labelPosition: labelPosition,
                        labelAlign: labelAlign,
                        necessityIndicator: necessityIndicator,
                        contextualHelp: props.contextualHelp,
                        children: label
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _field.FieldGroup), {
                        size: props.size,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Input), {
                                ref: inputRef
                            }),
                            isInvalid && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldErrorIcon), {
                                isDisabled: isDisabled
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.HelpText), {
                        size: props.size,
                        isDisabled: isDisabled,
                        isInvalid: isInvalid,
                        description: description,
                        children: errorMessage
                    })
                ]
            })
    });
});

},{"0":"1DVYa","react/jsx-runtime":"2Is6Z","react-aria-components":"heszb","react":"a1TxN","@react-spectrum/utils":"jqfrX","./Field":"eI7CE","./Form":"cHqN4","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1DVYa":[function() {},{}],"heszb":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColorFieldStateContext", ()=>ColorFieldStateContext);
parcelHelpers.export(exports, "ColorField", ()=>ColorField);
var _reactAria = require("react-aria");
var _utils = require("./utils");
var _reactStately = require("react-stately");
var _rspcontexts = require("./RSPContexts");
var _fieldError = require("./FieldError");
var _utils1 = require("@react-aria/utils");
var _group = require("./Group");
var _input = require("./Input");
var _label = require("./Label");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _text = require("./Text");
const ColorFieldStateContext = /*#__PURE__*/ (0, _react.createContext)(null);
const ColorField = /*#__PURE__*/ (0, _react.forwardRef)(function ColorField(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, (0, _rspcontexts.ColorFieldContext));
    if (props.channel) return /*#__PURE__*/ (0, _reactDefault.default).createElement(ColorChannelField, {
        ...props,
        channel: props.channel,
        forwardedRef: ref
    });
    else return /*#__PURE__*/ (0, _reactDefault.default).createElement(HexColorField, {
        ...props,
        forwardedRef: ref
    });
});
function ColorChannelField(props) {
    let { locale } = (0, _reactAria.useLocale)();
    let state = (0, _reactStately.useColorChannelFieldState)({
        ...props,
        locale
    });
    let inputRef = (0, _react.useRef)(null);
    let [labelRef, label] = (0, _utils.useSlot)(!props['aria-label'] && !props['aria-labelledby']);
    let { labelProps, inputProps, descriptionProps, errorMessageProps, ...validation } = (0, _reactAria.useColorChannelField)({
        ...(0, _utils.removeDataAttributes)(props),
        label,
        validationBehavior: props.validationBehavior ?? 'native'
    }, state, inputRef);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, useChildren(props, state, props.forwardedRef, inputProps, inputRef, labelProps, labelRef, descriptionProps, errorMessageProps, validation), props.name && /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        type: "hidden",
        name: props.name,
        form: props.form,
        value: isNaN(state.numberValue) ? '' : state.numberValue
    }));
}
function HexColorField(props) {
    let state = (0, _reactStately.useColorFieldState)({
        ...props,
        validationBehavior: props.validationBehavior ?? 'native'
    });
    let inputRef = (0, _react.useRef)(null);
    let [labelRef, label] = (0, _utils.useSlot)(!props['aria-label'] && !props['aria-labelledby']);
    let { labelProps, inputProps, descriptionProps, errorMessageProps, ...validation } = (0, _reactAria.useColorField)({
        ...(0, _utils.removeDataAttributes)(props),
        label,
        validationBehavior: props.validationBehavior ?? 'native'
    }, state, inputRef);
    return useChildren(props, state, props.forwardedRef, inputProps, inputRef, labelProps, labelRef, descriptionProps, errorMessageProps, validation);
}
function useChildren(props, state, ref, inputProps, inputRef, labelProps, labelRef, descriptionProps, errorMessageProps, validation) {
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        values: {
            state,
            channel: props.channel || 'hex',
            isDisabled: props.isDisabled || false,
            isInvalid: validation.isInvalid || false
        },
        defaultClassName: 'react-aria-ColorField'
    });
    let DOMProps = (0, _utils1.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                ColorFieldStateContext,
                state
            ],
            [
                (0, _input.InputContext),
                {
                    ...inputProps,
                    ref: inputRef
                }
            ],
            [
                (0, _label.LabelContext),
                {
                    ...labelProps,
                    ref: labelRef
                }
            ],
            [
                (0, _group.GroupContext),
                {
                    role: 'presentation',
                    isInvalid: validation.isInvalid,
                    isDisabled: props.isDisabled || false
                }
            ],
            [
                (0, _text.TextContext),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ],
            [
                (0, _fieldError.FieldErrorContext),
                validation
            ]
        ]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...DOMProps,
        ...renderProps,
        ref: ref,
        slot: props.slot || undefined,
        "data-channel": props.channel || 'hex',
        "data-disabled": props.isDisabled || undefined,
        "data-invalid": validation.isInvalid || undefined
    }));
}

},{"react-aria":[["useColorChannelField","dTs0L"],["useColorField","bGGkS"],["useLocale","4k4z8"]],"./utils":"bA6Cz","react-stately":[["useColorChannelFieldState","bFETS"],["useColorFieldState","cVqwI"]],"./RSPContexts":"lIerG","./FieldError":"algyu","@react-aria/utils":"3upVm","./Group":"6UspO","./Input":"jU9y1","./Label":"fjKq6","react":"a1TxN","./Text":"jt9fm","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"dTs0L":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a color channel field, allowing users to edit the
 * value of an individual color channel.
 */ parcelHelpers.export(exports, "useColorChannelField", ()=>useColorChannelField);
var _numberfield = require("@react-aria/numberfield");
var _i18N = require("@react-aria/i18n");
function useColorChannelField(props, state, inputRef) {
    let { locale } = (0, _i18N.useLocale)();
    return (0, _numberfield.useNumberField)({
        ...props,
        value: undefined,
        defaultValue: undefined,
        onChange: undefined,
        validate: undefined,
        // Provide a default aria-label if no other label is provided.
        'aria-label': props['aria-label'] || (props.label || props['aria-labelledby'] ? undefined : state.colorValue.getChannelName(props.channel, locale))
    }, state, inputRef);
}

},{"@react-aria/numberfield":"7QmQx","@react-aria/i18n":"4k4z8","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bGGkS":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a color field component.
 * Color fields allow users to enter and adjust a hex color value.
 */ parcelHelpers.export(exports, "useColorField", ()=>useColorField);
var _react = require("react");
var _utils = require("@react-aria/utils");
var _form = require("@react-stately/form");
var _interactions = require("@react-aria/interactions");
var _textfield = require("@react-aria/textfield");
var _spinbutton = require("@react-aria/spinbutton");
function useColorField(props, state, ref) {
    let { isDisabled, isReadOnly, isRequired, isWheelDisabled, validationBehavior = 'aria' } = props;
    let { colorValue, inputValue, increment, decrement, incrementToMax, decrementToMin, commit } = state;
    let inputId = (0, _utils.useId)();
    let { spinButtonProps } = (0, _spinbutton.useSpinButton)({
        isDisabled,
        isReadOnly,
        isRequired,
        maxValue: 0xFFFFFF,
        minValue: 0,
        onIncrement: increment,
        onIncrementToMax: incrementToMax,
        onDecrement: decrement,
        onDecrementToMin: decrementToMin,
        value: colorValue ? colorValue.toHexInt() : undefined,
        textValue: colorValue ? colorValue.toString('hex') : undefined
    });
    let [focusWithin, setFocusWithin] = (0, _react.useState)(false);
    let { focusWithinProps } = (0, _interactions.useFocusWithin)({
        isDisabled,
        onFocusWithinChange: setFocusWithin
    });
    let onWheel = (0, _react.useCallback)((e)=>{
        if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
        if (e.deltaY > 0) increment();
        else if (e.deltaY < 0) decrement();
    }, [
        decrement,
        increment
    ]);
    // If the input isn't supposed to receive input, disable scrolling.
    let scrollingDisabled = isWheelDisabled || isDisabled || isReadOnly || !focusWithin;
    (0, _interactions.useScrollWheel)({
        onScroll: onWheel,
        isDisabled: scrollingDisabled
    }, ref);
    let onChange = (value)=>{
        if (state.validate(value)) state.setInputValue(value);
    };
    let { inputProps, ...otherProps } = (0, _textfield.useFormattedTextField)({
        ...props,
        id: inputId,
        value: inputValue,
        // Intentionally invalid value that will be ignored by onChange during form reset
        // This is handled separately below.
        defaultValue: '!',
        validate: undefined,
        [(0, _form.privateValidationStateProp)]: state,
        type: 'text',
        autoComplete: 'off',
        onChange
    }, state, ref);
    (0, _utils.useFormReset)(ref, state.defaultColorValue, state.setColorValue);
    inputProps = (0, _utils.mergeProps)(inputProps, spinButtonProps, focusWithinProps, {
        role: 'textbox',
        'aria-valuemax': null,
        'aria-valuemin': null,
        'aria-valuenow': null,
        'aria-valuetext': null,
        autoCorrect: 'off',
        spellCheck: 'false',
        onBlur: commit
    });
    if (validationBehavior === 'native') inputProps['aria-required'] = undefined;
    return {
        inputProps,
        ...otherProps
    };
}

},{"react":"a1TxN","@react-aria/utils":[["mergeProps","aNvcY"],["useFormReset","dwBOx"],["useId","jbI4Y"]],"@react-stately/form":"icH0S","@react-aria/interactions":[["useFocusWithin","8bxuk"],["useScrollWheel","iG9Gj"]],"@react-aria/textfield":"5KN7d","@react-aria/spinbutton":"7EPVf","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bFETS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides state management for a color channel field, allowing users to edit the
 * value of an individual color channel.
 */ parcelHelpers.export(exports, "useColorChannelFieldState", ()=>useColorChannelFieldState);
var _numberfield = require("@react-stately/numberfield");
var _useColor = require("./useColor");
var _utils = require("@react-stately/utils");
var _react = require("react");
function useColorChannelFieldState(props) {
    let { channel, colorSpace, locale } = props;
    let initialValue = (0, _useColor.useColor)(props.value);
    let initialDefaultValue = (0, _useColor.useColor)(props.defaultValue);
    let [colorValue, setColor] = (0, _utils.useControlledState)(initialValue, initialDefaultValue ?? null, props.onChange);
    let color = useConvertColor(colorValue, colorSpace);
    let [initialColorValue] = (0, _react.useState)(colorValue);
    let defaultColorValue = initialDefaultValue ?? initialColorValue;
    let defaultColor = useConvertColor(defaultColorValue, colorSpace);
    let value = color.getChannelValue(channel);
    let range = color.getChannelRange(channel);
    let formatOptions = (0, _react.useMemo)(()=>color.getChannelFormatOptions(channel), [
        color,
        channel
    ]);
    let multiplier = formatOptions.style === 'percent' && range.maxValue === 100 ? 100 : 1;
    let numberFieldState = (0, _numberfield.useNumberFieldState)({
        locale,
        value: colorValue === null ? NaN : value / multiplier,
        defaultValue: defaultColorValue === null ? NaN : defaultColor.getChannelValue(channel) / multiplier,
        onChange: (v)=>{
            if (!Number.isNaN(v)) setColor(color.withChannelValue(channel, v * multiplier));
            else setColor(null);
        },
        minValue: range.minValue / multiplier,
        maxValue: range.maxValue / multiplier,
        step: range.step / multiplier,
        formatOptions
    });
    return {
        ...numberFieldState,
        colorValue: color,
        defaultColorValue,
        setColorValue: setColor
    };
}
function useConvertColor(colorValue, colorSpace) {
    let black = (0, _useColor.useColor)('#000');
    return (0, _react.useMemo)(()=>{
        let nonNullColorValue = colorValue || black;
        return colorSpace && nonNullColorValue ? nonNullColorValue.toFormat(colorSpace) : nonNullColorValue;
    }, [
        black,
        colorValue,
        colorSpace
    ]);
}

},{"@react-stately/numberfield":"kM0E9","./useColor":"6CHdE","@react-stately/utils":"4Nj6T","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6CHdE":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useColor", ()=>useColor);
var _color = require("./Color");
var _react = require("react");
function useColor(value) {
    return (0, _react.useMemo)(()=>{
        if (typeof value === 'string') try {
            return (0, _color.parseColor)(value);
        } catch  {
            return undefined;
        }
        return value;
    }, [
        value
    ]);
}

},{"./Color":"71wqN","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"cVqwI":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides state management for a color field component. Color fields allow
 * users to enter and adjust a hex color value.
 */ parcelHelpers.export(exports, "useColorFieldState", ()=>useColorFieldState);
var _form = require("@react-stately/form");
var _color = require("./Color");
var _useColor = require("./useColor");
var _utils = require("@react-stately/utils");
var _react = require("react");
const MIN_COLOR = (0, _color.parseColor)('#000000');
const MAX_COLOR = (0, _color.parseColor)('#FFFFFF');
const MIN_COLOR_INT = MIN_COLOR.toHexInt();
const MAX_COLOR_INT = MAX_COLOR.toHexInt();
function useColorFieldState(props) {
    let { value, defaultValue, onChange } = props;
    let { step } = MIN_COLOR.getChannelRange('red');
    let initialDefaultValue = (0, _useColor.useColor)(defaultValue);
    let [colorValue, setColorValue] = (0, _utils.useControlledState)((0, _useColor.useColor)(value), initialDefaultValue, onChange);
    let [initialValue] = (0, _react.useState)(colorValue);
    let [inputValue, setInputValue] = (0, _react.useState)(()=>(value || defaultValue) && colorValue ? colorValue.toString('hex') : '');
    let validation = (0, _form.useFormValidationState)({
        ...props,
        value: colorValue
    });
    let safelySetColorValue = (newColor)=>{
        if (!colorValue || !newColor) {
            setColorValue(newColor);
            return;
        }
        if (newColor.toHexInt() !== colorValue.toHexInt()) {
            setColorValue(newColor);
            return;
        }
    };
    let [prevValue, setPrevValue] = (0, _react.useState)(colorValue);
    if (prevValue !== colorValue) {
        setInputValue(colorValue ? colorValue.toString('hex') : '');
        setPrevValue(colorValue);
    }
    let parsedValue = (0, _react.useMemo)(()=>{
        let color;
        try {
            color = (0, _color.parseColor)(inputValue.startsWith('#') ? inputValue : `#${inputValue}`);
        } catch  {
            color = null;
        }
        return color;
    }, [
        inputValue
    ]);
    let commit = ()=>{
        // Set to empty state if input value is empty
        if (!inputValue.length) {
            safelySetColorValue(null);
            if (value === undefined || colorValue === null) setInputValue('');
            else setInputValue(colorValue.toString('hex'));
            return;
        }
        // if it failed to parse, then reset input to formatted version of current number
        if (parsedValue == null) {
            setInputValue(colorValue ? colorValue.toString('hex') : '');
            return;
        }
        safelySetColorValue(parsedValue);
        // in a controlled state, the numberValue won't change, so we won't go back to our old input without help
        let newColorValue = '';
        if (colorValue) newColorValue = colorValue.toString('hex');
        setInputValue(newColorValue);
        validation.commitValidation();
    };
    let increment = ()=>{
        let newValue = addColorValue(parsedValue, step);
        // if we've arrived at the same value that was previously in the state, the
        // input value should be updated to match
        // ex type 4, press increment, highlight the number in the input, type 4 again, press increment
        // you'd be at 5, then incrementing to 5 again, so no re-render would happen and 4 would be left in the input
        if (newValue === colorValue) setInputValue(newValue.toString('hex'));
        safelySetColorValue(newValue);
        validation.commitValidation();
    };
    let decrement = ()=>{
        let newValue = addColorValue(parsedValue, -step);
        // if we've arrived at the same value that was previously in the state, the
        // input value should be updated to match
        // ex type 4, press increment, highlight the number in the input, type 4 again, press increment
        // you'd be at 5, then incrementing to 5 again, so no re-render would happen and 4 would be left in the input
        if (newValue === colorValue) setInputValue(newValue.toString('hex'));
        safelySetColorValue(newValue);
        validation.commitValidation();
    };
    let incrementToMax = ()=>safelySetColorValue(MAX_COLOR);
    let decrementToMin = ()=>safelySetColorValue(MIN_COLOR);
    let validate = (value)=>value === '' || !!value.match(/^#?[0-9a-f]{0,6}$/i)?.[0];
    return {
        ...validation,
        validate,
        colorValue,
        defaultColorValue: initialDefaultValue ?? initialValue,
        setColorValue,
        inputValue,
        setInputValue,
        commit,
        increment,
        incrementToMax,
        decrement,
        decrementToMin
    };
}
function addColorValue(color, step) {
    let newColor = color ? color : MIN_COLOR;
    let colorInt = newColor.toHexInt();
    let clampInt = Math.min(Math.max(colorInt + step, MIN_COLOR_INT), MAX_COLOR_INT);
    if (clampInt !== colorInt) {
        let newColorString = `#${clampInt.toString(16).padStart(6, '0').toUpperCase()}`;
        newColor = (0, _color.parseColor)(newColorString);
    }
    return newColor;
}

},{"@react-stately/form":"icH0S","./Color":"71wqN","./useColor":"6CHdE","@react-stately/utils":"4Nj6T","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jWm5i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColorSliderStateContext", ()=>ColorSliderStateContext);
parcelHelpers.export(exports, "ColorSlider", ()=>ColorSlider);
var _reactAria = require("react-aria");
var _utils = require("./utils");
var _rspcontexts = require("./RSPContexts");
var _reactStately = require("react-stately");
var _utils1 = require("@react-aria/utils");
var _colorThumb = require("./ColorThumb");
var _label = require("./Label");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _slider = require("./Slider");
const ColorSliderStateContext = /*#__PURE__*/ (0, _react.createContext)(null);
const ColorSlider = /*#__PURE__*/ (0, _react.forwardRef)(function ColorSlider(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, (0, _rspcontexts.ColorSliderContext));
    let { locale } = (0, _reactAria.useLocale)();
    let state = (0, _reactStately.useColorSliderState)({
        ...props,
        locale
    });
    let trackRef = (0, _reactDefault.default).useRef(null);
    let inputRef = (0, _reactDefault.default).useRef(null);
    let [labelRef, label] = (0, _utils.useSlot)(!props['aria-label'] && !props['aria-labelledby']);
    let { trackProps, thumbProps, inputProps, labelProps, outputProps } = (0, _reactAria.useColorSlider)({
        ...props,
        label,
        trackRef,
        inputRef
    }, state);
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        values: {
            orientation: state.orientation,
            isDisabled: state.isDisabled,
            state
        },
        defaultClassName: 'react-aria-ColorSlider'
    });
    let DOMProps = (0, _utils1.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                ColorSliderStateContext,
                state
            ],
            [
                (0, _slider.SliderStateContext),
                state
            ],
            [
                (0, _slider.SliderTrackContext),
                {
                    ...trackProps,
                    ref: trackRef
                }
            ],
            [
                (0, _slider.SliderOutputContext),
                outputProps
            ],
            [
                (0, _label.LabelContext),
                {
                    ...labelProps,
                    ref: labelRef,
                    children: state.value.getChannelName(props.channel, locale)
                }
            ],
            [
                (0, _colorThumb.InternalColorThumbContext),
                {
                    state,
                    thumbProps,
                    inputXRef: inputRef,
                    xInputProps: inputProps,
                    isDisabled: props.isDisabled
                }
            ]
        ]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...DOMProps,
        ...renderProps,
        ref: ref,
        slot: props.slot || undefined,
        "data-orientation": state.orientation,
        "data-disabled": state.isDisabled || undefined
    }));
});

},{"react-aria":[["useColorSlider","fSouU"],["useLocale","4k4z8"]],"./utils":"bA6Cz","./RSPContexts":"lIerG","react-stately":"fqAXk","@react-aria/utils":"3upVm","./ColorThumb":"gcXiK","./Label":"fjKq6","react":"a1TxN","./Slider":"34zZe","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fSouU":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a color slider component.
 * Color sliders allow users to adjust an individual channel of a color value.
 */ parcelHelpers.export(exports, "useColorSlider", ()=>useColorSlider);
var _utils = require("@react-aria/utils");
var _i18N = require("@react-aria/i18n");
var _slider = require("@react-aria/slider");
var _visuallyHidden = require("@react-aria/visually-hidden");
function useColorSlider(props, state) {
    let { trackRef, inputRef, orientation, channel, 'aria-label': ariaLabel, name, form } = props;
    let { locale, direction } = (0, _i18N.useLocale)();
    // Provide a default aria-label if there is no other label provided.
    if (!props.label && !ariaLabel && !props['aria-labelledby']) ariaLabel = state.value.getChannelName(channel, locale);
    // @ts-ignore - ignore unused incompatible props
    let { groupProps, trackProps, labelProps, outputProps } = (0, _slider.useSlider)({
        ...props,
        'aria-label': ariaLabel
    }, state, trackRef);
    let { inputProps, thumbProps } = (0, _slider.useSliderThumb)({
        index: 0,
        orientation,
        isDisabled: props.isDisabled,
        name,
        form,
        trackRef,
        inputRef
    }, state);
    let value = state.getDisplayColor();
    let generateBackground = ()=>{
        let to;
        if (orientation === 'vertical') to = 'top';
        else if (direction === 'ltr') to = 'right';
        else to = 'left';
        switch(channel){
            case 'hue':
                {
                    let stops = [
                        0,
                        60,
                        120,
                        180,
                        240,
                        300,
                        360
                    ].map((hue)=>value.withChannelValue('hue', hue).toString('css')).join(', ');
                    return `linear-gradient(to ${to}, ${stops})`;
                }
            case 'lightness':
                {
                    // We have to add an extra color stop in the middle so that the hue shows up at all.
                    // Otherwise it will always just be black to white.
                    let min = state.getThumbMinValue(0);
                    let max = state.getThumbMaxValue(0);
                    let start = value.withChannelValue(channel, min).toString('css');
                    let middle = value.withChannelValue(channel, (max - min) / 2).toString('css');
                    let end = value.withChannelValue(channel, max).toString('css');
                    return `linear-gradient(to ${to}, ${start}, ${middle}, ${end})`;
                }
            case 'saturation':
            case 'brightness':
            case 'red':
            case 'green':
            case 'blue':
            case 'alpha':
                {
                    let start = value.withChannelValue(channel, state.getThumbMinValue(0)).toString('css');
                    let end = value.withChannelValue(channel, state.getThumbMaxValue(0)).toString('css');
                    return `linear-gradient(to ${to}, ${start}, ${end})`;
                }
            default:
                throw new Error('Unknown color channel: ' + channel);
        }
    };
    let forcedColorAdjustNoneStyle = {
        forcedColorAdjust: 'none'
    };
    if (channel === 'hue') inputProps['aria-valuetext'] += `, ${value.getHueName(locale)}`;
    else if (channel !== 'alpha') inputProps['aria-valuetext'] += `, ${value.getColorName(locale)}`;
    let { visuallyHiddenProps } = (0, _visuallyHidden.useVisuallyHidden)({
        style: {
            opacity: '0.0001',
            width: '100%',
            height: '100%',
            pointerEvents: 'none'
        }
    });
    return {
        trackProps: {
            ...(0, _utils.mergeProps)(groupProps, trackProps),
            style: {
                ...trackProps.style,
                ...forcedColorAdjustNoneStyle,
                background: generateBackground()
            }
        },
        inputProps: {
            ...inputProps,
            style: {
                ...inputProps.style,
                ...visuallyHiddenProps.style
            }
        },
        thumbProps: {
            ...thumbProps,
            style: {
                ...thumbProps.style,
                ...forcedColorAdjustNoneStyle
            }
        },
        labelProps,
        outputProps
    };
}

},{"@react-aria/utils":"aNvcY","@react-aria/i18n":"4k4z8","@react-aria/slider":[["useSlider","1xOFO"],["useSliderThumb","8sp6a"]],"@react-aria/visually-hidden":"7zrGr","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fqAXk":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides state management for a color slider component.
 * Color sliders allow users to adjust an individual channel of a color value.
 */ parcelHelpers.export(exports, "useColorSliderState", ()=>useColorSliderState);
var _color = require("./Color");
var _slider = require("@react-stately/slider");
var _utils = require("@react-stately/utils");
var _react = require("react");
function useColorSliderState(props) {
    let { channel, colorSpace, value, defaultValue, onChange, locale, ...otherProps } = props;
    if (value == null && defaultValue == null) throw new Error('useColorSliderState requires a value or defaultValue');
    if (value) value = (0, _color.normalizeColor)(value);
    if (defaultValue) defaultValue = (0, _color.normalizeColor)(defaultValue);
    // safe to cast value and defaultValue to Color, one of them will always be defined because if neither are, we throw an error
    let [colorValue, setColor] = (0, _utils.useControlledState)(value, defaultValue, onChange);
    let color = (0, _react.useMemo)(()=>colorSpace && colorValue ? colorValue.toFormat(colorSpace) : colorValue, [
        colorValue,
        colorSpace
    ]);
    let [initialValue] = (0, _react.useState)(colorValue);
    let defaultColorValue = defaultValue ?? initialValue;
    let defaultColor = (0, _react.useMemo)(()=>colorSpace && defaultColorValue ? defaultColorValue.toFormat(colorSpace) : defaultColorValue, [
        defaultColorValue,
        colorSpace
    ]);
    let sliderState = (0, _slider.useSliderState)({
        ...color.getChannelRange(channel),
        ...otherProps,
        // Unused except in getThumbValueLabel, which is overridden below. null to localize the TypeScript error for ignoring.
        // @ts-ignore
        numberFormatter: null,
        value: color.getChannelValue(channel),
        defaultValue: defaultColor.getChannelValue(channel),
        onChange (v) {
            setColor(color.withChannelValue(channel, v));
        },
        onChangeEnd (v) {
            // onChange will have already been called with the right value, this is just to trigger onChangeEnd
            if (props.onChangeEnd) props.onChangeEnd(color.withChannelValue(channel, v));
        }
    });
    let { step, pageSize } = color.getChannelRange(channel);
    return {
        ...sliderState,
        value: color,
        setValue (value) {
            setColor((0, _color.normalizeColor)(value));
        },
        getDisplayColor () {
            switch(channel){
                case 'hue':
                    return (0, _color.parseColor)(`hsl(${color.getChannelValue('hue')}, 100%, 50%)`);
                case 'lightness':
                case 'brightness':
                case 'saturation':
                case 'red':
                case 'green':
                case 'blue':
                    return color.withChannelValue('alpha', 1);
                case 'alpha':
                    return color;
                default:
                    throw new Error('Unknown color channel: ' + channel);
            }
        },
        getThumbValueLabel () {
            return color.formatChannelValue(channel, locale);
        },
        step,
        pageSize,
        isDragging: sliderState.isThumbDragging(0)
    };
}

},{"./Color":"71wqN","@react-stately/slider":"4wUXI","@react-stately/utils":"4Nj6T","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"itZYr":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColorSwatchContext", ()=>ColorSwatchContext);
parcelHelpers.export(exports, "InternalColorSwatchContext", ()=>InternalColorSwatchContext);
parcelHelpers.export(exports, "ColorSwatch", ()=>ColorSwatch);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _utils = require("@react-spectrum/utils");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const ColorSwatchContext = /*#__PURE__*/ (0, _react.createContext)(null);
const InternalColorSwatchContext = /*#__PURE__*/ (0, _react.createContext)(null);
const ColorSwatch = /*#__PURE__*/ (0, _react.forwardRef)(function ColorSwatch(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, ColorSwatchContext);
    let domRef = (0, _utils.useDOMRef)(ref);
    let ctx = (0, _react.useContext)(InternalColorSwatchContext);
    let { size = ctx?.size || 'M', rounding = ctx?.rounding || 'default', color } = props;
    let nonNullValue = color || '#fff0';
    color = (0, _react.useMemo)(()=>typeof nonNullValue === 'string' ? (0, _reactAriaComponents.parseColor)(nonNullValue) : nonNullValue, [
        nonNullValue
    ]);
    let swatch = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ColorSwatch), {
        ...props,
        color: color,
        ref: domRef,
        style: ({ color })=>({
                // TODO: should there be a distinction between transparent and no value (e.g. null)?
                background: color.getChannelValue('alpha') > 0 ? `linear-gradient(${color}, ${color}), repeating-conic-gradient(#e6e6e6 0% 25%, white 0% 50%) 0% 50% / 16px 16px` : 'linear-gradient(to bottom right, transparent calc(50% - 2px), var(--slash-color) calc(50% - 2px) calc(50% + 2px), transparent calc(50% + 2px)) no-repeat'
            }),
        className: function anonymous(props, overrides) {
            let rules = " ", currentRules = {};
            let width = false;
            let height = false;
            let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L|F|M|K|-macro\$)[^\s]+/g);
            for (let p of matches){
                if (p[1] === "Z") width = true;
                if (p[1] === "F") height = true;
                rules += p[0];
            }
            if (props.size === "L") {
                if (!width) rules += ' Zw12';
                currentRules["width"] = typeof currentRules["width"] === 'object' ? currentRules["width"] : {
                    "default": currentRules["width"]
                };
                currentRules["width"]["size === \"L\""] = 40;
            } else if (props.size === "M") {
                if (!width) rules += ' ZC12';
                currentRules["width"] = typeof currentRules["width"] === 'object' ? currentRules["width"] : {
                    "default": currentRules["width"]
                };
                currentRules["width"]["size === \"M\""] = 32;
            } else if (props.size === "S") {
                if (!width) rules += ' Zo12';
                currentRules["width"] = typeof currentRules["width"] === 'object' ? currentRules["width"] : {
                    "default": currentRules["width"]
                };
                currentRules["width"]["size === \"S\""] = 24;
            } else if (props.size === "XS") {
                if (!width) rules += ' Zu12';
                currentRules["width"] = typeof currentRules["width"] === 'object' ? currentRules["width"] : {
                    "default": currentRules["width"]
                };
                currentRules["width"]["size === \"XS\""] = 16;
            }
            if (props.size === "L") {
                if (!height) rules += ' Fv12';
                currentRules["height"] = typeof currentRules["height"] === 'object' ? currentRules["height"] : {
                    "default": currentRules["height"]
                };
                currentRules["height"]["size === \"L\""] = 40;
            } else if (props.size === "M") {
                if (!height) rules += ' Fx12';
                currentRules["height"] = typeof currentRules["height"] === 'object' ? currentRules["height"] : {
                    "default": currentRules["height"]
                };
                currentRules["height"]["size === \"M\""] = 32;
            } else if (props.size === "S") {
                if (!height) rules += ' Fp12';
                currentRules["height"] = typeof currentRules["height"] === 'object' ? currentRules["height"] : {
                    "default": currentRules["height"]
                };
                currentRules["height"]["size === \"S\""] = 24;
            } else if (props.size === "XS") {
                if (!height) rules += ' Ft12';
                currentRules["height"] = typeof currentRules["height"] === 'object' ? currentRules["height"] : {
                    "default": currentRules["height"]
                };
                currentRules["height"]["size === \"XS\""] = 16;
            }
            if (props.rounding === "full") {
                rules += ' og12';
                currentRules["borderTopStartRadius"] = typeof currentRules["borderTopStartRadius"] === 'object' ? currentRules["borderTopStartRadius"] : {
                    "default": currentRules["borderTopStartRadius"]
                };
                currentRules["borderTopStartRadius"]["rounding === \"full\""] = "full";
            } else if (props.rounding === "none") {
                rules += ' od12';
                currentRules["borderTopStartRadius"] = typeof currentRules["borderTopStartRadius"] === 'object' ? currentRules["borderTopStartRadius"] : {
                    "default": currentRules["borderTopStartRadius"]
                };
                currentRules["borderTopStartRadius"]["rounding === \"none\""] = "none";
            } else if (props.rounding === "default") {
                rules += ' oa12';
                currentRules["borderTopStartRadius"] = typeof currentRules["borderTopStartRadius"] === 'object' ? currentRules["borderTopStartRadius"] : {
                    "default": currentRules["borderTopStartRadius"]
                };
                currentRules["borderTopStartRadius"]["rounding === \"default\""] = "sm";
            }
            if (props.rounding === "full") {
                rules += ' ng12';
                currentRules["borderTopEndRadius"] = typeof currentRules["borderTopEndRadius"] === 'object' ? currentRules["borderTopEndRadius"] : {
                    "default": currentRules["borderTopEndRadius"]
                };
                currentRules["borderTopEndRadius"]["rounding === \"full\""] = "full";
            } else if (props.rounding === "none") {
                rules += ' nd12';
                currentRules["borderTopEndRadius"] = typeof currentRules["borderTopEndRadius"] === 'object' ? currentRules["borderTopEndRadius"] : {
                    "default": currentRules["borderTopEndRadius"]
                };
                currentRules["borderTopEndRadius"]["rounding === \"none\""] = "none";
            } else if (props.rounding === "default") {
                rules += ' na12';
                currentRules["borderTopEndRadius"] = typeof currentRules["borderTopEndRadius"] === 'object' ? currentRules["borderTopEndRadius"] : {
                    "default": currentRules["borderTopEndRadius"]
                };
                currentRules["borderTopEndRadius"]["rounding === \"default\""] = "sm";
            }
            if (props.rounding === "full") {
                rules += ' kg12';
                currentRules["borderBottomStartRadius"] = typeof currentRules["borderBottomStartRadius"] === 'object' ? currentRules["borderBottomStartRadius"] : {
                    "default": currentRules["borderBottomStartRadius"]
                };
                currentRules["borderBottomStartRadius"]["rounding === \"full\""] = "full";
            } else if (props.rounding === "none") {
                rules += ' kd12';
                currentRules["borderBottomStartRadius"] = typeof currentRules["borderBottomStartRadius"] === 'object' ? currentRules["borderBottomStartRadius"] : {
                    "default": currentRules["borderBottomStartRadius"]
                };
                currentRules["borderBottomStartRadius"]["rounding === \"none\""] = "none";
            } else if (props.rounding === "default") {
                rules += ' ka12';
                currentRules["borderBottomStartRadius"] = typeof currentRules["borderBottomStartRadius"] === 'object' ? currentRules["borderBottomStartRadius"] : {
                    "default": currentRules["borderBottomStartRadius"]
                };
                currentRules["borderBottomStartRadius"]["rounding === \"default\""] = "sm";
            }
            if (props.rounding === "full") {
                rules += ' jg12';
                currentRules["borderBottomEndRadius"] = typeof currentRules["borderBottomEndRadius"] === 'object' ? currentRules["borderBottomEndRadius"] : {
                    "default": currentRules["borderBottomEndRadius"]
                };
                currentRules["borderBottomEndRadius"]["rounding === \"full\""] = "full";
            } else if (props.rounding === "none") {
                rules += ' jd12';
                currentRules["borderBottomEndRadius"] = typeof currentRules["borderBottomEndRadius"] === 'object' ? currentRules["borderBottomEndRadius"] : {
                    "default": currentRules["borderBottomEndRadius"]
                };
                currentRules["borderBottomEndRadius"]["rounding === \"none\""] = "none";
            } else if (props.rounding === "default") {
                rules += ' ja12';
                currentRules["borderBottomEndRadius"] = typeof currentRules["borderBottomEndRadius"] === 'object' ? currentRules["borderBottomEndRadius"] : {
                    "default": currentRules["borderBottomEndRadius"]
                };
                currentRules["borderBottomEndRadius"]["rounding === \"default\""] = "sm";
            }
            rules += ' iz12';
            currentRules["borderColor"] = "gray-1000/42";
            rules += ' _kb12';
            currentRules["borderTopWidth"] = 1;
            rules += ' hb12';
            currentRules["borderBottomWidth"] = 1;
            rules += ' mb12';
            currentRules["borderStartWidth"] = 1;
            rules += ' lb12';
            currentRules["borderEndWidth"] = 1;
            rules += ' _jf12';
            currentRules["borderStyle"] = "solid";
            rules += ' _oa12';
            currentRules["boxSizing"] = "border-box";
            rules += ' _yb12';
            currentRules["forcedColorAdjust"] = "none";
            rules += ' -_8LZfRc-pq12';
            currentRules["--slash-color"] = "red-900";
            return rules;
        }({
            size,
            rounding
        }, props.styles)
    });
    // ColorSwatchPicker needs to wrap the swatch in a ListBoxItem.
    if (ctx) return ctx.useWrapper(swatch, color, rounding);
    return swatch;
});

},{"0":"5UWAQ","react/jsx-runtime":"2Is6Z","react-aria-components":[["ColorSwatch","iK3eK"],["parseColor","71wqN"]],"react":"a1TxN","@react-spectrum/utils":"jqfrX","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5UWAQ":[function() {},{}],"iK3eK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColorSwatchContext", ()=>ColorSwatchContext);
parcelHelpers.export(exports, "ColorSwatch", ()=>ColorSwatch);
var _reactAria = require("react-aria");
var _utils = require("./utils");
var _utils1 = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const ColorSwatchContext = /*#__PURE__*/ (0, _react.createContext)(null);
const ColorSwatch = /*#__PURE__*/ (0, _react.forwardRef)(function ColorSwatch(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, ColorSwatchContext);
    let { colorSwatchProps, color } = (0, _reactAria.useColorSwatch)(props);
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        defaultClassName: 'react-aria-ColorSwatch',
        defaultStyle: colorSwatchProps.style,
        values: {
            color
        }
    });
    let DOMProps = (0, _utils1.filterDOMProps)(props, {
        global: true
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _utils1.mergeProps)(DOMProps, colorSwatchProps, renderProps),
        slot: props.slot || undefined,
        ref: ref
    });
});

},{"react-aria":"2Co3G","./utils":"bA6Cz","@react-aria/utils":[["filterDOMProps","3upVm"],["mergeProps","aNvcY"]],"react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2Co3G":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the accessibility implementation for a color swatch component.
 * A color swatch displays a preview of a selected color.
 */ parcelHelpers.export(exports, "useColorSwatch", ()=>useColorSwatch);
var _utils = require("@react-aria/utils");
var _react = require("react");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _color = require("@react-stately/color");
var _i18N = require("@react-aria/i18n");
function useColorSwatch(props) {
    let { color: value, colorName } = props;
    let nonNullValue = value || '#fff0';
    let color = (0, _react.useMemo)(()=>typeof nonNullValue === 'string' ? (0, _color.parseColor)(nonNullValue) : nonNullValue, [
        nonNullValue
    ]);
    let { locale } = (0, _i18N.useLocale)();
    let DOMProps = (0, _utils.filterDOMProps)(props, {
        labelable: true
    });
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-aria/color');
    let id = (0, _utils.useId)(props.id);
    if (!colorName) colorName = color.getChannelValue('alpha') === 0 ? stringFormatter.format('transparent') : color.getColorName(locale);
    return {
        colorSwatchProps: {
            ...DOMProps,
            role: 'img',
            'aria-roledescription': stringFormatter.format('colorSwatch'),
            'aria-label': [
                colorName,
                props['aria-label'] || ''
            ].filter(Boolean).join(', '),
            'aria-labelledby': props['aria-labelledby'] ? `${id} ${props['aria-labelledby']}` : undefined,
            id,
            style: {
                backgroundColor: color.toString('css'),
                // @ts-ignore
                forcedColorAdjust: 'none'
            }
        },
        color: color || null
    };
}

},{"@react-aria/utils":[["filterDOMProps","3upVm"],["useId","jbI4Y"]],"react":"a1TxN","../intl/*.json":"jzrzz","@react-stately/color":"71wqN","@react-aria/i18n":[["useLocale","4k4z8"],["useLocalizedStringFormatter","7lxyl"]],"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kPcJG":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColorSwatchPickerContext", ()=>ColorSwatchPickerContext);
parcelHelpers.export(exports, "ColorSwatchPicker", ()=>ColorSwatchPicker);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _colorSwatch = require("./ColorSwatch");
var _react = require("react");
var _utils = require("@react-spectrum/utils");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const ColorSwatchPickerContext = /*#__PURE__*/ (0, _react.createContext)(null);
const ColorSwatchPicker = /*#__PURE__*/ (0, _react.forwardRef)(function ColorSwatchPicker(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, ColorSwatchPickerContext);
    let { density = 'regular', size = 'M', rounding = 'none', UNSAFE_className = '', ...otherProps } = props;
    let domRef = (0, _utils.useDOMRef)(ref);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ColorSwatchPicker), {
        ...otherProps,
        ref: domRef,
        className: UNSAFE_className + function anonymous(props, overrides) {
            let rules = " ", currentRules = {};
            rules += (String(overrides || '').match(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L|-macro\$)[^\s]+/g) || []).join('');
            rules += ' sd12';
            currentRules["display"] = "flex";
            rules += ' _wb12';
            currentRules["flexWrap"] = "wrap";
            if (props.density === "spacious") {
                rules += ' UWJpoB12';
                currentRules["rowGap"] = typeof currentRules["rowGap"] === 'object' ? currentRules["rowGap"] : {
                    "default": currentRules["rowGap"]
                };
                currentRules["rowGap"]["density === \"spacious\""] = "[0.375rem]";
            } else if (props.density === "regular") {
                rules += ' Ub12';
                currentRules["rowGap"] = typeof currentRules["rowGap"] === 'object' ? currentRules["rowGap"] : {
                    "default": currentRules["rowGap"]
                };
                currentRules["rowGap"]["density === \"regular\""] = 4;
            } else if (props.density === "compact") {
                rules += ' Ua12';
                currentRules["rowGap"] = typeof currentRules["rowGap"] === 'object' ? currentRules["rowGap"] : {
                    "default": currentRules["rowGap"]
                };
                currentRules["rowGap"]["density === \"compact\""] = "[0.125rem]";
            }
            if (props.density === "spacious") {
                rules += ' qWJpoB12';
                currentRules["columnGap"] = typeof currentRules["columnGap"] === 'object' ? currentRules["columnGap"] : {
                    "default": currentRules["columnGap"]
                };
                currentRules["columnGap"]["density === \"spacious\""] = "[0.375rem]";
            } else if (props.density === "regular") {
                rules += ' qb12';
                currentRules["columnGap"] = typeof currentRules["columnGap"] === 'object' ? currentRules["columnGap"] : {
                    "default": currentRules["columnGap"]
                };
                currentRules["columnGap"]["density === \"regular\""] = 4;
            } else if (props.density === "compact") {
                rules += ' qa12';
                currentRules["columnGap"] = typeof currentRules["columnGap"] === 'object' ? currentRules["columnGap"] : {
                    "default": currentRules["columnGap"]
                };
                currentRules["columnGap"]["density === \"compact\""] = "[0.125rem]";
            }
            return rules;
        }({
            density
        }, props.styles),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _colorSwatch.InternalColorSwatchContext).Provider, {
            value: {
                useWrapper,
                size,
                rounding
            },
            children: props.children
        })
    });
});
function useWrapper(swatch, color, rounding) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ColorSwatchPickerItem), {
        color: color,
        className: (renderProps)=>(function anonymous(props) {
                let rules = " ", currentRules = {};
                if (props.isFocusVisible) {
                    rules += ' _Lf12';
                    currentRules["outlineStyle"] = typeof currentRules["outlineStyle"] === 'object' ? currentRules["outlineStyle"] : {
                        "default": currentRules["outlineStyle"]
                    };
                    currentRules["outlineStyle"]["isFocusVisible"] = "solid";
                } else {
                    rules += ' _Le12';
                    currentRules["outlineStyle"] = "none";
                }
                rules += ' Oh12';
                currentRules["outlineColor"] = "focus-ring";
                rules += ' _Mc12';
                currentRules["outlineWidth"] = 2;
                rules += ' _Kd12';
                currentRules["outlineOffset"] = 2;
                rules += ' _Pc12';
                currentRules["position"] = "relative";
                if (props.rounding === "full") {
                    rules += ' og12';
                    currentRules["borderTopStartRadius"] = typeof currentRules["borderTopStartRadius"] === 'object' ? currentRules["borderTopStartRadius"] : {
                        "default": currentRules["borderTopStartRadius"]
                    };
                    currentRules["borderTopStartRadius"]["rounding === \"full\""] = "full";
                } else if (props.rounding === "default") {
                    rules += ' oa12';
                    currentRules["borderTopStartRadius"] = typeof currentRules["borderTopStartRadius"] === 'object' ? currentRules["borderTopStartRadius"] : {
                        "default": currentRules["borderTopStartRadius"]
                    };
                    currentRules["borderTopStartRadius"]["rounding === \"default\""] = "sm";
                } else if (props.rounding === "none") {
                    rules += ' od12';
                    currentRules["borderTopStartRadius"] = typeof currentRules["borderTopStartRadius"] === 'object' ? currentRules["borderTopStartRadius"] : {
                        "default": currentRules["borderTopStartRadius"]
                    };
                    currentRules["borderTopStartRadius"]["rounding === \"none\""] = "none";
                }
                if (props.rounding === "full") {
                    rules += ' ng12';
                    currentRules["borderTopEndRadius"] = typeof currentRules["borderTopEndRadius"] === 'object' ? currentRules["borderTopEndRadius"] : {
                        "default": currentRules["borderTopEndRadius"]
                    };
                    currentRules["borderTopEndRadius"]["rounding === \"full\""] = "full";
                } else if (props.rounding === "default") {
                    rules += ' na12';
                    currentRules["borderTopEndRadius"] = typeof currentRules["borderTopEndRadius"] === 'object' ? currentRules["borderTopEndRadius"] : {
                        "default": currentRules["borderTopEndRadius"]
                    };
                    currentRules["borderTopEndRadius"]["rounding === \"default\""] = "sm";
                } else if (props.rounding === "none") {
                    rules += ' nd12';
                    currentRules["borderTopEndRadius"] = typeof currentRules["borderTopEndRadius"] === 'object' ? currentRules["borderTopEndRadius"] : {
                        "default": currentRules["borderTopEndRadius"]
                    };
                    currentRules["borderTopEndRadius"]["rounding === \"none\""] = "none";
                }
                if (props.rounding === "full") {
                    rules += ' kg12';
                    currentRules["borderBottomStartRadius"] = typeof currentRules["borderBottomStartRadius"] === 'object' ? currentRules["borderBottomStartRadius"] : {
                        "default": currentRules["borderBottomStartRadius"]
                    };
                    currentRules["borderBottomStartRadius"]["rounding === \"full\""] = "full";
                } else if (props.rounding === "default") {
                    rules += ' ka12';
                    currentRules["borderBottomStartRadius"] = typeof currentRules["borderBottomStartRadius"] === 'object' ? currentRules["borderBottomStartRadius"] : {
                        "default": currentRules["borderBottomStartRadius"]
                    };
                    currentRules["borderBottomStartRadius"]["rounding === \"default\""] = "sm";
                } else if (props.rounding === "none") {
                    rules += ' kd12';
                    currentRules["borderBottomStartRadius"] = typeof currentRules["borderBottomStartRadius"] === 'object' ? currentRules["borderBottomStartRadius"] : {
                        "default": currentRules["borderBottomStartRadius"]
                    };
                    currentRules["borderBottomStartRadius"]["rounding === \"none\""] = "none";
                }
                if (props.rounding === "full") {
                    rules += ' jg12';
                    currentRules["borderBottomEndRadius"] = typeof currentRules["borderBottomEndRadius"] === 'object' ? currentRules["borderBottomEndRadius"] : {
                        "default": currentRules["borderBottomEndRadius"]
                    };
                    currentRules["borderBottomEndRadius"]["rounding === \"full\""] = "full";
                } else if (props.rounding === "default") {
                    rules += ' ja12';
                    currentRules["borderBottomEndRadius"] = typeof currentRules["borderBottomEndRadius"] === 'object' ? currentRules["borderBottomEndRadius"] : {
                        "default": currentRules["borderBottomEndRadius"]
                    };
                    currentRules["borderBottomEndRadius"]["rounding === \"default\""] = "sm";
                } else if (props.rounding === "none") {
                    rules += ' jd12';
                    currentRules["borderBottomEndRadius"] = typeof currentRules["borderBottomEndRadius"] === 'object' ? currentRules["borderBottomEndRadius"] : {
                        "default": currentRules["borderBottomEndRadius"]
                    };
                    currentRules["borderBottomEndRadius"]["rounding === \"none\""] = "none";
                }
                return rules;
            })({
                ...renderProps,
                rounding
            }),
        children: ({ isSelected })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    swatch,
                    isSelected && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        "aria-hidden": true,
                        className: " _Pa12 _Ob12 Wr12 _lr12 _Ar12 _zr12 _oa12 in12 _jf12 _kc12 hc12 mc12 lc12 Og12 _Lf12 _Mc12 _Kc12 _yb12 oi12 ni12 ki12 ji12"
                    })
                ]
            })
    });
}

},{"0":"dUPrm","1":"5eg51","2":"eTXZS","react/jsx-runtime":"2Is6Z","react-aria-components":"gL0u4","./ColorSwatch":"itZYr","react":"a1TxN","@react-spectrum/utils":"jqfrX","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"dUPrm":[function() {},{}],"5eg51":[function() {},{}],"eTXZS":[function() {},{}],"gL0u4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColorSwatchPickerContext", ()=>ColorSwatchPickerContext);
parcelHelpers.export(exports, "ColorSwatchPicker", ()=>ColorSwatchPicker);
parcelHelpers.export(exports, "ColorSwatchPickerItem", ()=>ColorSwatchPickerItem);
var _utils = require("./utils");
var _reactStately = require("react-stately");
var _colorSwatch = require("./ColorSwatch");
var _utils1 = require("@react-aria/utils");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _listBox = require("./ListBox");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAria = require("react-aria");
const ColorSwatchPickerContext = /*#__PURE__*/ (0, _react.createContext)(null);
const ColorMapContext = /*#__PURE__*/ (0, _react.createContext)(null);
const ColorSwatchPicker = /*#__PURE__*/ (0, _react.forwardRef)(function ColorSwatchPicker(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, ColorSwatchPickerContext);
    let state = (0, _reactStately.useColorPickerState)(props);
    let colorMap = (0, _react.useMemo)(()=>new Map(), []);
    let formatter = (0, _reactAria.useLocalizedStringFormatter)((0, _jsonDefault.default), 'react-aria-components');
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _listBox.ListBox), {
        ...(0, _utils1.filterDOMProps)(props, {
            labelable: true
        }),
        ref: ref,
        className: props.className || 'react-aria-ColorSwatchPicker',
        style: props.style,
        "aria-label": props['aria-label'] || (!props['aria-labelledby'] ? formatter.format('colorSwatchPicker') : undefined),
        layout: props.layout || 'grid',
        selectionMode: "single",
        selectedKeys: [
            state.color.toString('hexa')
        ],
        onSelectionChange: (keys)=>{
            // single select, 'all' cannot occur. appease typescript.
            if (keys !== 'all') state.setColor(colorMap.get([
                ...keys
            ][0]));
        },
        disallowEmptySelection: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ColorMapContext.Provider, {
        value: colorMap
    }, props.children));
});
const ColorSwatchPickerItem = /*#__PURE__*/ (0, _react.forwardRef)(function ColorSwatchPickerItem(props, ref) {
    let propColor = props.color || '#0000';
    let color = (0, _react.useMemo)(()=>typeof propColor === 'string' ? (0, _reactStately.parseColor)(propColor) : propColor, [
        propColor
    ]);
    let { locale } = (0, _reactAria.useLocale)();
    let map = (0, _react.useContext)(ColorMapContext);
    (0, _react.useEffect)(()=>{
        let key = color.toString('hexa');
        map.set(key, color);
        return ()=>{
            map.delete(key);
        };
    }, [
        color,
        map
    ]);
    let wrap = (v)=>{
        if (typeof v === 'function') return (renderProps)=>v({
                ...renderProps,
                color
            });
        return v;
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _listBox.ListBoxItem), {
        ...props,
        ref: ref,
        id: color.toString('hexa'),
        textValue: color.getColorName(locale),
        className: wrap(props.className || 'react-aria-ColorSwatchPickerItem'),
        style: wrap(props.style)
    }, (0, _utils.composeRenderProps)(wrap(props.children), (children)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _colorSwatch.ColorSwatchContext).Provider, {
            value: {
                color
            }
        }, children)));
});

},{"./utils":"bA6Cz","react-stately":[["parseColor","71wqN"],["useColorPickerState","1BvAT"]],"./ColorSwatch":"iK3eK","@react-aria/utils":"3upVm","../intl/*.json":"ibVl8","./ListBox":"dNdIK","react":"a1TxN","react-aria":[["useLocale","4k4z8"],["useLocalizedStringFormatter","7lxyl"]],"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1BvAT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useColorPickerState", ()=>useColorPickerState);
var _color = require("./Color");
var _useColor = require("./useColor");
var _utils = require("@react-stately/utils");
function useColorPickerState(props) {
    let value = (0, _useColor.useColor)(props.value);
    let defaultValue = (0, _useColor.useColor)(props.defaultValue || '#000000');
    let [color, setColor] = (0, _utils.useControlledState)(value || undefined, defaultValue, props.onChange);
    return {
        color,
        setColor (color) {
            if (color != null) setColor(color || (0, _color.parseColor)('#000000'));
        }
    };
}

},{"./Color":"71wqN","./useColor":"6CHdE","@react-stately/utils":"4Nj6T","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5FR53":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColorWheelContext", ()=>ColorWheelContext);
parcelHelpers.export(exports, "ColorWheel", ()=>ColorWheel);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _colorHandle = require("./ColorHandle");
var _react = require("react");
var _utils = require("@react-spectrum/utils");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const ColorWheelContext = /*#__PURE__*/ (0, _react.createContext)(null);
const ColorWheel = /*#__PURE__*/ (0, _react.forwardRef)(function ColorWheel(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, ColorWheelContext);
    let { UNSAFE_className = '', UNSAFE_style, styles = '' } = props;
    let containerRef = (0, _utils.useDOMRef)(ref);
    // TODO: how to do mobile scaling?
    let { size = 192 } = props;
    let outerRadius = Math.max(size, 175) / 2;
    let thickness = 24;
    let innerRadius = outerRadius - 24;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ColorWheel), {
        ...props,
        outerRadius: outerRadius,
        innerRadius: innerRadius,
        ref: containerRef,
        style: UNSAFE_style,
        className: UNSAFE_className + styles,
        children: ({ isDisabled, state })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ColorWheelTrack), {
                        style: ({ defaultStyle, isDisabled })=>({
                                background: isDisabled ? undefined : defaultStyle.background
                            }),
                        className: function anonymous(props) {
                            let rules = " ", currentRules = {};
                            rules += ' og12';
                            currentRules["borderTopStartRadius"] = "full";
                            rules += ' ng12';
                            currentRules["borderTopEndRadius"] = "full";
                            rules += ' kg12';
                            currentRules["borderBottomStartRadius"] = "full";
                            rules += ' jg12';
                            currentRules["borderBottomEndRadius"] = "full";
                            rules += ' Oi12';
                            currentRules["outlineColor"] = "gray-1000/10";
                            rules += ' Ola12';
                            currentRules["outlineColor"] = typeof currentRules["outlineColor"] === 'object' ? currentRules["outlineColor"] : {
                                "default": currentRules["outlineColor"]
                            };
                            currentRules["outlineColor"]["forcedColors"] = "ButtonBorder";
                            rules += ' _Mb12';
                            currentRules["outlineWidth"] = 1;
                            rules += ' _Ka12';
                            currentRules["outlineOffset"] = -1;
                            if (props.isDisabled) {
                                rules += ' _Le12';
                                currentRules["outlineStyle"] = typeof currentRules["outlineStyle"] === 'object' ? currentRules["outlineStyle"] : {
                                    "default": currentRules["outlineStyle"]
                                };
                                currentRules["outlineStyle"]["isDisabled"] = "none";
                            } else {
                                rules += ' _Lf12';
                                currentRules["outlineStyle"] = "solid";
                            }
                            if (props.isDisabled) {
                                rules += ' gH12';
                                currentRules["backgroundColor"] = typeof currentRules["backgroundColor"] === 'object' ? currentRules["backgroundColor"] : {
                                    "default": currentRules["backgroundColor"]
                                };
                                currentRules["backgroundColor"]["isDisabled"] = "disabled";
                            }
                            return rules;
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: function anonymous(props) {
                            let rules = " ", currentRules = {};
                            rules += ' _Pa12';
                            currentRules["position"] = "absolute";
                            rules += ' Ww12';
                            currentRules["top"] = 24;
                            rules += ' _lw12';
                            currentRules["bottom"] = 24;
                            rules += ' _Aw12';
                            currentRules["insetStart"] = 24;
                            rules += ' _zw12';
                            currentRules["insetEnd"] = 24;
                            rules += ' _Ob12';
                            currentRules["pointerEvents"] = "none";
                            rules += ' og12';
                            currentRules["borderTopStartRadius"] = "full";
                            rules += ' ng12';
                            currentRules["borderTopEndRadius"] = "full";
                            rules += ' kg12';
                            currentRules["borderBottomStartRadius"] = "full";
                            rules += ' jg12';
                            currentRules["borderBottomEndRadius"] = "full";
                            rules += ' Oi12';
                            currentRules["outlineColor"] = "gray-1000/10";
                            rules += ' Ola12';
                            currentRules["outlineColor"] = typeof currentRules["outlineColor"] === 'object' ? currentRules["outlineColor"] : {
                                "default": currentRules["outlineColor"]
                            };
                            currentRules["outlineColor"]["forcedColors"] = "ButtonBorder";
                            rules += ' _Mb12';
                            currentRules["outlineWidth"] = 1;
                            if (props.isDisabled) {
                                rules += ' _Le12';
                                currentRules["outlineStyle"] = typeof currentRules["outlineStyle"] === 'object' ? currentRules["outlineStyle"] : {
                                    "default": currentRules["outlineStyle"]
                                };
                                currentRules["outlineStyle"]["isDisabled"] = "none";
                            } else {
                                rules += ' _Lf12';
                                currentRules["outlineStyle"] = "solid";
                            }
                            return rules;
                        }({
                            isDisabled
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _colorHandle.ColorHandle), {
                        containerRef: containerRef,
                        getPosition: ()=>{
                            let { x, y } = state.getThumbPosition(outerRadius - thickness / 2);
                            return {
                                x: (outerRadius + x) / (outerRadius * 2),
                                y: (outerRadius + y) / (outerRadius * 2)
                            };
                        }
                    })
                ]
            })
    });
});

},{"0":"d1tR2","1":"8K1BE","react/jsx-runtime":"2Is6Z","react-aria-components":"lC6nI","./ColorHandle":"5r9wJ","react":"a1TxN","@react-spectrum/utils":"jqfrX","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"d1tR2":[function() {},{}],"8K1BE":[function() {},{}],"lC6nI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColorWheelStateContext", ()=>ColorWheelStateContext);
parcelHelpers.export(exports, "ColorWheel", ()=>ColorWheel);
parcelHelpers.export(exports, "ColorWheelTrackContext", ()=>ColorWheelTrackContext);
parcelHelpers.export(exports, "ColorWheelTrack", ()=>ColorWheelTrack);
var _reactAria = require("react-aria");
var _utils = require("./utils");
var _rspcontexts = require("./RSPContexts");
var _reactStately = require("react-stately");
var _utils1 = require("@react-aria/utils");
var _colorThumb = require("./ColorThumb");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const ColorWheelStateContext = /*#__PURE__*/ (0, _react.createContext)(null);
const ColorWheel = /*#__PURE__*/ (0, _react.forwardRef)(function ColorWheel(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, (0, _rspcontexts.ColorWheelContext));
    let state = (0, _reactStately.useColorWheelState)(props);
    let inputRef = (0, _react.useRef)(null);
    let { trackProps, inputProps, thumbProps } = (0, _reactAria.useColorWheel)(props, state, inputRef);
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        values: {
            state,
            isDisabled: props.isDisabled || false
        },
        defaultClassName: 'react-aria-ColorWheel',
        defaultStyle: {
            position: 'relative'
        }
    });
    let DOMProps = (0, _utils1.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...DOMProps,
        ...renderProps,
        ref: ref,
        slot: props.slot || undefined,
        "data-disabled": props.isDisabled || undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                ColorWheelStateContext,
                state
            ],
            [
                ColorWheelTrackContext,
                trackProps
            ],
            [
                (0, _colorThumb.InternalColorThumbContext),
                {
                    state,
                    thumbProps,
                    inputXRef: inputRef,
                    xInputProps: inputProps,
                    isDisabled: props.isDisabled
                }
            ]
        ]
    }, renderProps.children));
});
const ColorWheelTrackContext = /*#__PURE__*/ (0, _react.createContext)(null);
const ColorWheelTrack = /*#__PURE__*/ (0, _react.forwardRef)(function ColorWheelTrack(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, ColorWheelTrackContext);
    let state = (0, _react.useContext)(ColorWheelStateContext);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let { className, style, ...rest } = props;
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        defaultClassName: 'react-aria-ColorWheelTrack',
        values: {
            isDisabled: state.isDisabled,
            state
        }
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...rest,
        ...renderProps,
        ref: ref,
        "data-disabled": state.isDisabled || undefined
    });
});

},{"react-aria":"l8D1o","./utils":"bA6Cz","./RSPContexts":"lIerG","react-stately":"cok9D","@react-aria/utils":"3upVm","./ColorThumb":"gcXiK","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"l8D1o":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a color wheel component.
 * Color wheels allow users to adjust the hue of an HSL or HSB color value on a circular track.
 */ parcelHelpers.export(exports, "useColorWheel", ()=>useColorWheel);
var _utils = require("@react-aria/utils");
var _react = require("react");
var _interactions = require("@react-aria/interactions");
var _i18N = require("@react-aria/i18n");
var _visuallyHidden = require("@react-aria/visually-hidden");
function useColorWheel(props, state, inputRef) {
    let { isDisabled, innerRadius, outerRadius, 'aria-label': ariaLabel, name, form } = props;
    let { addGlobalListener, removeGlobalListener } = (0, _utils.useGlobalListeners)();
    let thumbRadius = (innerRadius + outerRadius) / 2;
    let focusInput = (0, _react.useCallback)(()=>{
        if (inputRef.current) (0, _utils.focusWithoutScrolling)(inputRef.current);
    }, [
        inputRef
    ]);
    (0, _utils.useFormReset)(inputRef, state.defaultValue, state.setValue);
    let currentPosition = (0, _react.useRef)(null);
    let { keyboardProps } = (0, _interactions.useKeyboard)({
        onKeyDown (e) {
            // these are the cases that useMove doesn't handle
            if (!/^(PageUp|PageDown)$/.test(e.key)) {
                e.continuePropagation();
                return;
            }
            // same handling as useMove, don't need to stop propagation, useKeyboard will do that for us
            e.preventDefault();
            // remember to set this and unset it so that onChangeEnd is fired
            state.setDragging(true);
            switch(e.key){
                case 'PageUp':
                    e.preventDefault();
                    state.increment(state.pageStep);
                    break;
                case 'PageDown':
                    e.preventDefault();
                    state.decrement(state.pageStep);
                    break;
            }
            state.setDragging(false);
        }
    });
    let moveHandler = {
        onMoveStart () {
            currentPosition.current = null;
            state.setDragging(true);
        },
        onMove ({ deltaX, deltaY, pointerType, shiftKey }) {
            if (currentPosition.current == null) currentPosition.current = state.getThumbPosition(thumbRadius);
            currentPosition.current.x += deltaX;
            currentPosition.current.y += deltaY;
            if (pointerType === 'keyboard') {
                if (deltaX > 0 || deltaY < 0) state.increment(shiftKey ? state.pageStep : state.step);
                else if (deltaX < 0 || deltaY > 0) state.decrement(shiftKey ? state.pageStep : state.step);
            } else state.setHueFromPoint(currentPosition.current.x, currentPosition.current.y, thumbRadius);
        },
        onMoveEnd () {
            isOnTrack.current = false;
            state.setDragging(false);
            focusInput();
        }
    };
    let { moveProps: movePropsThumb } = (0, _interactions.useMove)(moveHandler);
    let currentPointer = (0, _react.useRef)(undefined);
    let isOnTrack = (0, _react.useRef)(false);
    let { moveProps: movePropsContainer } = (0, _interactions.useMove)({
        onMoveStart () {
            if (isOnTrack.current) moveHandler.onMoveStart();
        },
        onMove (e) {
            if (isOnTrack.current) moveHandler.onMove(e);
        },
        onMoveEnd () {
            if (isOnTrack.current) moveHandler.onMoveEnd();
        }
    });
    let onThumbDown = (id)=>{
        if (!state.isDragging) {
            currentPointer.current = id;
            focusInput();
            state.setDragging(true);
            if (typeof PointerEvent !== 'undefined') addGlobalListener(window, 'pointerup', onThumbUp, false);
            else {
                addGlobalListener(window, 'mouseup', onThumbUp, false);
                addGlobalListener(window, 'touchend', onThumbUp, false);
            }
        }
    };
    let onThumbUp = (e)=>{
        let id = e.pointerId ?? e.changedTouches?.[0].identifier;
        if (id === currentPointer.current) {
            focusInput();
            state.setDragging(false);
            currentPointer.current = undefined;
            isOnTrack.current = false;
            if (typeof PointerEvent !== 'undefined') removeGlobalListener(window, 'pointerup', onThumbUp, false);
            else {
                removeGlobalListener(window, 'mouseup', onThumbUp, false);
                removeGlobalListener(window, 'touchend', onThumbUp, false);
            }
        }
    };
    let onTrackDown = (track, id, pageX, pageY)=>{
        let rect = track.getBoundingClientRect();
        let x = pageX - rect.x - rect.width / 2;
        let y = pageY - rect.y - rect.height / 2;
        let radius = Math.sqrt(x * x + y * y);
        if (innerRadius < radius && radius < outerRadius && !state.isDragging && currentPointer.current === undefined) {
            isOnTrack.current = true;
            currentPointer.current = id;
            state.setHueFromPoint(x, y, radius);
            focusInput();
            state.setDragging(true);
            if (typeof PointerEvent !== 'undefined') addGlobalListener(window, 'pointerup', onTrackUp, false);
            else {
                addGlobalListener(window, 'mouseup', onTrackUp, false);
                addGlobalListener(window, 'touchend', onTrackUp, false);
            }
        }
    };
    let onTrackUp = (e)=>{
        let id = e.pointerId ?? e.changedTouches?.[0].identifier;
        if (isOnTrack.current && id === currentPointer.current) {
            isOnTrack.current = false;
            currentPointer.current = undefined;
            state.setDragging(false);
            focusInput();
            if (typeof PointerEvent !== 'undefined') removeGlobalListener(window, 'pointerup', onTrackUp, false);
            else {
                removeGlobalListener(window, 'mouseup', onTrackUp, false);
                removeGlobalListener(window, 'touchend', onTrackUp, false);
            }
        }
    };
    let trackInteractions = isDisabled ? {} : (0, _utils.mergeProps)({
        ...typeof PointerEvent !== 'undefined' ? {
            onPointerDown: (e)=>{
                if (e.pointerType === 'mouse' && (e.button !== 0 || e.altKey || e.ctrlKey || e.metaKey)) return;
                onTrackDown(e.currentTarget, e.pointerId, e.clientX, e.clientY);
            }
        } : {
            onMouseDown: (e)=>{
                if (e.button !== 0 || e.altKey || e.ctrlKey || e.metaKey) return;
                onTrackDown(e.currentTarget, undefined, e.clientX, e.clientY);
            },
            onTouchStart: (e)=>{
                onTrackDown(e.currentTarget, e.changedTouches[0].identifier, e.changedTouches[0].clientX, e.changedTouches[0].clientY);
            }
        }
    }, movePropsContainer);
    let thumbInteractions = isDisabled ? {} : (0, _utils.mergeProps)({
        onMouseDown: (e)=>{
            if (e.button !== 0 || e.altKey || e.ctrlKey || e.metaKey) return;
            onThumbDown(undefined);
        },
        onPointerDown: (e)=>{
            if (e.pointerType === 'mouse' && (e.button !== 0 || e.altKey || e.ctrlKey || e.metaKey)) return;
            onThumbDown(e.pointerId);
        },
        onTouchStart: (e)=>{
            onThumbDown(e.changedTouches[0].identifier);
        }
    }, keyboardProps, movePropsThumb);
    let { x, y } = state.getThumbPosition(thumbRadius);
    // Provide a default aria-label if none is given
    let { locale } = (0, _i18N.useLocale)();
    if (ariaLabel == null && props['aria-labelledby'] == null) ariaLabel = state.value.getChannelName('hue', locale);
    let inputLabellingProps = (0, _utils.useLabels)({
        ...props,
        'aria-label': ariaLabel
    });
    let { minValue, maxValue, step } = state.value.getChannelRange('hue');
    let forcedColorAdjustNoneStyle = {
        forcedColorAdjust: 'none'
    };
    let { visuallyHiddenProps } = (0, _visuallyHidden.useVisuallyHidden)({
        style: {
            opacity: '0.0001',
            width: '100%',
            height: '100%',
            pointerEvents: 'none'
        }
    });
    return {
        trackProps: {
            ...trackInteractions,
            style: {
                position: 'relative',
                touchAction: 'none',
                width: outerRadius * 2,
                height: outerRadius * 2,
                background: `
          conic-gradient(
            from 90deg,
            hsl(0, 100%, 50%),
            hsl(30, 100%, 50%),
            hsl(60, 100%, 50%),
            hsl(90, 100%, 50%),
            hsl(120, 100%, 50%),
            hsl(150, 100%, 50%),
            hsl(180, 100%, 50%),
            hsl(210, 100%, 50%),
            hsl(240, 100%, 50%),
            hsl(270, 100%, 50%),
            hsl(300, 100%, 50%),
            hsl(330, 100%, 50%),
            hsl(360, 100%, 50%)
          )
        `,
                clipPath: `path(evenodd, "${circlePath(outerRadius, outerRadius, outerRadius)} ${circlePath(outerRadius, outerRadius, innerRadius)}")`,
                ...forcedColorAdjustNoneStyle
            }
        },
        thumbProps: {
            ...thumbInteractions,
            style: {
                position: 'absolute',
                left: (outerRadius + x).toFixed(3) + 'px',
                top: (outerRadius + y).toFixed(3) + 'px',
                transform: 'translate(-50%, -50%)',
                touchAction: 'none',
                ...forcedColorAdjustNoneStyle
            }
        },
        inputProps: (0, _utils.mergeProps)(inputLabellingProps, {
            type: 'range',
            min: String(minValue),
            max: String(maxValue),
            step: String(step),
            'aria-valuetext': `${state.value.formatChannelValue('hue', locale)}, ${state.value.getHueName(locale)}`,
            disabled: isDisabled,
            value: `${state.value.getChannelValue('hue')}`,
            name,
            form,
            onChange: (e)=>{
                state.setHue(parseFloat(e.target.value));
            },
            style: visuallyHiddenProps.style,
            'aria-errormessage': props['aria-errormessage'],
            'aria-describedby': props['aria-describedby'],
            'aria-details': props['aria-details']
        })
    };
}
// Creates an SVG path string for a circle.
function circlePath(cx, cy, r) {
    return `M ${cx}, ${cy} m ${-r}, 0 a ${r}, ${r}, 0, 1, 0, ${r * 2}, 0 a ${r}, ${r}, 0, 1, 0 ${-r * 2}, 0`;
}

},{"@react-aria/utils":[["focusWithoutScrolling","81NOP"],["mergeProps","aNvcY"],["useFormReset","dwBOx"],["useGlobalListeners","ceyTG"],["useLabels","7Uhyw"]],"react":"a1TxN","@react-aria/interactions":[["useKeyboard","vsbUl"],["useMove","kqQMp"]],"@react-aria/i18n":"4k4z8","@react-aria/visually-hidden":"7zrGr","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"cok9D":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides state management for a color wheel component.
 * Color wheels allow users to adjust the hue of an HSL or HSB color value on a circular track.
 */ parcelHelpers.export(exports, "useColorWheelState", ()=>useColorWheelState);
var _color = require("./Color");
var _utils = require("@react-stately/utils");
var _react = require("react");
const DEFAULT_COLOR = (0, _color.parseColor)('hsl(0, 100%, 50%)');
function roundToStep(value, step) {
    return Math.round(value / step) * step;
}
function mod(n, m) {
    return (n % m + m) % m;
}
function roundDown(v) {
    let r = Math.floor(v);
    if (r === v) return v - 1;
    else return r;
}
function degToRad(deg) {
    return deg * Math.PI / 180;
}
function radToDeg(rad) {
    return rad * 180 / Math.PI;
}
// 0deg = 3 o'clock. increases clockwise
function angleToCartesian(angle, radius) {
    let rad = degToRad(360 - angle + 90);
    let x = Math.sin(rad) * radius;
    let y = Math.cos(rad) * radius;
    return {
        x,
        y
    };
}
function cartesianToAngle(x, y, radius) {
    let deg = radToDeg(Math.atan2(y / radius, x / radius));
    return (deg + 360) % 360;
}
function useColorWheelState(props) {
    let { value: propsValue, defaultValue, onChange, onChangeEnd } = props;
    if (!propsValue && !defaultValue) defaultValue = DEFAULT_COLOR;
    if (propsValue) propsValue = (0, _color.normalizeColor)(propsValue);
    if (defaultValue) defaultValue = (0, _color.normalizeColor)(defaultValue);
    // safe to cast value and defaultValue to Color, one of them will always be defined because if neither are, we assign a default
    let [stateValue, setValueState] = (0, _utils.useControlledState)(propsValue, defaultValue, onChange);
    let [initialValue] = (0, _react.useState)(stateValue);
    let value = (0, _react.useMemo)(()=>{
        let colorSpace = stateValue.getColorSpace();
        return colorSpace === 'hsl' || colorSpace === 'hsb' ? stateValue : stateValue.toFormat('hsl');
    }, [
        stateValue
    ]);
    let valueRef = (0, _react.useRef)(value);
    let setValue = (value)=>{
        valueRef.current = value;
        setValueState(value);
    };
    let channelRange = value.getChannelRange('hue');
    let { minValue: minValueX, maxValue: maxValueX, step: step, pageSize: pageStep } = channelRange;
    let [isDragging, setDragging] = (0, _react.useState)(false);
    let isDraggingRef = (0, _react.useRef)(false);
    let hue = value.getChannelValue('hue');
    function setHue(v) {
        if (v > 360) // Make sure you can always get back to 0.
        v = 0;
        v = roundToStep(mod(v, 360), step);
        if (hue !== v) {
            let color = value.withChannelValue('hue', v);
            setValue(color);
        }
    }
    return {
        value,
        defaultValue: propsValue !== undefined ? initialValue : defaultValue,
        step,
        pageStep,
        setValue (v) {
            let color = (0, _color.normalizeColor)(v);
            setValue(color);
        },
        hue,
        setHue,
        setHueFromPoint (x, y, radius) {
            setHue(cartesianToAngle(x, y, radius));
        },
        getThumbPosition (radius) {
            return angleToCartesian(value.getChannelValue('hue'), radius);
        },
        increment (stepSize = 1) {
            let s = Math.max(stepSize, step);
            let newValue = hue + s;
            if (newValue >= maxValueX) // Make sure you can always get back to 0.
            newValue = minValueX;
            setHue(roundToStep(mod(newValue, 360), s));
        },
        decrement (stepSize = 1) {
            let s = Math.max(stepSize, step);
            if (hue === 0) // We can't just subtract step because this might be the case:
            // |(previous step) - 0| < step size
            setHue(roundDown(360 / s) * s);
            else setHue(roundToStep(mod(hue - s, 360), s));
        },
        setDragging (isDragging) {
            let wasDragging = isDraggingRef.current;
            isDraggingRef.current = isDragging;
            if (onChangeEnd && !isDragging && wasDragging) onChangeEnd(valueRef.current);
            setDragging(isDragging);
        },
        isDragging,
        getDisplayColor () {
            return value.toFormat('hsl').withChannelValue('saturation', 100).withChannelValue('lightness', 50).withChannelValue('alpha', 1);
        },
        isDisabled: props.isDisabled || false
    };
}

},{"./Color":"71wqN","@react-stately/utils":"4Nj6T","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fEve7":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RangeCalendarContext", ()=>RangeCalendarContext);
parcelHelpers.export(exports, "RangeCalendar", ()=>RangeCalendar);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _calendar = require("./Calendar");
var _s2IconChevronLeft20NSvg = require("../s2wf-icons/S2_Icon_ChevronLeft_20_N.svg");
var _s2IconChevronLeft20NSvgDefault = parcelHelpers.interopDefault(_s2IconChevronLeft20NSvg);
var _s2IconChevronRight20NSvg = require("../s2wf-icons/S2_Icon_ChevronRight_20_N.svg");
var _s2IconChevronRight20NSvgDefault = parcelHelpers.interopDefault(_s2IconChevronRight20NSvg);
var _react = require("react");
var _ = require("./");
var _field = require("./Field");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _i18N = require("@react-aria/i18n");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const RangeCalendarContext = /*#__PURE__*/ (0, _react.createContext)(null);
const calendarStyles = function anonymous(props, overrides) {
    let rules = " ", currentRules = {};
    let width = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L|-macro\$)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "Z") width = true;
        rules += p[0];
    }
    rules += ' sd12';
    currentRules["display"] = "flex";
    rules += ' _ta12';
    currentRules["flexDirection"] = "column";
    rules += ' Uj12';
    currentRules["rowGap"] = 24;
    rules += ' qj12';
    currentRules["columnGap"] = 24;
    if (!width) rules += ' ZJ12';
    currentRules["width"] = "fit";
    return rules;
};
const headerStyles = " sd12 eb12 _Ce12 Za12";
const RangeCalendar = /*#__PURE__*/ (0, _react.forwardRef)(function RangeCalendar(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, RangeCalendarContext);
    let { visibleMonths = 1, errorMessage, UNSAFE_style, UNSAFE_className, styles, ...otherProps } = props;
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-spectrum/s2');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.RangeCalendar), {
        ...otherProps,
        ref: ref,
        visibleDuration: {
            months: visibleMonths
        },
        style: UNSAFE_style,
        className: (UNSAFE_className || '') + calendarStyles(null, styles),
        children: ({ isInvalid, isDisabled })=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
                        values: [
                            [
                                (0, _.HeaderContext),
                                null
                            ],
                            [
                                (0, _.HeadingContext),
                                null
                            ]
                        ],
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _.Header), {
                            styles: headerStyles,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _calendar.CalendarButton), {
                                    slot: "previous",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2IconChevronLeft20NSvgDefault.default), {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _calendar.CalendarHeading), {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _calendar.CalendarButton), {
                                    slot: "next",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2IconChevronRight20NSvgDefault.default), {})
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: " sd12 _tc12 Uj12 qj12 Za12 ed12",
                        children: Array.from({
                            length: visibleMonths
                        }).map((_, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _calendar.CalendarGrid), {
                                months: i
                            }, i))
                    }),
                    isInvalid && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Text), {
                        slot: "errorMessage",
                        className: (0, _field.helpTextStyles)({
                            isInvalid,
                            isDisabled,
                            size: 'M'
                        }),
                        children: errorMessage || stringFormatter.format('calendar.invalidSelection', {
                            selectedCount: 2
                        })
                    })
                ]
            });
        }
    });
});

},{"0":"idi5K","1":"eR6vB","2":"7oUiz","react/jsx-runtime":"2Is6Z","react-aria-components":[["Provider","bA6Cz"],["RangeCalendar","2DleA"],["Text","jt9fm"]],"./Calendar":"j5ASf","../s2wf-icons/S2_Icon_ChevronLeft_20_N.svg":"5jnVm","../s2wf-icons/S2_Icon_ChevronRight_20_N.svg":"kmqkh","react":"a1TxN","./":"10r6w","./Field":"eI7CE","../intl/*.json":"gDH3q","@react-aria/i18n":"7lxyl","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"idi5K":[function() {},{}],"eR6vB":[function() {},{}],"7oUiz":[function() {},{}],"jnRZl":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DropZoneContext", ()=>DropZoneContext);
parcelHelpers.export(exports, "DropZone", ()=>DropZone);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _illustratedMessage = require("./IllustratedMessage");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _utils = require("@react-spectrum/utils");
var _i18N = require("@react-aria/i18n");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const DropZoneContext = /*#__PURE__*/ (0, _react.createContext)(null);
const dropzone = function anonymous(props, overrides) {
    let rules = " ", currentRules = {};
    let position = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L|F|M|K|-macro\$)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "_P") position = true;
        rules += p[0];
    }
    rules += ' sd12';
    currentRules["display"] = "flex";
    rules += ' _Ca12';
    currentRules["justifyContent"] = "center";
    rules += ' eb12';
    currentRules["alignItems"] = "center";
    if (!position) rules += ' _Pc12';
    currentRules["position"] = "relative";
    rules += ' uk12';
    currentRules["fontFamily"] = "sans";
    rules += ' uch12';
    currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
        "default": currentRules["fontFamily"]
    };
    currentRules["fontFamily"][":lang(ar)"] = "sans";
    rules += ' udi12';
    currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
        "default": currentRules["fontFamily"]
    };
    currentRules["fontFamily"][":lang(he)"] = "sans";
    rules += ' uea12';
    currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
        "default": currentRules["fontFamily"]
    };
    currentRules["fontFamily"][":lang(ja)"] = "sans";
    rules += ' ugb12';
    currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
        "default": currentRules["fontFamily"]
    };
    currentRules["fontFamily"][":lang(ko)"] = "sans";
    rules += ' uhd12';
    currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
        "default": currentRules["fontFamily"]
    };
    currentRules["fontFamily"][":lang(zh)"] = "sans";
    rules += ' uje12';
    currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
        "default": currentRules["fontFamily"]
    };
    currentRules["fontFamily"][":lang(zh-hant)"] = "sans";
    rules += ' u2NhKxcl12';
    currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
        "default": currentRules["fontFamily"]
    };
    currentRules["fontFamily"][":lang(zh-HK)"] = "sans";
    rules += ' uic12';
    currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
        "default": currentRules["fontFamily"]
    };
    currentRules["fontFamily"][":lang(zh-Hans, zh-CN, zh-SG)"] = "sans";
    rules += ' po12';
    currentRules["color"] = "gray-900";
    if (props.isDropTarget) {
        rules += ' _jf12';
        currentRules["borderStyle"] = typeof currentRules["borderStyle"] === 'object' ? currentRules["borderStyle"] : {
            "default": currentRules["borderStyle"]
        };
        currentRules["borderStyle"]["isDropTarget"] = "solid";
    } else {
        rules += ' _ja12';
        currentRules["borderStyle"] = "dashed";
    }
    if (props.isDropTarget) {
        rules += ' g_e12';
        currentRules["backgroundColor"] = typeof currentRules["backgroundColor"] === 'object' ? currentRules["backgroundColor"] : {
            "default": currentRules["backgroundColor"]
        };
        currentRules["backgroundColor"]["isDropTarget"] = "blue-200";
    }
    rules += ' _kc12';
    currentRules["borderTopWidth"] = 2;
    rules += ' hc12';
    currentRules["borderBottomWidth"] = 2;
    rules += ' mc12';
    currentRules["borderStartWidth"] = 2;
    rules += ' lc12';
    currentRules["borderEndWidth"] = 2;
    if (props.isFocusVisible) {
        rules += ' ix12';
        currentRules["borderColor"] = typeof currentRules["borderColor"] === 'object' ? currentRules["borderColor"] : {
            "default": currentRules["borderColor"]
        };
        currentRules["borderColor"]["isFocusVisible"] = "blue-800";
    } else if (props.isDropTarget) {
        rules += ' ix12';
        currentRules["borderColor"] = typeof currentRules["borderColor"] === 'object' ? currentRules["borderColor"] : {
            "default": currentRules["borderColor"]
        };
        currentRules["borderColor"]["isDropTarget"] = "blue-800";
    } else {
        rules += ' iq12';
        currentRules["borderColor"] = "gray-300";
    }
    rules += ' oc12';
    currentRules["borderTopStartRadius"] = "lg";
    rules += ' nc12';
    currentRules["borderTopEndRadius"] = "lg";
    rules += ' kc12';
    currentRules["borderBottomStartRadius"] = "lg";
    rules += ' jc12';
    currentRules["borderBottomEndRadius"] = "lg";
    rules += ' Th12';
    currentRules["paddingTop"] = 24;
    rules += ' Qh12';
    currentRules["paddingBottom"] = 24;
    rules += ' Sh12';
    currentRules["paddingStart"] = 24;
    rules += ' Rh12';
    currentRules["paddingEnd"] = 24;
    return rules;
};
const banner = function anonymous(props) {
    let rules = " ", currentRules = {};
    rules += ' _Pa12';
    currentRules["position"] = "absolute";
    rules += ' _Er12';
    currentRules["left"] = 0;
    rules += ' _Rr12';
    currentRules["right"] = 0;
    rules += ' IM12';
    currentRules["marginStart"] = "auto";
    rules += ' HM12';
    currentRules["marginEnd"] = "auto";
    rules += ' sd12';
    currentRules["display"] = "flex";
    rules += ' eb12';
    currentRules["alignItems"] = "center";
    rules += ' _Ca12';
    currentRules["justifyContent"] = "center";
    rules += ' MAyFGYc12';
    rules += ' ZJ12';
    currentRules["width"] = "fit";
    if (props.size === "L") {
        rules += ' Lg12';
        currentRules["maxWidth"] = typeof currentRules["maxWidth"] === 'object' ? currentRules["maxWidth"] : {
            "default": currentRules["maxWidth"]
        };
        currentRules["maxWidth"]["size === \"L\""] = 208;
    } else if (props.size === "S") {
        rules += ' Le12';
        currentRules["maxWidth"] = typeof currentRules["maxWidth"] === 'object' ? currentRules["maxWidth"] : {
            "default": currentRules["maxWidth"]
        };
        currentRules["maxWidth"]["size === \"S\""] = 160;
    } else {
        rules += ' Lf12';
        currentRules["maxWidth"] = 192;
    }
    rules += ' g212';
    currentRules["backgroundColor"] = "accent";
    rules += ' ob12';
    currentRules["borderTopStartRadius"] = "default";
    rules += ' nb12';
    currentRules["borderTopEndRadius"] = "default";
    rules += ' kb12';
    currentRules["borderBottomStartRadius"] = "default";
    rules += ' jb12';
    currentRules["borderBottomEndRadius"] = "default";
    rules += ' px12';
    currentRules["color"] = "white";
    rules += ' xd12';
    currentRules["fontWeight"] = "bold";
    rules += ' _xa12';
    currentRules["fontWeight"] = "bold";
    rules += ' xX0cczbc12';
    currentRules["fontWeight"] = typeof currentRules["fontWeight"] === 'object' ? currentRules["fontWeight"] : {
        "default": currentRules["fontWeight"]
    };
    currentRules["fontWeight"][":lang(ja, ko, zh)"] = "bold";
    rules += ' _xX0cczba12';
    currentRules["fontWeight"] = typeof currentRules["fontWeight"] === 'object' ? currentRules["fontWeight"] : {
        "default": currentRules["fontWeight"]
    };
    currentRules["fontWeight"][":lang(ja, ko, zh)"] = "bold";
    rules += ' T85xBjb12';
    currentRules["paddingTop"] = "calc((self(minHeight))/1.5)";
    rules += ' Q85xBjb12';
    currentRules["paddingBottom"] = "calc((self(minHeight))/1.5)";
    rules += ' S85xBjb12';
    currentRules["paddingStart"] = "calc((self(minHeight))/1.5)";
    rules += ' R85xBjb12';
    currentRules["paddingEnd"] = "calc((self(minHeight))/1.5)";
    rules += ' -M_-Mf12';
    currentRules["minHeight"] = 20;
    return rules;
};
const DropZone = /*#__PURE__*/ (0, _react.forwardRef)(function DropZone(props, ref) {
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-spectrum/s2');
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, DropZoneContext);
    let { size = 'M' } = props;
    let domRef = (0, _utils.useDOMRef)(ref);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.DropZone), {
        ...props,
        ref: domRef,
        style: props.UNSAFE_style,
        className: (renderProps)=>(props.UNSAFE_className || '') + dropzone(renderProps, props.styles),
        children: (renderProps)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _illustratedMessage.IllustratedMessageContext).Provider, {
                        value: {
                            isInDropZone: true,
                            isDropTarget: renderProps.isDropTarget,
                            size
                        },
                        children: props.children
                    }),
                    renderProps.isDropTarget && props.isFilled && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: banner({
                            size
                        }),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            children: props.replaceMessage ? props.replaceMessage : stringFormatter.format('dropzone.replaceMessage')
                        })
                    })
                ]
            })
    });
});

},{"0":"cbNzV","1":"NeMLd","react/jsx-runtime":"2Is6Z","react-aria-components":"8r9g2","react":"a1TxN","./IllustratedMessage":"6oPVu","../intl/*.json":"gDH3q","@react-spectrum/utils":"jqfrX","@react-aria/i18n":"7lxyl","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"cbNzV":[function() {},{}],"NeMLd":[function() {},{}],"8r9g2":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DropZoneContext", ()=>DropZoneContext);
parcelHelpers.export(exports, "DropZone", ()=>DropZone);
var _utils = require("./utils");
var _reactAria = require("react-aria");
var _utils1 = require("@react-aria/utils");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _text = require("./Text");
const DropZoneContext = /*#__PURE__*/ (0, _react.createContext)(null);
const DropZone = /*#__PURE__*/ (0, _react.forwardRef)(function DropZone(props, ref) {
    let { isDisabled = false } = props;
    [props, ref] = (0, _utils.useContextProps)(props, ref, DropZoneContext);
    let dropzoneRef = (0, _utils1.useObjectRef)(ref);
    let buttonRef = (0, _react.useRef)(null);
    let { dropProps, dropButtonProps, isDropTarget } = (0, _reactAria.useDrop)({
        ...props,
        ref: buttonRef,
        hasDropButton: true
    });
    let { buttonProps } = (0, _reactAria.useButton)(dropButtonProps || {}, buttonRef);
    let { hoverProps, isHovered } = (0, _reactAria.useHover)(props);
    let { focusProps, isFocused, isFocusVisible } = (0, _reactAria.useFocusRing)();
    let stringFormatter = (0, _reactAria.useLocalizedStringFormatter)((0, _jsonDefault.default), 'react-aria-components');
    let textId = (0, _utils1.useSlotId)();
    let ariaLabel = props['aria-label'] || stringFormatter.format('dropzoneLabel');
    let messageId = props['aria-labelledby'];
    let ariaLabelledby = [
        textId,
        messageId
    ].filter(Boolean).join(' ');
    let labelProps = (0, _utils1.useLabels)({
        'aria-label': ariaLabel,
        'aria-labelledby': ariaLabelledby
    });
    let { clipboardProps } = (0, _reactAria.useClipboard)({
        isDisabled,
        onPaste: (items)=>props.onDrop?.({
                type: 'drop',
                items,
                x: 0,
                y: 0,
                dropOperation: 'copy'
            })
    });
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        values: {
            isHovered,
            isFocused,
            isFocusVisible,
            isDropTarget,
            isDisabled
        },
        defaultClassName: 'react-aria-DropZone'
    });
    let DOMProps = (0, _utils1.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                (0, _text.TextContext),
                {
                    id: textId,
                    slot: 'label'
                }
            ]
        ]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _reactAria.mergeProps)(DOMProps, renderProps, dropProps, hoverProps),
        slot: props.slot || undefined,
        ref: dropzoneRef,
        onClick: (e)=>{
            let target = e.target;
            while(target && dropzoneRef.current?.contains(target)){
                if ((0, _utils1.isFocusable)(target)) break;
                else if (target === dropzoneRef.current) {
                    buttonRef.current?.focus();
                    break;
                }
                target = target.parentElement;
            }
        },
        "data-hovered": isHovered || undefined,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-drop-target": isDropTarget || undefined,
        "data-disabled": isDisabled || undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAria.VisuallyHidden), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        ...(0, _reactAria.mergeProps)(buttonProps, focusProps, clipboardProps, labelProps),
        ref: buttonRef
    })), renderProps.children));
});

},{"./utils":"bA6Cz","react-aria":[["mergeProps","aNvcY"],["useButton","exEOU"],["useClipboard","5RCSJ"],["useDrop","k4cyN"],["useFocusRing","6TXyU"],["useHover","k6FLA"],["useLocalizedStringFormatter","7lxyl"],["VisuallyHidden","7zrGr"]],"@react-aria/utils":[["filterDOMProps","3upVm"],["isFocusable","72VDv"],["useLabels","7Uhyw"],["useObjectRef","laqO5"],["useSlotId","jbI4Y"]],"../intl/*.json":"ibVl8","react":"a1TxN","./Text":"jt9fm","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5RCSJ":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Handles clipboard interactions for a focusable element. Supports items of multiple
 * data types, and integrates with the operating system native clipboard.
 */ parcelHelpers.export(exports, "useClipboard", ()=>useClipboard);
var _utils = require("@react-aria/utils");
var _utils1 = require("./utils");
var _react = require("react");
var _interactions = require("@react-aria/interactions");
const globalEvents = new Map();
function addGlobalEventListener(event, fn) {
    let eventData = globalEvents.get(event);
    if (!eventData) {
        let handlers = new Set();
        let listener = (e)=>{
            for (let handler of handlers)handler(e);
        };
        eventData = {
            listener,
            handlers
        };
        globalEvents.set(event, eventData);
        document.addEventListener(event, listener);
    }
    eventData.handlers.add(fn);
    return ()=>{
        eventData.handlers.delete(fn);
        if (eventData.handlers.size === 0) {
            document.removeEventListener(event, eventData.listener);
            globalEvents.delete(event);
        }
    };
}
function useClipboard(options) {
    let { isDisabled } = options;
    let isFocusedRef = (0, _react.useRef)(false);
    let { focusProps } = (0, _interactions.useFocus)({
        onFocusChange: (isFocused)=>{
            isFocusedRef.current = isFocused;
        }
    });
    let onBeforeCopy = (0, _utils.useEffectEvent)((e)=>{
        // Enable the "Copy" menu item in Safari if this element is focused and copying is supported.
        if (isFocusedRef.current && options.getItems) e.preventDefault();
    });
    let onCopy = (0, _utils.useEffectEvent)((e)=>{
        if (!isFocusedRef.current || !options.getItems) return;
        e.preventDefault();
        if (e.clipboardData) {
            (0, _utils1.writeToDataTransfer)(e.clipboardData, options.getItems({
                action: 'copy'
            }));
            options.onCopy?.();
        }
    });
    let onBeforeCut = (0, _utils.useEffectEvent)((e)=>{
        if (isFocusedRef.current && options.onCut && options.getItems) e.preventDefault();
    });
    let onCut = (0, _utils.useEffectEvent)((e)=>{
        if (!isFocusedRef.current || !options.onCut || !options.getItems) return;
        e.preventDefault();
        if (e.clipboardData) {
            (0, _utils1.writeToDataTransfer)(e.clipboardData, options.getItems({
                action: 'cut'
            }));
            options.onCut();
        }
    });
    let onBeforePaste = (0, _utils.useEffectEvent)((e)=>{
        // Unfortunately, e.clipboardData.types is not available in this event so we always
        // have to enable the Paste menu item even if the type of data is unsupported.
        if (isFocusedRef.current && options.onPaste) e.preventDefault();
    });
    let onPaste = (0, _utils.useEffectEvent)((e)=>{
        if (!isFocusedRef.current || !options.onPaste) return;
        e.preventDefault();
        if (e.clipboardData) {
            let items = (0, _utils1.readFromDataTransfer)(e.clipboardData);
            options.onPaste(items);
        }
    });
    (0, _react.useEffect)(()=>{
        if (isDisabled) return;
        return (0, _utils.chain)(addGlobalEventListener('beforecopy', onBeforeCopy), addGlobalEventListener('copy', onCopy), addGlobalEventListener('beforecut', onBeforeCut), addGlobalEventListener('cut', onCut), addGlobalEventListener('beforepaste', onBeforePaste), addGlobalEventListener('paste', onPaste));
    }, [
        isDisabled
    ]);
    return {
        clipboardProps: focusProps
    };
}

},{"@react-aria/utils":[["chain","ij7eS"],["useEffectEvent","eg4dC"]],"./utils":"gR4JY","react":"a1TxN","@react-aria/interactions":"j8nkn","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4ywiA":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MeterContext", ()=>MeterContext);
parcelHelpers.export(exports, "Meter", ()=>Meter);
var _reactAria = require("react-aria");
var _utils = require("@react-stately/utils");
var _utils1 = require("./utils");
var _utils2 = require("@react-aria/utils");
var _label = require("./Label");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const MeterContext = /*#__PURE__*/ (0, _react.createContext)(null);
const Meter = /*#__PURE__*/ (0, _react.forwardRef)(function Meter(props, ref) {
    [props, ref] = (0, _utils1.useContextProps)(props, ref, MeterContext);
    let { value = 0, minValue = 0, maxValue = 100 } = props;
    value = (0, _utils.clamp)(value, minValue, maxValue);
    let [labelRef, label] = (0, _utils1.useSlot)(!props['aria-label'] && !props['aria-labelledby']);
    let { meterProps, labelProps } = (0, _reactAria.useMeter)({
        ...props,
        label
    });
    // Calculate the width of the progress bar as a percentage
    let percentage = (value - minValue) / (maxValue - minValue) * 100;
    let renderProps = (0, _utils1.useRenderProps)({
        ...props,
        defaultClassName: 'react-aria-Meter',
        values: {
            percentage,
            valueText: meterProps['aria-valuetext']
        }
    });
    let DOMProps = (0, _utils2.filterDOMProps)(props, {
        global: true
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _utils2.mergeProps)(DOMProps, renderProps, meterProps),
        ref: ref,
        slot: props.slot || undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _label.LabelContext).Provider, {
        value: {
            ...labelProps,
            ref: labelRef,
            elementType: 'span'
        }
    }, renderProps.children));
});

},{"react-aria":"c3l6z","@react-stately/utils":"kO94U","./utils":"bA6Cz","@react-aria/utils":[["filterDOMProps","3upVm"],["mergeProps","aNvcY"]],"./Label":"fjKq6","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"c3l6z":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the accessibility implementation for a meter component.
 * Meters represent a quantity within a known range, or a fractional value.
 */ parcelHelpers.export(exports, "useMeter", ()=>useMeter);
var _progress = require("@react-aria/progress");
function useMeter(props) {
    let { progressBarProps, labelProps } = (0, _progress.useProgressBar)(props);
    return {
        meterProps: {
            ...progressBarProps,
            // Use the meter role if available, but fall back to progressbar if not
            // Chrome currently falls back from meter automatically, and Firefox
            // does not support meter at all. Safari 13+ seems to support meter properly.
            // https://bugs.chromium.org/p/chromium/issues/detail?id=944542
            // https://bugzilla.mozilla.org/show_bug.cgi?id=1460378
            role: 'meter progressbar'
        },
        labelProps
    };
}

},{"@react-aria/progress":"23mb4","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"f83W7":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SkeletonCollection", ()=>SkeletonCollection);
var _jsxRuntime = require("react/jsx-runtime");
var _collections = require("@react-aria/collections");
var _skeleton = require("./Skeleton");
let cache = new WeakMap();
class SkeletonNode extends (0, _collections.CollectionNode) {
    static{
        this.type = 'skeleton';
    }
}
const SkeletonCollection = (0, _collections.createLeafComponent)(SkeletonNode, (props, ref, node)=>{
    // Cache rendering based on node object identity. This allows the children function to randomize
    // its content (e.g. heights) and preserve on re-renders.
    // TODO: do we need a `dependencies` prop here?
    let cached = cache.get(node);
    if (!cached) {
        cached = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeleton.Skeleton), {
            isLoading: true,
            children: props.children()
        });
        cache.set(node, cached);
    }
    return cached;
});

},{"react/jsx-runtime":"2Is6Z","@react-aria/collections":[["CollectionNode","ab6Rh"],["createLeafComponent","2Jd0Q"]],"./Skeleton":"1mUnF","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8PFbf":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FileTrigger", ()=>FileTrigger);
var _utils = require("@react-aria/utils");
var _input = require("./Input");
var _interactions = require("@react-aria/interactions");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const FileTrigger = /*#__PURE__*/ (0, _react.forwardRef)(function FileTrigger(props, ref) {
    let { onSelect, acceptedFileTypes, allowsMultiple, defaultCamera, children, acceptDirectory, ...rest } = props;
    let inputRef = (0, _utils.useObjectRef)(ref);
    let domProps = (0, _utils.filterDOMProps)(rest, {
        global: true
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _interactions.PressResponder), {
        onPress: ()=>{
            if (inputRef.current?.value) inputRef.current.value = '';
            inputRef.current?.click();
        }
    }, children), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _input.Input), {
        ...domProps,
        type: "file",
        ref: inputRef,
        style: {
            display: 'none'
        },
        accept: acceptedFileTypes?.toString(),
        onChange: (e)=>onSelect?.(e.target.files),
        capture: defaultCamera,
        multiple: allowsMultiple,
        // @ts-expect-error
        webkitdirectory: acceptDirectory ? '' : undefined
    }));
});

},{"@react-aria/utils":[["filterDOMProps","3upVm"],["useObjectRef","laqO5"]],"./Input":"jU9y1","@react-aria/interactions":"bmg7W","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"7SNsW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InstallCommand", ()=>InstallCommand);
var _jsxRuntime = require("react/jsx-runtime");
var _copyButton = require("./CopyButton");
var _codePlatter = require("./CodePlatter");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _s2 = require("@react-spectrum/s2");
'use client';
const container = " gqlRAZb12 Jz12 Gz12 oe12 ne12 ke12 je12 sd12 _ta12";
const switcher = " Jx12 JpA12 Ix12 IpA12";
const codeWrap = " Tf12 Qf12 Sf12 Rf12";
function InstallCommand({ pkg, flags, label, isCommand }) {
    let [manager, setManager] = (0, _react.useState)('yarn');
    (0, _react.useEffect)(()=>{
        if (isCommand) return;
        let stored = localStorage.getItem('packageManager');
        if (stored === 'npm' || stored === 'pnpm' || stored === 'yarn') setManager(stored);
    }, [
        isCommand
    ]);
    let onSelectionChange = (key)=>{
        let value = String(key);
        setManager(value);
        localStorage.setItem('packageManager', value);
    };
    let command = (0, _react.useMemo)(()=>{
        let parts = [];
        if (isCommand) parts = [
            'npx',
            pkg
        ];
        else {
            switch(manager){
                case 'yarn':
                    parts = [
                        'yarn',
                        'add'
                    ];
                    break;
                case 'npm':
                    parts = [
                        'npm',
                        'install'
                    ];
                    break;
                case 'pnpm':
                    parts = [
                        'pnpm',
                        'add'
                    ];
                    break;
            }
            parts.push(pkg);
        }
        if (flags) parts.push(flags);
        return parts.join(' ');
    }, [
        isCommand,
        manager,
        pkg,
        flags
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: container,
        "data-example-switcher": true,
        children: [
            !isCommand && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.SegmentedControl), {
                selectedKey: manager,
                onSelectionChange: onSelectionChange,
                styles: switcher,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.SegmentedControlItem), {
                        id: "yarn",
                        children: "yarn"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.SegmentedControlItem), {
                        id: "npm",
                        children: "npm"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.SegmentedControlItem), {
                        id: "pnpm",
                        children: "pnpm"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: codeWrap,
                children: [
                    label && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: " uk12 uch12 udi12 uea12 ugb12 uhd12 uje12 u2NhKxcl12 uic12 -_6BNtrc-c12 vx12 xb12 _xa12 _Fb12 _FnuYUwec12 pt12 Gv12",
                        children: label
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: " sd12 eb12 Ug12 qg12 Tt12 Qt12 St12 Rt12",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _codePlatter.Pre), {
                                children: command
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _copyButton.CopyButton), {
                                ariaLabel: "Copy command",
                                tooltip: "Copy command",
                                text: command
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
exports.default = InstallCommand;

},{"0":"4oKuc","1":"4oKuc","2":"4oKuc","3":"4oKuc","4":"4oKuc","react/jsx-runtime":"2Is6Z","./CopyButton":"e24AO","./CodePlatter":"hi4fC","react":"a1TxN","@react-spectrum/s2":"hnIYG","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"dIN55":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TagGroupContext", ()=>TagGroupContext);
parcelHelpers.export(exports, "TagListContext", ()=>TagListContext);
parcelHelpers.export(exports, "TagGroup", ()=>TagGroup);
parcelHelpers.export(exports, "TagList", ()=>TagList);
parcelHelpers.export(exports, "Tag", ()=>Tag);
var _reactAria = require("react-aria");
var _button = require("./Button");
var _utils = require("./utils");
var _collections = require("@react-aria/collections");
var _collection = require("./Collection");
var _utils1 = require("@react-aria/utils");
var _label = require("./Label");
var _reactStately = require("react-stately");
var _listBox = require("./ListBox");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _rspcontexts = require("./RSPContexts");
var _selectionIndicator = require("./SelectionIndicator");
var _sharedElementTransition = require("./SharedElementTransition");
var _text = require("./Text");
const TagGroupContext = /*#__PURE__*/ (0, _react.createContext)(null);
const TagListContext = /*#__PURE__*/ (0, _react.createContext)(null);
const TagGroup = /*#__PURE__*/ (0, _react.forwardRef)(function TagGroup(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, TagGroupContext);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _listBox.ListStateContext).Provider, {
        value: null
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.CollectionBuilder), {
        content: props.children
    }, (collection)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(TagGroupInner, {
            props: props,
            forwardedRef: ref,
            collection: collection
        })));
});
function TagGroupInner({ props, forwardedRef: ref, collection }) {
    let tagListRef = (0, _react.useRef)(null);
    // Extract the user provided id so it doesn't clash with the collection id provided by Autocomplete
    let { id, ...otherProps } = props;
    [otherProps, tagListRef] = (0, _utils.useContextProps)(otherProps, tagListRef, (0, _rspcontexts.SelectableCollectionContext));
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let { filter, shouldUseVirtualFocus, ...DOMCollectionProps } = otherProps;
    let [labelRef, label] = (0, _utils.useSlot)(!props['aria-label'] && !props['aria-labelledby']);
    let tagGroupState = (0, _reactStately.useListState)({
        ...DOMCollectionProps,
        children: undefined,
        collection
    });
    let filteredState = (0, _reactStately.UNSTABLE_useFilteredListState)(tagGroupState, filter);
    // Prevent DOM props from going to two places.
    let domProps = (0, _utils1.filterDOMProps)(otherProps, {
        global: true
    });
    let domPropOverrides = Object.fromEntries(Object.entries(domProps).map(([k, val])=>[
            k,
            k === 'id' ? val : undefined
        ]));
    let { gridProps, labelProps, descriptionProps, errorMessageProps } = (0, _reactAria.useTagGroup)({
        ...DOMCollectionProps,
        ...domPropOverrides,
        label
    }, filteredState, tagListRef);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...domProps,
        id: id,
        ref: ref,
        slot: props.slot || undefined,
        className: props.className ?? 'react-aria-TagGroup',
        style: props.style
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                (0, _label.LabelContext),
                {
                    ...labelProps,
                    elementType: 'span',
                    ref: labelRef
                }
            ],
            [
                TagListContext,
                {
                    ...gridProps,
                    ref: tagListRef
                }
            ],
            [
                (0, _listBox.ListStateContext),
                filteredState
            ],
            [
                (0, _text.TextContext),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ]
        ]
    }, props.children));
}
const TagList = /*#__PURE__*/ (0, _react.forwardRef)(function TagList(props, ref) {
    let state = (0, _react.useContext)((0, _listBox.ListStateContext));
    return state ? /*#__PURE__*/ (0, _reactDefault.default).createElement(TagListInner, {
        props: props,
        forwardedRef: ref
    }) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collections.Collection), props);
});
function TagListInner({ props, forwardedRef }) {
    let state = (0, _react.useContext)((0, _listBox.ListStateContext));
    let { CollectionRoot } = (0, _react.useContext)((0, _collection.CollectionRendererContext));
    let [gridProps, ref] = (0, _utils.useContextProps)({}, forwardedRef, TagListContext);
    let { focusProps, isFocused, isFocusVisible } = (0, _reactAria.useFocusRing)();
    let renderValues = {
        isEmpty: state.collection.size === 0,
        isFocused,
        isFocusVisible,
        state
    };
    let renderProps = (0, _utils.useRenderProps)({
        className: props.className,
        style: props.style,
        defaultClassName: 'react-aria-TagList',
        values: renderValues
    });
    let persistedKeys = (0, _collection.usePersistedKeys)(state.selectionManager.focusedKey);
    let DOMProps = (0, _utils1.filterDOMProps)(props, {
        global: true
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _utils1.mergeProps)(DOMProps, renderProps, gridProps, focusProps),
        ref: ref,
        "data-empty": state.collection.size === 0 || undefined,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _sharedElementTransition.SharedElementTransition), null, state.collection.size === 0 && props.renderEmptyState ? props.renderEmptyState(renderValues) : /*#__PURE__*/ (0, _reactDefault.default).createElement(CollectionRoot, {
        collection: state.collection,
        persistedKeys: persistedKeys
    })));
}
const Tag = /*#__PURE__*/ (0, _collections.createLeafComponent)((0, _collections.ItemNode), (props, forwardedRef, item)=>{
    let state = (0, _react.useContext)((0, _listBox.ListStateContext));
    let ref = (0, _utils1.useObjectRef)(forwardedRef);
    let { focusProps, isFocusVisible } = (0, _reactAria.useFocusRing)({
        within: false
    });
    let { rowProps, gridCellProps, removeButtonProps, ...states } = (0, _reactAria.useTag)({
        item
    }, state, ref);
    let { hoverProps, isHovered } = (0, _reactAria.useHover)({
        isDisabled: !states.allowsSelection,
        onHoverStart: item.props.onHoverStart,
        onHoverChange: item.props.onHoverChange,
        onHoverEnd: item.props.onHoverEnd
    });
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        id: undefined,
        children: item.rendered,
        defaultClassName: 'react-aria-Tag',
        values: {
            ...states,
            isFocusVisible,
            isHovered,
            selectionMode: state.selectionManager.selectionMode,
            selectionBehavior: state.selectionManager.selectionBehavior
        }
    });
    (0, _react.useEffect)(()=>{
        item.textValue;
    }, [
        item.textValue
    ]);
    let DOMProps = (0, _utils1.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    delete DOMProps.onClick;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ref: ref,
        ...(0, _utils1.mergeProps)(DOMProps, renderProps, rowProps, focusProps, hoverProps),
        "data-selected": states.isSelected || undefined,
        "data-disabled": states.isDisabled || undefined,
        "data-hovered": isHovered || undefined,
        "data-focused": states.isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-pressed": states.isPressed || undefined,
        "data-allows-removing": states.allowsRemoving || undefined,
        "data-selection-mode": state.selectionManager.selectionMode === 'none' ? undefined : state.selectionManager.selectionMode
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...gridCellProps,
        style: {
            display: 'contents'
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                (0, _button.ButtonContext),
                {
                    slots: {
                        remove: removeButtonProps
                    }
                }
            ],
            [
                (0, _collection.CollectionRendererContext),
                (0, _collection.DefaultCollectionRenderer)
            ],
            [
                (0, _selectionIndicator.SelectionIndicatorContext),
                {
                    isSelected: states.isSelected
                }
            ]
        ]
    }, renderProps.children)));
});

},{"react-aria":[["useFocusRing","6TXyU"],["useHover","k6FLA"],["useTag","4yBpN"],["useTagGroup","1Cv9v"]],"./Button":"9G5XO","./utils":"bA6Cz","@react-aria/collections":[["Collection","2Jd0Q"],["CollectionBuilder","2Jd0Q"],["createLeafComponent","2Jd0Q"],["ItemNode","ab6Rh"]],"./Collection":"7QyMy","@react-aria/utils":[["filterDOMProps","3upVm"],["mergeProps","aNvcY"],["useObjectRef","laqO5"]],"./Label":"fjKq6","react-stately":"hjoHP","./ListBox":"dNdIK","react":"a1TxN","./RSPContexts":"lIerG","./SelectionIndicator":"dgQU7","./SharedElementTransition":"iVZnk","./Text":"jt9fm","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4yBpN":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a tag component.
 * @param props - Props to be applied to the tag.
 * @param state - State for the tag group, as returned by `useListState`.
 * @param ref - A ref to a DOM element for the tag.
 */ parcelHelpers.export(exports, "useTag", ()=>useTag);
var _utils = require("@react-aria/utils");
var _useTagGroup = require("./useTagGroup");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _interactions = require("@react-aria/interactions");
var _gridlist = require("@react-aria/gridlist");
var _i18N = require("@react-aria/i18n");
function useTag(props, state, ref) {
    let { item } = props;
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-aria/tag');
    let buttonId = (0, _utils.useId)();
    let { onRemove } = (0, _useTagGroup.hookData).get(state) || {};
    let { rowProps, gridCellProps, ...states } = (0, _gridlist.useGridListItem)({
        node: item
    }, state, ref);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let { descriptionProps: _, ...stateWithoutDescription } = states;
    let isDisabled = state.disabledKeys.has(item.key) || item.props.isDisabled;
    let onKeyDown = (e)=>{
        if (e.key === 'Delete' || e.key === 'Backspace') {
            if (isDisabled) return;
            e.preventDefault();
            if (state.selectionManager.isSelected(item.key)) onRemove?.(new Set(state.selectionManager.selectedKeys));
            else onRemove?.(new Set([
                item.key
            ]));
        }
    };
    let modality = (0, _interactions.useInteractionModality)();
    if (modality === 'virtual' && typeof window !== 'undefined' && 'ontouchstart' in window) modality = 'pointer';
    let description = onRemove && (modality === 'keyboard' || modality === 'virtual') ? stringFormatter.format('removeDescription') : '';
    let descProps = (0, _utils.useDescription)(description);
    let isItemFocused = item.key === state.selectionManager.focusedKey;
    let isFocused = state.selectionManager.focusedKey != null;
    let tabIndex = -1;
    if (!isDisabled && (isItemFocused || !isFocused)) tabIndex = 0;
    let domProps = (0, _utils.filterDOMProps)(item.props);
    let linkProps = (0, _utils.useSyntheticLinkProps)(item.props);
    let { focusableProps } = (0, _interactions.useFocusable)({
        isDisabled
    }, ref);
    return {
        removeButtonProps: {
            'aria-label': stringFormatter.format('removeButtonLabel'),
            'aria-labelledby': `${buttonId} ${rowProps.id}`,
            isDisabled,
            id: buttonId,
            onPress: ()=>onRemove ? onRemove(new Set([
                    item.key
                ])) : null
        },
        rowProps: (0, _utils.mergeProps)(focusableProps, rowProps, domProps, linkProps, {
            tabIndex,
            onKeyDown: onRemove ? onKeyDown : undefined,
            'aria-describedby': descProps['aria-describedby']
        }),
        gridCellProps: (0, _utils.mergeProps)(gridCellProps, {
            'aria-errormessage': props['aria-errormessage'],
            'aria-label': props['aria-label']
        }),
        ...stateWithoutDescription,
        allowsRemoving: !!onRemove
    };
}

},{"@react-aria/utils":[["filterDOMProps","3upVm"],["mergeProps","aNvcY"],["useDescription","h4qnk"],["useId","jbI4Y"],["useSyntheticLinkProps","4FGnT"]],"./useTagGroup":"1Cv9v","../intl/*.json":"kHvU9","@react-aria/interactions":[["useFocusable","kCQqy"],["useInteractionModality","dkfxW"]],"@react-aria/gridlist":"fNHH4","@react-aria/i18n":"7lxyl","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1Cv9v":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hookData", ()=>hookData);
/**
 * Provides the behavior and accessibility implementation for a tag group component.
 * A tag group is a focusable list of labels, categories, keywords, filters, or other items, with support for keyboard navigation, selection, and removal.
 * @param props - Props to be applied to the tag group.
 * @param state - State for the tag group, as returned by `useListState`.
 * @param ref - A ref to a DOM element for the tag group.
 */ parcelHelpers.export(exports, "useTagGroup", ()=>useTagGroup);
var _gridlist = require("@react-aria/gridlist");
var _utils = require("@react-aria/utils");
var _selection = require("@react-aria/selection");
var _react = require("react");
var _label = require("@react-aria/label");
var _interactions = require("@react-aria/interactions");
var _i18N = require("@react-aria/i18n");
const hookData = new WeakMap();
function useTagGroup(props, state, ref) {
    let { direction } = (0, _i18N.useLocale)();
    let keyboardDelegate = props.keyboardDelegate || new (0, _selection.ListKeyboardDelegate)({
        collection: state.collection,
        ref,
        orientation: 'horizontal',
        direction,
        disabledKeys: state.disabledKeys,
        disabledBehavior: state.selectionManager.disabledBehavior
    });
    let { labelProps, fieldProps, descriptionProps, errorMessageProps } = (0, _label.useField)({
        ...props,
        labelElementType: 'span'
    });
    let { gridProps } = (0, _gridlist.useGridList)({
        ...props,
        ...fieldProps,
        keyboardDelegate,
        shouldFocusWrap: true,
        linkBehavior: 'override',
        keyboardNavigationBehavior: 'tab'
    }, state, ref);
    let [isFocusWithin, setFocusWithin] = (0, _react.useState)(false);
    let { focusWithinProps } = (0, _interactions.useFocusWithin)({
        onFocusWithinChange: setFocusWithin
    });
    let domProps = (0, _utils.filterDOMProps)(props);
    // If the last tag is removed, focus the container.
    let prevCount = (0, _react.useRef)(state.collection.size);
    (0, _react.useEffect)(()=>{
        if (ref.current && prevCount.current > 0 && state.collection.size === 0 && isFocusWithin) ref.current.focus();
        prevCount.current = state.collection.size;
    }, [
        state.collection.size,
        isFocusWithin,
        ref
    ]);
    hookData.set(state, {
        onRemove: props.onRemove
    });
    return {
        gridProps: (0, _utils.mergeProps)(gridProps, domProps, {
            role: state.collection.size ? 'grid' : 'group',
            'aria-atomic': false,
            'aria-relevant': 'additions',
            'aria-live': isFocusWithin ? 'polite' : 'off',
            ...focusWithinProps,
            ...fieldProps
        }),
        labelProps,
        descriptionProps,
        errorMessageProps
    };
}

},{"@react-aria/gridlist":"1PPGS","@react-aria/utils":[["filterDOMProps","3upVm"],["mergeProps","aNvcY"]],"@react-aria/selection":"gVeiB","react":"a1TxN","@react-aria/label":"9u3SM","@react-aria/interactions":"8bxuk","@react-aria/i18n":"4k4z8","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kHvU9":[function(require,module,exports,__globalThis) {
const _temp0 = require("77a83ec7177562b0");
const _temp1 = require("a71334af04532c88");
const _temp2 = require("b58d6cdda251c3aa");
const _temp3 = require("5abe1fadd4060c75");
const _temp4 = require("d5e4b77bf8cbf1b6");
const _temp5 = require("af6c58bc4aa913a7");
const _temp6 = require("f80071ea6ea9b226");
const _temp7 = require("a07ea0970aff3a28");
const _temp8 = require("305f2330ff46db49");
const _temp9 = require("e2bb2af9b2caa9a7");
const _temp10 = require("96ef4cba68bc2904");
const _temp11 = require("4cfafc72815c42c7");
const _temp12 = require("162b3f6584de7098");
const _temp13 = require("c16a949c07d271bf");
const _temp14 = require("7264e6c6b58c6f21");
const _temp15 = require("cd4e4729b11ebb98");
const _temp16 = require("61c79efe9ef30034");
const _temp17 = require("8c93ae690903e0b7");
const _temp18 = require("9c868c06e19de608");
const _temp19 = require("6555bd162f92c26f");
const _temp20 = require("30a2cd82951abbdc");
const _temp21 = require("2c04b3171a74140f");
const _temp22 = require("78e0def959249052");
const _temp23 = require("de2f5a02362a9049");
const _temp24 = require("72d81f83b00a9fd4");
const _temp25 = require("72d103700fc3184c");
const _temp26 = require("570d9478465ab8ce");
const _temp27 = require("3817966d0f2826e1");
const _temp28 = require("18e95e32239fe4fb");
const _temp29 = require("3d146bae1547c210");
const _temp30 = require("39cf7bc86310651e");
const _temp31 = require("d670b4eaed1fdcb5");
const _temp32 = require("1dbec834c0dadd87");
const _temp33 = require("1cf998e47847bd6b");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"77a83ec7177562b0":"ctpKo","a71334af04532c88":"ctpKo","b58d6cdda251c3aa":"ctpKo","5abe1fadd4060c75":"ctpKo","d5e4b77bf8cbf1b6":"ctpKo","af6c58bc4aa913a7":"ctpKo","f80071ea6ea9b226":"6DIzC","a07ea0970aff3a28":"ctpKo","305f2330ff46db49":"ctpKo","e2bb2af9b2caa9a7":"ctpKo","96ef4cba68bc2904":"ctpKo","4cfafc72815c42c7":"ctpKo","162b3f6584de7098":"ctpKo","c16a949c07d271bf":"ctpKo","7264e6c6b58c6f21":"ctpKo","cd4e4729b11ebb98":"ctpKo","61c79efe9ef30034":"ctpKo","8c93ae690903e0b7":"ctpKo","9c868c06e19de608":"ctpKo","6555bd162f92c26f":"ctpKo","30a2cd82951abbdc":"ctpKo","2c04b3171a74140f":"ctpKo","78e0def959249052":"ctpKo","de2f5a02362a9049":"ctpKo","72d81f83b00a9fd4":"ctpKo","72d103700fc3184c":"ctpKo","570d9478465ab8ce":"ctpKo","3817966d0f2826e1":"ctpKo","18e95e32239fe4fb":"ctpKo","3d146bae1547c210":"ctpKo","39cf7bc86310651e":"ctpKo","d670b4eaed1fdcb5":"ctpKo","1dbec834c0dadd87":"ctpKo","1cf998e47847bd6b":"ctpKo"}],"6DIzC":[function(require,module,exports,__globalThis) {
module.exports = {
    "removeDescription": `Press Delete to remove tag.`,
    "removeButtonLabel": `Remove`
};

},{}],"jK89c":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimeFieldContext", ()=>TimeFieldContext);
parcelHelpers.export(exports, "TimeField", ()=>TimeField);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _dateField = require("./DateField");
var _field = require("./Field");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const TimeFieldContext = /*#__PURE__*/ (0, _react.createContext)(null);
const TimeField = /*#__PURE__*/ (0, _react.forwardRef)(function TimeField(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, TimeFieldContext);
    let { label, contextualHelp, description: descriptionMessage, errorMessage, isRequired, size = 'M', labelPosition = 'top', necessityIndicator, labelAlign = 'start', UNSAFE_style, UNSAFE_className, styles, ...timeFieldProps } = props;
    let formContext = (0, _react.useContext)((0, _reactAriaComponents.FormContext));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.TimeField), {
        ref: ref,
        isRequired: isRequired,
        ...timeFieldProps,
        style: UNSAFE_style,
        className: (UNSAFE_className || '') + function anonymous(props, overrides) {
            let rules = " ", currentRules = {};
            let gridColumnStart = false;
            let gridColumnEnd = false;
            let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L|-macro\$)[^\s]+/g);
            for (let p of matches){
                if (p[1] === "z") gridColumnStart = true;
                if (p[1] === "y") gridColumnEnd = true;
                rules += p[0];
            }
            rules += ' se12';
            currentRules["display"] = "grid";
            if (props.isInForm) {
                if (!gridColumnStart) rules += ' z2mU12';
                currentRules["gridColumnStart"] = typeof currentRules["gridColumnStart"] === 'object' ? currentRules["gridColumnStart"] : {
                    "default": currentRules["gridColumnStart"]
                };
                currentRules["gridColumnStart"]["isInForm"] = 1;
            }
            if (props.isInForm) {
                if (props.labelPosition === "side") {
                    if (!gridColumnEnd) rules += ' yvoofG12';
                    currentRules["gridColumnEnd"] = typeof currentRules["gridColumnEnd"] === 'object' ? currentRules["gridColumnEnd"] : {
                        "default": currentRules["gridColumnEnd"]
                    };
                    currentRules["gridColumnEnd"]["isInForm && labelPosition === \"side\""] = "span 2";
                }
            }
            if (props.isInForm) {
                rules += ' DLwlgod12';
                currentRules["gridTemplateColumns"] = typeof currentRules["gridTemplateColumns"] === 'object' ? currentRules["gridTemplateColumns"] : {
                    "default": currentRules["gridTemplateColumns"]
                };
                currentRules["gridTemplateColumns"]["isInForm"] = "subgrid";
            } else {
                if (props.labelPosition === "side") {
                    rules += ' DPlN5qb12';
                    currentRules["gridTemplateColumns"] = typeof currentRules["gridTemplateColumns"] === 'object' ? currentRules["gridTemplateColumns"] : {
                        "default": currentRules["gridTemplateColumns"]
                    };
                    currentRules["gridTemplateColumns"]["labelPosition === \"side\""] = [
                        "auto",
                        "1fr"
                    ];
                } else if (props.labelPosition === "top") {
                    rules += ' DM8Mfn12';
                    currentRules["gridTemplateColumns"] = typeof currentRules["gridTemplateColumns"] === 'object' ? currentRules["gridTemplateColumns"] : {
                        "default": currentRules["gridTemplateColumns"]
                    };
                    currentRules["gridTemplateColumns"]["labelPosition === \"top\""] = [
                        "1fr"
                    ];
                }
            }
            if (props.labelPosition === "side") {
                rules += ' EPlN5qb12';
                currentRules["gridTemplateRows"] = typeof currentRules["gridTemplateRows"] === 'object' ? currentRules["gridTemplateRows"] : {
                    "default": currentRules["gridTemplateRows"]
                };
                currentRules["gridTemplateRows"]["labelPosition === \"side\""] = [
                    "auto",
                    "1fr"
                ];
            } else if (props.labelPosition === "top") {
                rules += ' E4w1sLc12';
                currentRules["gridTemplateRows"] = typeof currentRules["gridTemplateRows"] === 'object' ? currentRules["gridTemplateRows"] : {
                    "default": currentRules["gridTemplateRows"]
                };
                currentRules["gridTemplateRows"]["labelPosition === \"top\""] = [
                    "auto",
                    "1fr",
                    "auto"
                ];
            }
            if (props.labelPosition === "side") {
                rules += ' CbRM95c12';
                currentRules["gridTemplateAreas"] = typeof currentRules["gridTemplateAreas"] === 'object' ? currentRules["gridTemplateAreas"] : {
                    "default": currentRules["gridTemplateAreas"]
                };
                currentRules["gridTemplateAreas"]["labelPosition === \"side\""] = [
                    "label input",
                    "label helptext"
                ];
            } else if (props.labelPosition === "top") {
                rules += ' Cxaocre12';
                currentRules["gridTemplateAreas"] = typeof currentRules["gridTemplateAreas"] === 'object' ? currentRules["gridTemplateAreas"] : {
                    "default": currentRules["gridTemplateAreas"]
                };
                currentRules["gridTemplateAreas"]["labelPosition === \"top\""] = [
                    "label",
                    "input",
                    "helptext"
                ];
            }
            if (props.size === "XL") {
                rules += ' -_6BNtrc-e12';
                currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
                    "default": currentRules["fontSize"]
                };
                currentRules["fontSize"]["size === \"XL\""] = "ui-xl";
                rules += ' vx12';
                currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
                    "default": currentRules["fontSize"]
                };
                currentRules["fontSize"]["size === \"XL\""] = "ui-xl";
            } else if (props.size === "L") {
                rules += ' -_6BNtrc-d12';
                currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
                    "default": currentRules["fontSize"]
                };
                currentRules["fontSize"]["size === \"L\""] = "ui-lg";
                rules += ' vx12';
                currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
                    "default": currentRules["fontSize"]
                };
                currentRules["fontSize"]["size === \"L\""] = "ui-lg";
            } else if (props.size === "S") {
                rules += ' -_6BNtrc-b12';
                currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
                    "default": currentRules["fontSize"]
                };
                currentRules["fontSize"]["size === \"S\""] = "ui-sm";
                rules += ' vx12';
                currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
                    "default": currentRules["fontSize"]
                };
                currentRules["fontSize"]["size === \"S\""] = "ui-sm";
            } else if (props.size === "XS") {
                rules += ' -_6BNtrc-a12';
                currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
                    "default": currentRules["fontSize"]
                };
                currentRules["fontSize"]["size === \"XS\""] = "ui-xs";
                rules += ' vx12';
                currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
                    "default": currentRules["fontSize"]
                };
                currentRules["fontSize"]["size === \"XS\""] = "ui-xs";
            } else {
                rules += ' -_6BNtrc-c12';
                currentRules["fontSize"] = "ui";
                rules += ' vx12';
                currentRules["fontSize"] = "ui";
            }
            rules += ' ea12';
            currentRules["alignItems"] = "baseline";
            rules += ' _Fd12';
            currentRules["lineHeight"] = "ui";
            rules += ' _FezxGHba12';
            currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
                "default": currentRules["lineHeight"]
            };
            currentRules["lineHeight"][":lang(ar, he)"] = "ui";
            rules += ' _FnuYUweb12';
            currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
                "default": currentRules["lineHeight"]
            };
            currentRules["lineHeight"][":lang(ja, ko, zh, zh-Hant, zh-Hans, zh-CN, zh-SG)"] = "ui";
            if (props.size === "XL") {
                rules += ' -BhX7R-Fz12';
                currentRules["--field-height"] = typeof currentRules["--field-height"] === 'object' ? currentRules["--field-height"] : {
                    "default": currentRules["--field-height"]
                };
                currentRules["--field-height"]["size === \"XL\""] = 48;
            } else if (props.size === "L") {
                rules += ' -BhX7R-Fv12';
                currentRules["--field-height"] = typeof currentRules["--field-height"] === 'object' ? currentRules["--field-height"] : {
                    "default": currentRules["--field-height"]
                };
                currentRules["--field-height"]["size === \"L\""] = 40;
            } else if (props.size === "S") {
                rules += ' -BhX7R-Fp12';
                currentRules["--field-height"] = typeof currentRules["--field-height"] === 'object' ? currentRules["--field-height"] : {
                    "default": currentRules["--field-height"]
                };
                currentRules["--field-height"]["size === \"S\""] = 24;
            } else if (props.size === "XS") {
                rules += ' -BhX7R-Fn12';
                currentRules["--field-height"] = typeof currentRules["--field-height"] === 'object' ? currentRules["--field-height"] : {
                    "default": currentRules["--field-height"]
                };
                currentRules["--field-height"]["size === \"XS\""] = 20;
            } else {
                rules += ' -BhX7R-Fx12';
                currentRules["--field-height"] = 32;
            }
            rules += ' -AJjOLd-UVkF0Db12';
            currentRules["--field-gap"] = "[calc((var(--field-height) - self(borderTopWidth, 0px) - self(borderBottomWidth, 0px) - 1lh) / 2)]";
            rules += ' qg12';
            currentRules["columnGap"] = 12;
            rules += ' __ca12';
            currentRules["disableTapHighlight"] = true;
            return rules;
        }({
            isInForm: !!formContext,
            labelPosition,
            size
        }, styles),
        children: ({ isDisabled, isInvalid })=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldLabel), {
                        isDisabled: isDisabled,
                        isRequired: isRequired,
                        size: size,
                        labelPosition: labelPosition,
                        labelAlign: labelAlign,
                        necessityIndicator: necessityIndicator,
                        contextualHelp: contextualHelp,
                        children: label
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _field.FieldGroup), {
                        role: "presentation",
                        isDisabled: isDisabled,
                        isInvalid: isInvalid,
                        size: size,
                        styles: function anonymous(props) {
                            let rules = " ", currentRules = {};
                            rules += ' zXcEWr12';
                            currentRules["gridColumnStart"] = "input";
                            rules += ' yXcEWr12';
                            currentRules["gridColumnEnd"] = "input";
                            rules += ' BXcEWr12';
                            currentRules["gridRowStart"] = "input";
                            rules += ' AXcEWr12';
                            currentRules["gridRowEnd"] = "input";
                            if (props.size === "XL") {
                                rules += ' Nl12';
                                currentRules["minWidth"] = typeof currentRules["minWidth"] === 'object' ? currentRules["minWidth"] : {
                                    "default": currentRules["minWidth"]
                                };
                                currentRules["minWidth"]["size === \"XL\""] = 48;
                            } else if (props.size === "L") {
                                rules += ' Nj12';
                                currentRules["minWidth"] = typeof currentRules["minWidth"] === 'object' ? currentRules["minWidth"] : {
                                    "default": currentRules["minWidth"]
                                };
                                currentRules["minWidth"]["size === \"L\""] = 40;
                            } else if (props.size === "S") {
                                rules += ' Nf12';
                                currentRules["minWidth"] = typeof currentRules["minWidth"] === 'object' ? currentRules["minWidth"] : {
                                    "default": currentRules["minWidth"]
                                };
                                currentRules["minWidth"]["size === \"S\""] = 24;
                            } else if (props.size === "XS") {
                                rules += ' Ne12';
                                currentRules["minWidth"] = typeof currentRules["minWidth"] === 'object' ? currentRules["minWidth"] : {
                                    "default": currentRules["minWidth"]
                                };
                                currentRules["minWidth"]["size === \"XS\""] = 20;
                            } else {
                                rules += ' Nk12';
                                currentRules["minWidth"] = 32;
                            }
                            if (props.isQuiet) {
                                rules += ' _qd12';
                                currentRules["contain"] = typeof currentRules["contain"] === 'object' ? currentRules["contain"] : {
                                    "default": currentRules["contain"]
                                };
                                currentRules["contain"]["isQuiet"] = "none";
                            } else {
                                rules += ' _qtb12';
                                currentRules["contain"] = typeof currentRules["contain"] === 'object' ? currentRules["contain"] : {
                                    "default": currentRules["contain"]
                                };
                                currentRules["contain"]["@supports (contain-intrinsic-width: 1px)"] = "inline-size";
                            }
                            if (props.size === "XL") {
                                rules += ' -Anxdcc-Zt12';
                                currentRules["--defaultWidth"] = typeof currentRules["--defaultWidth"] === 'object' ? currentRules["--defaultWidth"] : {
                                    "default": currentRules["--defaultWidth"]
                                };
                                currentRules["--defaultWidth"]["size === \"XL\""] = 240;
                            } else if (props.size === "L") {
                                rules += ' -Anxdcc-ZStdtne12';
                                currentRules["--defaultWidth"] = typeof currentRules["--defaultWidth"] === 'object' ? currentRules["--defaultWidth"] : {
                                    "default": currentRules["--defaultWidth"]
                                };
                                currentRules["--defaultWidth"]["size === \"L\""] = 224;
                            } else if (props.size === "S") {
                                rules += ' -Anxdcc-Zr12';
                                currentRules["--defaultWidth"] = typeof currentRules["--defaultWidth"] === 'object' ? currentRules["--defaultWidth"] : {
                                    "default": currentRules["--defaultWidth"]
                                };
                                currentRules["--defaultWidth"]["size === \"S\""] = 192;
                            } else {
                                rules += ' -Anxdcc-Z3fn9H12';
                                currentRules["--defaultWidth"] = 208;
                            }
                            rules += ' __v6TNLWb12';
                            currentRules["containIntrinsicWidth"] = "calc(var(--defaultWidth) - self(paddingStart, 0px) - self(paddingEnd, 0px) - self(borderStartWidth, 0px) - self(borderEndWidth, 0px))";
                            rules += ' SMBFGYc12';
                            rules += ' RfBFGYc12';
                            rules += ' -S_-Sv12';
                            currentRules["paddingStart"] = "edge-to-text";
                            rules += ' -R_-Rv12';
                            currentRules["paddingEnd"] = "edge-to-text";
                            return rules;
                        }({
                            size
                        }),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateField.DateInputContainer), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateField.DateInput), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateField.InvalidIndicator), {
                                isInvalid: isInvalid,
                                isDisabled: isDisabled
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.HelpText), {
                        size: size,
                        isDisabled: isDisabled,
                        isInvalid: isInvalid,
                        description: descriptionMessage,
                        children: errorMessage
                    })
                ]
            });
        }
    });
});

},{"0":"chKdZ","1":"25K8F","react/jsx-runtime":"2Is6Z","react-aria-components":[["FormContext","g7RKA"],["TimeField","5wv9P"]],"react":"a1TxN","./DateField":"l2Cjd","./Field":"eI7CE","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"chKdZ":[function() {},{}],"25K8F":[function() {},{}],"l2Cjd":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateFieldContext", ()=>DateFieldContext);
parcelHelpers.export(exports, "DateField", ()=>DateField);
parcelHelpers.export(exports, "DateInputContainer", ()=>DateInputContainer);
parcelHelpers.export(exports, "DateInput", ()=>DateInput);
parcelHelpers.export(exports, "InvalidIndicator", ()=>InvalidIndicator);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _field = require("./Field");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const DateFieldContext = /*#__PURE__*/ (0, _react.createContext)(null);
const segmentContainer = " _ub12 _vb12 Na12 Fb12 _Nc12 Pc12 sd12 eb12 __Wb12";
const dateSegment = function anonymous(props) {
    let rules = " ", currentRules = {};
    rules += ' _Le12';
    currentRules["outlineStyle"] = "none";
    rules += ' -zNggOc-RWHrbc12';
    currentRules["caretColor"] = "transparent";
    if (props.isFocused) {
        rules += ' g_h12';
        currentRules["backgroundColor"] = typeof currentRules["backgroundColor"] === 'object' ? currentRules["backgroundColor"] : {
            "default": currentRules["backgroundColor"]
        };
        currentRules["backgroundColor"]["isFocused"] = "blue-800";
    } else {
        rules += ' g912';
        currentRules["backgroundColor"] = "transparent";
    }
    if (props.isFocused) {
        rules += ' gle12';
        currentRules["backgroundColor"] = typeof currentRules["backgroundColor"] === 'object' ? currentRules["backgroundColor"] : {
            "default": currentRules["backgroundColor"]
        };
        currentRules["backgroundColor"]["forcedColors && isFocused"] = "Highlight";
    } else {
        rules += ' gl912';
        currentRules["backgroundColor"] = typeof currentRules["backgroundColor"] === 'object' ? currentRules["backgroundColor"] : {
            "default": currentRules["backgroundColor"]
        };
        currentRules["backgroundColor"]["forcedColors"] = "transparent";
    }
    if (props.isFocused) {
        rules += ' px12';
        currentRules["color"] = typeof currentRules["color"] === 'object' ? currentRules["color"] : {
            "default": currentRules["color"]
        };
        currentRules["color"]["isFocused"] = "white";
    }
    if (props.isFocused) {
        rules += ' ple12';
        currentRules["color"] = typeof currentRules["color"] === 'object' ? currentRules["color"] : {
            "default": currentRules["color"]
        };
        currentRules["color"]["forcedColors && isFocused"] = "HighlightText";
    }
    rules += ' oLvNfn12';
    currentRules["borderTopStartRadius"] = "[2px]";
    rules += ' nLvNfn12';
    currentRules["borderTopEndRadius"] = "[2px]";
    rules += ' kLvNfn12';
    currentRules["borderBottomStartRadius"] = "[2px]";
    rules += ' jLvNfn12';
    currentRules["borderBottomEndRadius"] = "[2px]";
    if (props.isPunctuation) {
        rules += ' Sd12';
        currentRules["paddingStart"] = typeof currentRules["paddingStart"] === 'object' ? currentRules["paddingStart"] : {
            "default": currentRules["paddingStart"]
        };
        currentRules["paddingStart"]["isPunctuation"] = 0;
    } else {
        rules += ' Sj12';
        currentRules["paddingStart"] = 2;
    }
    if (props.isPunctuation) {
        rules += ' Rd12';
        currentRules["paddingEnd"] = typeof currentRules["paddingEnd"] === 'object' ? currentRules["paddingEnd"] : {
            "default": currentRules["paddingEnd"]
        };
        currentRules["paddingEnd"]["isPunctuation"] = 0;
    } else {
        rules += ' Rj12';
        currentRules["paddingEnd"] = 2;
    }
    rules += ' Tj12';
    currentRules["paddingTop"] = 2;
    rules += ' Qj12';
    currentRules["paddingBottom"] = 2;
    rules += ' _yb12';
    currentRules["forcedColorAdjust"] = "none";
    return rules;
};
const iconStyles = " sd12 eb12 _Cb12";
const DateField = /*#__PURE__*/ (0, _react.forwardRef)(function DateField(props1, ref) {
    [props1, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props1, ref, DateFieldContext);
    let { label, contextualHelp, description: descriptionMessage, errorMessage, isRequired, size = 'M', labelPosition = 'top', necessityIndicator, labelAlign = 'start', UNSAFE_style, UNSAFE_className, styles, ...dateFieldProps } = props1;
    let formContext = (0, _react.useContext)((0, _reactAriaComponents.FormContext));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.DateField), {
        ref: ref,
        isRequired: isRequired,
        ...dateFieldProps,
        style: UNSAFE_style,
        className: (UNSAFE_className || '') + function anonymous(props, overrides) {
            let rules = " ", currentRules = {};
            let gridColumnStart = false;
            let gridColumnEnd = false;
            let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L|-macro\$)[^\s]+/g);
            for (let p of matches){
                if (p[1] === "z") gridColumnStart = true;
                if (p[1] === "y") gridColumnEnd = true;
                rules += p[0];
            }
            rules += ' se12';
            currentRules["display"] = "grid";
            if (props.isInForm) {
                if (!gridColumnStart) rules += ' z2mU12';
                currentRules["gridColumnStart"] = typeof currentRules["gridColumnStart"] === 'object' ? currentRules["gridColumnStart"] : {
                    "default": currentRules["gridColumnStart"]
                };
                currentRules["gridColumnStart"]["isInForm"] = 1;
            }
            if (props.isInForm) {
                if (props.labelPosition === "side") {
                    if (!gridColumnEnd) rules += ' yvoofG12';
                    currentRules["gridColumnEnd"] = typeof currentRules["gridColumnEnd"] === 'object' ? currentRules["gridColumnEnd"] : {
                        "default": currentRules["gridColumnEnd"]
                    };
                    currentRules["gridColumnEnd"]["isInForm && labelPosition === \"side\""] = "span 2";
                }
            }
            if (props.isInForm) {
                rules += ' DLwlgod12';
                currentRules["gridTemplateColumns"] = typeof currentRules["gridTemplateColumns"] === 'object' ? currentRules["gridTemplateColumns"] : {
                    "default": currentRules["gridTemplateColumns"]
                };
                currentRules["gridTemplateColumns"]["isInForm"] = "subgrid";
            } else {
                if (props.labelPosition === "side") {
                    rules += ' DPlN5qb12';
                    currentRules["gridTemplateColumns"] = typeof currentRules["gridTemplateColumns"] === 'object' ? currentRules["gridTemplateColumns"] : {
                        "default": currentRules["gridTemplateColumns"]
                    };
                    currentRules["gridTemplateColumns"]["labelPosition === \"side\""] = [
                        "auto",
                        "1fr"
                    ];
                } else if (props.labelPosition === "top") {
                    rules += ' DM8Mfn12';
                    currentRules["gridTemplateColumns"] = typeof currentRules["gridTemplateColumns"] === 'object' ? currentRules["gridTemplateColumns"] : {
                        "default": currentRules["gridTemplateColumns"]
                    };
                    currentRules["gridTemplateColumns"]["labelPosition === \"top\""] = [
                        "1fr"
                    ];
                }
            }
            if (props.labelPosition === "side") {
                rules += ' EPlN5qb12';
                currentRules["gridTemplateRows"] = typeof currentRules["gridTemplateRows"] === 'object' ? currentRules["gridTemplateRows"] : {
                    "default": currentRules["gridTemplateRows"]
                };
                currentRules["gridTemplateRows"]["labelPosition === \"side\""] = [
                    "auto",
                    "1fr"
                ];
            } else if (props.labelPosition === "top") {
                rules += ' E4w1sLc12';
                currentRules["gridTemplateRows"] = typeof currentRules["gridTemplateRows"] === 'object' ? currentRules["gridTemplateRows"] : {
                    "default": currentRules["gridTemplateRows"]
                };
                currentRules["gridTemplateRows"]["labelPosition === \"top\""] = [
                    "auto",
                    "1fr",
                    "auto"
                ];
            }
            if (props.labelPosition === "side") {
                rules += ' CbRM95c12';
                currentRules["gridTemplateAreas"] = typeof currentRules["gridTemplateAreas"] === 'object' ? currentRules["gridTemplateAreas"] : {
                    "default": currentRules["gridTemplateAreas"]
                };
                currentRules["gridTemplateAreas"]["labelPosition === \"side\""] = [
                    "label input",
                    "label helptext"
                ];
            } else if (props.labelPosition === "top") {
                rules += ' Cxaocre12';
                currentRules["gridTemplateAreas"] = typeof currentRules["gridTemplateAreas"] === 'object' ? currentRules["gridTemplateAreas"] : {
                    "default": currentRules["gridTemplateAreas"]
                };
                currentRules["gridTemplateAreas"]["labelPosition === \"top\""] = [
                    "label",
                    "input",
                    "helptext"
                ];
            }
            if (props.size === "XL") {
                rules += ' -_6BNtrc-e12';
                currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
                    "default": currentRules["fontSize"]
                };
                currentRules["fontSize"]["size === \"XL\""] = "ui-xl";
                rules += ' vx12';
                currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
                    "default": currentRules["fontSize"]
                };
                currentRules["fontSize"]["size === \"XL\""] = "ui-xl";
            } else if (props.size === "L") {
                rules += ' -_6BNtrc-d12';
                currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
                    "default": currentRules["fontSize"]
                };
                currentRules["fontSize"]["size === \"L\""] = "ui-lg";
                rules += ' vx12';
                currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
                    "default": currentRules["fontSize"]
                };
                currentRules["fontSize"]["size === \"L\""] = "ui-lg";
            } else if (props.size === "S") {
                rules += ' -_6BNtrc-b12';
                currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
                    "default": currentRules["fontSize"]
                };
                currentRules["fontSize"]["size === \"S\""] = "ui-sm";
                rules += ' vx12';
                currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
                    "default": currentRules["fontSize"]
                };
                currentRules["fontSize"]["size === \"S\""] = "ui-sm";
            } else if (props.size === "XS") {
                rules += ' -_6BNtrc-a12';
                currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
                    "default": currentRules["fontSize"]
                };
                currentRules["fontSize"]["size === \"XS\""] = "ui-xs";
                rules += ' vx12';
                currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
                    "default": currentRules["fontSize"]
                };
                currentRules["fontSize"]["size === \"XS\""] = "ui-xs";
            } else {
                rules += ' -_6BNtrc-c12';
                currentRules["fontSize"] = "ui";
                rules += ' vx12';
                currentRules["fontSize"] = "ui";
            }
            rules += ' ea12';
            currentRules["alignItems"] = "baseline";
            rules += ' _Fd12';
            currentRules["lineHeight"] = "ui";
            rules += ' _FezxGHba12';
            currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
                "default": currentRules["lineHeight"]
            };
            currentRules["lineHeight"][":lang(ar, he)"] = "ui";
            rules += ' _FnuYUweb12';
            currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
                "default": currentRules["lineHeight"]
            };
            currentRules["lineHeight"][":lang(ja, ko, zh, zh-Hant, zh-Hans, zh-CN, zh-SG)"] = "ui";
            if (props.size === "XL") {
                rules += ' -BhX7R-Fz12';
                currentRules["--field-height"] = typeof currentRules["--field-height"] === 'object' ? currentRules["--field-height"] : {
                    "default": currentRules["--field-height"]
                };
                currentRules["--field-height"]["size === \"XL\""] = 48;
            } else if (props.size === "L") {
                rules += ' -BhX7R-Fv12';
                currentRules["--field-height"] = typeof currentRules["--field-height"] === 'object' ? currentRules["--field-height"] : {
                    "default": currentRules["--field-height"]
                };
                currentRules["--field-height"]["size === \"L\""] = 40;
            } else if (props.size === "S") {
                rules += ' -BhX7R-Fp12';
                currentRules["--field-height"] = typeof currentRules["--field-height"] === 'object' ? currentRules["--field-height"] : {
                    "default": currentRules["--field-height"]
                };
                currentRules["--field-height"]["size === \"S\""] = 24;
            } else if (props.size === "XS") {
                rules += ' -BhX7R-Fn12';
                currentRules["--field-height"] = typeof currentRules["--field-height"] === 'object' ? currentRules["--field-height"] : {
                    "default": currentRules["--field-height"]
                };
                currentRules["--field-height"]["size === \"XS\""] = 20;
            } else {
                rules += ' -BhX7R-Fx12';
                currentRules["--field-height"] = 32;
            }
            rules += ' -AJjOLd-UVkF0Db12';
            currentRules["--field-gap"] = "[calc((var(--field-height) - self(borderTopWidth, 0px) - self(borderBottomWidth, 0px) - 1lh) / 2)]";
            rules += ' qg12';
            currentRules["columnGap"] = 12;
            rules += ' __ca12';
            currentRules["disableTapHighlight"] = true;
            return rules;
        }({
            isInForm: !!formContext,
            labelPosition,
            size
        }, styles),
        children: ({ isDisabled, isInvalid })=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldLabel), {
                        isDisabled: isDisabled,
                        isRequired: isRequired,
                        size: size,
                        labelPosition: labelPosition,
                        labelAlign: labelAlign,
                        necessityIndicator: necessityIndicator,
                        contextualHelp: contextualHelp,
                        children: label
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _field.FieldGroup), {
                        role: "presentation",
                        isDisabled: isDisabled,
                        isInvalid: isInvalid,
                        size: size,
                        styles: function anonymous(props) {
                            let rules = " ", currentRules = {};
                            rules += ' zXcEWr12';
                            currentRules["gridColumnStart"] = "input";
                            rules += ' yXcEWr12';
                            currentRules["gridColumnEnd"] = "input";
                            rules += ' BXcEWr12';
                            currentRules["gridRowStart"] = "input";
                            rules += ' AXcEWr12';
                            currentRules["gridRowEnd"] = "input";
                            if (props.size === "XL") {
                                rules += ' Nl12';
                                currentRules["minWidth"] = typeof currentRules["minWidth"] === 'object' ? currentRules["minWidth"] : {
                                    "default": currentRules["minWidth"]
                                };
                                currentRules["minWidth"]["size === \"XL\""] = 48;
                            } else if (props.size === "L") {
                                rules += ' Nj12';
                                currentRules["minWidth"] = typeof currentRules["minWidth"] === 'object' ? currentRules["minWidth"] : {
                                    "default": currentRules["minWidth"]
                                };
                                currentRules["minWidth"]["size === \"L\""] = 40;
                            } else if (props.size === "S") {
                                rules += ' Nf12';
                                currentRules["minWidth"] = typeof currentRules["minWidth"] === 'object' ? currentRules["minWidth"] : {
                                    "default": currentRules["minWidth"]
                                };
                                currentRules["minWidth"]["size === \"S\""] = 24;
                            } else if (props.size === "XS") {
                                rules += ' Ne12';
                                currentRules["minWidth"] = typeof currentRules["minWidth"] === 'object' ? currentRules["minWidth"] : {
                                    "default": currentRules["minWidth"]
                                };
                                currentRules["minWidth"]["size === \"XS\""] = 20;
                            } else {
                                rules += ' Nk12';
                                currentRules["minWidth"] = 32;
                            }
                            if (props.isQuiet) {
                                rules += ' _qd12';
                                currentRules["contain"] = typeof currentRules["contain"] === 'object' ? currentRules["contain"] : {
                                    "default": currentRules["contain"]
                                };
                                currentRules["contain"]["isQuiet"] = "none";
                            } else {
                                rules += ' _qtb12';
                                currentRules["contain"] = typeof currentRules["contain"] === 'object' ? currentRules["contain"] : {
                                    "default": currentRules["contain"]
                                };
                                currentRules["contain"]["@supports (contain-intrinsic-width: 1px)"] = "inline-size";
                            }
                            if (props.size === "XL") {
                                rules += ' -Anxdcc-Zt12';
                                currentRules["--defaultWidth"] = typeof currentRules["--defaultWidth"] === 'object' ? currentRules["--defaultWidth"] : {
                                    "default": currentRules["--defaultWidth"]
                                };
                                currentRules["--defaultWidth"]["size === \"XL\""] = 240;
                            } else if (props.size === "L") {
                                rules += ' -Anxdcc-ZStdtne12';
                                currentRules["--defaultWidth"] = typeof currentRules["--defaultWidth"] === 'object' ? currentRules["--defaultWidth"] : {
                                    "default": currentRules["--defaultWidth"]
                                };
                                currentRules["--defaultWidth"]["size === \"L\""] = 224;
                            } else if (props.size === "S") {
                                rules += ' -Anxdcc-Zr12';
                                currentRules["--defaultWidth"] = typeof currentRules["--defaultWidth"] === 'object' ? currentRules["--defaultWidth"] : {
                                    "default": currentRules["--defaultWidth"]
                                };
                                currentRules["--defaultWidth"]["size === \"S\""] = 192;
                            } else {
                                rules += ' -Anxdcc-Z3fn9H12';
                                currentRules["--defaultWidth"] = 208;
                            }
                            rules += ' __v6TNLWb12';
                            currentRules["containIntrinsicWidth"] = "calc(var(--defaultWidth) - self(paddingStart, 0px) - self(paddingEnd, 0px) - self(borderStartWidth, 0px) - self(borderEndWidth, 0px))";
                            rules += ' SMBFGYc12';
                            rules += ' RfBFGYc12';
                            rules += ' -S_-Sv12';
                            currentRules["paddingStart"] = "edge-to-text";
                            rules += ' -R_-Rv12';
                            currentRules["paddingEnd"] = "edge-to-text";
                            return rules;
                        }({
                            size
                        }),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(DateInputContainer, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DateInput, {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(InvalidIndicator, {
                                isInvalid: isInvalid,
                                isDisabled: isDisabled
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.HelpText), {
                        size: size,
                        isDisabled: isDisabled,
                        isInvalid: isInvalid,
                        description: descriptionMessage,
                        children: errorMessage
                    })
                ]
            });
        }
    });
});
function DateInputContainer(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: segmentContainer,
        children: props.children
    });
}
function DateInput(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.DateInput), {
        ...props,
        children: (segment)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.DateSegment), {
                segment: segment,
                className: (renderProps)=>dateSegment({
                        ...renderProps,
                        isPunctuation: segment.type === 'literal'
                    })
            })
    });
}
function InvalidIndicator(props) {
    return props.isInvalid ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: iconStyles,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldErrorIcon), {
            isDisabled: props.isDisabled
        })
    }) : null;
}

},{"0":"2ueem","1":"8ZPUF","2":"iADjS","3":"5blUZ","4":"bw8YO","react/jsx-runtime":"2Is6Z","react-aria-components":[["DateField","5wv9P"],["DateInput","5wv9P"],["DateSegment","5wv9P"],["FormContext","g7RKA"]],"react":"a1TxN","./Field":"eI7CE","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2ueem":[function() {},{}],"8ZPUF":[function() {},{}],"iADjS":[function() {},{}],"5blUZ":[function() {},{}],"bw8YO":[function() {},{}],"4kPrI":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RadioGroupContext", ()=>RadioGroupContext);
parcelHelpers.export(exports, "RadioContext", ()=>RadioContext);
parcelHelpers.export(exports, "RadioGroupStateContext", ()=>RadioGroupStateContext);
parcelHelpers.export(exports, "RadioGroup", ()=>RadioGroup);
parcelHelpers.export(exports, "Radio", ()=>Radio);
var _reactAria = require("react-aria");
var _utils = require("./utils");
var _fieldError = require("./FieldError");
var _utils1 = require("@react-aria/utils");
var _form = require("./Form");
var _label = require("./Label");
var _reactStately = require("react-stately");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _selectionIndicator = require("./SelectionIndicator");
var _sharedElementTransition = require("./SharedElementTransition");
var _text = require("./Text");
const RadioGroupContext = /*#__PURE__*/ (0, _react.createContext)(null);
const RadioContext = /*#__PURE__*/ (0, _react.createContext)(null);
const RadioGroupStateContext = /*#__PURE__*/ (0, _react.createContext)(null);
const RadioGroup = /*#__PURE__*/ (0, _react.forwardRef)(function RadioGroup(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, RadioGroupContext);
    let { validationBehavior: formValidationBehavior } = (0, _utils.useSlottedContext)((0, _form.FormContext)) || {};
    let validationBehavior = props.validationBehavior ?? formValidationBehavior ?? 'native';
    let state = (0, _reactStately.useRadioGroupState)({
        ...props,
        validationBehavior
    });
    let [labelRef, label] = (0, _utils.useSlot)(!props['aria-label'] && !props['aria-labelledby']);
    let { radioGroupProps, labelProps, descriptionProps, errorMessageProps, ...validation } = (0, _reactAria.useRadioGroup)({
        ...props,
        label,
        validationBehavior
    }, state);
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        values: {
            orientation: props.orientation || 'vertical',
            isDisabled: state.isDisabled,
            isReadOnly: state.isReadOnly,
            isRequired: state.isRequired,
            isInvalid: state.isInvalid,
            state
        },
        defaultClassName: 'react-aria-RadioGroup'
    });
    let DOMProps = (0, _utils1.filterDOMProps)(props, {
        global: true
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...(0, _utils1.mergeProps)(DOMProps, renderProps, radioGroupProps),
        ref: ref,
        slot: props.slot || undefined,
        "data-orientation": props.orientation || 'vertical',
        "data-invalid": state.isInvalid || undefined,
        "data-disabled": state.isDisabled || undefined,
        "data-readonly": state.isReadOnly || undefined,
        "data-required": state.isRequired || undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                RadioGroupStateContext,
                state
            ],
            [
                (0, _label.LabelContext),
                {
                    ...labelProps,
                    ref: labelRef,
                    elementType: 'span'
                }
            ],
            [
                (0, _text.TextContext),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ],
            [
                (0, _fieldError.FieldErrorContext),
                validation
            ]
        ]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _sharedElementTransition.SharedElementTransition), null, renderProps.children)));
});
const Radio = /*#__PURE__*/ (0, _react.forwardRef)(function Radio(props, ref) {
    let { inputRef: userProvidedInputRef = null, ...otherProps } = props;
    [props, ref] = (0, _utils.useContextProps)(otherProps, ref, RadioContext);
    let state = (0, _reactDefault.default).useContext(RadioGroupStateContext);
    let inputRef = (0, _utils1.useObjectRef)((0, _react.useMemo)(()=>(0, _utils1.mergeRefs)(userProvidedInputRef, props.inputRef !== undefined ? props.inputRef : null), [
        userProvidedInputRef,
        props.inputRef
    ]));
    let { labelProps, inputProps, isSelected, isDisabled, isPressed } = (0, _reactAria.useRadio)({
        ...(0, _utils.removeDataAttributes)(props),
        // ReactNode type doesn't allow function children.
        children: typeof props.children === 'function' ? true : props.children
    }, state, inputRef);
    let { isFocused, isFocusVisible, focusProps } = (0, _reactAria.useFocusRing)();
    let interactionDisabled = isDisabled || state.isReadOnly;
    let { hoverProps, isHovered } = (0, _reactAria.useHover)({
        ...props,
        isDisabled: interactionDisabled
    });
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        defaultClassName: 'react-aria-Radio',
        values: {
            isSelected,
            isPressed,
            isHovered,
            isFocused,
            isFocusVisible,
            isDisabled,
            isReadOnly: state.isReadOnly,
            isInvalid: state.isInvalid,
            isRequired: state.isRequired
        }
    });
    let DOMProps = (0, _utils1.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    delete DOMProps.onClick;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("label", {
        ...(0, _utils1.mergeProps)(DOMProps, labelProps, hoverProps, renderProps),
        ref: ref,
        "data-selected": isSelected || undefined,
        "data-pressed": isPressed || undefined,
        "data-hovered": isHovered || undefined,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-disabled": isDisabled || undefined,
        "data-readonly": state.isReadOnly || undefined,
        "data-invalid": state.isInvalid || undefined,
        "data-required": state.isRequired || undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactAria.VisuallyHidden), {
        elementType: "span"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        ...(0, _utils1.mergeProps)(inputProps, focusProps),
        ref: inputRef
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _selectionIndicator.SelectionIndicatorContext).Provider, {
        value: {
            isSelected
        }
    }, renderProps.children));
});

},{"react-aria":[["useFocusRing","6TXyU"],["useHover","k6FLA"],["useRadio","lUPom"],["useRadioGroup","42ODK"],["VisuallyHidden","7zrGr"]],"./utils":"bA6Cz","./FieldError":"algyu","@react-aria/utils":[["filterDOMProps","3upVm"],["mergeProps","aNvcY"],["mergeRefs","1vHgg"],["useObjectRef","laqO5"]],"./Form":"g7RKA","./Label":"fjKq6","react-stately":"9P3yJ","react":"a1TxN","./SelectionIndicator":"dgQU7","./SharedElementTransition":"iVZnk","./Text":"jt9fm","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"lUPom":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for an individual
 * radio button in a radio group.
 * @param props - Props for the radio.
 * @param state - State for the radio group, as returned by `useRadioGroupState`.
 * @param ref - Ref to the HTML input element.
 */ parcelHelpers.export(exports, "useRadio", ()=>useRadio);
var _utils = require("@react-aria/utils");
var _react = require("react");
var _utils1 = require("./utils");
var _interactions = require("@react-aria/interactions");
var _form = require("@react-aria/form");
function useRadio(props, state, ref) {
    let { value, children, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledby, onPressStart, onPressEnd, onPressChange, onPress, onPressUp, onClick } = props;
    const isDisabled = props.isDisabled || state.isDisabled;
    let hasChildren = children != null;
    let hasAriaLabel = ariaLabel != null || ariaLabelledby != null;
    !hasChildren && hasAriaLabel;
    let checked = state.selectedValue === value;
    let onChange = (e)=>{
        e.stopPropagation();
        state.setSelectedValue(value);
    };
    // Handle press state for keyboard interactions and cases where labelProps is not used.
    let { pressProps, isPressed } = (0, _interactions.usePress)({
        onPressStart,
        onPressEnd,
        onPressChange,
        onPress,
        onPressUp,
        onClick,
        isDisabled
    });
    // Handle press state on the label.
    let { pressProps: labelProps, isPressed: isLabelPressed } = (0, _interactions.usePress)({
        onPressStart,
        onPressEnd,
        onPressChange,
        onPressUp,
        onClick,
        isDisabled,
        onPress (e) {
            onPress?.(e);
            state.setSelectedValue(value);
            ref.current?.focus();
        }
    });
    let { focusableProps } = (0, _interactions.useFocusable)((0, _utils.mergeProps)(props, {
        onFocus: ()=>state.setLastFocusedValue(value)
    }), ref);
    let interactions = (0, _utils.mergeProps)(pressProps, focusableProps);
    let domProps = (0, _utils.filterDOMProps)(props, {
        labelable: true
    });
    let tabIndex = -1;
    if (state.selectedValue != null) {
        if (state.selectedValue === value) tabIndex = 0;
    } else if (state.lastFocusedValue === value || state.lastFocusedValue == null) tabIndex = 0;
    if (isDisabled) tabIndex = undefined;
    let { name, form, descriptionId, errorMessageId, validationBehavior } = (0, _utils1.radioGroupData).get(state);
    (0, _utils.useFormReset)(ref, state.defaultSelectedValue, state.setSelectedValue);
    (0, _form.useFormValidation)({
        validationBehavior
    }, state, ref);
    return {
        labelProps: (0, _utils.mergeProps)(labelProps, (0, _react.useMemo)(()=>({
                onClick: (e)=>e.preventDefault(),
                // Prevent label from being focused when mouse down on it.
                // Note, this does not prevent the input from being focused in the `click` event.
                onMouseDown: (e)=>e.preventDefault()
            }), [])),
        inputProps: (0, _utils.mergeProps)(domProps, {
            ...interactions,
            type: 'radio',
            name,
            form,
            tabIndex,
            disabled: isDisabled,
            required: state.isRequired && validationBehavior === 'native',
            checked,
            value,
            onChange,
            'aria-describedby': [
                props['aria-describedby'],
                state.isInvalid ? errorMessageId : null,
                descriptionId
            ].filter(Boolean).join(' ') || undefined
        }),
        isDisabled,
        isSelected: checked,
        isPressed: isPressed || isLabelPressed
    };
}

},{"@react-aria/utils":[["filterDOMProps","3upVm"],["mergeProps","aNvcY"],["useFormReset","dwBOx"]],"react":"a1TxN","./utils":"1WKSm","@react-aria/interactions":[["useFocusable","kCQqy"],["usePress","ckRNv"]],"@react-aria/form":"dKOez","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1WKSm":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "radioGroupData", ()=>radioGroupData);
const radioGroupData = new WeakMap();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"42ODK":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a radio group component.
 * Radio groups allow users to select a single item from a list of mutually exclusive options.
 * @param props - Props for the radio group.
 * @param state - State for the radio group, as returned by `useRadioGroupState`.
 */ parcelHelpers.export(exports, "useRadioGroup", ()=>useRadioGroup);
var _utils = require("@react-aria/utils");
var _focus = require("@react-aria/focus");
var _utils1 = require("./utils");
var _label = require("@react-aria/label");
var _interactions = require("@react-aria/interactions");
var _i18N = require("@react-aria/i18n");
function useRadioGroup(props, state) {
    let { name, form, isReadOnly, isRequired, isDisabled, orientation = 'vertical', validationBehavior = 'aria' } = props;
    let { direction } = (0, _i18N.useLocale)();
    let { isInvalid, validationErrors, validationDetails } = state.displayValidation;
    let { labelProps, fieldProps, descriptionProps, errorMessageProps } = (0, _label.useField)({
        ...props,
        // Radio group is not an HTML input element so it
        // shouldn't be labeled by a <label> element.
        labelElementType: 'span',
        isInvalid: state.isInvalid,
        errorMessage: props.errorMessage || validationErrors
    });
    let domProps = (0, _utils.filterDOMProps)(props, {
        labelable: true
    });
    // When the radio group loses focus, reset the focusable radio to null if
    // there is no selection. This allows tabbing into the group from either
    // direction to go to the first or last radio.
    let { focusWithinProps } = (0, _interactions.useFocusWithin)({
        onBlurWithin (e) {
            props.onBlur?.(e);
            if (!state.selectedValue) state.setLastFocusedValue(null);
        },
        onFocusWithin: props.onFocus,
        onFocusWithinChange: props.onFocusChange
    });
    let onKeyDown = (e)=>{
        let nextDir;
        switch(e.key){
            case 'ArrowRight':
                if (direction === 'rtl' && orientation !== 'vertical') nextDir = 'prev';
                else nextDir = 'next';
                break;
            case 'ArrowLeft':
                if (direction === 'rtl' && orientation !== 'vertical') nextDir = 'next';
                else nextDir = 'prev';
                break;
            case 'ArrowDown':
                nextDir = 'next';
                break;
            case 'ArrowUp':
                nextDir = 'prev';
                break;
            default:
                return;
        }
        e.preventDefault();
        let walker = (0, _focus.getFocusableTreeWalker)(e.currentTarget, {
            from: e.target,
            accept: (node)=>node instanceof (0, _utils.getOwnerWindow)(node).HTMLInputElement && node.type === 'radio'
        });
        let nextElem;
        if (nextDir === 'next') {
            nextElem = walker.nextNode();
            if (!nextElem) {
                walker.currentNode = e.currentTarget;
                nextElem = walker.firstChild();
            }
        } else {
            nextElem = walker.previousNode();
            if (!nextElem) {
                walker.currentNode = e.currentTarget;
                nextElem = walker.lastChild();
            }
        }
        if (nextElem) {
            // Call focus on nextElem so that keyboard navigation scrolls the radio into view
            nextElem.focus();
            state.setSelectedValue(nextElem.value);
        }
    };
    let groupName = (0, _utils.useId)(name);
    (0, _utils1.radioGroupData).set(state, {
        name: groupName,
        form,
        descriptionId: descriptionProps.id,
        errorMessageId: errorMessageProps.id,
        validationBehavior
    });
    return {
        radioGroupProps: (0, _utils.mergeProps)(domProps, {
            // https://www.w3.org/TR/wai-aria-1.2/#radiogroup
            role: 'radiogroup',
            onKeyDown,
            'aria-invalid': state.isInvalid || undefined,
            'aria-errormessage': props['aria-errormessage'],
            'aria-readonly': isReadOnly || undefined,
            'aria-required': isRequired || undefined,
            'aria-disabled': isDisabled || undefined,
            'aria-orientation': orientation,
            ...fieldProps,
            ...focusWithinProps
        }),
        labelProps,
        descriptionProps,
        errorMessageProps,
        isInvalid,
        validationErrors,
        validationDetails
    };
}

},{"@react-aria/utils":[["filterDOMProps","3upVm"],["getOwnerWindow","fioCG"],["mergeProps","aNvcY"],["useId","jbI4Y"]],"@react-aria/focus":"9oPIl","./utils":"1WKSm","@react-aria/label":"9u3SM","@react-aria/interactions":"8bxuk","@react-aria/i18n":"4k4z8","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9P3yJ":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides state management for a radio group component. Provides a name for the group,
 * and manages selection and focus state.
 */ parcelHelpers.export(exports, "useRadioGroupState", ()=>useRadioGroupState);
var _form = require("@react-stately/form");
var _utils = require("@react-stately/utils");
var _react = require("react");
let instance = Math.round(Math.random() * 10000000000);
let i = 0;
function useRadioGroupState(props) {
    // Preserved here for backward compatibility. React Aria now generates the name instead of stately.
    let name = (0, _react.useMemo)(()=>props.name || `radio-group-${instance}-${++i}`, [
        props.name
    ]);
    let [selectedValue, setSelected] = (0, _utils.useControlledState)(props.value, props.defaultValue ?? null, props.onChange);
    let [initialValue] = (0, _react.useState)(selectedValue);
    let [lastFocusedValue, setLastFocusedValue] = (0, _react.useState)(null);
    let validation = (0, _form.useFormValidationState)({
        ...props,
        value: selectedValue
    });
    let setSelectedValue = (value)=>{
        if (!props.isReadOnly && !props.isDisabled) {
            setSelected(value);
            validation.commitValidation();
        }
    };
    let isInvalid = validation.displayValidation.isInvalid;
    return {
        ...validation,
        name,
        selectedValue: selectedValue,
        defaultSelectedValue: props.value !== undefined ? initialValue : props.defaultValue ?? null,
        setSelectedValue,
        lastFocusedValue,
        setLastFocusedValue,
        isDisabled: props.isDisabled || false,
        isReadOnly: props.isReadOnly || false,
        isRequired: props.isRequired || false,
        validationState: props.validationState || (isInvalid ? 'invalid' : null),
        isInvalid
    };
}

},{"@react-stately/form":"icH0S","@react-stately/utils":"4Nj6T","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"92IrI":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AutocompleteContext", ()=>AutocompleteContext);
parcelHelpers.export(exports, "AutocompleteStateContext", ()=>AutocompleteStateContext);
/**
 * An autocomplete combines a TextField or SearchField with a Menu or ListBox, allowing users to search or filter a list of suggestions.
 */ parcelHelpers.export(exports, "Autocomplete", ()=>Autocomplete);
var _autocomplete = require("@react-aria/autocomplete");
var _autocomplete1 = require("@react-stately/autocomplete");
var _rspcontexts = require("./RSPContexts");
var _utils = require("@react-aria/utils");
var _utils1 = require("./utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const AutocompleteContext = /*#__PURE__*/ (0, _react.createContext)(null);
const AutocompleteStateContext = /*#__PURE__*/ (0, _react.createContext)(null);
function Autocomplete(props) {
    let ctx = (0, _utils1.useSlottedContext)(AutocompleteContext, props.slot);
    props = (0, _utils.mergeProps)(ctx, props);
    let { filter, disableAutoFocusFirst } = props;
    let state = (0, _autocomplete1.useAutocompleteState)(props);
    let inputRef = (0, _react.useRef)(null);
    let collectionRef = (0, _react.useRef)(null);
    let { inputProps, collectionProps, collectionRef: mergedCollectionRef, filter: filterFn } = (0, _autocomplete.useAutocomplete)({
        ...(0, _utils1.removeDataAttributes)(props),
        filter,
        disableAutoFocusFirst,
        inputRef,
        collectionRef
    }, state);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils1.Provider), {
        values: [
            [
                AutocompleteStateContext,
                state
            ],
            [
                (0, _rspcontexts.FieldInputContext),
                {
                    ...inputProps,
                    ref: inputRef
                }
            ],
            [
                (0, _rspcontexts.SelectableCollectionContext),
                {
                    ...collectionProps,
                    filter: filterFn,
                    ref: mergedCollectionRef
                }
            ]
        ]
    }, props.children);
}

},{"@react-aria/autocomplete":"3cIk9","@react-stately/autocomplete":"dOQgU","./RSPContexts":"lIerG","@react-aria/utils":"aNvcY","./utils":"bA6Cz","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"3cIk9":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for an autocomplete component.
 * An autocomplete combines a text input with a collection, allowing users to filter the collection's contents match a query.
 * @param props - Props for the autocomplete.
 * @param state - State for the autocomplete, as returned by `useAutocompleteState`.
 */ parcelHelpers.export(exports, "useAutocomplete", ()=>useAutocomplete);
var _utils = require("@react-aria/utils");
var _focus = require("@react-aria/focus");
var _interactions = require("@react-aria/interactions");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _react = require("react");
var _i18N = require("@react-aria/i18n");
function useAutocomplete(props, state) {
    let { inputRef, collectionRef, filter, disableAutoFocusFirst = false, disableVirtualFocus = false } = props;
    let collectionId = (0, _utils.useId)();
    let timeout = (0, _react.useRef)(undefined);
    let delayNextActiveDescendant = (0, _react.useRef)(false);
    let queuedActiveDescendant = (0, _react.useRef)(null);
    // For mobile screen readers, we don't want virtual focus, instead opting to disable FocusScope's restoreFocus and manually
    // moving focus back to the subtriggers
    let isMobileScreenReader = (0, _interactions.getInteractionModality)() === 'virtual' && ((0, _utils.isIOS)() || (0, _utils.isAndroid)());
    let [shouldUseVirtualFocus, setShouldUseVirtualFocus] = (0, _react.useState)(!isMobileScreenReader && !disableVirtualFocus);
    // Tracks if a collection has been connected to the autocomplete. If false, we don't want to add various attributes to the autocomplete input
    // since it isn't attached to a filterable collection (e.g. Tabs)
    let [hasCollection, setHasCollection] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>{
        return ()=>clearTimeout(timeout.current);
    }, []);
    let updateActiveDescendantEvent = (0, _utils.useEffectEvent)((e)=>{
        // Ensure input is focused if the user clicks on the collection directly.
        if (!e.isTrusted && shouldUseVirtualFocus && inputRef.current && (0, _utils.getActiveElement)((0, _utils.getOwnerDocument)(inputRef.current)) !== inputRef.current) inputRef.current.focus();
        let target = e.target;
        if (e.isTrusted || !target || queuedActiveDescendant.current === target.id) return;
        clearTimeout(timeout.current);
        if (target !== collectionRef.current) {
            if (delayNextActiveDescendant.current) {
                queuedActiveDescendant.current = target.id;
                timeout.current = setTimeout(()=>{
                    state.setFocusedNodeId(target.id);
                }, 500);
            } else {
                queuedActiveDescendant.current = target.id;
                state.setFocusedNodeId(target.id);
            }
        } else if (queuedActiveDescendant.current && !document.getElementById(queuedActiveDescendant.current)) {
            // If we recieve a focus event refocusing the collection, either we have newly refocused the input and are waiting for the
            // wrapped collection to refocus the previously focused node if any OR
            // we are in a state where we've filtered to such a point that there aren't any matching items in the collection to focus.
            // In this case we want to clear tracked item if any and clear active descendant
            queuedActiveDescendant.current = null;
            state.setFocusedNodeId(null);
        }
        delayNextActiveDescendant.current = false;
    });
    let [collectionNode, setCollectionNode] = (0, _react.useState)(null);
    let callbackRef = (0, _react.useCallback)((node)=>{
        setCollectionNode(node);
        if (node != null) {
            // If useSelectableCollection isn't passed shouldUseVirtualFocus even when useAutocomplete provides it
            // that means the collection doesn't support it (e.g. Table). If that is the case, we need to disable it here regardless
            // of what the user's provided so that the input doesn't recieve the onKeyDown and autocomplete props.
            if (node.getAttribute('tabindex') != null) setShouldUseVirtualFocus(false);
            setHasCollection(true);
        } else setHasCollection(false);
    }, []);
    (0, _utils.useLayoutEffect)(()=>{
        if (collectionNode != null) // When typing forward, we want to delay the setting of active descendant to not interrupt the native screen reader announcement
        // of the letter you just typed. If we recieve another focus event then we clear the queued update
        collectionNode.addEventListener('focusin', updateActiveDescendantEvent);
        return ()=>{
            collectionNode?.removeEventListener('focusin', updateActiveDescendantEvent);
        };
    }, [
        collectionNode
    ]);
    // Make sure to memo so that React doesn't keep registering a new event listeners on every rerender of the wrapped collection
    let mergedCollectionRef = (0, _utils.useObjectRef)((0, _react.useMemo)(()=>(0, _utils.mergeRefs)(collectionRef, callbackRef), [
        collectionRef,
        callbackRef
    ]));
    let focusFirstItem = (0, _react.useCallback)(()=>{
        delayNextActiveDescendant.current = true;
        collectionRef.current?.dispatchEvent(new CustomEvent((0, _utils.FOCUS_EVENT), {
            cancelable: true,
            bubbles: true,
            detail: {
                focusStrategy: 'first'
            }
        }));
    }, [
        collectionRef
    ]);
    let clearVirtualFocus = (0, _react.useCallback)((clearFocusKey)=>{
        (0, _focus.moveVirtualFocus)((0, _utils.getActiveElement)());
        queuedActiveDescendant.current = null;
        state.setFocusedNodeId(null);
        let clearFocusEvent = new CustomEvent((0, _utils.CLEAR_FOCUS_EVENT), {
            cancelable: true,
            bubbles: true,
            detail: {
                clearFocusKey
            }
        });
        clearTimeout(timeout.current);
        delayNextActiveDescendant.current = false;
        collectionRef.current?.dispatchEvent(clearFocusEvent);
    }, [
        collectionRef,
        state
    ]);
    let lastInputType = (0, _react.useRef)('');
    (0, _utils.useEvent)(inputRef, 'input', (e)=>{
        let { inputType } = e;
        lastInputType.current = inputType;
    });
    let onChange = (value)=>{
        // Tell wrapped collection to focus the first element in the list when typing forward and to clear focused key when modifying the text via
        // copy paste/backspacing/undo/redo for screen reader announcements
        if (lastInputType.current === 'insertText' && !disableAutoFocusFirst) focusFirstItem();
        else if (lastInputType.current && (lastInputType.current.includes('insert') || lastInputType.current.includes('delete') || lastInputType.current.includes('history'))) {
            clearVirtualFocus(true);
            // If onChange was triggered before the timeout actually updated the activedescendant, we need to fire
            // our own dispatchVirtualFocus so focusVisible gets reapplied on the input
            if ((0, _focus.getVirtuallyFocusedElement)(document) === inputRef.current) (0, _focus.dispatchVirtualFocus)(inputRef.current, null);
        }
        state.setInputValue(value);
    };
    let keyDownTarget = (0, _react.useRef)(null);
    // For textfield specific keydown operations
    let onKeyDown = (e)=>{
        keyDownTarget.current = e.target;
        if (e.nativeEvent.isComposing) return;
        let focusedNodeId = queuedActiveDescendant.current;
        switch(e.key){
            case 'a':
                if ((0, _utils.isCtrlKeyPressed)(e)) return;
                break;
            case 'Escape':
                // Early return for Escape here so it doesn't leak the Escape event from the simulated collection event below and
                // close the dialog prematurely. Ideally that should be up to the discretion of the input element hence the check
                // for isPropagationStopped
                if (e.isDefaultPrevented()) return;
                break;
            case ' ':
                // Space shouldn't trigger onAction so early return.
                return;
            case 'Tab':
                // Don't propogate Tab down to the collection, otherwise we will try to focus the collection via useSelectableCollection's Tab handler (aka shift tab logic)
                // We want FocusScope to handle Tab if one exists (aka sub dialog), so special casepropogate
                if ('continuePropagation' in e) e.continuePropagation();
                return;
            case 'Home':
            case 'End':
            case 'PageDown':
            case 'PageUp':
            case 'ArrowUp':
            case 'ArrowDown':
                {
                    if ((e.key === 'Home' || e.key === 'End') && focusedNodeId == null && e.shiftKey) return;
                    // Prevent these keys from moving the text cursor in the input
                    e.preventDefault();
                    // Move virtual focus into the wrapped collection
                    let focusCollection = new CustomEvent((0, _utils.FOCUS_EVENT), {
                        cancelable: true,
                        bubbles: true
                    });
                    collectionRef.current?.dispatchEvent(focusCollection);
                    break;
                }
        }
        // Emulate the keyboard events that happen in the input field in the wrapped collection. This is for triggering things like onAction via Enter
        // or moving focus from one item to another. Stop propagation on the input event if it isn't already stopped so it doesn't leak out. For events
        // like ESC, the dispatched event below will bubble out of the collection and be stopped if handled by useSelectableCollection, otherwise will bubble
        // as expected
        if (!e.isPropagationStopped()) e.stopPropagation();
        let shouldPerformDefaultAction = true;
        if (collectionRef.current !== null) {
            if (focusedNodeId == null) shouldPerformDefaultAction = collectionRef.current?.dispatchEvent(new KeyboardEvent(e.nativeEvent.type, e.nativeEvent)) || false;
            else {
                let item = document.getElementById(focusedNodeId);
                if (item) shouldPerformDefaultAction = item?.dispatchEvent(new KeyboardEvent(e.nativeEvent.type, e.nativeEvent)) || false;
            }
        }
        if (shouldPerformDefaultAction) switch(e.key){
            case 'ArrowLeft':
            case 'ArrowRight':
                // Clear the activedescendant so NVDA announcements aren't interrupted but retain the focused key in the collection so the
                // user's keyboard navigation restarts from where they left off
                clearVirtualFocus();
                break;
            case 'Enter':
                // Trigger click action on item when Enter key was pressed.
                if (focusedNodeId != null) {
                    let item = document.getElementById(focusedNodeId);
                    item?.dispatchEvent(new PointerEvent('click', e.nativeEvent));
                }
                break;
        }
        else // TODO: check if we can do this, want to stop textArea from using its default Enter behavior so items are properly triggered
        e.preventDefault();
    };
    let onKeyUpCapture = (0, _utils.useEffectEvent)((e)=>{
        // Dispatch simulated key up events for things like triggering links in listbox
        // Make sure to stop the propagation of the input keyup event so that the simulated keyup/down pair
        // is detected by usePress instead of the original keyup originating from the input
        if (e.target === keyDownTarget.current) {
            e.stopImmediatePropagation();
            let focusedNodeId = queuedActiveDescendant.current;
            if (focusedNodeId == null) collectionRef.current?.dispatchEvent(new KeyboardEvent(e.type, e));
            else {
                let item = document.getElementById(focusedNodeId);
                item?.dispatchEvent(new KeyboardEvent(e.type, e));
            }
        }
    });
    (0, _react.useEffect)(()=>{
        document.addEventListener('keyup', onKeyUpCapture, true);
        return ()=>{
            document.removeEventListener('keyup', onKeyUpCapture, true);
        };
    }, []);
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-aria/autocomplete');
    let collectionProps = (0, _utils.useLabels)({
        id: collectionId,
        'aria-label': stringFormatter.format('collectionLabel')
    });
    let filterFn = (0, _react.useCallback)((nodeTextValue, node)=>{
        if (filter) return filter(nodeTextValue, state.inputValue, node);
        return true;
    }, [
        state.inputValue,
        filter
    ]);
    // Be sure to clear/restore the virtual + collection focus when blurring/refocusing the field so we only show the
    // focus ring on the virtually focused collection when are actually interacting with the Autocomplete
    let onBlur = (e)=>{
        if (!e.isTrusted) return;
        let lastFocusedNode = queuedActiveDescendant.current ? document.getElementById(queuedActiveDescendant.current) : null;
        if (lastFocusedNode) (0, _focus.dispatchVirtualBlur)(lastFocusedNode, e.relatedTarget);
    };
    let onFocus = (e)=>{
        if (!e.isTrusted) return;
        let curFocusedNode = queuedActiveDescendant.current ? document.getElementById(queuedActiveDescendant.current) : null;
        if (curFocusedNode) {
            let target = e.target;
            queueMicrotask(()=>{
                // instead of focusing the last focused node, just focus the collection instead and have the collection handle what item to focus via useSelectableCollection/Item
                (0, _focus.dispatchVirtualBlur)(target, collectionRef.current);
                (0, _focus.dispatchVirtualFocus)(collectionRef.current, target);
            });
        }
    };
    // Only apply the autocomplete specific behaviors if the collection component wrapped by it is actually
    // being filtered/allows filtering by the Autocomplete.
    let inputProps = {
        value: state.inputValue,
        onChange
    };
    let virtualFocusProps = {
        onKeyDown,
        'aria-activedescendant': state.focusedNodeId ?? undefined,
        onBlur,
        onFocus
    };
    if (hasCollection) inputProps = {
        ...inputProps,
        ...shouldUseVirtualFocus && virtualFocusProps,
        enterKeyHint: 'go',
        'aria-controls': collectionId,
        // TODO: readd proper logic for completionMode = complete (aria-autocomplete: both)
        'aria-autocomplete': 'list',
        // This disable's iOS's autocorrect suggestions, since the autocomplete provides its own suggestions.
        autoCorrect: 'off',
        // This disable's the macOS Safari spell check auto corrections.
        spellCheck: 'false',
        autoComplete: 'off'
    };
    return {
        inputProps,
        collectionProps: (0, _utils.mergeProps)(collectionProps, {
            shouldUseVirtualFocus,
            disallowTypeAhead: shouldUseVirtualFocus
        }),
        collectionRef: mergedCollectionRef,
        filter: filter != null ? filterFn : undefined
    };
}

},{"@react-aria/utils":[["CLEAR_FOCUS_EVENT","gP0bT"],["FOCUS_EVENT","gP0bT"],["getActiveElement","9OiSj"],["getOwnerDocument","fioCG"],["isAndroid","7AGiA"],["isIOS","7AGiA"],["isCtrlKeyPressed","4IgPc"],["mergeProps","aNvcY"],["mergeRefs","1vHgg"],["useEffectEvent","eg4dC"],["useEvent","c8GoD"],["useId","jbI4Y"],["useLabels","7Uhyw"],["useLayoutEffect","2ViQu"],["useObjectRef","laqO5"]],"@react-aria/focus":"5dDnl","@react-aria/interactions":"dkfxW","../intl/*.json":"5xdac","react":"a1TxN","@react-aria/i18n":"7lxyl","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5xdac":[function(require,module,exports,__globalThis) {
const _temp0 = require("aab8529f83d78c64");
const _temp1 = require("e3a954a8fa8649");
const _temp2 = require("4cb4606ad02168b7");
const _temp3 = require("ff04b7bd2e6d69ed");
const _temp4 = require("bb179ddffbe502f2");
const _temp5 = require("755c7d97432d6fa2");
const _temp6 = require("a9b57e53e370556a");
const _temp7 = require("cfa35ac2c3ec0a43");
const _temp8 = require("c69af7c884012def");
const _temp9 = require("812d3093ed607fbd");
const _temp10 = require("3cc2433b74ee4be3");
const _temp11 = require("b18f532fff1c6238");
const _temp12 = require("1c06ffc07d62b673");
const _temp13 = require("86ad52d940858a69");
const _temp14 = require("5613f3fccabc912f");
const _temp15 = require("378b8c8ee1594dae");
const _temp16 = require("7bab6b0ec3521211");
const _temp17 = require("360d4a2fb278b12b");
const _temp18 = require("fe09155d5abc0dad");
const _temp19 = require("6be7ba4c6e8274f0");
const _temp20 = require("fbe1a873687ea837");
const _temp21 = require("a19fac5fe2e076f9");
const _temp22 = require("9ccc1a074e60da78");
const _temp23 = require("78120e2373bddbc1");
const _temp24 = require("cf4429f336bc38c2");
const _temp25 = require("b6e2eb24e77570a8");
const _temp26 = require("50b07a68b2d2fe08");
const _temp27 = require("496c79e536cf7d55");
const _temp28 = require("1a34629c92039f0");
const _temp29 = require("7db1b456062707a7");
const _temp30 = require("7d298cf69b41380e");
const _temp31 = require("598cc2026a65eeea");
const _temp32 = require("b08a20f8c4391529");
const _temp33 = require("941f28ded036b0d");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"aab8529f83d78c64":"ctpKo","e3a954a8fa8649":"ctpKo","4cb4606ad02168b7":"ctpKo","ff04b7bd2e6d69ed":"ctpKo","bb179ddffbe502f2":"ctpKo","755c7d97432d6fa2":"ctpKo","a9b57e53e370556a":"3fqEt","cfa35ac2c3ec0a43":"ctpKo","c69af7c884012def":"ctpKo","812d3093ed607fbd":"ctpKo","3cc2433b74ee4be3":"ctpKo","b18f532fff1c6238":"ctpKo","1c06ffc07d62b673":"ctpKo","86ad52d940858a69":"ctpKo","5613f3fccabc912f":"ctpKo","378b8c8ee1594dae":"ctpKo","7bab6b0ec3521211":"ctpKo","360d4a2fb278b12b":"ctpKo","fe09155d5abc0dad":"ctpKo","6be7ba4c6e8274f0":"ctpKo","fbe1a873687ea837":"ctpKo","a19fac5fe2e076f9":"ctpKo","9ccc1a074e60da78":"ctpKo","78120e2373bddbc1":"ctpKo","cf4429f336bc38c2":"ctpKo","b6e2eb24e77570a8":"ctpKo","50b07a68b2d2fe08":"ctpKo","496c79e536cf7d55":"ctpKo","1a34629c92039f0":"ctpKo","7db1b456062707a7":"ctpKo","7d298cf69b41380e":"ctpKo","598cc2026a65eeea":"ctpKo","b08a20f8c4391529":"ctpKo","941f28ded036b0d":"ctpKo"}],"3fqEt":[function(require,module,exports,__globalThis) {
module.exports = {
    "collectionLabel": `Suggestions`
};

},{}],"dOQgU":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides state management for an autocomplete component.
 */ parcelHelpers.export(exports, "useAutocompleteState", ()=>useAutocompleteState);
var _react = require("react");
var _utils = require("@react-stately/utils");
function useAutocompleteState(props) {
    let { onInputChange: propsOnInputChange, inputValue: propsInputValue, defaultInputValue: propsDefaultInputValue = '' } = props;
    let onInputChange = (value)=>{
        if (propsOnInputChange) propsOnInputChange(value);
    };
    let [focusedNodeId, setFocusedNodeId] = (0, _react.useState)(null);
    let [inputValue, setInputValue] = (0, _utils.useControlledState)(propsInputValue, propsDefaultInputValue, onInputChange);
    return {
        inputValue,
        setInputValue,
        focusedNodeId,
        setFocusedNodeId
    };
}

},{"react":"a1TxN","@react-stately/utils":"4Nj6T","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hJ2AB":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateRangePickerContext", ()=>DateRangePickerContext);
parcelHelpers.export(exports, "DateRangePicker", ()=>DateRangePicker);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _datePicker = require("./DatePicker");
var _react = require("react");
var _dateField = require("./DateField");
var _field = require("./Field");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _ = require("../");
var _i18N = require("@react-aria/i18n");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const DateRangePickerContext = /*#__PURE__*/ (0, _react.createContext)(null);
const DateRangePicker = /*#__PURE__*/ (0, _react.forwardRef)(function DateRangePicker(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, DateRangePickerContext);
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-spectrum/s2');
    let { label, contextualHelp, description: descriptionMessage, errorMessage, isRequired, size = 'M', labelPosition = 'top', necessityIndicator, labelAlign = 'start', UNSAFE_style, UNSAFE_className, styles, placeholderValue, maxVisibleMonths = 1, createCalendar, ...dateFieldProps } = props;
    let formContext = (0, _react.useContext)((0, _reactAriaComponents.FormContext));
    let [buttonHasFocus, setButtonHasFocus] = (0, _react.useState)(false);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.DateRangePicker), {
        ref: ref,
        isRequired: isRequired,
        ...dateFieldProps,
        style: UNSAFE_style,
        className: (UNSAFE_className || '') + function anonymous(props, overrides) {
            let rules = " ", currentRules = {};
            let gridColumnStart = false;
            let gridColumnEnd = false;
            let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L|-macro\$)[^\s]+/g);
            for (let p of matches){
                if (p[1] === "z") gridColumnStart = true;
                if (p[1] === "y") gridColumnEnd = true;
                rules += p[0];
            }
            rules += ' se12';
            currentRules["display"] = "grid";
            if (props.isInForm) {
                if (!gridColumnStart) rules += ' z2mU12';
                currentRules["gridColumnStart"] = typeof currentRules["gridColumnStart"] === 'object' ? currentRules["gridColumnStart"] : {
                    "default": currentRules["gridColumnStart"]
                };
                currentRules["gridColumnStart"]["isInForm"] = 1;
            }
            if (props.isInForm) {
                if (props.labelPosition === "side") {
                    if (!gridColumnEnd) rules += ' yvoofG12';
                    currentRules["gridColumnEnd"] = typeof currentRules["gridColumnEnd"] === 'object' ? currentRules["gridColumnEnd"] : {
                        "default": currentRules["gridColumnEnd"]
                    };
                    currentRules["gridColumnEnd"]["isInForm && labelPosition === \"side\""] = "span 2";
                }
            }
            if (props.isInForm) {
                rules += ' DLwlgod12';
                currentRules["gridTemplateColumns"] = typeof currentRules["gridTemplateColumns"] === 'object' ? currentRules["gridTemplateColumns"] : {
                    "default": currentRules["gridTemplateColumns"]
                };
                currentRules["gridTemplateColumns"]["isInForm"] = "subgrid";
            } else {
                if (props.labelPosition === "side") {
                    rules += ' DPlN5qb12';
                    currentRules["gridTemplateColumns"] = typeof currentRules["gridTemplateColumns"] === 'object' ? currentRules["gridTemplateColumns"] : {
                        "default": currentRules["gridTemplateColumns"]
                    };
                    currentRules["gridTemplateColumns"]["labelPosition === \"side\""] = [
                        "auto",
                        "1fr"
                    ];
                } else if (props.labelPosition === "top") {
                    rules += ' DM8Mfn12';
                    currentRules["gridTemplateColumns"] = typeof currentRules["gridTemplateColumns"] === 'object' ? currentRules["gridTemplateColumns"] : {
                        "default": currentRules["gridTemplateColumns"]
                    };
                    currentRules["gridTemplateColumns"]["labelPosition === \"top\""] = [
                        "1fr"
                    ];
                }
            }
            if (props.labelPosition === "side") {
                rules += ' EPlN5qb12';
                currentRules["gridTemplateRows"] = typeof currentRules["gridTemplateRows"] === 'object' ? currentRules["gridTemplateRows"] : {
                    "default": currentRules["gridTemplateRows"]
                };
                currentRules["gridTemplateRows"]["labelPosition === \"side\""] = [
                    "auto",
                    "1fr"
                ];
            } else if (props.labelPosition === "top") {
                rules += ' E4w1sLc12';
                currentRules["gridTemplateRows"] = typeof currentRules["gridTemplateRows"] === 'object' ? currentRules["gridTemplateRows"] : {
                    "default": currentRules["gridTemplateRows"]
                };
                currentRules["gridTemplateRows"]["labelPosition === \"top\""] = [
                    "auto",
                    "1fr",
                    "auto"
                ];
            }
            if (props.labelPosition === "side") {
                rules += ' CbRM95c12';
                currentRules["gridTemplateAreas"] = typeof currentRules["gridTemplateAreas"] === 'object' ? currentRules["gridTemplateAreas"] : {
                    "default": currentRules["gridTemplateAreas"]
                };
                currentRules["gridTemplateAreas"]["labelPosition === \"side\""] = [
                    "label input",
                    "label helptext"
                ];
            } else if (props.labelPosition === "top") {
                rules += ' Cxaocre12';
                currentRules["gridTemplateAreas"] = typeof currentRules["gridTemplateAreas"] === 'object' ? currentRules["gridTemplateAreas"] : {
                    "default": currentRules["gridTemplateAreas"]
                };
                currentRules["gridTemplateAreas"]["labelPosition === \"top\""] = [
                    "label",
                    "input",
                    "helptext"
                ];
            }
            if (props.size === "XL") {
                rules += ' -_6BNtrc-e12';
                currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
                    "default": currentRules["fontSize"]
                };
                currentRules["fontSize"]["size === \"XL\""] = "ui-xl";
                rules += ' vx12';
                currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
                    "default": currentRules["fontSize"]
                };
                currentRules["fontSize"]["size === \"XL\""] = "ui-xl";
            } else if (props.size === "L") {
                rules += ' -_6BNtrc-d12';
                currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
                    "default": currentRules["fontSize"]
                };
                currentRules["fontSize"]["size === \"L\""] = "ui-lg";
                rules += ' vx12';
                currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
                    "default": currentRules["fontSize"]
                };
                currentRules["fontSize"]["size === \"L\""] = "ui-lg";
            } else if (props.size === "S") {
                rules += ' -_6BNtrc-b12';
                currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
                    "default": currentRules["fontSize"]
                };
                currentRules["fontSize"]["size === \"S\""] = "ui-sm";
                rules += ' vx12';
                currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
                    "default": currentRules["fontSize"]
                };
                currentRules["fontSize"]["size === \"S\""] = "ui-sm";
            } else if (props.size === "XS") {
                rules += ' -_6BNtrc-a12';
                currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
                    "default": currentRules["fontSize"]
                };
                currentRules["fontSize"]["size === \"XS\""] = "ui-xs";
                rules += ' vx12';
                currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
                    "default": currentRules["fontSize"]
                };
                currentRules["fontSize"]["size === \"XS\""] = "ui-xs";
            } else {
                rules += ' -_6BNtrc-c12';
                currentRules["fontSize"] = "ui";
                rules += ' vx12';
                currentRules["fontSize"] = "ui";
            }
            rules += ' ea12';
            currentRules["alignItems"] = "baseline";
            rules += ' _Fd12';
            currentRules["lineHeight"] = "ui";
            rules += ' _FezxGHba12';
            currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
                "default": currentRules["lineHeight"]
            };
            currentRules["lineHeight"][":lang(ar, he)"] = "ui";
            rules += ' _FnuYUweb12';
            currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
                "default": currentRules["lineHeight"]
            };
            currentRules["lineHeight"][":lang(ja, ko, zh, zh-Hant, zh-Hans, zh-CN, zh-SG)"] = "ui";
            if (props.size === "XL") {
                rules += ' -BhX7R-Fz12';
                currentRules["--field-height"] = typeof currentRules["--field-height"] === 'object' ? currentRules["--field-height"] : {
                    "default": currentRules["--field-height"]
                };
                currentRules["--field-height"]["size === \"XL\""] = 48;
            } else if (props.size === "L") {
                rules += ' -BhX7R-Fv12';
                currentRules["--field-height"] = typeof currentRules["--field-height"] === 'object' ? currentRules["--field-height"] : {
                    "default": currentRules["--field-height"]
                };
                currentRules["--field-height"]["size === \"L\""] = 40;
            } else if (props.size === "S") {
                rules += ' -BhX7R-Fp12';
                currentRules["--field-height"] = typeof currentRules["--field-height"] === 'object' ? currentRules["--field-height"] : {
                    "default": currentRules["--field-height"]
                };
                currentRules["--field-height"]["size === \"S\""] = 24;
            } else if (props.size === "XS") {
                rules += ' -BhX7R-Fn12';
                currentRules["--field-height"] = typeof currentRules["--field-height"] === 'object' ? currentRules["--field-height"] : {
                    "default": currentRules["--field-height"]
                };
                currentRules["--field-height"]["size === \"XS\""] = 20;
            } else {
                rules += ' -BhX7R-Fx12';
                currentRules["--field-height"] = 32;
            }
            rules += ' -AJjOLd-UVkF0Db12';
            currentRules["--field-gap"] = "[calc((var(--field-height) - self(borderTopWidth, 0px) - self(borderBottomWidth, 0px) - 1lh) / 2)]";
            rules += ' qg12';
            currentRules["columnGap"] = 12;
            rules += ' __ca12';
            currentRules["disableTapHighlight"] = true;
            return rules;
        }({
            isInForm: !!formContext,
            labelPosition,
            size
        }, styles),
        children: ({ isDisabled, isInvalid, isOpen, state })=>{
            let placeholder = placeholderValue || undefined;
            let timePlaceholder = placeholder && 'hour' in placeholder ? placeholder : undefined;
            let timeMinValue = props.minValue && 'hour' in props.minValue ? props.minValue : undefined;
            let timeMaxValue = props.maxValue && 'hour' in props.maxValue ? props.maxValue : undefined;
            let timeGranularity = state.granularity === 'hour' || state.granularity === 'minute' || state.granularity === 'second' ? state.granularity : undefined;
            let showTimeField = !!timeGranularity;
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldLabel), {
                        isDisabled: isDisabled,
                        isRequired: isRequired,
                        size: size,
                        labelPosition: labelPosition,
                        labelAlign: labelAlign,
                        necessityIndicator: necessityIndicator,
                        contextualHelp: contextualHelp,
                        children: label
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _field.FieldGroup), {
                        role: "presentation",
                        shouldTurnOffFocusRing: buttonHasFocus,
                        isDisabled: isDisabled,
                        isInvalid: isInvalid,
                        size: size,
                        styles: function anonymous(props) {
                            let rules = " ", currentRules = {};
                            rules += ' zXcEWr12';
                            currentRules["gridColumnStart"] = "input";
                            rules += ' yXcEWr12';
                            currentRules["gridColumnEnd"] = "input";
                            rules += ' BXcEWr12';
                            currentRules["gridRowStart"] = "input";
                            rules += ' AXcEWr12';
                            currentRules["gridRowEnd"] = "input";
                            if (props.size === "XL") {
                                rules += ' Nl12';
                                currentRules["minWidth"] = typeof currentRules["minWidth"] === 'object' ? currentRules["minWidth"] : {
                                    "default": currentRules["minWidth"]
                                };
                                currentRules["minWidth"]["size === \"XL\""] = 48;
                            } else if (props.size === "L") {
                                rules += ' Nj12';
                                currentRules["minWidth"] = typeof currentRules["minWidth"] === 'object' ? currentRules["minWidth"] : {
                                    "default": currentRules["minWidth"]
                                };
                                currentRules["minWidth"]["size === \"L\""] = 40;
                            } else if (props.size === "S") {
                                rules += ' Nf12';
                                currentRules["minWidth"] = typeof currentRules["minWidth"] === 'object' ? currentRules["minWidth"] : {
                                    "default": currentRules["minWidth"]
                                };
                                currentRules["minWidth"]["size === \"S\""] = 24;
                            } else if (props.size === "XS") {
                                rules += ' Ne12';
                                currentRules["minWidth"] = typeof currentRules["minWidth"] === 'object' ? currentRules["minWidth"] : {
                                    "default": currentRules["minWidth"]
                                };
                                currentRules["minWidth"]["size === \"XS\""] = 20;
                            } else {
                                rules += ' Nk12';
                                currentRules["minWidth"] = 32;
                            }
                            if (props.isQuiet) {
                                rules += ' _qd12';
                                currentRules["contain"] = typeof currentRules["contain"] === 'object' ? currentRules["contain"] : {
                                    "default": currentRules["contain"]
                                };
                                currentRules["contain"]["isQuiet"] = "none";
                            } else {
                                rules += ' _qtb12';
                                currentRules["contain"] = typeof currentRules["contain"] === 'object' ? currentRules["contain"] : {
                                    "default": currentRules["contain"]
                                };
                                currentRules["contain"]["@supports (contain-intrinsic-width: 1px)"] = "inline-size";
                            }
                            if (props.size === "XL") {
                                rules += ' -Anxdcc-Zt12';
                                currentRules["--defaultWidth"] = typeof currentRules["--defaultWidth"] === 'object' ? currentRules["--defaultWidth"] : {
                                    "default": currentRules["--defaultWidth"]
                                };
                                currentRules["--defaultWidth"]["size === \"XL\""] = 240;
                            } else if (props.size === "L") {
                                rules += ' -Anxdcc-ZStdtne12';
                                currentRules["--defaultWidth"] = typeof currentRules["--defaultWidth"] === 'object' ? currentRules["--defaultWidth"] : {
                                    "default": currentRules["--defaultWidth"]
                                };
                                currentRules["--defaultWidth"]["size === \"L\""] = 224;
                            } else if (props.size === "S") {
                                rules += ' -Anxdcc-Zr12';
                                currentRules["--defaultWidth"] = typeof currentRules["--defaultWidth"] === 'object' ? currentRules["--defaultWidth"] : {
                                    "default": currentRules["--defaultWidth"]
                                };
                                currentRules["--defaultWidth"]["size === \"S\""] = 192;
                            } else {
                                rules += ' -Anxdcc-Z3fn9H12';
                                currentRules["--defaultWidth"] = 208;
                            }
                            rules += ' __v6TNLWb12';
                            currentRules["containIntrinsicWidth"] = "calc(var(--defaultWidth) - self(paddingStart, 0px) - self(paddingEnd, 0px) - self(borderStartWidth, 0px) - self(borderEndWidth, 0px))";
                            rules += ' __Wb12';
                            currentRules["textWrap"] = "nowrap";
                            rules += ' SMBFGYc12';
                            rules += ' RfBFGYc12';
                            rules += ' -S_-Sv12';
                            currentRules["paddingStart"] = "edge-to-text";
                            rules += ' -R_-Rp12';
                            currentRules["paddingEnd"] = 4;
                            return rules;
                        }({
                            size
                        }),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dateField.DateInputContainer), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateField.DateInput), {
                                        slot: "start"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        "aria-hidden": "true",
                                        className: " _va12 _ua12 Sj12 Rj12",
                                        children: "\u2013"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateField.DateInput), {
                                        slot: "end"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateField.InvalidIndicator), {
                                isInvalid: isInvalid,
                                isDisabled: isDisabled
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: " _va12 _ub12 sd12 _Cb12",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _datePicker.CalendarButton), {
                                    isOpen: isOpen,
                                    size: size,
                                    setButtonHasFocus: setButtonHasFocus
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _datePicker.CalendarPopover), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _.RangeCalendar), {
                                visibleMonths: maxVisibleMonths,
                                createCalendar: createCalendar
                            }),
                            showTimeField && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: " sd12 Ul12 ql12 _qb12 JA12",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _.TimeField), {
                                        styles: (0, _datePicker.timeField),
                                        label: stringFormatter.format('datepicker.startTime'),
                                        value: state.timeRange?.start || null,
                                        onChange: (v)=>state.setTime('start', v),
                                        placeholderValue: timePlaceholder,
                                        granularity: timeGranularity,
                                        minValue: timeMinValue,
                                        maxValue: timeMaxValue,
                                        hourCycle: props.hourCycle,
                                        hideTimeZone: props.hideTimeZone
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _.TimeField), {
                                        styles: (0, _datePicker.timeField),
                                        label: stringFormatter.format('datepicker.endTime'),
                                        value: state.timeRange?.end || null,
                                        onChange: (v)=>state.setTime('end', v),
                                        placeholderValue: timePlaceholder,
                                        granularity: timeGranularity,
                                        minValue: timeMinValue,
                                        maxValue: timeMaxValue,
                                        hourCycle: props.hourCycle,
                                        hideTimeZone: props.hideTimeZone
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.HelpText), {
                        size: size,
                        isDisabled: isDisabled,
                        isInvalid: isInvalid,
                        description: descriptionMessage,
                        children: errorMessage
                    })
                ]
            });
        }
    });
});

},{"0":"dfRo0","1":"i8L17","2":"1IADb","3":"a7PDz","4":"gNsA4","react/jsx-runtime":"2Is6Z","react-aria-components":[["DateRangePicker","59rph"],["FormContext","g7RKA"]],"./DatePicker":"dwOW5","react":"a1TxN","./DateField":"l2Cjd","./Field":"eI7CE","../intl/*.json":"gDH3q","../":[["RangeCalendar","fEve7"],["TimeField","jK89c"]],"@react-aria/i18n":"7lxyl","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"dfRo0":[function() {},{}],"i8L17":[function() {},{}],"1IADb":[function() {},{}],"a7PDz":[function() {},{}],"gNsA4":[function() {},{}],"dMZh4":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TableLayout", ()=>TableLayout);
var _layout = require("@react-stately/layout");
var _table = require("./Table");
var _react = require("react");
class TableLayout extends (0, _layout.TableLayout) {
    // Invalidate the layout whenever the column widths change.
    useLayoutOptions() {
        // This is not a React class component, just a regular class.
        /* eslint-disable react-hooks/rules-of-hooks */ let colResizeState = (0, _react.useContext)((0, _table.TableColumnResizeStateContext));
        return (0, _react.useMemo)(()=>({
                columnWidths: colResizeState?.columnWidths
            }), [
            colResizeState?.columnWidths
        ]);
    }
}

},{"@react-stately/layout":"1NFmB","./Table":"3vnUd","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1NFmB":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * TableLayout is a virtualizer Layout implementation that arranges
 * items in rows and columns.
 */ parcelHelpers.export(exports, "TableLayout", ()=>TableLayout);
var _collections = require("@react-stately/collections");
var _virtualizer = require("@react-stately/virtualizer");
var _listLayout = require("./ListLayout");
var _table = require("@react-stately/table");
const DEFAULT_ROW_HEIGHT = 48;
class TableLayout extends (0, _listLayout.ListLayout) {
    constructor(options){
        super(options), this.lastCollection = null, this.columnWidths = new Map(), this.lastPersistedKeys = null, this.persistedIndices = new Map();
        this.stickyColumnIndices = [];
    }
    // Backward compatibility for subclassing.
    get collection() {
        return this.virtualizer.collection;
    }
    columnsChanged(newCollection, oldCollection) {
        return !oldCollection || newCollection.columns !== oldCollection.columns && newCollection.columns.length !== oldCollection.columns.length || newCollection.columns.some((c, i)=>c.key !== oldCollection.columns[i].key || c.props.width !== oldCollection.columns[i].props.width || c.props.minWidth !== oldCollection.columns[i].props.minWidth || c.props.maxWidth !== oldCollection.columns[i].props.maxWidth);
    }
    shouldInvalidateLayoutOptions(newOptions, oldOptions) {
        return newOptions.columnWidths !== oldOptions.columnWidths || super.shouldInvalidateLayoutOptions(newOptions, oldOptions);
    }
    update(invalidationContext) {
        let newCollection = this.virtualizer.collection;
        // If columnWidths were provided via layoutOptions, update those.
        // Otherwise, calculate column widths ourselves.
        if (invalidationContext.layoutOptions?.columnWidths) {
            for (const [key, val] of invalidationContext.layoutOptions.columnWidths)if (this.columnWidths.get(key) !== val) {
                this.columnWidths = invalidationContext.layoutOptions.columnWidths;
                invalidationContext.sizeChanged = true;
                break;
            }
        } else if (invalidationContext.sizeChanged || this.columnsChanged(newCollection, this.lastCollection)) {
            let columnLayout = new (0, _table.TableColumnLayout)({});
            this.columnWidths = columnLayout.buildColumnWidths(this.virtualizer.visibleRect.width - this.padding * 2, newCollection, new Map());
            invalidationContext.sizeChanged = true;
        }
        super.update(invalidationContext);
    }
    buildCollection() {
        this.stickyColumnIndices = [];
        let collection = this.virtualizer.collection;
        if (collection.head?.key === -1) return [];
        for (let column of collection.columns)// The selection cell and any other sticky columns always need to be visible.
        // In addition, row headers need to be in the DOM for accessibility labeling.
        if (this.isStickyColumn(column) || collection.rowHeaderColumnKeys.has(column.key)) this.stickyColumnIndices.push(column.index);
        let header = this.buildTableHeader();
        this.layoutNodes.set(header.layoutInfo.key, header);
        let body = this.buildBody(header.layoutInfo.rect.maxY + this.gap);
        this.lastPersistedKeys = null;
        body.layoutInfo.rect.width = Math.max(header.layoutInfo.rect.width, body.layoutInfo.rect.width);
        this.contentSize = new (0, _virtualizer.Size)(body.layoutInfo.rect.width + this.padding * 2, body.layoutInfo.rect.maxY + this.padding);
        return [
            header,
            body
        ];
    }
    buildTableHeader() {
        let collection = this.virtualizer.collection;
        let rect = new (0, _virtualizer.Rect)(this.padding, this.padding, 0, 0);
        let layoutInfo = new (0, _virtualizer.LayoutInfo)('header', collection.head?.key ?? 'header', rect);
        layoutInfo.isSticky = true;
        layoutInfo.zIndex = 1;
        let y = this.padding;
        let width = 0;
        let children = [];
        for (let headerRow of collection.headerRows){
            let layoutNode = this.buildChild(headerRow, this.padding, y, layoutInfo.key);
            layoutNode.layoutInfo.parentKey = layoutInfo.key;
            y = layoutNode.layoutInfo.rect.maxY;
            width = Math.max(width, layoutNode.layoutInfo.rect.width);
            layoutNode.index = children.length;
            children.push(layoutNode);
        }
        rect.width = width;
        rect.height = y - this.padding;
        return {
            layoutInfo,
            children,
            validRect: layoutInfo.rect,
            node: collection.head
        };
    }
    buildHeaderRow(headerRow, x, y) {
        let rect = new (0, _virtualizer.Rect)(x, y, 0, 0);
        let row = new (0, _virtualizer.LayoutInfo)('headerrow', headerRow.key, rect);
        let height = 0;
        let columns = [];
        for (let cell of (0, _collections.getChildNodes)(headerRow, this.virtualizer.collection)){
            let layoutNode = this.buildChild(cell, x, y, row.key);
            layoutNode.layoutInfo.parentKey = row.key;
            x = layoutNode.layoutInfo.rect.maxX;
            height = Math.max(height, layoutNode.layoutInfo.rect.height);
            layoutNode.index = columns.length;
            columns.push(layoutNode);
        }
        for (let [i, layout] of columns.entries())layout.layoutInfo.zIndex = columns.length - i + 1;
        this.setChildHeights(columns, height);
        rect.height = height;
        rect.width = x - rect.x;
        return {
            layoutInfo: row,
            children: columns,
            validRect: rect,
            node: headerRow
        };
    }
    setChildHeights(children, height) {
        for (let child of children)if (child.layoutInfo.rect.height !== height) {
            // Need to copy the layout info before we mutate it.
            child.layoutInfo = child.layoutInfo.copy();
            child.layoutInfo.rect.height = height;
        }
    }
    // used to get the column widths when rendering to the DOM
    getRenderedColumnWidth(node) {
        let collection = this.virtualizer.collection;
        let colSpan = node.colSpan ?? 1;
        let colIndex = node.colIndex ?? node.index;
        let width = 0;
        for(let i = colIndex; i < colIndex + colSpan; i++){
            let column = collection.columns[i];
            if (column?.key != null) width += this.columnWidths.get(column.key) ?? 0;
        }
        return width;
    }
    getEstimatedHeight(node, width, height, estimatedHeight) {
        let isEstimated = false;
        // If no explicit height is available, use an estimated height.
        if (height == null) {
            // If a previous version of this layout info exists, reuse its height.
            // Mark as estimated if the size of the overall collection view changed,
            // or the content of the item changed.
            let previousLayoutNode = this.layoutNodes.get(node.key);
            if (previousLayoutNode) {
                height = previousLayoutNode.layoutInfo.rect.height;
                isEstimated = node !== previousLayoutNode.node || width !== previousLayoutNode.layoutInfo.rect.width || previousLayoutNode.layoutInfo.estimatedSize;
            } else {
                height = estimatedHeight ?? DEFAULT_ROW_HEIGHT;
                isEstimated = true;
            }
        }
        return {
            height,
            isEstimated
        };
    }
    getEstimatedRowHeight() {
        return this.rowHeight ?? this.estimatedRowHeight ?? DEFAULT_ROW_HEIGHT;
    }
    buildColumn(node, x, y) {
        let width = this.getRenderedColumnWidth(node);
        let { height, isEstimated } = this.getEstimatedHeight(node, width, this.headingHeight ?? this.rowHeight, this.estimatedHeadingHeight ?? this.estimatedRowHeight);
        let rect = new (0, _virtualizer.Rect)(x, y, width, height);
        let layoutInfo = new (0, _virtualizer.LayoutInfo)(node.type, node.key, rect);
        layoutInfo.isSticky = this.isStickyColumn(node);
        layoutInfo.zIndex = layoutInfo.isSticky ? 2 : 1;
        layoutInfo.estimatedSize = isEstimated;
        return {
            layoutInfo,
            children: [],
            validRect: layoutInfo.rect,
            node
        };
    }
    // For subclasses.
    // eslint-disable-next-line
    isStickyColumn(node) {
        return false;
    }
    buildBody(y) {
        let collection = this.virtualizer.collection;
        let rect = new (0, _virtualizer.Rect)(this.padding, y, 0, 0);
        let layoutInfo = new (0, _virtualizer.LayoutInfo)('rowgroup', collection.body.key, rect);
        let startY = y;
        let skipped = 0;
        let width = 0;
        let children = [];
        let rowHeight = this.getEstimatedRowHeight() + this.gap;
        let childNodes = (0, _collections.getChildNodes)(collection.body, collection);
        for (let node of childNodes){
            // Skip rows before the valid rectangle unless they are already cached.
            if (y + rowHeight < this.requestedRect.y && !this.isValid(node, y)) {
                y += rowHeight;
                skipped++;
                continue;
            }
            let layoutNode = this.buildChild(node, this.padding, y, layoutInfo.key);
            layoutNode.layoutInfo.parentKey = layoutInfo.key;
            layoutNode.index = children.length;
            y = layoutNode.layoutInfo.rect.maxY + this.gap;
            width = Math.max(width, layoutNode.layoutInfo.rect.width);
            children.push(layoutNode);
            if (y > this.requestedRect.maxY) {
                let rowsAfterRect = collection.size - (children.length + skipped);
                let lastNode = (0, _collections.getLastItem)(childNodes);
                // Estimate the remaining height for rows that we don't need to layout right now.
                y += rowsAfterRect * rowHeight;
                // Always add the loader sentinel if present. This assumes the loader is the last row in the body,
                // will need to refactor when handling multi section loading
                if (lastNode?.type === 'loader' && children.at(-1)?.layoutInfo.type !== 'loader') {
                    let loader = this.buildChild(lastNode, this.padding, y, layoutInfo.key);
                    loader.layoutInfo.parentKey = layoutInfo.key;
                    loader.index = collection.size;
                    width = Math.max(width, loader.layoutInfo.rect.width);
                    children.push(loader);
                    y = loader.layoutInfo.rect.maxY;
                }
                break;
            }
        }
        // Make sure that the table body gets a height if empty or performing initial load
        let isEmptyOrLoading = collection?.size === 0;
        if (isEmptyOrLoading) y = this.virtualizer.visibleRect.maxY;
        else y -= this.gap;
        rect.width = width;
        rect.height = y - startY;
        return {
            layoutInfo,
            children,
            validRect: layoutInfo.rect.intersection(this.requestedRect),
            node: collection.body
        };
    }
    buildNode(node, x, y) {
        switch(node.type){
            case 'headerrow':
                return this.buildHeaderRow(node, x, y);
            case 'item':
                return this.buildRow(node, x, y);
            case 'column':
            case 'placeholder':
                return this.buildColumn(node, x, y);
            case 'cell':
                return this.buildCell(node, x, y);
            case 'loader':
                return this.buildLoader(node, x, y);
            default:
                throw new Error('Unknown node type ' + node.type);
        }
    }
    buildRow(node, x, y) {
        let collection = this.virtualizer.collection;
        let rect = new (0, _virtualizer.Rect)(x, y, 0, 0);
        let layoutInfo = new (0, _virtualizer.LayoutInfo)('row', node.key, rect);
        let children = [];
        let height = 0;
        for (let child of (0, _collections.getChildNodes)(node, collection))if (child.type === 'cell') {
            if (x > this.requestedRect.maxX) {
                // Adjust existing cached layoutInfo to ensure that it is out of view.
                // This can happen due to column resizing.
                let layoutNode = this.layoutNodes.get(child.key);
                if (layoutNode) {
                    layoutNode.layoutInfo.rect.x = x;
                    x += layoutNode.layoutInfo.rect.width;
                } else break;
            } else {
                let layoutNode = this.buildChild(child, x, y, layoutInfo.key);
                x = layoutNode.layoutInfo.rect.maxX;
                height = Math.max(height, layoutNode.layoutInfo.rect.height);
                layoutNode.index = children.length;
                children.push(layoutNode);
            }
        }
        this.setChildHeights(children, height);
        rect.width = this.layoutNodes.get(collection.head?.key ?? 'header').layoutInfo.rect.width;
        rect.height = height;
        return {
            layoutInfo,
            children,
            validRect: rect.intersection(this.requestedRect),
            node
        };
    }
    buildCell(node, x, y) {
        let width = this.getRenderedColumnWidth(node);
        let { height, isEstimated } = this.getEstimatedHeight(node, width, this.rowHeight, this.estimatedRowHeight);
        let rect = new (0, _virtualizer.Rect)(x, y, width, height);
        let layoutInfo = new (0, _virtualizer.LayoutInfo)(node.type, node.key, rect);
        layoutInfo.isSticky = this.isStickyColumn(node);
        layoutInfo.zIndex = layoutInfo.isSticky ? 2 : 1;
        layoutInfo.estimatedSize = isEstimated;
        return {
            layoutInfo,
            children: [],
            validRect: rect,
            node
        };
    }
    getVisibleLayoutInfos(rect) {
        // Adjust rect to keep number of visible rows consistent.
        // (only if height > 1 for getDropTargetFromPoint)
        if (rect.height > 1) {
            let rowHeight = this.getEstimatedRowHeight();
            rect.y = Math.floor(rect.y / rowHeight) * rowHeight;
            rect.height = Math.ceil(rect.height / rowHeight) * rowHeight;
        }
        // If layout hasn't yet been done for the requested rect, union the
        // new rect with the existing valid rect, and recompute.
        this.layoutIfNeeded(rect);
        let res = [];
        this.buildPersistedIndices();
        for (let node of this.rootNodes){
            res.push(node.layoutInfo);
            this.addVisibleLayoutInfos(res, node, rect);
        }
        return res;
    }
    addVisibleLayoutInfos(res, node, rect) {
        if (!node.children || node.children.length === 0) return;
        switch(node.layoutInfo.type){
            case 'header':
                for (let child of node.children){
                    res.push(child.layoutInfo);
                    this.addVisibleLayoutInfos(res, child, rect);
                }
                break;
            case 'rowgroup':
                {
                    let firstVisibleRow = this.binarySearch(node.children, rect.topLeft, 'y');
                    let lastVisibleRow = this.binarySearch(node.children, rect.bottomRight, 'y');
                    // Add persisted rows before the visible rows.
                    let persistedRowIndices = this.persistedIndices.get(node.layoutInfo.key);
                    let persistIndex = 0;
                    while(persistedRowIndices && persistIndex < persistedRowIndices.length && persistedRowIndices[persistIndex] < firstVisibleRow){
                        let idx = persistedRowIndices[persistIndex];
                        if (idx < node.children.length) {
                            res.push(node.children[idx].layoutInfo);
                            this.addVisibleLayoutInfos(res, node.children[idx], rect);
                        }
                        persistIndex++;
                    }
                    for(let i = firstVisibleRow; i <= lastVisibleRow; i++){
                        // Skip persisted rows that overlap with visible cells.
                        while(persistedRowIndices && persistIndex < persistedRowIndices.length && persistedRowIndices[persistIndex] < i)persistIndex++;
                        res.push(node.children[i].layoutInfo);
                        this.addVisibleLayoutInfos(res, node.children[i], rect);
                    }
                    // Add persisted rows after the visible rows.
                    while(persistedRowIndices && persistIndex < persistedRowIndices.length){
                        let idx = persistedRowIndices[persistIndex++];
                        if (idx < node.children.length) {
                            res.push(node.children[idx].layoutInfo);
                            this.addVisibleLayoutInfos(res, node.children[idx], rect);
                        }
                    }
                    // Always include loading sentinel even when virtualized, we assume it is always the last child for now
                    let lastRow = node.children.at(-1);
                    if (lastRow?.layoutInfo.type === 'loader') res.push(lastRow.layoutInfo);
                    break;
                }
            case 'headerrow':
            case 'row':
                {
                    let firstVisibleCell = this.binarySearch(node.children, rect.topLeft, 'x');
                    let lastVisibleCell = this.binarySearch(node.children, rect.topRight, 'x');
                    let stickyIndex = 0;
                    // Add persisted/sticky cells before the visible cells.
                    let persistedCellIndices = this.persistedIndices.get(node.layoutInfo.key) || this.stickyColumnIndices;
                    while(stickyIndex < persistedCellIndices.length && persistedCellIndices[stickyIndex] < firstVisibleCell){
                        let idx = persistedCellIndices[stickyIndex];
                        if (idx < node.children.length) res.push(node.children[idx].layoutInfo);
                        stickyIndex++;
                    }
                    for(let i = firstVisibleCell; i <= lastVisibleCell; i++){
                        // Skip sticky cells that overlap with visible cells.
                        while(stickyIndex < persistedCellIndices.length && persistedCellIndices[stickyIndex] < i)stickyIndex++;
                        res.push(node.children[i].layoutInfo);
                    }
                    // Add any remaining sticky cells after the visible cells.
                    while(stickyIndex < persistedCellIndices.length){
                        let idx = persistedCellIndices[stickyIndex++];
                        if (idx < node.children.length) res.push(node.children[idx].layoutInfo);
                    }
                    break;
                }
            default:
                throw new Error('Unknown node type ' + node.layoutInfo.type);
        }
    }
    binarySearch(items, point, axis) {
        let low = 0;
        let high = items.length - 1;
        while(low <= high){
            let mid = low + high >> 1;
            let item = items[mid];
            if (axis === 'x' && item.layoutInfo.rect.maxX <= point.x || axis === 'y' && item.layoutInfo.rect.maxY <= point.y) low = mid + 1;
            else if (axis === 'x' && item.layoutInfo.rect.x > point.x || axis === 'y' && item.layoutInfo.rect.y > point.y) high = mid - 1;
            else return mid;
        }
        return Math.max(0, Math.min(items.length - 1, low));
    }
    buildPersistedIndices() {
        if (this.virtualizer.persistedKeys === this.lastPersistedKeys) return;
        this.lastPersistedKeys = this.virtualizer.persistedKeys;
        this.persistedIndices.clear();
        // Build a map of parentKey => indices of children to persist.
        for (let key of this.virtualizer.persistedKeys){
            let layoutInfo = this.layoutNodes.get(key)?.layoutInfo;
            // Walk up ancestors so parents are also persisted if children are.
            while(layoutInfo && layoutInfo.parentKey){
                let collectionNode = this.virtualizer.collection.getItem(layoutInfo.key);
                let indices = this.persistedIndices.get(layoutInfo.parentKey);
                if (!indices) {
                    // stickyColumnIndices are always persisted along with any cells from persistedKeys.
                    indices = collectionNode?.type === 'cell' || collectionNode?.type === 'column' ? [
                        ...this.stickyColumnIndices
                    ] : [];
                    this.persistedIndices.set(layoutInfo.parentKey, indices);
                }
                let index = this.layoutNodes.get(layoutInfo.key)?.index;
                if (index != null && !indices.includes(index)) indices.push(index);
                layoutInfo = this.layoutNodes.get(layoutInfo.parentKey)?.layoutInfo;
            }
        }
        for (let indices of this.persistedIndices.values())indices.sort((a, b)=>a - b);
    }
    getDropTargetFromPoint(x, y, isValidDropTarget) {
        x += this.virtualizer.visibleRect.x;
        y += this.virtualizer.visibleRect.y;
        // Find the closest item within on either side of the point using the gap width.
        let searchRect = new (0, _virtualizer.Rect)(x, Math.max(0, y - this.gap), 1, Math.max(1, this.gap * 2));
        let candidates = this.getVisibleLayoutInfos(searchRect);
        let key = null;
        let minDistance = Infinity;
        for (let candidate of candidates){
            // Ignore items outside the search rect, e.g. persisted keys.
            if (candidate.type !== 'row' || !candidate.rect.intersects(searchRect)) continue;
            let yDist = Math.abs(candidate.rect.y - y);
            let maxYDist = Math.abs(candidate.rect.maxY - y);
            let dist = Math.min(yDist, maxYDist);
            if (dist < minDistance) {
                minDistance = dist;
                key = candidate.key;
            }
        }
        if (key == null || this.virtualizer.collection.size === 0) return {
            type: 'root'
        };
        let layoutInfo = this.getLayoutInfo(key);
        if (!layoutInfo) return null;
        let rect = layoutInfo.rect;
        let target = {
            type: 'item',
            key: layoutInfo.key,
            dropPosition: 'on'
        };
        // If dropping on the item isn't accepted, try the target before or after depending on the y position.
        // Otherwise, if dropping on the item is accepted, still try the before/after positions if within 10px
        // of the top or bottom of the item.
        if (!isValidDropTarget(target)) {
            if (y <= rect.y + rect.height / 2 && isValidDropTarget({
                ...target,
                dropPosition: 'before'
            })) target.dropPosition = 'before';
            else if (isValidDropTarget({
                ...target,
                dropPosition: 'after'
            })) target.dropPosition = 'after';
        } else if (y <= rect.y + 10 && isValidDropTarget({
            ...target,
            dropPosition: 'before'
        })) target.dropPosition = 'before';
        else if (y >= rect.maxY - 10 && isValidDropTarget({
            ...target,
            dropPosition: 'after'
        })) target.dropPosition = 'after';
        return target;
    }
    getDropTargetLayoutInfo(target) {
        let layoutInfo = super.getDropTargetLayoutInfo(target);
        layoutInfo.parentKey = this.virtualizer.collection.body.key;
        return layoutInfo;
    }
}

},{"@react-stately/collections":"HxEYQ","@react-stately/virtualizer":[["LayoutInfo","6H2VJ"],["Rect","l3p76"],["Size","F8cca"]],"./ListLayout":"6OEhs","@react-stately/table":"lxLyd","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"lHsCS":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InlineAlertContext", ()=>InlineAlertContext);
parcelHelpers.export(exports, "InlineAlert", ()=>InlineAlert);
var _jsxRuntime = require("react/jsx-runtime");
var _s2IconAlertTriangle20NSvg = require("../s2wf-icons/S2_Icon_AlertTriangle_20_N.svg");
var _s2IconAlertTriangle20NSvgDefault = parcelHelpers.interopDefault(_s2IconAlertTriangle20NSvg);
var _s2IconCheckmarkCircle20NSvg = require("../s2wf-icons/S2_Icon_CheckmarkCircle_20_N.svg");
var _s2IconCheckmarkCircle20NSvgDefault = parcelHelpers.interopDefault(_s2IconCheckmarkCircle20NSvg);
var _react = require("react");
var _content = require("./Content");
var _reactAriaComponents = require("react-aria-components");
var _utils = require("@react-aria/utils");
var _icon = require("./Icon");
var _s2IconInfoCircle20NSvg = require("../s2wf-icons/S2_Icon_InfoCircle_20_N.svg");
var _s2IconInfoCircle20NSvgDefault = parcelHelpers.interopDefault(_s2IconInfoCircle20NSvg);
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _s2IconAlertDiamond20NSvg = require("../s2wf-icons/S2_Icon_AlertDiamond_20_N.svg");
var _s2IconAlertDiamond20NSvgDefault = parcelHelpers.interopDefault(_s2IconAlertDiamond20NSvg);
var _utils1 = require("@react-spectrum/utils");
var _reactAria = require("react-aria");
var _i18N = require("@react-aria/i18n");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const InlineAlertContext = /*#__PURE__*/ (0, _react.createContext)(null);
const inlineAlert = function anonymous(props, overrides) {
    let rules = " ", currentRules = {};
    let position = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L|-macro\$)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "_P") position = true;
        rules += p[0];
    }
    if (props.isFocusVisible) {
        rules += ' _Lf12';
        currentRules["outlineStyle"] = typeof currentRules["outlineStyle"] === 'object' ? currentRules["outlineStyle"] : {
            "default": currentRules["outlineStyle"]
        };
        currentRules["outlineStyle"]["isFocusVisible"] = "solid";
    } else {
        rules += ' _Le12';
        currentRules["outlineStyle"] = "none";
    }
    rules += ' Oh12';
    currentRules["outlineColor"] = "focus-ring";
    rules += ' _Mc12';
    currentRules["outlineWidth"] = 2;
    rules += ' _Kd12';
    currentRules["outlineOffset"] = 2;
    rules += ' sg12';
    currentRules["display"] = "inline-block";
    if (!position) rules += ' _Pc12';
    currentRules["position"] = "relative";
    rules += ' _oa12';
    currentRules["boxSizing"] = "border-box";
    rules += ' Th12';
    currentRules["paddingTop"] = 24;
    rules += ' Qh12';
    currentRules["paddingBottom"] = 24;
    rules += ' Sh12';
    currentRules["paddingStart"] = 24;
    rules += ' Rh12';
    currentRules["paddingEnd"] = 24;
    rules += ' oc12';
    currentRules["borderTopStartRadius"] = "lg";
    rules += ' nc12';
    currentRules["borderTopEndRadius"] = "lg";
    rules += ' kc12';
    currentRules["borderBottomStartRadius"] = "lg";
    rules += ' jc12';
    currentRules["borderBottomEndRadius"] = "lg";
    rules += ' _jf12';
    currentRules["borderStyle"] = "solid";
    rules += ' _kc12';
    currentRules["borderTopWidth"] = 2;
    rules += ' hc12';
    currentRules["borderBottomWidth"] = 2;
    rules += ' mc12';
    currentRules["borderStartWidth"] = 2;
    rules += ' lc12';
    currentRules["borderEndWidth"] = 2;
    if (props.fillStyle === "boldFill") {
        rules += ' iA12';
        currentRules["borderColor"] = typeof currentRules["borderColor"] === 'object' ? currentRules["borderColor"] : {
            "default": currentRules["borderColor"]
        };
        currentRules["borderColor"]["fillStyle === \"boldFill\""] = "transparent";
    } else if (props.fillStyle === "subtleFill") {
        rules += ' iA12';
        currentRules["borderColor"] = typeof currentRules["borderColor"] === 'object' ? currentRules["borderColor"] : {
            "default": currentRules["borderColor"]
        };
        currentRules["borderColor"]["fillStyle === \"subtleFill\""] = "transparent";
    } else if (props.fillStyle === "border") {
        if (props.variant === "neutral") {
            rules += ' iy12';
            currentRules["borderColor"] = typeof currentRules["borderColor"] === 'object' ? currentRules["borderColor"] : {
                "default": currentRules["borderColor"]
            };
            currentRules["borderColor"]["fillStyle === \"border\" && variant === \"neutral\""] = "gray-700";
        } else if (props.variant === "negative") {
            rules += ' it12';
            currentRules["borderColor"] = typeof currentRules["borderColor"] === 'object' ? currentRules["borderColor"] : {
                "default": currentRules["borderColor"]
            };
            currentRules["borderColor"]["fillStyle === \"border\" && variant === \"negative\""] = "negative-800";
        } else if (props.variant === "notice") {
            rules += ' is12';
            currentRules["borderColor"] = typeof currentRules["borderColor"] === 'object' ? currentRules["borderColor"] : {
                "default": currentRules["borderColor"]
            };
            currentRules["borderColor"]["fillStyle === \"border\" && variant === \"notice\""] = "notice-700";
        } else if (props.variant === "positive") {
            rules += ' il12';
            currentRules["borderColor"] = typeof currentRules["borderColor"] === 'object' ? currentRules["borderColor"] : {
                "default": currentRules["borderColor"]
            };
            currentRules["borderColor"]["fillStyle === \"border\" && variant === \"positive\""] = "positive-700";
        } else if (props.variant === "informative") {
            rules += ' ix12';
            currentRules["borderColor"] = typeof currentRules["borderColor"] === 'object' ? currentRules["borderColor"] : {
                "default": currentRules["borderColor"]
            };
            currentRules["borderColor"]["fillStyle === \"border\" && variant === \"informative\""] = "informative-800";
        }
    }
    if (props.variant === "neutral") {
        if (props.fillStyle === "boldFill") {
            rules += ' g612';
            currentRules["backgroundColor"] = typeof currentRules["backgroundColor"] === 'object' ? currentRules["backgroundColor"] : {
                "default": currentRules["backgroundColor"]
            };
            currentRules["backgroundColor"]["variant === \"neutral\" && fillStyle === \"boldFill\""] = "neutral-subdued";
        } else if (props.fillStyle === "subtleFill") {
            rules += ' gI12';
            currentRules["backgroundColor"] = typeof currentRules["backgroundColor"] === 'object' ? currentRules["backgroundColor"] : {
                "default": currentRules["backgroundColor"]
            };
            currentRules["backgroundColor"]["variant === \"neutral\" && fillStyle === \"subtleFill\""] = "neutral-subtle";
        } else if (props.fillStyle === "border") {
            rules += ' gX12';
            currentRules["backgroundColor"] = typeof currentRules["backgroundColor"] === 'object' ? currentRules["backgroundColor"] : {
                "default": currentRules["backgroundColor"]
            };
            currentRules["backgroundColor"]["variant === \"neutral\" && fillStyle === \"border\""] = "gray-25";
        }
    } else if (props.variant === "negative") {
        if (props.fillStyle === "boldFill") {
            rules += ' gB12';
            currentRules["backgroundColor"] = typeof currentRules["backgroundColor"] === 'object' ? currentRules["backgroundColor"] : {
                "default": currentRules["backgroundColor"]
            };
            currentRules["backgroundColor"]["variant === \"negative\" && fillStyle === \"boldFill\""] = "negative";
        } else if (props.fillStyle === "subtleFill") {
            rules += ' gU12';
            currentRules["backgroundColor"] = typeof currentRules["backgroundColor"] === 'object' ? currentRules["backgroundColor"] : {
                "default": currentRules["backgroundColor"]
            };
            currentRules["backgroundColor"]["variant === \"negative\" && fillStyle === \"subtleFill\""] = "negative-subtle";
        } else if (props.fillStyle === "border") {
            rules += ' gX12';
            currentRules["backgroundColor"] = typeof currentRules["backgroundColor"] === 'object' ? currentRules["backgroundColor"] : {
                "default": currentRules["backgroundColor"]
            };
            currentRules["backgroundColor"]["variant === \"negative\" && fillStyle === \"border\""] = "gray-25";
        }
    } else if (props.variant === "notice") {
        if (props.fillStyle === "boldFill") {
            rules += ' gQ12';
            currentRules["backgroundColor"] = typeof currentRules["backgroundColor"] === 'object' ? currentRules["backgroundColor"] : {
                "default": currentRules["backgroundColor"]
            };
            currentRules["backgroundColor"]["variant === \"notice\" && fillStyle === \"boldFill\""] = "notice";
        } else if (props.fillStyle === "subtleFill") {
            rules += ' gV12';
            currentRules["backgroundColor"] = typeof currentRules["backgroundColor"] === 'object' ? currentRules["backgroundColor"] : {
                "default": currentRules["backgroundColor"]
            };
            currentRules["backgroundColor"]["variant === \"notice\" && fillStyle === \"subtleFill\""] = "notice-subtle";
        } else if (props.fillStyle === "border") {
            rules += ' gX12';
            currentRules["backgroundColor"] = typeof currentRules["backgroundColor"] === 'object' ? currentRules["backgroundColor"] : {
                "default": currentRules["backgroundColor"]
            };
            currentRules["backgroundColor"]["variant === \"notice\" && fillStyle === \"border\""] = "gray-25";
        }
    } else if (props.variant === "positive") {
        if (props.fillStyle === "boldFill") {
            rules += ' g112';
            currentRules["backgroundColor"] = typeof currentRules["backgroundColor"] === 'object' ? currentRules["backgroundColor"] : {
                "default": currentRules["backgroundColor"]
            };
            currentRules["backgroundColor"]["variant === \"positive\" && fillStyle === \"boldFill\""] = "positive";
        } else if (props.fillStyle === "subtleFill") {
            rules += ' gA12';
            currentRules["backgroundColor"] = typeof currentRules["backgroundColor"] === 'object' ? currentRules["backgroundColor"] : {
                "default": currentRules["backgroundColor"]
            };
            currentRules["backgroundColor"]["variant === \"positive\" && fillStyle === \"subtleFill\""] = "positive-subtle";
        } else if (props.fillStyle === "border") {
            rules += ' gX12';
            currentRules["backgroundColor"] = typeof currentRules["backgroundColor"] === 'object' ? currentRules["backgroundColor"] : {
                "default": currentRules["backgroundColor"]
            };
            currentRules["backgroundColor"]["variant === \"positive\" && fillStyle === \"border\""] = "gray-25";
        }
    } else if (props.variant === "informative") {
        if (props.fillStyle === "boldFill") {
            rules += ' g212';
            currentRules["backgroundColor"] = typeof currentRules["backgroundColor"] === 'object' ? currentRules["backgroundColor"] : {
                "default": currentRules["backgroundColor"]
            };
            currentRules["backgroundColor"]["variant === \"informative\" && fillStyle === \"boldFill\""] = "informative";
        } else if (props.fillStyle === "subtleFill") {
            rules += ' gG12';
            currentRules["backgroundColor"] = typeof currentRules["backgroundColor"] === 'object' ? currentRules["backgroundColor"] : {
                "default": currentRules["backgroundColor"]
            };
            currentRules["backgroundColor"]["variant === \"informative\" && fillStyle === \"subtleFill\""] = "informative-subtle";
        } else if (props.fillStyle === "border") {
            rules += ' gX12';
            currentRules["backgroundColor"] = typeof currentRules["backgroundColor"] === 'object' ? currentRules["backgroundColor"] : {
                "default": currentRules["backgroundColor"]
            };
            currentRules["backgroundColor"]["variant === \"informative\" && fillStyle === \"border\""] = "gray-25";
        }
    }
    return rules;
};
const icon = function anonymous(props) {
    let rules = " ", currentRules = {};
    rules += ' __wa12';
    currentRules["float"] = "inline-end";
    if (props.fillStyle === "boldFill") {
        if (props.variant === "notice") {
            rules += ' -_8sjo0b-tcwrnr12';
            currentRules["--iconPrimary"] = typeof currentRules["--iconPrimary"] === 'object' ? currentRules["--iconPrimary"] : {
                "default": currentRules["--iconPrimary"]
            };
            currentRules["--iconPrimary"]["fillStyle === \"boldFill\" && variant === \"notice\""] = "black";
        } else {
            rules += ' -_8sjo0b-tw12';
            currentRules["--iconPrimary"] = typeof currentRules["--iconPrimary"] === 'object' ? currentRules["--iconPrimary"] : {
                "default": currentRules["--iconPrimary"]
            };
            currentRules["--iconPrimary"]["fillStyle === \"boldFill\""] = "white";
        }
    } else if (props.fillStyle === "subtleFill") {
        if (props.variant === "neutral") {
            rules += ' -_8sjo0b-tf12';
            currentRules["--iconPrimary"] = typeof currentRules["--iconPrimary"] === 'object' ? currentRules["--iconPrimary"] : {
                "default": currentRules["--iconPrimary"]
            };
            currentRules["--iconPrimary"]["fillStyle === \"subtleFill\" && variant === \"neutral\""] = "neutral";
        } else if (props.variant === "negative") {
            rules += ' -_8sjo0b-tq12';
            currentRules["--iconPrimary"] = typeof currentRules["--iconPrimary"] === 'object' ? currentRules["--iconPrimary"] : {
                "default": currentRules["--iconPrimary"]
            };
            currentRules["--iconPrimary"]["fillStyle === \"subtleFill\" && variant === \"negative\""] = "negative";
        } else if (props.variant === "notice") {
            rules += ' -_8sjo0b-tq12';
            currentRules["--iconPrimary"] = typeof currentRules["--iconPrimary"] === 'object' ? currentRules["--iconPrimary"] : {
                "default": currentRules["--iconPrimary"]
            };
            currentRules["--iconPrimary"]["fillStyle === \"subtleFill\" && variant === \"notice\""] = "negative";
        } else if (props.variant === "positive") {
            rules += ' -_8sjo0b-tt12';
            currentRules["--iconPrimary"] = typeof currentRules["--iconPrimary"] === 'object' ? currentRules["--iconPrimary"] : {
                "default": currentRules["--iconPrimary"]
            };
            currentRules["--iconPrimary"]["fillStyle === \"subtleFill\" && variant === \"positive\""] = "positive";
        } else if (props.variant === "informative") {
            rules += ' -_8sjo0b-tu12';
            currentRules["--iconPrimary"] = typeof currentRules["--iconPrimary"] === 'object' ? currentRules["--iconPrimary"] : {
                "default": currentRules["--iconPrimary"]
            };
            currentRules["--iconPrimary"]["fillStyle === \"subtleFill\" && variant === \"informative\""] = "informative";
        }
    } else if (props.fillStyle === "border") {
        if (props.variant === "neutral") {
            rules += ' -_8sjo0b-tf12';
            currentRules["--iconPrimary"] = typeof currentRules["--iconPrimary"] === 'object' ? currentRules["--iconPrimary"] : {
                "default": currentRules["--iconPrimary"]
            };
            currentRules["--iconPrimary"]["fillStyle === \"border\" && variant === \"neutral\""] = "neutral";
        } else if (props.variant === "negative") {
            rules += ' -_8sjo0b-tq12';
            currentRules["--iconPrimary"] = typeof currentRules["--iconPrimary"] === 'object' ? currentRules["--iconPrimary"] : {
                "default": currentRules["--iconPrimary"]
            };
            currentRules["--iconPrimary"]["fillStyle === \"border\" && variant === \"negative\""] = "negative";
        } else if (props.variant === "notice") {
            rules += ' -_8sjo0b-tm12';
            currentRules["--iconPrimary"] = typeof currentRules["--iconPrimary"] === 'object' ? currentRules["--iconPrimary"] : {
                "default": currentRules["--iconPrimary"]
            };
            currentRules["--iconPrimary"]["fillStyle === \"border\" && variant === \"notice\""] = "notice";
        } else if (props.variant === "positive") {
            rules += ' -_8sjo0b-tt12';
            currentRules["--iconPrimary"] = typeof currentRules["--iconPrimary"] === 'object' ? currentRules["--iconPrimary"] : {
                "default": currentRules["--iconPrimary"]
            };
            currentRules["--iconPrimary"]["fillStyle === \"border\" && variant === \"positive\""] = "positive";
        } else if (props.variant === "informative") {
            rules += ' -_8sjo0b-tu12';
            currentRules["--iconPrimary"] = typeof currentRules["--iconPrimary"] === 'object' ? currentRules["--iconPrimary"] : {
                "default": currentRules["--iconPrimary"]
            };
            currentRules["--iconPrimary"]["fillStyle === \"border\" && variant === \"informative\""] = "informative";
        }
    }
    return rules;
};
let ICONS = {
    informative: (0, _s2IconInfoCircle20NSvgDefault.default),
    positive: (0, _s2IconCheckmarkCircle20NSvgDefault.default),
    notice: (0, _s2IconAlertDiamond20NSvgDefault.default),
    negative: (0, _s2IconAlertTriangle20NSvgDefault.default),
    neutral: undefined
};
const heading = function anonymous(props) {
    let rules = " ", currentRules = {};
    rules += ' Jy12';
    currentRules["marginTop"] = 0;
    rules += ' uk12';
    currentRules["fontFamily"] = "sans";
    rules += ' uch12';
    currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
        "default": currentRules["fontFamily"]
    };
    currentRules["fontFamily"][":lang(ar)"] = "sans";
    rules += ' udi12';
    currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
        "default": currentRules["fontFamily"]
    };
    currentRules["fontFamily"][":lang(he)"] = "sans";
    rules += ' uea12';
    currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
        "default": currentRules["fontFamily"]
    };
    currentRules["fontFamily"][":lang(ja)"] = "sans";
    rules += ' ugb12';
    currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
        "default": currentRules["fontFamily"]
    };
    currentRules["fontFamily"][":lang(ko)"] = "sans";
    rules += ' uhd12';
    currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
        "default": currentRules["fontFamily"]
    };
    currentRules["fontFamily"][":lang(zh)"] = "sans";
    rules += ' uje12';
    currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
        "default": currentRules["fontFamily"]
    };
    currentRules["fontFamily"][":lang(zh-hant)"] = "sans";
    rules += ' u2NhKxcl12';
    currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
        "default": currentRules["fontFamily"]
    };
    currentRules["fontFamily"][":lang(zh-HK)"] = "sans";
    rules += ' uic12';
    currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
        "default": currentRules["fontFamily"]
    };
    currentRules["fontFamily"][":lang(zh-Hans, zh-CN, zh-SG)"] = "sans";
    rules += ' -_6BNtrc-c12';
    currentRules["fontSize"] = "title-sm";
    rules += ' vx12';
    currentRules["fontSize"] = "title-sm";
    rules += ' xd12';
    currentRules["fontWeight"] = "title";
    rules += ' _xa12';
    currentRules["fontWeight"] = "title";
    rules += ' xX0cczbc12';
    currentRules["fontWeight"] = typeof currentRules["fontWeight"] === 'object' ? currentRules["fontWeight"] : {
        "default": currentRules["fontWeight"]
    };
    currentRules["fontWeight"][":lang(ja, ko, zh)"] = "title";
    rules += ' _xX0cczba12';
    currentRules["fontWeight"] = typeof currentRules["fontWeight"] === 'object' ? currentRules["fontWeight"] : {
        "default": currentRules["fontWeight"]
    };
    currentRules["fontWeight"][":lang(ja, ko, zh)"] = "title";
    rules += ' xfd12';
    currentRules["fontWeight"] = typeof currentRules["fontWeight"] === 'object' ? currentRules["fontWeight"] : {
        "default": currentRules["fontWeight"]
    };
    currentRules["fontWeight"][":lang(ja, ko, zh, zh-Hant, zh-Hans)"] = "title";
    rules += ' _xfa12';
    currentRules["fontWeight"] = typeof currentRules["fontWeight"] === 'object' ? currentRules["fontWeight"] : {
        "default": currentRules["fontWeight"]
    };
    currentRules["fontWeight"][":lang(ja, ko, zh, zh-Hant, zh-Hans)"] = "title";
    rules += ' xfX0cczbc12';
    currentRules["fontWeight"] = typeof currentRules["fontWeight"] === 'object' ? currentRules["fontWeight"] : {
        "default": currentRules["fontWeight"]
    };
    currentRules["fontWeight"][":lang(ja, ko, zh):lang(ja, ko, zh, zh-Hant, zh-Hans)"] = "title";
    rules += ' _xfX0cczba12';
    currentRules["fontWeight"] = typeof currentRules["fontWeight"] === 'object' ? currentRules["fontWeight"] : {
        "default": currentRules["fontWeight"]
    };
    currentRules["fontWeight"][":lang(ja, ko, zh):lang(ja, ko, zh, zh-Hant, zh-Hans)"] = "title";
    rules += ' _Fd12';
    currentRules["lineHeight"] = "title";
    rules += ' _FezxGHba12';
    currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
        "default": currentRules["lineHeight"]
    };
    currentRules["lineHeight"][":lang(ar, he)"] = "title";
    rules += ' _FnuYUweb12';
    currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
        "default": currentRules["lineHeight"]
    };
    currentRules["lineHeight"][":lang(ja, ko, zh, zh-Hant, zh-Hans, zh-CN, zh-SG)"] = "title";
    if (props.fillStyle === "boldFill") {
        if (props.variant === "notice") {
            rules += ' pg12';
            currentRules["color"] = typeof currentRules["color"] === 'object' ? currentRules["color"] : {
                "default": currentRules["color"]
            };
            currentRules["color"]["fillStyle === \"boldFill\" && variant === \"notice\""] = "black";
        } else {
            rules += ' px12';
            currentRules["color"] = typeof currentRules["color"] === 'object' ? currentRules["color"] : {
                "default": currentRules["color"]
            };
            currentRules["color"]["fillStyle === \"boldFill\""] = "white";
        }
    } else {
        rules += ' po12';
        currentRules["color"] = "title";
    }
    return rules;
};
const content = function anonymous(props) {
    let rules = " ", currentRules = {};
    rules += ' uk12';
    currentRules["fontFamily"] = "sans";
    rules += ' uch12';
    currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
        "default": currentRules["fontFamily"]
    };
    currentRules["fontFamily"][":lang(ar)"] = "sans";
    rules += ' udi12';
    currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
        "default": currentRules["fontFamily"]
    };
    currentRules["fontFamily"][":lang(he)"] = "sans";
    rules += ' uea12';
    currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
        "default": currentRules["fontFamily"]
    };
    currentRules["fontFamily"][":lang(ja)"] = "sans";
    rules += ' ugb12';
    currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
        "default": currentRules["fontFamily"]
    };
    currentRules["fontFamily"][":lang(ko)"] = "sans";
    rules += ' uhd12';
    currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
        "default": currentRules["fontFamily"]
    };
    currentRules["fontFamily"][":lang(zh)"] = "sans";
    rules += ' uje12';
    currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
        "default": currentRules["fontFamily"]
    };
    currentRules["fontFamily"][":lang(zh-hant)"] = "sans";
    rules += ' u2NhKxcl12';
    currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
        "default": currentRules["fontFamily"]
    };
    currentRules["fontFamily"][":lang(zh-HK)"] = "sans";
    rules += ' uic12';
    currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
        "default": currentRules["fontFamily"]
    };
    currentRules["fontFamily"][":lang(zh-Hans, zh-CN, zh-SG)"] = "sans";
    rules += ' -_6BNtrc-c12';
    currentRules["fontSize"] = "body-sm";
    rules += ' vx12';
    currentRules["fontSize"] = "body-sm";
    rules += ' xb12';
    currentRules["fontWeight"] = "normal";
    rules += ' _xa12';
    currentRules["fontWeight"] = "normal";
    rules += ' _Fb12';
    currentRules["lineHeight"] = "body";
    rules += ' _FnuYUwec12';
    currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
        "default": currentRules["lineHeight"]
    };
    currentRules["lineHeight"][":lang(ja, ko, zh, zh-Hant, zh-Hans, zh-CN, zh-SG)"] = "body";
    if (props.fillStyle === "boldFill") {
        if (props.variant === "notice") {
            rules += ' pg12';
            currentRules["color"] = typeof currentRules["color"] === 'object' ? currentRules["color"] : {
                "default": currentRules["color"]
            };
            currentRules["color"]["fillStyle === \"boldFill\" && variant === \"notice\""] = "black";
        } else {
            rules += ' px12';
            currentRules["color"] = typeof currentRules["color"] === 'object' ? currentRules["color"] : {
                "default": currentRules["color"]
            };
            currentRules["color"]["fillStyle === \"boldFill\""] = "white";
        }
    } else {
        rules += ' pt12';
        currentRules["color"] = "body";
    }
    return rules;
};
const InlineAlert = /*#__PURE__*/ (0, _react.forwardRef)(function InlineAlert(props, ref) {
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-spectrum/s2');
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, InlineAlertContext);
    let { children, variant = 'neutral', fillStyle = 'border', autoFocus } = props;
    let domRef = (0, _utils1.useDOMRef)(ref);
    let Icon = null;
    let iconAlt = '';
    if (variant in ICONS) {
        Icon = ICONS[variant];
        if (Icon) iconAlt = stringFormatter.format(`inlinealert.${variant}`);
    }
    let { isFocusVisible, focusProps } = (0, _reactAria.useFocusRing)({
        autoFocus: props.autoFocus
    });
    let autoFocusRef = (0, _react.useRef)(props.autoFocus);
    (0, _react.useEffect)(()=>{
        if (autoFocusRef.current && domRef.current) domRef.current.focus();
        autoFocusRef.current = false;
    }, [
        domRef
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ...(0, _utils.filterDOMProps)(props),
        ...focusProps,
        ref: domRef,
        tabIndex: autoFocus ? -1 : undefined,
        autoFocus: autoFocus,
        role: "alert",
        style: props.UNSAFE_style,
        className: (props.UNSAFE_className || '') + inlineAlert({
            variant,
            fillStyle,
            isFocusVisible
        }, props.styles),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.Provider), {
            values: [
                [
                    (0, _content.HeadingContext),
                    {
                        styles: heading({
                            fillStyle
                        })
                    }
                ],
                [
                    (0, _content.ContentContext),
                    {
                        styles: content({
                            fillStyle
                        })
                    }
                ],
                [
                    (0, _icon.IconContext),
                    {
                        styles: icon({
                            variant,
                            fillStyle
                        })
                    }
                ]
            ],
            children: [
                Icon && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Icon, {
                    "aria-label": iconAlt
                }),
                children
            ]
        })
    });
});

},{"0":"acJkl","1":"fdBhW","2":"knKAC","3":"8iSQ4","react/jsx-runtime":"2Is6Z","../s2wf-icons/S2_Icon_AlertTriangle_20_N.svg":"jyuVv","../s2wf-icons/S2_Icon_CheckmarkCircle_20_N.svg":"6hpGX","react":"a1TxN","./Content":"10r6w","react-aria-components":"bA6Cz","@react-aria/utils":"3upVm","./Icon":"jQAJE","../s2wf-icons/S2_Icon_InfoCircle_20_N.svg":"hByEX","../intl/*.json":"gDH3q","../s2wf-icons/S2_Icon_AlertDiamond_20_N.svg":"921LY","@react-spectrum/utils":"jqfrX","react-aria":"6TXyU","@react-aria/i18n":"7lxyl","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"acJkl":[function() {},{}],"fdBhW":[function() {},{}],"knKAC":[function() {},{}],"8iSQ4":[function() {},{}],"bFtl7":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2025 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SelectBoxGroupContext", ()=>SelectBoxGroupContext);
/**
 * SelectBox is a single selectable item in a SelectBoxGroup.
 */ parcelHelpers.export(exports, "SelectBox", ()=>SelectBox);
parcelHelpers.export(exports, "SelectBoxGroup", ()=>SelectBoxGroup);
var _jsxRuntime = require("react/jsx-runtime");
var _checkbox = require("./Checkbox");
var _checkmark = require("../ui-icons/Checkmark");
var _checkmarkDefault = parcelHelpers.interopDefault(_checkmark);
var _reactAriaComponents = require("react-aria-components");
var _icon = require("../src/Icon");
var _pressScale = require("./pressScale");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _content = require("./Content");
var _reactAria = require("react-aria");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const SelectBoxContext = /*#__PURE__*/ (0, _react.createContext)({
    orientation: 'vertical'
});
const SelectBoxGroupContext = /*#__PURE__*/ (0, _react.createContext)(null);
const labelOnly = ':has([slot=label]):not(:has([slot=description]))';
const noIllustration = ':not(:has([slot=illustration]))';
const selectBoxStyles = function anonymous(props, overrides) {
    let rules = " ", currentRules = {};
    let position = false;
    let width = false;
    let minWidth = false;
    let maxWidth = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L|-macro\$)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "_P") position = true;
        if (p[1] === "Z") width = true;
        if (p[1] === "N") minWidth = true;
        if (p[1] === "L") maxWidth = true;
        rules += p[0];
    }
    if (props.isFocusVisible) {
        rules += ' _Lf12';
        currentRules["outlineStyle"] = typeof currentRules["outlineStyle"] === 'object' ? currentRules["outlineStyle"] : {
            "default": currentRules["outlineStyle"]
        };
        currentRules["outlineStyle"]["isFocusVisible"] = "solid";
    } else {
        rules += ' _Le12';
        currentRules["outlineStyle"] = "none";
    }
    rules += ' Oh12';
    currentRules["outlineColor"] = "focus-ring";
    rules += ' _Mc12';
    currentRules["outlineWidth"] = 2;
    rules += ' _Kd12';
    currentRules["outlineOffset"] = 2;
    rules += ' se12';
    currentRules["display"] = "grid";
    rules += ' __yM8Mfn12';
    currentRules["gridAutoRows"] = "1fr";
    if (!position) rules += ' _Pc12';
    currentRules["position"] = "relative";
    rules += ' uk12';
    currentRules["fontFamily"] = "sans";
    rules += ' uch12';
    currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
        "default": currentRules["fontFamily"]
    };
    currentRules["fontFamily"][":lang(ar)"] = "sans";
    rules += ' udi12';
    currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
        "default": currentRules["fontFamily"]
    };
    currentRules["fontFamily"][":lang(he)"] = "sans";
    rules += ' uea12';
    currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
        "default": currentRules["fontFamily"]
    };
    currentRules["fontFamily"][":lang(ja)"] = "sans";
    rules += ' ugb12';
    currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
        "default": currentRules["fontFamily"]
    };
    currentRules["fontFamily"][":lang(ko)"] = "sans";
    rules += ' uhd12';
    currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
        "default": currentRules["fontFamily"]
    };
    currentRules["fontFamily"][":lang(zh)"] = "sans";
    rules += ' uje12';
    currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
        "default": currentRules["fontFamily"]
    };
    currentRules["fontFamily"][":lang(zh-hant)"] = "sans";
    rules += ' u2NhKxcl12';
    currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
        "default": currentRules["fontFamily"]
    };
    currentRules["fontFamily"][":lang(zh-HK)"] = "sans";
    rules += ' uic12';
    currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
        "default": currentRules["fontFamily"]
    };
    currentRules["fontFamily"][":lang(zh-Hans, zh-CN, zh-SG)"] = "sans";
    rules += ' -_6BNtrc-c12';
    currentRules["fontSize"] = "ui";
    rules += ' vx12';
    currentRules["fontSize"] = "ui";
    rules += ' xb12';
    currentRules["fontWeight"] = "normal";
    rules += ' _xa12';
    currentRules["fontWeight"] = "normal";
    rules += ' _Fd12';
    currentRules["lineHeight"] = "ui";
    rules += ' _FezxGHba12';
    currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
        "default": currentRules["lineHeight"]
    };
    currentRules["lineHeight"][":lang(ar, he)"] = "ui";
    rules += ' _FnuYUweb12';
    currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
        "default": currentRules["lineHeight"]
    };
    currentRules["lineHeight"][":lang(ja, ko, zh, zh-Hant, zh-Hans, zh-CN, zh-SG)"] = "ui";
    if (props.isDisabled) {
        rules += ' pp12';
        currentRules["color"] = typeof currentRules["color"] === 'object' ? currentRules["color"] : {
            "default": currentRules["color"]
        };
        currentRules["color"]["isDisabled"] = "disabled";
    }
    rules += ' ri12';
    currentRules["cursor"] = "default";
    rules += ' _oa12';
    currentRules["boxSizing"] = "border-box";
    rules += ' _Nc12';
    currentRules["overflowX"] = "hidden";
    rules += ' Pc12';
    currentRules["overflowY"] = "hidden";
    if (props.orientation === "horizontal") {
        if (!width) rules += ' ZAK24ue12';
        currentRules["width"] = typeof currentRules["width"] === 'object' ? currentRules["width"] : {
            "default": currentRules["width"]
        };
        currentRules["width"]["orientation === \"horizontal\""] = 368;
    } else {
        if (!width) rules += ' Z75oWv12';
        currentRules["width"] = 170;
    }
    if (props.orientation === "horizontal") {
        rules += ' Fd12';
        currentRules["height"] = typeof currentRules["height"] === 'object' ? currentRules["height"] : {
            "default": currentRules["height"]
        };
        currentRules["height"]["orientation === \"horizontal\""] = "auto";
    } else {
        rules += ' F75oWv12';
        currentRules["height"] = 170;
    }
    if (props.orientation === "horizontal") {
        if (!minWidth) rules += ' NBzUiud12';
        currentRules["minWidth"] = typeof currentRules["minWidth"] === 'object' ? currentRules["minWidth"] : {
            "default": currentRules["minWidth"]
        };
        currentRules["minWidth"]["orientation === \"horizontal\""] = 188;
    } else {
        if (!minWidth) rules += ' NQGV3L12';
        currentRules["minWidth"] = 144;
    }
    if (props.orientation === "horizontal") {
        if (!maxWidth) rules += ' LILqIYb12';
        currentRules["maxWidth"] = typeof currentRules["maxWidth"] === 'object' ? currentRules["maxWidth"] : {
            "default": currentRules["maxWidth"]
        };
        currentRules["maxWidth"]["orientation === \"horizontal\""] = 480;
    } else {
        if (!maxWidth) rules += ' L75oWv12';
        currentRules["maxWidth"] = 170;
    }
    if (props.orientation === "horizontal") {
        rules += ' MKniM12';
        currentRules["minHeight"] = typeof currentRules["minHeight"] === 'object' ? currentRules["minHeight"] : {
            "default": currentRules["minHeight"]
        };
        currentRules["minHeight"]["orientation === \"horizontal\""] = 80;
    } else {
        rules += ' MQGV3L12';
        currentRules["minHeight"] = 144;
    }
    if (props.orientation === "horizontal") {
        rules += ' KDvO7ld12';
        currentRules["maxHeight"] = typeof currentRules["maxHeight"] === 'object' ? currentRules["maxHeight"] : {
            "default": currentRules["maxHeight"]
        };
        currentRules["maxHeight"]["orientation === \"horizontal\""] = 240;
    } else {
        rules += ' K75oWv12';
        currentRules["maxHeight"] = 170;
    }
    if (props.orientation === "horizontal") {
        rules += ' Tf12';
        currentRules["paddingTop"] = typeof currentRules["paddingTop"] === 'object' ? currentRules["paddingTop"] : {
            "default": currentRules["paddingTop"]
        };
        currentRules["paddingTop"]["orientation === \"horizontal\""] = 16;
    } else {
        rules += ' Th12';
        currentRules["paddingTop"] = 24;
    }
    if (props.orientation === "horizontal") {
        rules += ' Qf12';
        currentRules["paddingBottom"] = typeof currentRules["paddingBottom"] === 'object' ? currentRules["paddingBottom"] : {
            "default": currentRules["paddingBottom"]
        };
        currentRules["paddingBottom"]["orientation === \"horizontal\""] = 16;
    } else {
        rules += ' Qh12';
        currentRules["paddingBottom"] = 24;
    }
    if (props.orientation === "horizontal") {
        rules += ' Sk12';
        currentRules["paddingStart"] = typeof currentRules["paddingStart"] === 'object' ? currentRules["paddingStart"] : {
            "default": currentRules["paddingStart"]
        };
        currentRules["paddingStart"]["orientation === \"horizontal\""] = 32;
    }
    if (props.orientation === "horizontal") {
        rules += ' Rh12';
        currentRules["paddingEnd"] = typeof currentRules["paddingEnd"] === 'object' ? currentRules["paddingEnd"] : {
            "default": currentRules["paddingEnd"]
        };
        currentRules["paddingEnd"]["orientation === \"horizontal\""] = 24;
    }
    if (props.orientation === "horizontal") {
        rules += ' CtXiS9b12';
        currentRules["gridTemplateAreas"] = typeof currentRules["gridTemplateAreas"] === 'object' ? currentRules["gridTemplateAreas"] : {
            "default": currentRules["gridTemplateAreas"]
        };
        currentRules["gridTemplateAreas"]["orientation === \"horizontal\""] = [
            "illustration . label",
            "illustration . description"
        ];
        rules += ' CbWiMddxbX3ib12';
        currentRules["gridTemplateAreas"] = typeof currentRules["gridTemplateAreas"] === 'object' ? currentRules["gridTemplateAreas"] : {
            "default": currentRules["gridTemplateAreas"]
        };
        currentRules["gridTemplateAreas"]["orientation === \"horizontal\" && :has([slot=label]):not(:has([slot=description]))"] = [
            "illustration . label"
        ];
    } else if (props.orientation === "vertical") {
        rules += ' CfwsTtd12';
        currentRules["gridTemplateAreas"] = typeof currentRules["gridTemplateAreas"] === 'object' ? currentRules["gridTemplateAreas"] : {
            "default": currentRules["gridTemplateAreas"]
        };
        currentRules["gridTemplateAreas"]["orientation === \"vertical\""] = [
            "illustration",
            ".",
            "label"
        ];
    }
    if (props.orientation === "horizontal") {
        rules += ' EtYIsBb12';
        currentRules["gridTemplateRows"] = typeof currentRules["gridTemplateRows"] === 'object' ? currentRules["gridTemplateRows"] : {
            "default": currentRules["gridTemplateRows"]
        };
        currentRules["gridTemplateRows"]["orientation === \"horizontal\""] = [
            "min-content",
            2,
            "min-content"
        ];
        rules += ' E1099pdfYMhHd12';
        currentRules["gridTemplateRows"] = typeof currentRules["gridTemplateRows"] === 'object' ? currentRules["gridTemplateRows"] : {
            "default": currentRules["gridTemplateRows"]
        };
        currentRules["gridTemplateRows"]["orientation === \"horizontal\" && :not(:has([slot=illustration]))"] = [
            "min-content"
        ];
    } else if (props.orientation === "vertical") {
        rules += ' EOwqVhc12';
        currentRules["gridTemplateRows"] = typeof currentRules["gridTemplateRows"] === 'object' ? currentRules["gridTemplateRows"] : {
            "default": currentRules["gridTemplateRows"]
        };
        currentRules["gridTemplateRows"]["orientation === \"vertical\""] = [
            "min-content",
            8,
            "min-content"
        ];
    }
    if (props.orientation === "horizontal") {
        rules += ' DJSAqje12';
        currentRules["gridTemplateColumns"] = typeof currentRules["gridTemplateColumns"] === 'object' ? currentRules["gridTemplateColumns"] : {
            "default": currentRules["gridTemplateColumns"]
        };
        currentRules["gridTemplateColumns"]["orientation === \"horizontal\""] = "min-content 10px 1fr";
    }
    if (props.orientation === "vertical") {
        rules += ' _cb12';
        currentRules["alignContent"] = typeof currentRules["alignContent"] === 'object' ? currentRules["alignContent"] : {
            "default": currentRules["alignContent"]
        };
        currentRules["alignContent"]["orientation === \"vertical\""] = "center";
    }
    rules += ' oc12';
    currentRules["borderTopStartRadius"] = "lg";
    rules += ' nc12';
    currentRules["borderTopEndRadius"] = "lg";
    rules += ' kc12';
    currentRules["borderBottomStartRadius"] = "lg";
    rules += ' jc12';
    currentRules["borderBottomEndRadius"] = "lg";
    rules += ' _jf12';
    currentRules["borderStyle"] = "solid";
    if (props.isDisabled) {
        rules += ' iA12';
        currentRules["borderColor"] = typeof currentRules["borderColor"] === 'object' ? currentRules["borderColor"] : {
            "default": currentRules["borderColor"]
        };
        currentRules["borderColor"]["isDisabled"] = "transparent";
    } else if (props.isSelected) {
        rules += ' in12';
        currentRules["borderColor"] = typeof currentRules["borderColor"] === 'object' ? currentRules["borderColor"] : {
            "default": currentRules["borderColor"]
        };
        currentRules["borderColor"]["isSelected"] = "gray-900";
    } else {
        rules += ' iA12';
        currentRules["borderColor"] = "transparent";
    }
    if (props.isDisabled) {
        rules += ' gH12';
        currentRules["backgroundColor"] = typeof currentRules["backgroundColor"] === 'object' ? currentRules["backgroundColor"] : {
            "default": currentRules["backgroundColor"]
        };
        currentRules["backgroundColor"]["isDisabled"] = "disabled";
    } else {
        rules += ' g_g12';
        currentRules["backgroundColor"] = "layer-2";
    }
    if (props.isDisabled) {
        rules += ' _nd12';
        currentRules["boxShadow"] = typeof currentRules["boxShadow"] === 'object' ? currentRules["boxShadow"] : {
            "default": currentRules["boxShadow"]
        };
        currentRules["boxShadow"]["isDisabled"] = "none";
    } else if (props.isSelected) {
        rules += ' _nLeasBb12';
        currentRules["boxShadow"] = typeof currentRules["boxShadow"] === 'object' ? currentRules["boxShadow"] : {
            "default": currentRules["boxShadow"]
        };
        currentRules["boxShadow"]["isSelected"] = "elevated";
    } else if (props.isHovered) {
        rules += ' _nLeasBb12';
        currentRules["boxShadow"] = typeof currentRules["boxShadow"] === 'object' ? currentRules["boxShadow"] : {
            "default": currentRules["boxShadow"]
        };
        currentRules["boxShadow"]["isHovered"] = "elevated";
    } else {
        rules += ' _n4zCLMe12';
        currentRules["boxShadow"] = "emphasized";
    }
    rules += ' _kc12';
    currentRules["borderTopWidth"] = 2;
    rules += ' hc12';
    currentRules["borderBottomWidth"] = 2;
    rules += ' mc12';
    currentRules["borderStartWidth"] = 2;
    rules += ' lc12';
    currentRules["borderEndWidth"] = 2;
    rules += ' Yd12';
    currentRules["transition"] = "default";
    rules += ' Xb12';
    currentRules["transitionDuration"] = 150;
    rules += ' _2b12';
    currentRules["transitionTimingFunction"] = "default";
    return rules;
};
const illustrationContainer = function anonymous(props) {
    let rules = " ", currentRules = {};
    rules += ' zTZ8xtd12';
    currentRules["gridColumnStart"] = "illustration";
    rules += ' yTZ8xtd12';
    currentRules["gridColumnEnd"] = "illustration";
    rules += ' BTZ8xtd12';
    currentRules["gridRowStart"] = "illustration";
    rules += ' ATZ8xtd12';
    currentRules["gridRowEnd"] = "illustration";
    rules += ' _dc12';
    currentRules["alignSelf"] = "center";
    rules += ' __Ab12';
    currentRules["justifySelf"] = "center";
    rules += ' Nl12';
    currentRules["minWidth"] = 48;
    rules += ' Mk12';
    currentRules["minHeight"] = 48;
    if (props.isDisabled) {
        rules += ' -_8sjo0b-pp12';
        currentRules["--iconPrimary"] = typeof currentRules["--iconPrimary"] === 'object' ? currentRules["--iconPrimary"] : {
            "default": currentRules["--iconPrimary"]
        };
        currentRules["--iconPrimary"]["isDisabled"] = "disabled";
    } else {
        if (props.isPressed) {
            rules += ' -_8sjo0b-po12';
            currentRules["--iconPrimary"] = typeof currentRules["--iconPrimary"] === 'object' ? currentRules["--iconPrimary"] : {
                "default": currentRules["--iconPrimary"]
            };
            currentRules["--iconPrimary"]["isPressed"] = "neutral:pressed";
        } else if (props.isFocusVisible) {
            rules += ' -_8sjo0b-po12';
            currentRules["--iconPrimary"] = typeof currentRules["--iconPrimary"] === 'object' ? currentRules["--iconPrimary"] : {
                "default": currentRules["--iconPrimary"]
            };
            currentRules["--iconPrimary"]["isFocusVisible"] = "neutral:focused";
        } else if (props.isHovered) {
            rules += ' -_8sjo0b-po12';
            currentRules["--iconPrimary"] = typeof currentRules["--iconPrimary"] === 'object' ? currentRules["--iconPrimary"] : {
                "default": currentRules["--iconPrimary"]
            };
            currentRules["--iconPrimary"]["isHovered"] = "neutral:hovered";
        } else {
            rules += ' -_8sjo0b-pt12';
            currentRules["--iconPrimary"] = "neutral";
        }
    }
    return rules;
};
const descriptionText = function anonymous(props) {
    let rules = " ", currentRules = {};
    rules += ' z9u7zPc12';
    currentRules["gridColumnStart"] = "description";
    rules += ' y9u7zPc12';
    currentRules["gridColumnEnd"] = "description";
    rules += ' B9u7zPc12';
    currentRules["gridRowStart"] = "description";
    rules += ' A9u7zPc12';
    currentRules["gridRowEnd"] = "description";
    rules += ' _dc12';
    currentRules["alignSelf"] = "center";
    if (props.orientation === "vertical") {
        rules += ' sk12';
        currentRules["display"] = typeof currentRules["display"] === 'object' ? currentRules["display"] : {
            "default": currentRules["display"]
        };
        currentRules["display"]["orientation === \"vertical\""] = "none";
    } else {
        rules += ' sb12';
        currentRules["display"] = "block";
    }
    rules += ' _Nc12';
    currentRules["overflowX"] = "hidden";
    rules += ' Pc12';
    currentRules["overflowY"] = "hidden";
    if (props.orientation === "horizontal") {
        rules += ' _Wd12';
        currentRules["textAlign"] = typeof currentRules["textAlign"] === 'object' ? currentRules["textAlign"] : {
            "default": currentRules["textAlign"]
        };
        currentRules["textAlign"]["orientation === \"horizontal\""] = "start";
    } else {
        rules += ' _Wa12';
        currentRules["textAlign"] = "center";
    }
    if (props.isDisabled) {
        rules += ' pp12';
        currentRules["color"] = typeof currentRules["color"] === 'object' ? currentRules["color"] : {
            "default": currentRules["color"]
        };
        currentRules["color"]["isDisabled"] = "disabled";
    } else {
        if (props.isPressed) {
            rules += ' po12';
            currentRules["color"] = typeof currentRules["color"] === 'object' ? currentRules["color"] : {
                "default": currentRules["color"]
            };
            currentRules["color"]["isPressed"] = "neutral:pressed";
        } else if (props.isFocusVisible) {
            rules += ' po12';
            currentRules["color"] = typeof currentRules["color"] === 'object' ? currentRules["color"] : {
                "default": currentRules["color"]
            };
            currentRules["color"]["isFocusVisible"] = "neutral:focused";
        } else if (props.isHovered) {
            rules += ' po12';
            currentRules["color"] = typeof currentRules["color"] === 'object' ? currentRules["color"] : {
                "default": currentRules["color"]
            };
            currentRules["color"]["isHovered"] = "neutral:hovered";
        } else {
            rules += ' pt12';
            currentRules["color"] = "neutral";
        }
    }
    return rules;
};
const labelText = function anonymous(props) {
    let rules = " ", currentRules = {};
    rules += ' zv6x9r12';
    currentRules["gridColumnStart"] = "label";
    rules += ' yv6x9r12';
    currentRules["gridColumnEnd"] = "label";
    rules += ' Bv6x9r12';
    currentRules["gridRowStart"] = "label";
    rules += ' Av6x9r12';
    currentRules["gridRowEnd"] = "label";
    rules += ' _dc12';
    currentRules["alignSelf"] = "center";
    if (props.orientation === "horizontal") {
        rules += ' __Ad12';
        currentRules["justifySelf"] = typeof currentRules["justifySelf"] === 'object' ? currentRules["justifySelf"] : {
            "default": currentRules["justifySelf"]
        };
        currentRules["justifySelf"]["orientation === \"horizontal\""] = "start";
    } else {
        rules += ' __Ab12';
        currentRules["justifySelf"] = "center";
    }
    rules += ' Za12';
    currentRules["width"] = "100%";
    rules += ' _Nc12';
    currentRules["overflowX"] = "hidden";
    rules += ' Pc12';
    currentRules["overflowY"] = "hidden";
    rules += ' Na12';
    currentRules["minWidth"] = 0;
    if (props.orientation === "horizontal") {
        rules += ' _Wd12';
        currentRules["textAlign"] = typeof currentRules["textAlign"] === 'object' ? currentRules["textAlign"] : {
            "default": currentRules["textAlign"]
        };
        currentRules["textAlign"]["orientation === \"horizontal\""] = "start";
    } else {
        rules += ' _Wa12';
        currentRules["textAlign"] = "center";
    }
    rules += ' _7c12';
    currentRules["whiteSpace"] = "nowrap";
    rules += ' _Yb12';
    currentRules["textOverflow"] = "ellipsis";
    if (props.orientation === "horizontal") {
        rules += ' xd12';
        currentRules["fontWeight"] = typeof currentRules["fontWeight"] === 'object' ? currentRules["fontWeight"] : {
            "default": currentRules["fontWeight"]
        };
        currentRules["fontWeight"]["orientation === \"horizontal\""] = "bold";
        rules += ' _xa12';
        currentRules["fontWeight"] = typeof currentRules["fontWeight"] === 'object' ? currentRules["fontWeight"] : {
            "default": currentRules["fontWeight"]
        };
        currentRules["fontWeight"]["orientation === \"horizontal\""] = "bold";
        rules += ' xX0cczbc12';
        currentRules["fontWeight"] = typeof currentRules["fontWeight"] === 'object' ? currentRules["fontWeight"] : {
            "default": currentRules["fontWeight"]
        };
        currentRules["fontWeight"]["orientation === \"horizontal\" && :lang(ja, ko, zh)"] = "bold";
        rules += ' _xX0cczba12';
        currentRules["fontWeight"] = typeof currentRules["fontWeight"] === 'object' ? currentRules["fontWeight"] : {
            "default": currentRules["fontWeight"]
        };
        currentRules["fontWeight"]["orientation === \"horizontal\" && :lang(ja, ko, zh)"] = "bold";
    }
    if (props.isDisabled) {
        rules += ' pp12';
        currentRules["color"] = typeof currentRules["color"] === 'object' ? currentRules["color"] : {
            "default": currentRules["color"]
        };
        currentRules["color"]["isDisabled"] = "disabled";
    } else {
        if (props.isPressed) {
            rules += ' po12';
            currentRules["color"] = typeof currentRules["color"] === 'object' ? currentRules["color"] : {
                "default": currentRules["color"]
            };
            currentRules["color"]["isPressed"] = "neutral:pressed";
        } else if (props.isFocusVisible) {
            rules += ' po12';
            currentRules["color"] = typeof currentRules["color"] === 'object' ? currentRules["color"] : {
                "default": currentRules["color"]
            };
            currentRules["color"]["isFocusVisible"] = "neutral:focused";
        } else if (props.isHovered) {
            rules += ' po12';
            currentRules["color"] = typeof currentRules["color"] === 'object' ? currentRules["color"] : {
                "default": currentRules["color"]
            };
            currentRules["color"]["isHovered"] = "neutral:hovered";
        } else {
            rules += ' pt12';
            currentRules["color"] = "neutral";
        }
    }
    return rules;
};
const gridStyles = function anonymous(props, overrides) {
    let rules = " ", currentRules = {};
    rules += (String(overrides || '').match(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L|-macro\$)[^\s]+/g) || []).join('');
    rules += ' se12';
    currentRules["display"] = "grid";
    rules += ' __yM8Mfn12';
    currentRules["gridAutoRows"] = "1fr";
    rules += ' Uj12';
    currentRules["rowGap"] = 24;
    rules += ' qj12';
    currentRules["columnGap"] = 24;
    rules += ' _Ca12';
    currentRules["justifyContent"] = "center";
    if (props.orientation === "vertical") {
        rules += ' -SFnbic-Z75oWv12';
        currentRules["--size"] = typeof currentRules["--size"] === 'object' ? currentRules["--size"] : {
            "default": currentRules["--size"]
        };
        currentRules["--size"]["orientation === \"vertical\""] = 170;
    } else if (props.orientation === "horizontal") {
        rules += ' -SFnbic-ZAK24ue12';
        currentRules["--size"] = typeof currentRules["--size"] === 'object' ? currentRules["--size"] : {
            "default": currentRules["--size"]
        };
        currentRules["--size"]["orientation === \"horizontal\""] = 368;
    }
    if (props.orientation === "vertical") {
        rules += ' DbFoS412';
        currentRules["gridTemplateColumns"] = typeof currentRules["gridTemplateColumns"] === 'object' ? currentRules["gridTemplateColumns"] : {
            "default": currentRules["gridTemplateColumns"]
        };
        currentRules["gridTemplateColumns"]["orientation === \"vertical\""] = "repeat(auto-fit, var(--size))";
    } else if (props.orientation === "horizontal") {
        rules += ' DbFoS412';
        currentRules["gridTemplateColumns"] = typeof currentRules["gridTemplateColumns"] === 'object' ? currentRules["gridTemplateColumns"] : {
            "default": currentRules["gridTemplateColumns"]
        };
        currentRules["gridTemplateColumns"]["orientation === \"horizontal\""] = "repeat(auto-fit, var(--size))";
    }
    return rules;
};
function SelectBox(props) {
    let { children, isDisabled: individualDisabled = false, UNSAFE_style, UNSAFE_className, styles, ...otherProps } = props;
    let { orientation = 'vertical', isDisabled: groupDisabled = false } = (0, _react.useContext)(SelectBoxContext);
    const isDisabled = individualDisabled || groupDisabled;
    const ref = (0, _react.useRef)(null);
    let { isFocusVisible } = (0, _reactAria.useFocusVisible)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ListBoxItem), {
        isDisabled: isDisabled,
        ref: ref,
        className: (renderProps)=>(UNSAFE_className || '') + selectBoxStyles({
                ...renderProps,
                isFocusVisible: isFocusVisible && renderProps.isFocused,
                orientation
            }, styles),
        style: (0, _pressScale.pressScale)(ref, UNSAFE_style),
        ...otherProps,
        children: ({ isSelected, isDisabled, isHovered })=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: " _Pa12 WJ12 _AI12 _Ob12",
                        "aria-hidden": "true",
                        children: !isDisabled && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: (0, _checkbox.box)({
                                isSelected,
                                isDisabled,
                                size: 'M'
                            }),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkmarkDefault.default), {
                                size: "S",
                                className: (0, _checkbox.iconStyles)
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
                        values: [
                            [
                                (0, _icon.IllustrationContext),
                                {
                                    size: 'S',
                                    styles: illustrationContainer({
                                        size: 'S',
                                        orientation,
                                        isDisabled,
                                        isHovered
                                    })
                                }
                            ],
                            [
                                (0, _content.TextContext),
                                {
                                    slots: {
                                        [(0, _reactAriaComponents.DEFAULT_SLOT)]: {
                                            styles: labelText({
                                                orientation,
                                                isDisabled,
                                                isHovered
                                            })
                                        },
                                        label: {
                                            styles: labelText({
                                                orientation,
                                                isDisabled,
                                                isHovered
                                            })
                                        },
                                        description: {
                                            styles: descriptionText({
                                                orientation,
                                                isDisabled,
                                                isHovered
                                            })
                                        }
                                    }
                                }
                            ]
                        ],
                        children: children
                    })
                ]
            });
        }
    });
}
const SelectBoxGroup = /*#__PURE__*/ (0, _react.forwardRef)(function SelectBoxGroup(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, SelectBoxGroupContext);
    let { children, selectionMode = 'single', orientation = 'vertical', isDisabled = false, UNSAFE_className, UNSAFE_style, styles, ...otherProps } = props;
    const selectBoxContextValue = (0, _react.useMemo)(()=>({
            orientation,
            isDisabled
        }), [
        orientation,
        isDisabled
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(SelectBoxContext.Provider, {
        value: selectBoxContextValue,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ListBox), {
            selectionMode: selectionMode,
            layout: "grid",
            orientation: orientation,
            className: (UNSAFE_className || '') + gridStyles({
                orientation
            }, styles),
            style: UNSAFE_style,
            ...otherProps,
            children: children
        })
    });
});

},{"0":"4qe2i","1":"bHXbq","2":"5EXin","3":"81lKo","4":"8DRdz","5":"fMrP7","react/jsx-runtime":"2Is6Z","./Checkbox":"jdSVu","../ui-icons/Checkmark":"gK3Wp","react-aria-components":[["DEFAULT_SLOT","bA6Cz"],["Provider","bA6Cz"],["ListBox","dNdIK"],["ListBoxItem","dNdIK"]],"../src/Icon":"jQAJE","./pressScale":"8Ufux","react":"a1TxN","./Content":"10r6w","react-aria":"dkfxW","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4qe2i":[function() {},{}],"bHXbq":[function() {},{}],"5EXin":[function() {},{}],"81lKo":[function() {},{}],"8DRdz":[function() {},{}],"fMrP7":[function() {},{}],"f1osu":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StatusLightContext", ()=>StatusLightContext);
parcelHelpers.export(exports, "StatusLight", ()=>StatusLight);
var _jsxRuntime = require("react/jsx-runtime");
var _centerBaseline = require("./CenterBaseline");
var _react = require("react");
var _utils = require("@react-aria/utils");
var _content = require("./Content");
var _utils1 = require("@react-spectrum/utils");
var _skeleton = require("./Skeleton");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const StatusLightContext = /*#__PURE__*/ (0, _react.createContext)(null);
const wrapper = function anonymous(props, overrides) {
    let rules = " ", currentRules = {};
    let width = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L|-macro\$)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "Z") width = true;
        rules += p[0];
    }
    rules += ' sd12';
    currentRules["display"] = "flex";
    rules += ' Uc12';
    currentRules["rowGap"] = "text-to-visual";
    rules += ' Usd12';
    currentRules["rowGap"] = typeof currentRules["rowGap"] === 'object' ? currentRules["rowGap"] : {
        "default": currentRules["rowGap"]
    };
    currentRules["rowGap"]["touch"] = "text-to-visual";
    rules += ' qc12';
    currentRules["columnGap"] = "text-to-visual";
    rules += ' qsd12';
    currentRules["columnGap"] = typeof currentRules["columnGap"] === 'object' ? currentRules["columnGap"] : {
        "default": currentRules["columnGap"]
    };
    currentRules["columnGap"]["touch"] = "text-to-visual";
    rules += ' ea12';
    currentRules["alignItems"] = "baseline";
    if (!width) rules += ' ZJ12';
    currentRules["width"] = "fit";
    if (props.size === "XL") {
        rules += ' uk12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"XL\""] = "sans";
        rules += ' uch12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"XL\" && :lang(ar)"] = "sans";
        rules += ' udi12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"XL\" && :lang(he)"] = "sans";
        rules += ' uea12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"XL\" && :lang(ja)"] = "sans";
        rules += ' ugb12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"XL\" && :lang(ko)"] = "sans";
        rules += ' uhd12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"XL\" && :lang(zh)"] = "sans";
        rules += ' uje12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"XL\" && :lang(zh-hant)"] = "sans";
        rules += ' u2NhKxcl12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"XL\" && :lang(zh-HK)"] = "sans";
        rules += ' uic12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"XL\" && :lang(zh-Hans, zh-CN, zh-SG)"] = "sans";
    } else if (props.size === "L") {
        rules += ' uk12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"L\""] = "sans";
        rules += ' uch12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"L\" && :lang(ar)"] = "sans";
        rules += ' udi12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"L\" && :lang(he)"] = "sans";
        rules += ' uea12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"L\" && :lang(ja)"] = "sans";
        rules += ' ugb12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"L\" && :lang(ko)"] = "sans";
        rules += ' uhd12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"L\" && :lang(zh)"] = "sans";
        rules += ' uje12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"L\" && :lang(zh-hant)"] = "sans";
        rules += ' u2NhKxcl12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"L\" && :lang(zh-HK)"] = "sans";
        rules += ' uic12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"L\" && :lang(zh-Hans, zh-CN, zh-SG)"] = "sans";
    } else if (props.size === "S") {
        rules += ' uk12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"S\""] = "sans";
        rules += ' uch12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"S\" && :lang(ar)"] = "sans";
        rules += ' udi12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"S\" && :lang(he)"] = "sans";
        rules += ' uea12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"S\" && :lang(ja)"] = "sans";
        rules += ' ugb12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"S\" && :lang(ko)"] = "sans";
        rules += ' uhd12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"S\" && :lang(zh)"] = "sans";
        rules += ' uje12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"S\" && :lang(zh-hant)"] = "sans";
        rules += ' u2NhKxcl12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"S\" && :lang(zh-HK)"] = "sans";
        rules += ' uic12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"S\" && :lang(zh-Hans, zh-CN, zh-SG)"] = "sans";
    } else if (props.size === "XS") {
        rules += ' uk12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"XS\""] = "sans";
        rules += ' uch12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"XS\" && :lang(ar)"] = "sans";
        rules += ' udi12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"XS\" && :lang(he)"] = "sans";
        rules += ' uea12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"XS\" && :lang(ja)"] = "sans";
        rules += ' ugb12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"XS\" && :lang(ko)"] = "sans";
        rules += ' uhd12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"XS\" && :lang(zh)"] = "sans";
        rules += ' uje12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"XS\" && :lang(zh-hant)"] = "sans";
        rules += ' u2NhKxcl12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"XS\" && :lang(zh-HK)"] = "sans";
        rules += ' uic12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"XS\" && :lang(zh-Hans, zh-CN, zh-SG)"] = "sans";
    } else {
        rules += ' uk12';
        currentRules["fontFamily"] = "sans";
        rules += ' uch12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"][":lang(ar)"] = "sans";
        rules += ' udi12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"][":lang(he)"] = "sans";
        rules += ' uea12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"][":lang(ja)"] = "sans";
        rules += ' ugb12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"][":lang(ko)"] = "sans";
        rules += ' uhd12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"][":lang(zh)"] = "sans";
        rules += ' uje12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"][":lang(zh-hant)"] = "sans";
        rules += ' u2NhKxcl12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"][":lang(zh-HK)"] = "sans";
        rules += ' uic12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"][":lang(zh-Hans, zh-CN, zh-SG)"] = "sans";
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e12';
        currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
            "default": currentRules["fontSize"]
        };
        currentRules["fontSize"]["size === \"XL\""] = "ui-xl";
        rules += ' vx12';
        currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
            "default": currentRules["fontSize"]
        };
        currentRules["fontSize"]["size === \"XL\""] = "ui-xl";
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d12';
        currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
            "default": currentRules["fontSize"]
        };
        currentRules["fontSize"]["size === \"L\""] = "ui-lg";
        rules += ' vx12';
        currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
            "default": currentRules["fontSize"]
        };
        currentRules["fontSize"]["size === \"L\""] = "ui-lg";
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b12';
        currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
            "default": currentRules["fontSize"]
        };
        currentRules["fontSize"]["size === \"S\""] = "ui-sm";
        rules += ' vx12';
        currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
            "default": currentRules["fontSize"]
        };
        currentRules["fontSize"]["size === \"S\""] = "ui-sm";
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a12';
        currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
            "default": currentRules["fontSize"]
        };
        currentRules["fontSize"]["size === \"XS\""] = "ui-xs";
        rules += ' vx12';
        currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
            "default": currentRules["fontSize"]
        };
        currentRules["fontSize"]["size === \"XS\""] = "ui-xs";
    } else {
        rules += ' -_6BNtrc-c12';
        currentRules["fontSize"] = "ui";
        rules += ' vx12';
        currentRules["fontSize"] = "ui";
    }
    if (props.size === "XL") {
        rules += ' xb12';
        currentRules["fontWeight"] = typeof currentRules["fontWeight"] === 'object' ? currentRules["fontWeight"] : {
            "default": currentRules["fontWeight"]
        };
        currentRules["fontWeight"]["size === \"XL\""] = "normal";
        rules += ' _xa12';
        currentRules["fontWeight"] = typeof currentRules["fontWeight"] === 'object' ? currentRules["fontWeight"] : {
            "default": currentRules["fontWeight"]
        };
        currentRules["fontWeight"]["size === \"XL\""] = "normal";
    } else if (props.size === "L") {
        rules += ' xb12';
        currentRules["fontWeight"] = typeof currentRules["fontWeight"] === 'object' ? currentRules["fontWeight"] : {
            "default": currentRules["fontWeight"]
        };
        currentRules["fontWeight"]["size === \"L\""] = "normal";
        rules += ' _xa12';
        currentRules["fontWeight"] = typeof currentRules["fontWeight"] === 'object' ? currentRules["fontWeight"] : {
            "default": currentRules["fontWeight"]
        };
        currentRules["fontWeight"]["size === \"L\""] = "normal";
    } else if (props.size === "S") {
        rules += ' xb12';
        currentRules["fontWeight"] = typeof currentRules["fontWeight"] === 'object' ? currentRules["fontWeight"] : {
            "default": currentRules["fontWeight"]
        };
        currentRules["fontWeight"]["size === \"S\""] = "normal";
        rules += ' _xa12';
        currentRules["fontWeight"] = typeof currentRules["fontWeight"] === 'object' ? currentRules["fontWeight"] : {
            "default": currentRules["fontWeight"]
        };
        currentRules["fontWeight"]["size === \"S\""] = "normal";
    } else if (props.size === "XS") {
        rules += ' xb12';
        currentRules["fontWeight"] = typeof currentRules["fontWeight"] === 'object' ? currentRules["fontWeight"] : {
            "default": currentRules["fontWeight"]
        };
        currentRules["fontWeight"]["size === \"XS\""] = "normal";
        rules += ' _xa12';
        currentRules["fontWeight"] = typeof currentRules["fontWeight"] === 'object' ? currentRules["fontWeight"] : {
            "default": currentRules["fontWeight"]
        };
        currentRules["fontWeight"]["size === \"XS\""] = "normal";
    } else {
        rules += ' xb12';
        currentRules["fontWeight"] = "normal";
        rules += ' _xa12';
        currentRules["fontWeight"] = "normal";
    }
    if (props.size === "XL") {
        rules += ' _Fd12';
        currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
            "default": currentRules["lineHeight"]
        };
        currentRules["lineHeight"]["size === \"XL\""] = "ui";
        rules += ' _FezxGHba12';
        currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
            "default": currentRules["lineHeight"]
        };
        currentRules["lineHeight"]["size === \"XL\" && :lang(ar, he)"] = "ui";
        rules += ' _FnuYUweb12';
        currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
            "default": currentRules["lineHeight"]
        };
        currentRules["lineHeight"]["size === \"XL\" && :lang(ja, ko, zh, zh-Hant, zh-Hans, zh-CN, zh-SG)"] = "ui";
    } else if (props.size === "L") {
        rules += ' _Fd12';
        currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
            "default": currentRules["lineHeight"]
        };
        currentRules["lineHeight"]["size === \"L\""] = "ui";
        rules += ' _FezxGHba12';
        currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
            "default": currentRules["lineHeight"]
        };
        currentRules["lineHeight"]["size === \"L\" && :lang(ar, he)"] = "ui";
        rules += ' _FnuYUweb12';
        currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
            "default": currentRules["lineHeight"]
        };
        currentRules["lineHeight"]["size === \"L\" && :lang(ja, ko, zh, zh-Hant, zh-Hans, zh-CN, zh-SG)"] = "ui";
    } else if (props.size === "S") {
        rules += ' _Fd12';
        currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
            "default": currentRules["lineHeight"]
        };
        currentRules["lineHeight"]["size === \"S\""] = "ui";
        rules += ' _FezxGHba12';
        currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
            "default": currentRules["lineHeight"]
        };
        currentRules["lineHeight"]["size === \"S\" && :lang(ar, he)"] = "ui";
        rules += ' _FnuYUweb12';
        currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
            "default": currentRules["lineHeight"]
        };
        currentRules["lineHeight"]["size === \"S\" && :lang(ja, ko, zh, zh-Hant, zh-Hans, zh-CN, zh-SG)"] = "ui";
    } else if (props.size === "XS") {
        rules += ' _Fd12';
        currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
            "default": currentRules["lineHeight"]
        };
        currentRules["lineHeight"]["size === \"XS\""] = "ui";
        rules += ' _FezxGHba12';
        currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
            "default": currentRules["lineHeight"]
        };
        currentRules["lineHeight"]["size === \"XS\" && :lang(ar, he)"] = "ui";
        rules += ' _FnuYUweb12';
        currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
            "default": currentRules["lineHeight"]
        };
        currentRules["lineHeight"]["size === \"XS\" && :lang(ja, ko, zh, zh-Hant, zh-Hans, zh-CN, zh-SG)"] = "ui";
    } else {
        rules += ' _Fd12';
        currentRules["lineHeight"] = "ui";
        rules += ' _FezxGHba12';
        currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
            "default": currentRules["lineHeight"]
        };
        currentRules["lineHeight"][":lang(ar, he)"] = "ui";
        rules += ' _FnuYUweb12';
        currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
            "default": currentRules["lineHeight"]
        };
        currentRules["lineHeight"][":lang(ja, ko, zh, zh-Hant, zh-Hans, zh-CN, zh-SG)"] = "ui";
    }
    if (props.variant === "neutral") {
        rules += ' pn12';
        currentRules["color"] = typeof currentRules["color"] === 'object' ? currentRules["color"] : {
            "default": currentRules["color"]
        };
        currentRules["color"]["variant === \"neutral\""] = "gray-600";
    } else {
        rules += ' pt12';
        currentRules["color"] = "neutral";
    }
    rules += ' __ca12';
    currentRules["disableTapHighlight"] = true;
    return rules;
};
const light = function anonymous(props) {
    let rules = " ", currentRules = {};
    if (props.size === "XL") {
        rules += ' Zk12';
        currentRules["width"] = typeof currentRules["width"] === 'object' ? currentRules["width"] : {
            "default": currentRules["width"]
        };
        currentRules["width"]["size === \"XL\""] = 14;
    } else if (props.size === "L") {
        rules += ' Zj12';
        currentRules["width"] = typeof currentRules["width"] === 'object' ? currentRules["width"] : {
            "default": currentRules["width"]
        };
        currentRules["width"]["size === \"L\""] = 12;
    } else if (props.size === "M") {
        rules += ' Zi12';
        currentRules["width"] = typeof currentRules["width"] === 'object' ? currentRules["width"] : {
            "default": currentRules["width"]
        };
        currentRules["width"]["size === \"M\""] = 10;
    } else if (props.size === "S") {
        rules += ' Zh12';
        currentRules["width"] = typeof currentRules["width"] === 'object' ? currentRules["width"] : {
            "default": currentRules["width"]
        };
        currentRules["width"]["size === \"S\""] = 8;
    }
    if (props.size === "XL") {
        rules += ' Fl12';
        currentRules["height"] = typeof currentRules["height"] === 'object' ? currentRules["height"] : {
            "default": currentRules["height"]
        };
        currentRules["height"]["size === \"XL\""] = 14;
    } else if (props.size === "L") {
        rules += ' Fk12';
        currentRules["height"] = typeof currentRules["height"] === 'object' ? currentRules["height"] : {
            "default": currentRules["height"]
        };
        currentRules["height"]["size === \"L\""] = 12;
    } else if (props.size === "M") {
        rules += ' Fj12';
        currentRules["height"] = typeof currentRules["height"] === 'object' ? currentRules["height"] : {
            "default": currentRules["height"]
        };
        currentRules["height"]["size === \"M\""] = 10;
    } else if (props.size === "S") {
        rules += ' Fi12';
        currentRules["height"] = typeof currentRules["height"] === 'object' ? currentRules["height"] : {
            "default": currentRules["height"]
        };
        currentRules["height"]["size === \"S\""] = 8;
    }
    if (props.isSkeleton) {
        rules += ' tn12';
        currentRules["fill"] = typeof currentRules["fill"] === 'object' ? currentRules["fill"] : {
            "default": currentRules["fill"]
        };
        currentRules["fill"]["isSkeleton"] = "gray-200";
    } else if (props.variant === "silver") {
        rules += ' te12';
        currentRules["fill"] = typeof currentRules["fill"] === 'object' ? currentRules["fill"] : {
            "default": currentRules["fill"]
        };
        currentRules["fill"]["variant === \"silver\""] = "silver";
    } else if (props.variant === "brown") {
        rules += ' th12';
        currentRules["fill"] = typeof currentRules["fill"] === 'object' ? currentRules["fill"] : {
            "default": currentRules["fill"]
        };
        currentRules["fill"]["variant === \"brown\""] = "brown";
    } else if (props.variant === "cinnamon") {
        rules += ' tj12';
        currentRules["fill"] = typeof currentRules["fill"] === 'object' ? currentRules["fill"] : {
            "default": currentRules["fill"]
        };
        currentRules["fill"]["variant === \"cinnamon\""] = "cinnamon";
    } else if (props.variant === "turquoise") {
        rules += ' tb12';
        currentRules["fill"] = typeof currentRules["fill"] === 'object' ? currentRules["fill"] : {
            "default": currentRules["fill"]
        };
        currentRules["fill"]["variant === \"turquoise\""] = "turquoise";
    } else if (props.variant === "pink") {
        rules += ' to12';
        currentRules["fill"] = typeof currentRules["fill"] === 'object' ? currentRules["fill"] : {
            "default": currentRules["fill"]
        };
        currentRules["fill"]["variant === \"pink\""] = "pink";
    } else if (props.variant === "yellow") {
        rules += ' tl12';
        currentRules["fill"] = typeof currentRules["fill"] === 'object' ? currentRules["fill"] : {
            "default": currentRules["fill"]
        };
        currentRules["fill"]["variant === \"yellow\""] = "yellow";
    } else if (props.variant === "seafoam") {
        rules += ' tc12';
        currentRules["fill"] = typeof currentRules["fill"] === 'object' ? currentRules["fill"] : {
            "default": currentRules["fill"]
        };
        currentRules["fill"]["variant === \"seafoam\""] = "seafoam";
    } else if (props.variant === "indigo") {
        rules += ' td12';
        currentRules["fill"] = typeof currentRules["fill"] === 'object' ? currentRules["fill"] : {
            "default": currentRules["fill"]
        };
        currentRules["fill"]["variant === \"indigo\""] = "indigo";
    } else if (props.variant === "magenta") {
        rules += ' tp12';
        currentRules["fill"] = typeof currentRules["fill"] === 'object' ? currentRules["fill"] : {
            "default": currentRules["fill"]
        };
        currentRules["fill"]["variant === \"magenta\""] = "magenta";
    } else if (props.variant === "purple") {
        rules += ' ti12';
        currentRules["fill"] = typeof currentRules["fill"] === 'object' ? currentRules["fill"] : {
            "default": currentRules["fill"]
        };
        currentRules["fill"]["variant === \"purple\""] = "purple";
    } else if (props.variant === "fuchsia") {
        rules += ' tk12';
        currentRules["fill"] = typeof currentRules["fill"] === 'object' ? currentRules["fill"] : {
            "default": currentRules["fill"]
        };
        currentRules["fill"]["variant === \"fuchsia\""] = "fuchsia";
    } else if (props.variant === "cyan") {
        rules += ' ts12';
        currentRules["fill"] = typeof currentRules["fill"] === 'object' ? currentRules["fill"] : {
            "default": currentRules["fill"]
        };
        currentRules["fill"]["variant === \"cyan\""] = "cyan";
    } else if (props.variant === "chartreuse") {
        rules += ' tg12';
        currentRules["fill"] = typeof currentRules["fill"] === 'object' ? currentRules["fill"] : {
            "default": currentRules["fill"]
        };
        currentRules["fill"]["variant === \"chartreuse\""] = "chartreuse";
    } else if (props.variant === "celery") {
        rules += ' tv12';
        currentRules["fill"] = typeof currentRules["fill"] === 'object' ? currentRules["fill"] : {
            "default": currentRules["fill"]
        };
        currentRules["fill"]["variant === \"celery\""] = "celery";
    } else if (props.variant === "negative") {
        rules += ' tq12';
        currentRules["fill"] = typeof currentRules["fill"] === 'object' ? currentRules["fill"] : {
            "default": currentRules["fill"]
        };
        currentRules["fill"]["variant === \"negative\""] = "negative";
    } else if (props.variant === "notice") {
        rules += ' tm12';
        currentRules["fill"] = typeof currentRules["fill"] === 'object' ? currentRules["fill"] : {
            "default": currentRules["fill"]
        };
        currentRules["fill"]["variant === \"notice\""] = "notice";
    } else if (props.variant === "positive") {
        rules += ' tt12';
        currentRules["fill"] = typeof currentRules["fill"] === 'object' ? currentRules["fill"] : {
            "default": currentRules["fill"]
        };
        currentRules["fill"]["variant === \"positive\""] = "positive";
    } else if (props.variant === "neutral") {
        rules += ' tf12';
        currentRules["fill"] = typeof currentRules["fill"] === 'object' ? currentRules["fill"] : {
            "default": currentRules["fill"]
        };
        currentRules["fill"]["variant === \"neutral\""] = "neutral";
    } else if (props.variant === "informative") {
        rules += ' tu12';
        currentRules["fill"] = typeof currentRules["fill"] === 'object' ? currentRules["fill"] : {
            "default": currentRules["fill"]
        };
        currentRules["fill"]["variant === \"informative\""] = "informative";
    }
    rules += ' _Ne12';
    currentRules["overflowX"] = "visible";
    rules += ' Pe12';
    currentRules["overflowY"] = "visible";
    return rules;
};
const StatusLight = /*#__PURE__*/ (0, _react.forwardRef)(function StatusLight(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, StatusLightContext);
    let { children, size = 'M', variant, role, UNSAFE_className = '', UNSAFE_style, styles } = props;
    let domRef = (0, _utils1.useDOMRef)(ref);
    let isSkeleton = (0, _skeleton.useIsSkeleton)();
    !children && props['aria-label'];
    !role && (props['aria-label'] || props['aria-labelledby']);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        ...(0, _utils.filterDOMProps)(props, {
            labelable: !!role
        }),
        ref: domRef,
        role: role,
        style: UNSAFE_style,
        className: UNSAFE_className + wrapper({
            size,
            variant
        }, styles),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _centerBaseline.CenterBaseline), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                    className: light({
                        size,
                        variant,
                        isSkeleton
                    }),
                    "aria-hidden": "true",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        r: "50%",
                        cx: "50%",
                        cy: "50%"
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
                children: children
            })
        ]
    });
});

},{"0":"hD24H","1":"jVrEL","react/jsx-runtime":"2Is6Z","./CenterBaseline":"1vpL9","react":"a1TxN","@react-aria/utils":"3upVm","./Content":"10r6w","@react-spectrum/utils":"jqfrX","./Skeleton":"1mUnF","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hD24H":[function() {},{}],"jVrEL":[function() {},{}],"5eylf":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AvatarGroupContext", ()=>AvatarGroupContext);
parcelHelpers.export(exports, "AvatarGroup", ()=>AvatarGroup);
var _jsxRuntime = require("react/jsx-runtime");
var _avatar = require("./Avatar");
var _react = require("react");
var _utils = require("@react-aria/utils");
var _utils1 = require("@react-spectrum/utils");
var _reactAria = require("react-aria");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const AvatarGroupContext = /*#__PURE__*/ (0, _react.createContext)(null);
const avatar = " I4gnV8d12 Iby12";
const text = function anonymous(props) {
    let rules = " ", currentRules = {};
    rules += ' Iv12';
    currentRules["marginStart"] = 8;
    rules += ' _Nc12';
    currentRules["overflowX"] = "hidden";
    rules += ' Pc12';
    currentRules["overflowY"] = "hidden";
    rules += ' _Yb12';
    currentRules["textOverflow"] = "ellipsis";
    rules += ' _7c12';
    currentRules["whiteSpace"] = "nowrap";
    if (props.size === "40") {
        rules += ' uk12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"40\""] = "sans";
        rules += ' uch12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"40\" && :lang(ar)"] = "sans";
        rules += ' udi12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"40\" && :lang(he)"] = "sans";
        rules += ' uea12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"40\" && :lang(ja)"] = "sans";
        rules += ' ugb12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"40\" && :lang(ko)"] = "sans";
        rules += ' uhd12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"40\" && :lang(zh)"] = "sans";
        rules += ' uje12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"40\" && :lang(zh-hant)"] = "sans";
        rules += ' u2NhKxcl12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"40\" && :lang(zh-HK)"] = "sans";
        rules += ' uic12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"40\" && :lang(zh-Hans, zh-CN, zh-SG)"] = "sans";
    } else if (props.size === "36") {
        rules += ' uk12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"36\""] = "sans";
        rules += ' uch12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"36\" && :lang(ar)"] = "sans";
        rules += ' udi12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"36\" && :lang(he)"] = "sans";
        rules += ' uea12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"36\" && :lang(ja)"] = "sans";
        rules += ' ugb12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"36\" && :lang(ko)"] = "sans";
        rules += ' uhd12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"36\" && :lang(zh)"] = "sans";
        rules += ' uje12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"36\" && :lang(zh-hant)"] = "sans";
        rules += ' u2NhKxcl12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"36\" && :lang(zh-HK)"] = "sans";
        rules += ' uic12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"36\" && :lang(zh-Hans, zh-CN, zh-SG)"] = "sans";
    } else if (props.size === "32") {
        rules += ' uk12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"32\""] = "sans";
        rules += ' uch12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"32\" && :lang(ar)"] = "sans";
        rules += ' udi12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"32\" && :lang(he)"] = "sans";
        rules += ' uea12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"32\" && :lang(ja)"] = "sans";
        rules += ' ugb12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"32\" && :lang(ko)"] = "sans";
        rules += ' uhd12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"32\" && :lang(zh)"] = "sans";
        rules += ' uje12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"32\" && :lang(zh-hant)"] = "sans";
        rules += ' u2NhKxcl12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"32\" && :lang(zh-HK)"] = "sans";
        rules += ' uic12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"32\" && :lang(zh-Hans, zh-CN, zh-SG)"] = "sans";
    } else if (props.size === "28") {
        rules += ' uk12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"28\""] = "sans";
        rules += ' uch12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"28\" && :lang(ar)"] = "sans";
        rules += ' udi12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"28\" && :lang(he)"] = "sans";
        rules += ' uea12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"28\" && :lang(ja)"] = "sans";
        rules += ' ugb12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"28\" && :lang(ko)"] = "sans";
        rules += ' uhd12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"28\" && :lang(zh)"] = "sans";
        rules += ' uje12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"28\" && :lang(zh-hant)"] = "sans";
        rules += ' u2NhKxcl12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"28\" && :lang(zh-HK)"] = "sans";
        rules += ' uic12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"28\" && :lang(zh-Hans, zh-CN, zh-SG)"] = "sans";
    } else if (props.size === "24") {
        rules += ' uk12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"24\""] = "sans";
        rules += ' uch12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"24\" && :lang(ar)"] = "sans";
        rules += ' udi12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"24\" && :lang(he)"] = "sans";
        rules += ' uea12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"24\" && :lang(ja)"] = "sans";
        rules += ' ugb12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"24\" && :lang(ko)"] = "sans";
        rules += ' uhd12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"24\" && :lang(zh)"] = "sans";
        rules += ' uje12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"24\" && :lang(zh-hant)"] = "sans";
        rules += ' u2NhKxcl12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"24\" && :lang(zh-HK)"] = "sans";
        rules += ' uic12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"24\" && :lang(zh-Hans, zh-CN, zh-SG)"] = "sans";
    } else if (props.size === "20") {
        rules += ' uk12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"20\""] = "sans";
        rules += ' uch12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"20\" && :lang(ar)"] = "sans";
        rules += ' udi12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"20\" && :lang(he)"] = "sans";
        rules += ' uea12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"20\" && :lang(ja)"] = "sans";
        rules += ' ugb12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"20\" && :lang(ko)"] = "sans";
        rules += ' uhd12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"20\" && :lang(zh)"] = "sans";
        rules += ' uje12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"20\" && :lang(zh-hant)"] = "sans";
        rules += ' u2NhKxcl12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"20\" && :lang(zh-HK)"] = "sans";
        rules += ' uic12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"20\" && :lang(zh-Hans, zh-CN, zh-SG)"] = "sans";
    } else if (props.size === "16") {
        rules += ' uk12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"16\""] = "sans";
        rules += ' uch12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"16\" && :lang(ar)"] = "sans";
        rules += ' udi12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"16\" && :lang(he)"] = "sans";
        rules += ' uea12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"16\" && :lang(ja)"] = "sans";
        rules += ' ugb12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"16\" && :lang(ko)"] = "sans";
        rules += ' uhd12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"16\" && :lang(zh)"] = "sans";
        rules += ' uje12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"16\" && :lang(zh-hant)"] = "sans";
        rules += ' u2NhKxcl12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"16\" && :lang(zh-HK)"] = "sans";
        rules += ' uic12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"16\" && :lang(zh-Hans, zh-CN, zh-SG)"] = "sans";
    }
    if (props.size === "40") {
        rules += ' -_6BNtrc-g12';
        currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
            "default": currentRules["fontSize"]
        };
        currentRules["fontSize"]["size === \"40\""] = "ui-3xl";
        rules += ' vx12';
        currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
            "default": currentRules["fontSize"]
        };
        currentRules["fontSize"]["size === \"40\""] = "ui-3xl";
    } else if (props.size === "36") {
        rules += ' -_6BNtrc-f12';
        currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
            "default": currentRules["fontSize"]
        };
        currentRules["fontSize"]["size === \"36\""] = "ui-2xl";
        rules += ' vx12';
        currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
            "default": currentRules["fontSize"]
        };
        currentRules["fontSize"]["size === \"36\""] = "ui-2xl";
    } else if (props.size === "32") {
        rules += ' -_6BNtrc-e12';
        currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
            "default": currentRules["fontSize"]
        };
        currentRules["fontSize"]["size === \"32\""] = "ui-xl";
        rules += ' vx12';
        currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
            "default": currentRules["fontSize"]
        };
        currentRules["fontSize"]["size === \"32\""] = "ui-xl";
    } else if (props.size === "28") {
        rules += ' -_6BNtrc-d12';
        currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
            "default": currentRules["fontSize"]
        };
        currentRules["fontSize"]["size === \"28\""] = "ui-lg";
        rules += ' vx12';
        currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
            "default": currentRules["fontSize"]
        };
        currentRules["fontSize"]["size === \"28\""] = "ui-lg";
    } else if (props.size === "24") {
        rules += ' -_6BNtrc-c12';
        currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
            "default": currentRules["fontSize"]
        };
        currentRules["fontSize"]["size === \"24\""] = "ui";
        rules += ' vx12';
        currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
            "default": currentRules["fontSize"]
        };
        currentRules["fontSize"]["size === \"24\""] = "ui";
    } else if (props.size === "20") {
        rules += ' -_6BNtrc-b12';
        currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
            "default": currentRules["fontSize"]
        };
        currentRules["fontSize"]["size === \"20\""] = "ui-sm";
        rules += ' vx12';
        currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
            "default": currentRules["fontSize"]
        };
        currentRules["fontSize"]["size === \"20\""] = "ui-sm";
    } else if (props.size === "16") {
        rules += ' -_6BNtrc-a12';
        currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
            "default": currentRules["fontSize"]
        };
        currentRules["fontSize"]["size === \"16\""] = "ui-xs";
        rules += ' vx12';
        currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
            "default": currentRules["fontSize"]
        };
        currentRules["fontSize"]["size === \"16\""] = "ui-xs";
    }
    if (props.size === "40") {
        rules += ' xb12';
        currentRules["fontWeight"] = typeof currentRules["fontWeight"] === 'object' ? currentRules["fontWeight"] : {
            "default": currentRules["fontWeight"]
        };
        currentRules["fontWeight"]["size === \"40\""] = "normal";
        rules += ' _xa12';
        currentRules["fontWeight"] = typeof currentRules["fontWeight"] === 'object' ? currentRules["fontWeight"] : {
            "default": currentRules["fontWeight"]
        };
        currentRules["fontWeight"]["size === \"40\""] = "normal";
    } else if (props.size === "36") {
        rules += ' xb12';
        currentRules["fontWeight"] = typeof currentRules["fontWeight"] === 'object' ? currentRules["fontWeight"] : {
            "default": currentRules["fontWeight"]
        };
        currentRules["fontWeight"]["size === \"36\""] = "normal";
        rules += ' _xa12';
        currentRules["fontWeight"] = typeof currentRules["fontWeight"] === 'object' ? currentRules["fontWeight"] : {
            "default": currentRules["fontWeight"]
        };
        currentRules["fontWeight"]["size === \"36\""] = "normal";
    } else if (props.size === "32") {
        rules += ' xb12';
        currentRules["fontWeight"] = typeof currentRules["fontWeight"] === 'object' ? currentRules["fontWeight"] : {
            "default": currentRules["fontWeight"]
        };
        currentRules["fontWeight"]["size === \"32\""] = "normal";
        rules += ' _xa12';
        currentRules["fontWeight"] = typeof currentRules["fontWeight"] === 'object' ? currentRules["fontWeight"] : {
            "default": currentRules["fontWeight"]
        };
        currentRules["fontWeight"]["size === \"32\""] = "normal";
    } else if (props.size === "28") {
        rules += ' xb12';
        currentRules["fontWeight"] = typeof currentRules["fontWeight"] === 'object' ? currentRules["fontWeight"] : {
            "default": currentRules["fontWeight"]
        };
        currentRules["fontWeight"]["size === \"28\""] = "normal";
        rules += ' _xa12';
        currentRules["fontWeight"] = typeof currentRules["fontWeight"] === 'object' ? currentRules["fontWeight"] : {
            "default": currentRules["fontWeight"]
        };
        currentRules["fontWeight"]["size === \"28\""] = "normal";
    } else if (props.size === "24") {
        rules += ' xb12';
        currentRules["fontWeight"] = typeof currentRules["fontWeight"] === 'object' ? currentRules["fontWeight"] : {
            "default": currentRules["fontWeight"]
        };
        currentRules["fontWeight"]["size === \"24\""] = "normal";
        rules += ' _xa12';
        currentRules["fontWeight"] = typeof currentRules["fontWeight"] === 'object' ? currentRules["fontWeight"] : {
            "default": currentRules["fontWeight"]
        };
        currentRules["fontWeight"]["size === \"24\""] = "normal";
    } else if (props.size === "20") {
        rules += ' xb12';
        currentRules["fontWeight"] = typeof currentRules["fontWeight"] === 'object' ? currentRules["fontWeight"] : {
            "default": currentRules["fontWeight"]
        };
        currentRules["fontWeight"]["size === \"20\""] = "normal";
        rules += ' _xa12';
        currentRules["fontWeight"] = typeof currentRules["fontWeight"] === 'object' ? currentRules["fontWeight"] : {
            "default": currentRules["fontWeight"]
        };
        currentRules["fontWeight"]["size === \"20\""] = "normal";
    } else if (props.size === "16") {
        rules += ' xb12';
        currentRules["fontWeight"] = typeof currentRules["fontWeight"] === 'object' ? currentRules["fontWeight"] : {
            "default": currentRules["fontWeight"]
        };
        currentRules["fontWeight"]["size === \"16\""] = "normal";
        rules += ' _xa12';
        currentRules["fontWeight"] = typeof currentRules["fontWeight"] === 'object' ? currentRules["fontWeight"] : {
            "default": currentRules["fontWeight"]
        };
        currentRules["fontWeight"]["size === \"16\""] = "normal";
    }
    if (props.size === "40") {
        rules += ' _Fd12';
        currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
            "default": currentRules["lineHeight"]
        };
        currentRules["lineHeight"]["size === \"40\""] = "ui";
        rules += ' _FezxGHba12';
        currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
            "default": currentRules["lineHeight"]
        };
        currentRules["lineHeight"]["size === \"40\" && :lang(ar, he)"] = "ui";
        rules += ' _FnuYUweb12';
        currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
            "default": currentRules["lineHeight"]
        };
        currentRules["lineHeight"]["size === \"40\" && :lang(ja, ko, zh, zh-Hant, zh-Hans, zh-CN, zh-SG)"] = "ui";
    } else if (props.size === "36") {
        rules += ' _Fd12';
        currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
            "default": currentRules["lineHeight"]
        };
        currentRules["lineHeight"]["size === \"36\""] = "ui";
        rules += ' _FezxGHba12';
        currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
            "default": currentRules["lineHeight"]
        };
        currentRules["lineHeight"]["size === \"36\" && :lang(ar, he)"] = "ui";
        rules += ' _FnuYUweb12';
        currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
            "default": currentRules["lineHeight"]
        };
        currentRules["lineHeight"]["size === \"36\" && :lang(ja, ko, zh, zh-Hant, zh-Hans, zh-CN, zh-SG)"] = "ui";
    } else if (props.size === "32") {
        rules += ' _Fd12';
        currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
            "default": currentRules["lineHeight"]
        };
        currentRules["lineHeight"]["size === \"32\""] = "ui";
        rules += ' _FezxGHba12';
        currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
            "default": currentRules["lineHeight"]
        };
        currentRules["lineHeight"]["size === \"32\" && :lang(ar, he)"] = "ui";
        rules += ' _FnuYUweb12';
        currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
            "default": currentRules["lineHeight"]
        };
        currentRules["lineHeight"]["size === \"32\" && :lang(ja, ko, zh, zh-Hant, zh-Hans, zh-CN, zh-SG)"] = "ui";
    } else if (props.size === "28") {
        rules += ' _Fd12';
        currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
            "default": currentRules["lineHeight"]
        };
        currentRules["lineHeight"]["size === \"28\""] = "ui";
        rules += ' _FezxGHba12';
        currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
            "default": currentRules["lineHeight"]
        };
        currentRules["lineHeight"]["size === \"28\" && :lang(ar, he)"] = "ui";
        rules += ' _FnuYUweb12';
        currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
            "default": currentRules["lineHeight"]
        };
        currentRules["lineHeight"]["size === \"28\" && :lang(ja, ko, zh, zh-Hant, zh-Hans, zh-CN, zh-SG)"] = "ui";
    } else if (props.size === "24") {
        rules += ' _Fd12';
        currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
            "default": currentRules["lineHeight"]
        };
        currentRules["lineHeight"]["size === \"24\""] = "ui";
        rules += ' _FezxGHba12';
        currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
            "default": currentRules["lineHeight"]
        };
        currentRules["lineHeight"]["size === \"24\" && :lang(ar, he)"] = "ui";
        rules += ' _FnuYUweb12';
        currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
            "default": currentRules["lineHeight"]
        };
        currentRules["lineHeight"]["size === \"24\" && :lang(ja, ko, zh, zh-Hant, zh-Hans, zh-CN, zh-SG)"] = "ui";
    } else if (props.size === "20") {
        rules += ' _Fd12';
        currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
            "default": currentRules["lineHeight"]
        };
        currentRules["lineHeight"]["size === \"20\""] = "ui";
        rules += ' _FezxGHba12';
        currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
            "default": currentRules["lineHeight"]
        };
        currentRules["lineHeight"]["size === \"20\" && :lang(ar, he)"] = "ui";
        rules += ' _FnuYUweb12';
        currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
            "default": currentRules["lineHeight"]
        };
        currentRules["lineHeight"]["size === \"20\" && :lang(ja, ko, zh, zh-Hant, zh-Hans, zh-CN, zh-SG)"] = "ui";
    } else if (props.size === "16") {
        rules += ' _Fd12';
        currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
            "default": currentRules["lineHeight"]
        };
        currentRules["lineHeight"]["size === \"16\""] = "ui";
        rules += ' _FezxGHba12';
        currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
            "default": currentRules["lineHeight"]
        };
        currentRules["lineHeight"]["size === \"16\" && :lang(ar, he)"] = "ui";
        rules += ' _FnuYUweb12';
        currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
            "default": currentRules["lineHeight"]
        };
        currentRules["lineHeight"]["size === \"16\" && :lang(ja, ko, zh, zh-Hant, zh-Hans, zh-CN, zh-SG)"] = "ui";
    }
    if (props.size === "40") {
        rules += ' pt12';
        currentRules["color"] = typeof currentRules["color"] === 'object' ? currentRules["color"] : {
            "default": currentRules["color"]
        };
        currentRules["color"]["size === \"40\""] = "body";
    } else if (props.size === "36") {
        rules += ' pt12';
        currentRules["color"] = typeof currentRules["color"] === 'object' ? currentRules["color"] : {
            "default": currentRules["color"]
        };
        currentRules["color"]["size === \"36\""] = "body";
    } else if (props.size === "32") {
        rules += ' pt12';
        currentRules["color"] = typeof currentRules["color"] === 'object' ? currentRules["color"] : {
            "default": currentRules["color"]
        };
        currentRules["color"]["size === \"32\""] = "body";
    } else if (props.size === "28") {
        rules += ' pt12';
        currentRules["color"] = typeof currentRules["color"] === 'object' ? currentRules["color"] : {
            "default": currentRules["color"]
        };
        currentRules["color"]["size === \"28\""] = "body";
    } else if (props.size === "24") {
        rules += ' pt12';
        currentRules["color"] = typeof currentRules["color"] === 'object' ? currentRules["color"] : {
            "default": currentRules["color"]
        };
        currentRules["color"]["size === \"24\""] = "body";
    } else if (props.size === "20") {
        rules += ' pt12';
        currentRules["color"] = typeof currentRules["color"] === 'object' ? currentRules["color"] : {
            "default": currentRules["color"]
        };
        currentRules["color"]["size === \"20\""] = "body";
    } else if (props.size === "16") {
        rules += ' pt12';
        currentRules["color"] = typeof currentRules["color"] === 'object' ? currentRules["color"] : {
            "default": currentRules["color"]
        };
        currentRules["color"]["size === \"16\""] = "body";
    }
    return rules;
};
const container = function anonymous(props, overrides) {
    let rules = " ", currentRules = {};
    rules += (String(overrides || '').match(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|-macro\$)[^\s]+/g) || []).join('');
    rules += ' sd12';
    currentRules["display"] = "flex";
    rules += ' eb12';
    currentRules["alignItems"] = "center";
    return rules;
};
const AvatarGroup = /*#__PURE__*/ (0, _react.forwardRef)(function AvatarGroup(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, AvatarGroupContext);
    let domRef = (0, _utils1.useDOMRef)(ref);
    let { children, label, size = 24, styles, UNSAFE_style, UNSAFE_className, ...otherProps } = props;
    let { labelProps, fieldProps } = (0, _reactAria.useLabel)({
        ...props,
        labelElementType: 'span'
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _avatar.AvatarContext).Provider, {
        value: {
            styles: avatar,
            size,
            isOverBackground: true
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            ref: domRef,
            ...(0, _utils.filterDOMProps)(otherProps),
            ...fieldProps,
            role: "group",
            className: (UNSAFE_className ?? '') + container(null, styles),
            style: {
                ...UNSAFE_style,
                '--size': size / 16 + 'rem'
            },
            children: [
                children,
                label && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    ...labelProps,
                    className: text({
                        size: String(size)
                    }),
                    children: label
                })
            ]
        })
    });
});

},{"0":"a7OkD","1":"g4BhU","2":"i4iI4","react/jsx-runtime":"2Is6Z","./Avatar":"f3T9F","react":"a1TxN","@react-aria/utils":"3upVm","@react-spectrum/utils":"jqfrX","react-aria":"baGld","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"a7OkD":[function() {},{}],"g4BhU":[function() {},{}],"i4iI4":[function() {},{}],"1sDWa":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TreeView", ()=>TreeView);
parcelHelpers.export(exports, "TreeViewItem", ()=>TreeViewItem);
parcelHelpers.export(exports, "TreeViewItemContent", ()=>TreeViewItemContent);
parcelHelpers.export(exports, "TreeViewLoadMoreItem", ()=>TreeViewLoadMoreItem);
var _jsxRuntime = require("react/jsx-runtime");
var _actionButtonGroup = require("./ActionButtonGroup");
var _actionMenu = require("./ActionMenu");
var _reactAriaComponents = require("react-aria-components");
var _centerBaseline = require("./CenterBaseline");
var _checkbox = require("./Checkbox");
var _chevron = require("../ui-icons/Chevron");
var _chevronDefault = parcelHelpers.interopDefault(_chevron);
var _icon = require("./Icon");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _progressCircle = require("./ProgressCircle");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _content = require("./Content");
var _utils = require("@react-spectrum/utils");
var _reactAria = require("react-aria");
var _utils1 = require("./utils");
const TreeRendererContext = /*#__PURE__*/ (0, _react.createContext)({});
let InternalTreeContext = /*#__PURE__*/ (0, _react.createContext)({});
// TODO: the below is needed so the borders of the top and bottom row isn't cut off if the TreeView is wrapped within a container by always reserving the 2px needed for the
// keyboard focus ring. Perhaps find a different way of rendering the outlines since the top of the item doesn't
// scroll into view due to how the ring is offset. Alternatively, have the tree render the top/bottom outline like it does in Listview
const tree = function anonymous(props, overrides) {
    let rules = " ", currentRules = {};
    let minHeight = false;
    let minWidth = false;
    let width = false;
    let height = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L|F|M|K|-macro\$)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "M") minHeight = true;
        if (p[1] === "N") minWidth = true;
        if (p[1] === "Z") width = true;
        if (p[1] === "F") height = true;
        rules += p[0];
    }
    if (props.isFocusVisible) {
        rules += ' _Lf12';
        currentRules["outlineStyle"] = typeof currentRules["outlineStyle"] === 'object' ? currentRules["outlineStyle"] : {
            "default": currentRules["outlineStyle"]
        };
        currentRules["outlineStyle"]["isFocusVisible"] = "solid";
    } else {
        rules += ' _Le12';
        currentRules["outlineStyle"] = "none";
    }
    rules += ' Oh12';
    currentRules["outlineColor"] = "focus-ring";
    rules += ' _Mc12';
    currentRules["outlineWidth"] = 2;
    rules += ' _Kb12';
    currentRules["outlineOffset"] = -2;
    rules += ' _4c12';
    currentRules["userSelect"] = "none";
    if (!minHeight) rules += ' Ma12';
    currentRules["minHeight"] = 0;
    if (!minWidth) rules += ' Na12';
    currentRules["minWidth"] = 0;
    if (!width) rules += ' Za12';
    currentRules["width"] = "full";
    if (!height) rules += ' Fb12';
    currentRules["height"] = "full";
    rules += ' _Na12';
    currentRules["overflowX"] = "auto";
    rules += ' Pa12';
    currentRules["overflowY"] = "auto";
    rules += ' _oa12';
    currentRules["boxSizing"] = "border-box";
    if (props.isEmpty) {
        rules += ' _Ca12';
        currentRules["justifyContent"] = typeof currentRules["justifyContent"] === 'object' ? currentRules["justifyContent"] : {
            "default": currentRules["justifyContent"]
        };
        currentRules["justifyContent"]["isEmpty"] = "center";
    }
    if (props.isEmpty) {
        rules += ' eb12';
        currentRules["alignItems"] = typeof currentRules["alignItems"] === 'object' ? currentRules["alignItems"] : {
            "default": currentRules["alignItems"]
        };
        currentRules["alignItems"]["isEmpty"] = "center";
    }
    rules += ' -lPUMEc-Zu12';
    currentRules["--indent"] = 16;
    return rules;
};
const TreeView = /*#__PURE__*/ (0, _react.forwardRef)(function TreeView(props, ref) {
    let { children, isDetached, isEmphasized, UNSAFE_className, UNSAFE_style } = props;
    let scale = (0, _utils1.useScale)();
    let renderer;
    if (typeof children === 'function') renderer = children;
    let domRef = (0, _utils.useDOMRef)(ref);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Virtualizer), {
        layout: (0, _reactAriaComponents.ListLayout),
        layoutOptions: {
            rowHeight: scale === 'large' ? 50 : 40,
            gap: isDetached ? 2 : 0
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(TreeRendererContext.Provider, {
            value: {
                renderer
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(InternalTreeContext.Provider, {
                value: {
                    isDetached,
                    isEmphasized
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Tree), {
                    ...props,
                    style: UNSAFE_style,
                    className: (renderProps)=>(UNSAFE_className ?? '') + tree({
                            isDetached,
                            ...renderProps
                        }, props.styles),
                    selectionBehavior: "toggle",
                    ref: domRef,
                    children: props.children
                })
            })
        })
    });
});
const selectedBackground = "[light-dark(color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(59, 99, 251), rgb(86, 129, 255)) 10%), color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(93, 137, 255), rgb(52, 91, 248)) 10%))]";
const selectedActiveBackground = "[light-dark(color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(59, 99, 251), rgb(86, 129, 255)) 15%), color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(93, 137, 255), rgb(52, 91, 248)) 15%))]";
const rowBackgroundColor = {
    default: '--s2-container-bg',
    isFocusVisibleWithin: "[color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(19, 19, 19), rgb(242, 242, 242)) 7%)]",
    isHovered: "[color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(19, 19, 19), rgb(242, 242, 242)) 7%)]",
    isPressed: "[color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(19, 19, 19), rgb(242, 242, 242)) 10%)]",
    isSelected: {
        default: "[color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(19, 19, 19), rgb(242, 242, 242)) 7%)]",
        isEmphasized: selectedBackground,
        isFocusVisibleWithin: {
            default: "[color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(19, 19, 19), rgb(242, 242, 242)) 10%)]",
            isEmphasized: selectedActiveBackground
        },
        isHovered: {
            default: "[color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(19, 19, 19), rgb(242, 242, 242)) 10%)]",
            isEmphasized: selectedActiveBackground
        },
        isPressed: {
            default: "[color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(19, 19, 19), rgb(242, 242, 242)) 10%)]",
            isEmphasized: selectedActiveBackground
        }
    },
    forcedColors: {
        default: 'Background'
    }
};
const treeRow = function anonymous(props) {
    let rules = " ", currentRules = {};
    rules += ' _Pc12';
    currentRules["position"] = "relative";
    rules += ' sd12';
    currentRules["display"] = "flex";
    rules += ' Fv12';
    currentRules["height"] = 40;
    rules += ' Za12';
    currentRules["width"] = "full";
    rules += ' _oa12';
    currentRules["boxSizing"] = "border-box";
    rules += ' uk12';
    currentRules["fontFamily"] = "sans";
    rules += ' uch12';
    currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
        "default": currentRules["fontFamily"]
    };
    currentRules["fontFamily"][":lang(ar)"] = "sans";
    rules += ' udi12';
    currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
        "default": currentRules["fontFamily"]
    };
    currentRules["fontFamily"][":lang(he)"] = "sans";
    rules += ' uea12';
    currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
        "default": currentRules["fontFamily"]
    };
    currentRules["fontFamily"][":lang(ja)"] = "sans";
    rules += ' ugb12';
    currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
        "default": currentRules["fontFamily"]
    };
    currentRules["fontFamily"][":lang(ko)"] = "sans";
    rules += ' uhd12';
    currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
        "default": currentRules["fontFamily"]
    };
    currentRules["fontFamily"][":lang(zh)"] = "sans";
    rules += ' uje12';
    currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
        "default": currentRules["fontFamily"]
    };
    currentRules["fontFamily"][":lang(zh-hant)"] = "sans";
    rules += ' u2NhKxcl12';
    currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
        "default": currentRules["fontFamily"]
    };
    currentRules["fontFamily"][":lang(zh-HK)"] = "sans";
    rules += ' uic12';
    currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
        "default": currentRules["fontFamily"]
    };
    currentRules["fontFamily"][":lang(zh-Hans, zh-CN, zh-SG)"] = "sans";
    rules += ' -_6BNtrc-c12';
    currentRules["fontSize"] = "ui";
    rules += ' vx12';
    currentRules["fontSize"] = "ui";
    rules += ' xb12';
    currentRules["fontWeight"] = "normal";
    rules += ' _xa12';
    currentRules["fontWeight"] = "normal";
    rules += ' _Fd12';
    currentRules["lineHeight"] = "ui";
    rules += ' _FezxGHba12';
    currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
        "default": currentRules["lineHeight"]
    };
    currentRules["lineHeight"][":lang(ar, he)"] = "ui";
    rules += ' _FnuYUweb12';
    currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
        "default": currentRules["lineHeight"]
    };
    currentRules["lineHeight"][":lang(ja, ko, zh, zh-Hant, zh-Hans, zh-CN, zh-SG)"] = "ui";
    rules += ' pt12';
    currentRules["color"] = "body";
    rules += ' _Le12';
    currentRules["outlineStyle"] = "none";
    if (props.isLink) {
        rules += ' ry12';
        currentRules["cursor"] = typeof currentRules["cursor"] === 'object' ? currentRules["cursor"] : {
            "default": currentRules["cursor"]
        };
        currentRules["cursor"]["isLink"] = "pointer";
    } else {
        rules += ' ri12';
        currentRules["cursor"] = "default";
    }
    if (props.isSelected) {
        if (props.isPressed) {
            if (props.isEmphasized) {
                rules += ' -qH4xad-gT9rOHd12';
                currentRules["--rowBackgroundColor"] = typeof currentRules["--rowBackgroundColor"] === 'object' ? currentRules["--rowBackgroundColor"] : {
                    "default": currentRules["--rowBackgroundColor"]
                };
                currentRules["--rowBackgroundColor"]["isSelected && isPressed && isEmphasized"] = "[light-dark(color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(59, 99, 251), rgb(86, 129, 255)) 15%), color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(93, 137, 255), rgb(52, 91, 248)) 15%))]";
            } else {
                rules += ' -qH4xad-gRfT7e12';
                currentRules["--rowBackgroundColor"] = typeof currentRules["--rowBackgroundColor"] === 'object' ? currentRules["--rowBackgroundColor"] : {
                    "default": currentRules["--rowBackgroundColor"]
                };
                currentRules["--rowBackgroundColor"]["isSelected && isPressed"] = "[color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(19, 19, 19), rgb(242, 242, 242)) 10%)]";
            }
        } else if (props.isHovered) {
            if (props.isEmphasized) {
                rules += ' -qH4xad-gT9rOHd12';
                currentRules["--rowBackgroundColor"] = typeof currentRules["--rowBackgroundColor"] === 'object' ? currentRules["--rowBackgroundColor"] : {
                    "default": currentRules["--rowBackgroundColor"]
                };
                currentRules["--rowBackgroundColor"]["isSelected && isHovered && isEmphasized"] = "[light-dark(color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(59, 99, 251), rgb(86, 129, 255)) 15%), color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(93, 137, 255), rgb(52, 91, 248)) 15%))]";
            } else {
                rules += ' -qH4xad-gRfT7e12';
                currentRules["--rowBackgroundColor"] = typeof currentRules["--rowBackgroundColor"] === 'object' ? currentRules["--rowBackgroundColor"] : {
                    "default": currentRules["--rowBackgroundColor"]
                };
                currentRules["--rowBackgroundColor"]["isSelected && isHovered"] = "[color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(19, 19, 19), rgb(242, 242, 242)) 10%)]";
            }
        } else if (props.isFocusVisibleWithin) {
            if (props.isEmphasized) {
                rules += ' -qH4xad-gT9rOHd12';
                currentRules["--rowBackgroundColor"] = typeof currentRules["--rowBackgroundColor"] === 'object' ? currentRules["--rowBackgroundColor"] : {
                    "default": currentRules["--rowBackgroundColor"]
                };
                currentRules["--rowBackgroundColor"]["isSelected && isFocusVisibleWithin && isEmphasized"] = "[light-dark(color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(59, 99, 251), rgb(86, 129, 255)) 15%), color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(93, 137, 255), rgb(52, 91, 248)) 15%))]";
            } else {
                rules += ' -qH4xad-gRfT7e12';
                currentRules["--rowBackgroundColor"] = typeof currentRules["--rowBackgroundColor"] === 'object' ? currentRules["--rowBackgroundColor"] : {
                    "default": currentRules["--rowBackgroundColor"]
                };
                currentRules["--rowBackgroundColor"]["isSelected && isFocusVisibleWithin"] = "[color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(19, 19, 19), rgb(242, 242, 242)) 10%)]";
            }
        } else if (props.isEmphasized) {
            rules += ' -qH4xad-gJpow3b12';
            currentRules["--rowBackgroundColor"] = typeof currentRules["--rowBackgroundColor"] === 'object' ? currentRules["--rowBackgroundColor"] : {
                "default": currentRules["--rowBackgroundColor"]
            };
            currentRules["--rowBackgroundColor"]["isSelected && isEmphasized"] = "[light-dark(color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(59, 99, 251), rgb(86, 129, 255)) 10%), color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(93, 137, 255), rgb(52, 91, 248)) 10%))]";
        } else {
            rules += ' -qH4xad-gj1B7i12';
            currentRules["--rowBackgroundColor"] = typeof currentRules["--rowBackgroundColor"] === 'object' ? currentRules["--rowBackgroundColor"] : {
                "default": currentRules["--rowBackgroundColor"]
            };
            currentRules["--rowBackgroundColor"]["isSelected"] = "[color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(19, 19, 19), rgb(242, 242, 242)) 7%)]";
        }
    } else if (props.isPressed) {
        rules += ' -qH4xad-gRfT7e12';
        currentRules["--rowBackgroundColor"] = typeof currentRules["--rowBackgroundColor"] === 'object' ? currentRules["--rowBackgroundColor"] : {
            "default": currentRules["--rowBackgroundColor"]
        };
        currentRules["--rowBackgroundColor"]["isPressed"] = "[color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(19, 19, 19), rgb(242, 242, 242)) 10%)]";
    } else if (props.isHovered) {
        rules += ' -qH4xad-gj1B7i12';
        currentRules["--rowBackgroundColor"] = typeof currentRules["--rowBackgroundColor"] === 'object' ? currentRules["--rowBackgroundColor"] : {
            "default": currentRules["--rowBackgroundColor"]
        };
        currentRules["--rowBackgroundColor"]["isHovered"] = "[color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(19, 19, 19), rgb(242, 242, 242)) 7%)]";
    } else if (props.isFocusVisibleWithin) {
        rules += ' -qH4xad-gj1B7i12';
        currentRules["--rowBackgroundColor"] = typeof currentRules["--rowBackgroundColor"] === 'object' ? currentRules["--rowBackgroundColor"] : {
            "default": currentRules["--rowBackgroundColor"]
        };
        currentRules["--rowBackgroundColor"]["isFocusVisibleWithin"] = "[color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(19, 19, 19), rgb(242, 242, 242)) 7%)]";
    } else {
        rules += ' -qH4xad-gEzkoQe12';
        currentRules["--rowBackgroundColor"] = "--s2-container-bg";
    }
    rules += ' -qH4xad-lga12';
    currentRules["--rowBackgroundColor"] = typeof currentRules["--rowBackgroundColor"] === 'object' ? currentRules["--rowBackgroundColor"] : {
        "default": currentRules["--rowBackgroundColor"]
    };
    currentRules["--rowBackgroundColor"]["forcedColors"] = "Background";
    rules += ' -_34HbNb-Oh12';
    currentRules["--rowFocusIndicatorColor"] = "focus-ring";
    rules += ' -_34HbNb-lOc12';
    currentRules["--rowFocusIndicatorColor"] = typeof currentRules["--rowFocusIndicatorColor"] === 'object' ? currentRules["--rowFocusIndicatorColor"] : {
        "default": currentRules["--rowFocusIndicatorColor"]
    };
    currentRules["--rowFocusIndicatorColor"]["forcedColors"] = "Highlight";
    return rules;
};
const treeCellGrid = function anonymous(props) {
    let rules = " ", currentRules = {};
    rules += ' se12';
    currentRules["display"] = "grid";
    rules += ' Za12';
    currentRules["width"] = "full";
    rules += ' Fb12';
    currentRules["height"] = "full";
    rules += ' _oa12';
    currentRules["boxSizing"] = "border-box";
    rules += ' _cb12';
    currentRules["alignContent"] = "center";
    rules += ' eb12';
    currentRules["alignItems"] = "center";
    rules += ' Dw9uTxc12';
    currentRules["gridTemplateColumns"] = [
        "auto",
        "auto",
        "auto",
        "auto",
        "auto",
        "1fr",
        "minmax(0, auto)",
        "auto"
    ];
    rules += ' EM8Mfn12';
    currentRules["gridTemplateRows"] = "1fr";
    rules += ' CgjMZ2c12';
    currentRules["gridTemplateAreas"] = [
        "drag-handle checkbox level-padding expand-button icon content actions actionmenu"
    ];
    rules += ' gs9yXOb12';
    currentRules["backgroundColor"] = "--rowBackgroundColor";
    rules += ' Rp12';
    currentRules["paddingEnd"] = 4;
    if (props.isDisabled) {
        rules += ' pp12';
        currentRules["color"] = typeof currentRules["color"] === 'object' ? currentRules["color"] : {
            "default": currentRules["color"]
        };
        currentRules["color"]["isDisabled"] = "gray-400";
        rules += ' plc12';
        currentRules["color"] = typeof currentRules["color"] === 'object' ? currentRules["color"] : {
            "default": currentRules["color"]
        };
        currentRules["color"]["isDisabled && forcedColors"] = "GrayText";
    }
    if (props.isFocusVisible) {
        rules += ' -_7xg3bb-Oh12';
        currentRules["--rowSelectedBorderColor"] = typeof currentRules["--rowSelectedBorderColor"] === 'object' ? currentRules["--rowSelectedBorderColor"] : {
            "default": currentRules["--rowSelectedBorderColor"]
        };
        currentRules["--rowSelectedBorderColor"]["isFocusVisible"] = "focus-ring";
    } else {
        rules += ' -_7xg3bb-O8Izf8c12';
        currentRules["--rowSelectedBorderColor"] = "gray-800";
    }
    rules += ' -_7xg3bb-lOc12';
    currentRules["--rowSelectedBorderColor"] = typeof currentRules["--rowSelectedBorderColor"] === 'object' ? currentRules["--rowSelectedBorderColor"] : {
        "default": currentRules["--rowSelectedBorderColor"]
    };
    currentRules["--rowSelectedBorderColor"]["forcedColors"] = "Highlight";
    rules += ' -pKMv1c-Oh12';
    currentRules["--rowForcedFocusBorderColor"] = "focus-ring";
    rules += ' -pKMv1c-lOc12';
    currentRules["--rowForcedFocusBorderColor"] = typeof currentRules["--rowForcedFocusBorderColor"] === 'object' ? currentRules["--rowForcedFocusBorderColor"] : {
        "default": currentRules["--rowForcedFocusBorderColor"]
    };
    currentRules["--rowForcedFocusBorderColor"]["forcedColors"] = "Highlight";
    if (props.isDetached) {
        if (props.isSelected) {
            rules += ' iBGbjub12';
            currentRules["borderColor"] = typeof currentRules["borderColor"] === 'object' ? currentRules["borderColor"] : {
                "default": currentRules["borderColor"]
            };
            currentRules["borderColor"]["isDetached && isSelected"] = "--rowSelectedBorderColor";
        } else {
            rules += ' iA12';
            currentRules["borderColor"] = typeof currentRules["borderColor"] === 'object' ? currentRules["borderColor"] : {
                "default": currentRules["borderColor"]
            };
            currentRules["borderColor"]["isDetached"] = "transparent";
        }
    }
    if (props.isDetached) {
        rules += ' _kb12';
        currentRules["borderTopWidth"] = typeof currentRules["borderTopWidth"] === 'object' ? currentRules["borderTopWidth"] : {
            "default": currentRules["borderTopWidth"]
        };
        currentRules["borderTopWidth"]["isDetached"] = 1;
    }
    if (props.isDetached) {
        rules += ' hb12';
        currentRules["borderBottomWidth"] = typeof currentRules["borderBottomWidth"] === 'object' ? currentRules["borderBottomWidth"] : {
            "default": currentRules["borderBottomWidth"]
        };
        currentRules["borderBottomWidth"]["isDetached"] = 1;
    }
    if (props.isDetached) {
        rules += ' mb12';
        currentRules["borderStartWidth"] = typeof currentRules["borderStartWidth"] === 'object' ? currentRules["borderStartWidth"] : {
            "default": currentRules["borderStartWidth"]
        };
        currentRules["borderStartWidth"]["isDetached"] = 1;
    }
    if (props.isDetached) {
        rules += ' lb12';
        currentRules["borderEndWidth"] = typeof currentRules["borderEndWidth"] === 'object' ? currentRules["borderEndWidth"] : {
            "default": currentRules["borderEndWidth"]
        };
        currentRules["borderEndWidth"]["isDetached"] = 1;
    }
    if (props.isDetached) {
        rules += ' ob12';
        currentRules["borderTopStartRadius"] = typeof currentRules["borderTopStartRadius"] === 'object' ? currentRules["borderTopStartRadius"] : {
            "default": currentRules["borderTopStartRadius"]
        };
        currentRules["borderTopStartRadius"]["isDetached"] = "default";
    }
    if (props.isDetached) {
        rules += ' nb12';
        currentRules["borderTopEndRadius"] = typeof currentRules["borderTopEndRadius"] === 'object' ? currentRules["borderTopEndRadius"] : {
            "default": currentRules["borderTopEndRadius"]
        };
        currentRules["borderTopEndRadius"]["isDetached"] = "default";
    }
    if (props.isDetached) {
        rules += ' kb12';
        currentRules["borderBottomStartRadius"] = typeof currentRules["borderBottomStartRadius"] === 'object' ? currentRules["borderBottomStartRadius"] : {
            "default": currentRules["borderBottomStartRadius"]
        };
        currentRules["borderBottomStartRadius"]["isDetached"] = "default";
    }
    if (props.isDetached) {
        rules += ' jb12';
        currentRules["borderBottomEndRadius"] = typeof currentRules["borderBottomEndRadius"] === 'object' ? currentRules["borderBottomEndRadius"] : {
            "default": currentRules["borderBottomEndRadius"]
        };
        currentRules["borderBottomEndRadius"]["isDetached"] = "default";
    }
    if (props.isDetached) {
        rules += ' _jf12';
        currentRules["borderStyle"] = typeof currentRules["borderStyle"] === 'object' ? currentRules["borderStyle"] : {
            "default": currentRules["borderStyle"]
        };
        currentRules["borderStyle"]["isDetached"] = "solid";
    }
    return rules;
};
const treeCheckbox = " zoRzcu12 yoRzcu12 BoRzcu12 AoRzcu12 Ix12 Hy12 Rd12";
const treeIcon = " z2U5Crc12 y2U5Crc12 B2U5Crc12 A2U5Crc12 Ht12 Hsu12 -_8sjo0b-t5ZbAob12";
const treeContent = " zk52g2d12 yk52g2d12 Bk52g2d12 Ak52g2d12 _Yb12 _7c12 _Nc12 Pc12";
const treeActions = " zkG38H12 ykG38H12 BkG38H12 AkG38H12 Ir12 Hs12";
const treeActionMenu = " z6Nrfjc12 y6Nrfjc12 B6Nrfjc12 A6Nrfjc12";
const cellFocus = {
    outlineStyle: {
        default: 'none',
        isFocusVisible: 'solid'
    },
    outlineOffset: -2,
    outlineWidth: 2,
    outlineColor: 'focus-ring',
    borderRadius: '[6px]'
};
const treeRowFocusIndicator = "tDhuzb";
const TreeViewItem = (props)=>{
    let { href } = props;
    let { isDetached, isEmphasized } = (0, _react.useContext)(InternalTreeContext);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.TreeItem), {
        ...props,
        className: (renderProps)=>treeRow({
                ...renderProps,
                isLink: !!href,
                isEmphasized
            }) + (renderProps.isFocusVisible && !isDetached ? ' ' + treeRowFocusIndicator : '')
    });
};
const TreeViewItemContent = (props1)=>{
    let { children } = props1;
    let { isDetached, isEmphasized } = (0, _react.useContext)(InternalTreeContext);
    let scale = (0, _utils1.useScale)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.TreeItemContent), {
        children: ({ isExpanded, hasChildItems, selectionMode, selectionBehavior, isDisabled, isFocusVisible, isSelected, id, state })=>{
            let isNextSelected = false;
            let isNextFocused = false;
            let keyAfter = state.collection.getKeyAfter(id);
            if (keyAfter != null) isNextSelected = state.selectionManager.isSelected(keyAfter);
            let isFirst = state.collection.getFirstKey() === id;
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: treeCellGrid({
                    isDisabled,
                    isNextSelected,
                    isSelected,
                    isFirst,
                    isNextFocused,
                    isDetached
                }),
                children: [
                    selectionMode !== 'none' && selectionBehavior === 'toggle' && // TODO: add transition?
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: treeCheckbox,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkbox.Checkbox), {
                            isEmphasized: isEmphasized,
                            slot: "selection"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: " z7fSmKc12 y7fSmKc12 B7fSmKc12 A7fSmKc12 ZecPNad12"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(ExpandableRowChevron, {
                        isDisabled: isDisabled,
                        isExpanded: isExpanded,
                        scale: scale,
                        isHidden: !hasChildItems
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
                        values: [
                            [
                                (0, _content.TextContext),
                                {
                                    styles: treeContent
                                }
                            ],
                            [
                                (0, _icon.IconContext),
                                {
                                    render: (0, _centerBaseline.centerBaseline)({
                                        slot: 'icon',
                                        styles: treeIcon
                                    }),
                                    styles: " ZuUmpre12 FuUmpre12 _va12"
                                }
                            ],
                            [
                                (0, _actionButtonGroup.ActionButtonGroupContext),
                                {
                                    styles: treeActions
                                }
                            ],
                            [
                                (0, _actionMenu.ActionMenuContext),
                                {
                                    styles: treeActionMenu,
                                    isQuiet: true
                                }
                            ]
                        ],
                        children: typeof children === 'string' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
                            children: children
                        }) : children
                    }),
                    isFocusVisible && isDetached && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        role: "presentation",
                        className: function anonymous(props) {
                            let rules = " ", currentRules = {};
                            if (props.isFocusVisible) {
                                rules += ' _Lf12';
                                currentRules["outlineStyle"] = typeof currentRules["outlineStyle"] === 'object' ? currentRules["outlineStyle"] : {
                                    "default": currentRules["outlineStyle"]
                                };
                                currentRules["outlineStyle"]["isFocusVisible"] = "solid";
                            } else {
                                rules += ' _Le12';
                                currentRules["outlineStyle"] = "none";
                            }
                            rules += ' _Kb12';
                            currentRules["outlineOffset"] = -2;
                            rules += ' _Mc12';
                            currentRules["outlineWidth"] = 2;
                            rules += ' Oh12';
                            currentRules["outlineColor"] = "focus-ring";
                            rules += ' of12';
                            currentRules["borderTopStartRadius"] = "[6px]";
                            rules += ' nf12';
                            currentRules["borderTopEndRadius"] = "[6px]";
                            rules += ' kf12';
                            currentRules["borderBottomStartRadius"] = "[6px]";
                            rules += ' jf12';
                            currentRules["borderBottomEndRadius"] = "[6px]";
                            rules += ' _Pa12';
                            currentRules["position"] = "absolute";
                            rules += ' Wr12';
                            currentRules["top"] = 0;
                            rules += ' _lr12';
                            currentRules["bottom"] = 0;
                            rules += ' _Ar12';
                            currentRules["insetStart"] = 0;
                            rules += ' _zr12';
                            currentRules["insetEnd"] = 0;
                            return rules;
                        }({
                            isFocusVisible: true
                        })
                    })
                ]
            });
        }
    });
};
const centeredWrapper = " sd12 eb12 _Ca12 Za12 Fb12";
const TreeViewLoadMoreItem = (props)=>{
    let { loadingState, onLoadMore } = props;
    let stringFormatter = (0, _reactAria.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-spectrum/s2');
    let isLoading = loadingState === 'loading' || loadingState === 'loadingMore';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.TreeLoadMoreItem), {
        isLoading: isLoading,
        onLoadMore: onLoadMore,
        className: " Za12 Js12 Gs12",
        children: ()=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: centeredWrapper,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progressCircle.ProgressCircle), {
                    isIndeterminate: true,
                    "aria-label": stringFormatter.format('table.loadingMore')
                })
            });
        }
    });
};
const expandButton = function anonymous(props) {
    let rules = " ", currentRules = {};
    rules += ' z8dW5Qb12';
    currentRules["gridColumnStart"] = "expand-button";
    rules += ' y8dW5Qb12';
    currentRules["gridColumnEnd"] = "expand-button";
    rules += ' B8dW5Qb12';
    currentRules["gridRowStart"] = "expand-button";
    rules += ' A8dW5Qb12';
    currentRules["gridRowEnd"] = "expand-button";
    if (props.isDisabled) {
        rules += ' pp12';
        currentRules["color"] = typeof currentRules["color"] === 'object' ? currentRules["color"] : {
            "default": currentRules["color"]
        };
        currentRules["color"]["isDisabled"] = "disabled";
        rules += ' plc12';
        currentRules["color"] = typeof currentRules["color"] === 'object' ? currentRules["color"] : {
            "default": currentRules["color"]
        };
        currentRules["color"]["isDisabled && forcedColors"] = "GrayText";
    } else {
        rules += ' p40ub4c12';
        currentRules["color"] = "inherit";
    }
    rules += ' Fv12';
    currentRules["height"] = 40;
    rules += ' Zw12';
    currentRules["width"] = 40;
    rules += ' sd12';
    currentRules["display"] = "flex";
    rules += ' _wb12';
    currentRules["flexWrap"] = "wrap";
    rules += ' _cb12';
    currentRules["alignContent"] = "center";
    rules += ' _Ca12';
    currentRules["justifyContent"] = "center";
    rules += ' _Le12';
    currentRules["outlineStyle"] = "none";
    rules += ' ri12';
    currentRules["cursor"] = "default";
    if (props.isExpanded) {
        if (props.isRTL) {
            rules += ' _Za12';
            currentRules["transform"] = typeof currentRules["transform"] === 'object' ? currentRules["transform"] : {
                "default": currentRules["transform"]
            };
            currentRules["transform"]["isExpanded && isRTL"] = "rotate(-90deg)";
        } else {
            rules += ' _Zb12';
            currentRules["transform"] = typeof currentRules["transform"] === 'object' ? currentRules["transform"] : {
                "default": currentRules["transform"]
            };
            currentRules["transform"]["isExpanded"] = "rotate(90deg)";
        }
    }
    rules += ' Td12';
    currentRules["paddingTop"] = 0;
    rules += ' Qd12';
    currentRules["paddingBottom"] = 0;
    rules += ' Sd12';
    currentRules["paddingStart"] = 0;
    rules += ' Rd12';
    currentRules["paddingEnd"] = 0;
    rules += ' Yd12';
    currentRules["transition"] = "default";
    rules += ' Xb12';
    currentRules["transitionDuration"] = 150;
    rules += ' _2b12';
    currentRules["transitionTimingFunction"] = "default";
    rules += ' g912';
    currentRules["backgroundColor"] = "transparent";
    rules += ' _je12';
    currentRules["borderStyle"] = "none";
    rules += ' __ca12';
    currentRules["disableTapHighlight"] = true;
    if (props.isHidden) {
        rules += ' _6b12';
        currentRules["visibility"] = typeof currentRules["visibility"] === 'object' ? currentRules["visibility"] : {
            "default": currentRules["visibility"]
        };
        currentRules["visibility"]["isHidden"] = "hidden";
    }
    return rules;
};
function ExpandableRowChevron(props1) {
    let expandButtonRef = (0, _react.useRef)(null);
    let [fullProps, ref] = (0, _reactAriaComponents.useContextProps)({
        ...props1,
        slot: 'chevron'
    }, expandButtonRef, (0, _reactAriaComponents.ButtonContext));
    let { isExpanded, scale, isHidden } = fullProps;
    let { direction } = (0, _reactAria.useLocale)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Button), {
        ...props1,
        ref: ref,
        slot: "chevron",
        className: (renderProps)=>expandButton({
                ...renderProps,
                isExpanded,
                isRTL: direction === 'rtl',
                scale,
                isHidden
            }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chevronDefault.default), {
            className: function anonymous(props) {
                let rules = " ", currentRules = {};
                if (props.direction === "rtl") {
                    rules += ' -Z4Pn4c-a12';
                    currentRules["scaleX"] = typeof currentRules["scaleX"] === 'object' ? currentRules["scaleX"] : {
                        "default": currentRules["scaleX"]
                    };
                    currentRules["scaleX"]["direction === \"rtl\""] = "-1";
                    rules += ' __Ha12';
                    currentRules["scaleX"] = typeof currentRules["scaleX"] === 'object' ? currentRules["scaleX"] : {
                        "default": currentRules["scaleX"]
                    };
                    currentRules["scaleX"]["direction === \"rtl\""] = "-1";
                } else if (props.direction === "ltr") {
                    rules += ' -Z4Pn4c-b12';
                    currentRules["scaleX"] = typeof currentRules["scaleX"] === 'object' ? currentRules["scaleX"] : {
                        "default": currentRules["scaleX"]
                    };
                    currentRules["scaleX"]["direction === \"ltr\""] = "1";
                    rules += ' __Ha12';
                    currentRules["scaleX"] = typeof currentRules["scaleX"] === 'object' ? currentRules["scaleX"] : {
                        "default": currentRules["scaleX"]
                    };
                    currentRules["scaleX"]["direction === \"ltr\""] = "1";
                }
                if (props.direction === "rtl") {
                    rules += ' -_04Pn4c-a12';
                    currentRules["scaleY"] = typeof currentRules["scaleY"] === 'object' ? currentRules["scaleY"] : {
                        "default": currentRules["scaleY"]
                    };
                    currentRules["scaleY"]["direction === \"rtl\""] = "-1";
                    rules += ' __Ha12';
                    currentRules["scaleY"] = typeof currentRules["scaleY"] === 'object' ? currentRules["scaleY"] : {
                        "default": currentRules["scaleY"]
                    };
                    currentRules["scaleY"]["direction === \"rtl\""] = "-1";
                } else if (props.direction === "ltr") {
                    rules += ' -_04Pn4c-b12';
                    currentRules["scaleY"] = typeof currentRules["scaleY"] === 'object' ? currentRules["scaleY"] : {
                        "default": currentRules["scaleY"]
                    };
                    currentRules["scaleY"]["direction === \"ltr\""] = "1";
                    rules += ' __Ha12';
                    currentRules["scaleY"] = typeof currentRules["scaleY"] === 'object' ? currentRules["scaleY"] : {
                        "default": currentRules["scaleY"]
                    };
                    currentRules["scaleY"]["direction === \"ltr\""] = "1";
                }
                rules += ' -_8sjo0b-t5ZbAob12';
                currentRules["--iconPrimary"] = "currentColor";
                return rules;
            }({
                direction
            })
        })
    });
}

},{"0":"kfhuw","1":"3iwSx","2":"kDAtl","3":"9JGbW","4":"9z357","5":"3HGyl","6":"f3LRf","7":"aEzVn","8":"iXfL8","9":"84U11","10":"8ZRVs","11":"mQ3I5","12":"g8YtD","13":"eF2zk","14":"SUUo3","15":"hbRen","react/jsx-runtime":"2Is6Z","./ActionButtonGroup":"1RyqL","./ActionMenu":"3fSPo","react-aria-components":[["Button","9G5XO"],["ButtonContext","9G5XO"],["ListLayout","6OEhs"],["Provider","bA6Cz"],["useContextProps","bA6Cz"],["Tree","kwlwT"],["TreeItem","kwlwT"],["TreeItemContent","kwlwT"],["TreeLoadMoreItem","kwlwT"],["Virtualizer","2WSF6"]],"./CenterBaseline":"1vpL9","./Checkbox":"jdSVu","../ui-icons/Chevron":"1904U","./Icon":"jQAJE","../intl/*.json":"gDH3q","./ProgressCircle":"dztOy","react":"a1TxN","./Content":"10r6w","@react-spectrum/utils":"jqfrX","react-aria":[["useLocale","4k4z8"],["useLocalizedStringFormatter","7lxyl"]],"./utils":"9papc","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kfhuw":[function() {},{}],"3iwSx":[function() {},{}],"kDAtl":[function() {},{}],"9JGbW":[function() {},{}],"9z357":[function() {},{}],"3HGyl":[function() {},{}],"f3LRf":[function() {},{}],"aEzVn":[function() {},{}],"iXfL8":[function() {},{}],"84U11":[function() {},{}],"8ZRVs":[function() {},{}],"mQ3I5":[function() {},{}],"g8YtD":[function() {},{}],"eF2zk":[function() {},{}],"SUUo3":[function() {},{}],"hbRen":[function() {},{}],"ZaaaK":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MeterContext", ()=>MeterContext);
parcelHelpers.export(exports, "Meter", ()=>Meter);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _field = require("./Field");
var _skeleton = require("./Skeleton");
var _content = require("./Content");
var _utils = require("@react-spectrum/utils");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const MeterContext = /*#__PURE__*/ (0, _react.createContext)(null);
const wrapper = function anonymous(props, overrides) {
    let rules = " ", currentRules = {};
    let position = false;
    let minWidth = false;
    let maxWidth = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L|-macro\$)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "_P") position = true;
        if (p[1] === "N") minWidth = true;
        if (p[1] === "L") maxWidth = true;
        rules += p[0];
    }
    if (props.staticColor === "white") {
        rules += ' -Ovbhqd-gcwrnr12';
        currentRules["--s2-container-bg"] = typeof currentRules["--s2-container-bg"] === 'object' ? currentRules["--s2-container-bg"] : {
            "default": currentRules["--s2-container-bg"]
        };
        currentRules["--s2-container-bg"]["staticColor === \"white\""] = "black";
    } else if (props.staticColor === "black") {
        rules += ' -Ovbhqd-g4hn3s12';
        currentRules["--s2-container-bg"] = typeof currentRules["--s2-container-bg"] === 'object' ? currentRules["--s2-container-bg"] : {
            "default": currentRules["--s2-container-bg"]
        };
        currentRules["--s2-container-bg"]["staticColor === \"black\""] = "white";
    }
    if (!position) rules += ' _Pc12';
    currentRules["position"] = "relative";
    rules += ' se12';
    currentRules["display"] = "grid";
    if (props.labelPosition === "side") {
        rules += ' DPlN5qb12';
        currentRules["gridTemplateColumns"] = typeof currentRules["gridTemplateColumns"] === 'object' ? currentRules["gridTemplateColumns"] : {
            "default": currentRules["gridTemplateColumns"]
        };
        currentRules["gridTemplateColumns"]["labelPosition === \"side\""] = [
            "auto",
            "1fr"
        ];
    } else if (props.labelPosition === "top") {
        rules += ' Dxumf9b12';
        currentRules["gridTemplateColumns"] = typeof currentRules["gridTemplateColumns"] === 'object' ? currentRules["gridTemplateColumns"] : {
            "default": currentRules["gridTemplateColumns"]
        };
        currentRules["gridTemplateColumns"]["labelPosition === \"top\""] = [
            "1fr",
            "auto"
        ];
    }
    if (props.labelPosition === "side") {
        rules += ' Cvv4gue12';
        currentRules["gridTemplateAreas"] = typeof currentRules["gridTemplateAreas"] === 'object' ? currentRules["gridTemplateAreas"] : {
            "default": currentRules["gridTemplateAreas"]
        };
        currentRules["gridTemplateAreas"]["labelPosition === \"side\""] = [
            "label bar value"
        ];
    } else if (props.labelPosition === "top") {
        rules += ' CC0Gyo12';
        currentRules["gridTemplateAreas"] = typeof currentRules["gridTemplateAreas"] === 'object' ? currentRules["gridTemplateAreas"] : {
            "default": currentRules["gridTemplateAreas"]
        };
        currentRules["gridTemplateAreas"]["labelPosition === \"top\""] = [
            "label value",
            "bar bar"
        ];
    }
    rules += ' ea12';
    currentRules["alignItems"] = "baseline";
    rules += ' _Bb12';
    currentRules["isolation"] = "isolate";
    if (!minWidth) rules += ' Nl12';
    currentRules["minWidth"] = 48;
    if (!maxWidth) rules += ' Lk12';
    currentRules["maxWidth"] = 768;
    if (props.size === "XL") {
        rules += ' -BhX7R-Fz12';
        currentRules["--field-height"] = typeof currentRules["--field-height"] === 'object' ? currentRules["--field-height"] : {
            "default": currentRules["--field-height"]
        };
        currentRules["--field-height"]["size === \"XL\""] = 48;
    } else if (props.size === "L") {
        rules += ' -BhX7R-Fv12';
        currentRules["--field-height"] = typeof currentRules["--field-height"] === 'object' ? currentRules["--field-height"] : {
            "default": currentRules["--field-height"]
        };
        currentRules["--field-height"]["size === \"L\""] = 40;
    } else if (props.size === "S") {
        rules += ' -BhX7R-Fp12';
        currentRules["--field-height"] = typeof currentRules["--field-height"] === 'object' ? currentRules["--field-height"] : {
            "default": currentRules["--field-height"]
        };
        currentRules["--field-height"]["size === \"S\""] = 24;
    } else if (props.size === "XS") {
        rules += ' -BhX7R-Fn12';
        currentRules["--field-height"] = typeof currentRules["--field-height"] === 'object' ? currentRules["--field-height"] : {
            "default": currentRules["--field-height"]
        };
        currentRules["--field-height"]["size === \"XS\""] = 20;
    } else {
        rules += ' -BhX7R-Fx12';
        currentRules["--field-height"] = 32;
    }
    rules += ' -dTMmze-Fe12';
    currentRules["--track-to-label"] = 4;
    rules += ' -AJjOLd-UCwrhQe12';
    currentRules["--field-gap"] = "[calc((calc(var(--field-height) + var(--track-to-label)) - self(borderTopWidth, 0px) - self(borderBottomWidth, 0px) - 1lh) / 2)]";
    rules += ' qg12';
    currentRules["columnGap"] = 12;
    return rules;
};
const valueStyles = function anonymous(props) {
    let rules = " ", currentRules = {};
    if (props.size === "XL") {
        rules += ' uk12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"XL\""] = "sans";
        rules += ' uch12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"XL\" && :lang(ar)"] = "sans";
        rules += ' udi12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"XL\" && :lang(he)"] = "sans";
        rules += ' uea12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"XL\" && :lang(ja)"] = "sans";
        rules += ' ugb12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"XL\" && :lang(ko)"] = "sans";
        rules += ' uhd12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"XL\" && :lang(zh)"] = "sans";
        rules += ' uje12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"XL\" && :lang(zh-hant)"] = "sans";
        rules += ' u2NhKxcl12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"XL\" && :lang(zh-HK)"] = "sans";
        rules += ' uic12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"XL\" && :lang(zh-Hans, zh-CN, zh-SG)"] = "sans";
    } else if (props.size === "L") {
        rules += ' uk12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"L\""] = "sans";
        rules += ' uch12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"L\" && :lang(ar)"] = "sans";
        rules += ' udi12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"L\" && :lang(he)"] = "sans";
        rules += ' uea12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"L\" && :lang(ja)"] = "sans";
        rules += ' ugb12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"L\" && :lang(ko)"] = "sans";
        rules += ' uhd12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"L\" && :lang(zh)"] = "sans";
        rules += ' uje12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"L\" && :lang(zh-hant)"] = "sans";
        rules += ' u2NhKxcl12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"L\" && :lang(zh-HK)"] = "sans";
        rules += ' uic12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"L\" && :lang(zh-Hans, zh-CN, zh-SG)"] = "sans";
    } else if (props.size === "S") {
        rules += ' uk12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"S\""] = "sans";
        rules += ' uch12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"S\" && :lang(ar)"] = "sans";
        rules += ' udi12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"S\" && :lang(he)"] = "sans";
        rules += ' uea12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"S\" && :lang(ja)"] = "sans";
        rules += ' ugb12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"S\" && :lang(ko)"] = "sans";
        rules += ' uhd12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"S\" && :lang(zh)"] = "sans";
        rules += ' uje12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"S\" && :lang(zh-hant)"] = "sans";
        rules += ' u2NhKxcl12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"S\" && :lang(zh-HK)"] = "sans";
        rules += ' uic12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"S\" && :lang(zh-Hans, zh-CN, zh-SG)"] = "sans";
    } else if (props.size === "XS") {
        rules += ' uk12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"XS\""] = "sans";
        rules += ' uch12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"XS\" && :lang(ar)"] = "sans";
        rules += ' udi12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"XS\" && :lang(he)"] = "sans";
        rules += ' uea12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"XS\" && :lang(ja)"] = "sans";
        rules += ' ugb12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"XS\" && :lang(ko)"] = "sans";
        rules += ' uhd12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"XS\" && :lang(zh)"] = "sans";
        rules += ' uje12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"XS\" && :lang(zh-hant)"] = "sans";
        rules += ' u2NhKxcl12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"XS\" && :lang(zh-HK)"] = "sans";
        rules += ' uic12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"]["size === \"XS\" && :lang(zh-Hans, zh-CN, zh-SG)"] = "sans";
    } else {
        rules += ' uk12';
        currentRules["fontFamily"] = "sans";
        rules += ' uch12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"][":lang(ar)"] = "sans";
        rules += ' udi12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"][":lang(he)"] = "sans";
        rules += ' uea12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"][":lang(ja)"] = "sans";
        rules += ' ugb12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"][":lang(ko)"] = "sans";
        rules += ' uhd12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"][":lang(zh)"] = "sans";
        rules += ' uje12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"][":lang(zh-hant)"] = "sans";
        rules += ' u2NhKxcl12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"][":lang(zh-HK)"] = "sans";
        rules += ' uic12';
        currentRules["fontFamily"] = typeof currentRules["fontFamily"] === 'object' ? currentRules["fontFamily"] : {
            "default": currentRules["fontFamily"]
        };
        currentRules["fontFamily"][":lang(zh-Hans, zh-CN, zh-SG)"] = "sans";
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e12';
        currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
            "default": currentRules["fontSize"]
        };
        currentRules["fontSize"]["size === \"XL\""] = "ui-xl";
        rules += ' vx12';
        currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
            "default": currentRules["fontSize"]
        };
        currentRules["fontSize"]["size === \"XL\""] = "ui-xl";
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d12';
        currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
            "default": currentRules["fontSize"]
        };
        currentRules["fontSize"]["size === \"L\""] = "ui-lg";
        rules += ' vx12';
        currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
            "default": currentRules["fontSize"]
        };
        currentRules["fontSize"]["size === \"L\""] = "ui-lg";
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b12';
        currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
            "default": currentRules["fontSize"]
        };
        currentRules["fontSize"]["size === \"S\""] = "ui-sm";
        rules += ' vx12';
        currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
            "default": currentRules["fontSize"]
        };
        currentRules["fontSize"]["size === \"S\""] = "ui-sm";
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a12';
        currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
            "default": currentRules["fontSize"]
        };
        currentRules["fontSize"]["size === \"XS\""] = "ui-xs";
        rules += ' vx12';
        currentRules["fontSize"] = typeof currentRules["fontSize"] === 'object' ? currentRules["fontSize"] : {
            "default": currentRules["fontSize"]
        };
        currentRules["fontSize"]["size === \"XS\""] = "ui-xs";
    } else {
        rules += ' -_6BNtrc-c12';
        currentRules["fontSize"] = "ui";
        rules += ' vx12';
        currentRules["fontSize"] = "ui";
    }
    if (props.size === "XL") {
        rules += ' xb12';
        currentRules["fontWeight"] = typeof currentRules["fontWeight"] === 'object' ? currentRules["fontWeight"] : {
            "default": currentRules["fontWeight"]
        };
        currentRules["fontWeight"]["size === \"XL\""] = "normal";
        rules += ' _xa12';
        currentRules["fontWeight"] = typeof currentRules["fontWeight"] === 'object' ? currentRules["fontWeight"] : {
            "default": currentRules["fontWeight"]
        };
        currentRules["fontWeight"]["size === \"XL\""] = "normal";
    } else if (props.size === "L") {
        rules += ' xb12';
        currentRules["fontWeight"] = typeof currentRules["fontWeight"] === 'object' ? currentRules["fontWeight"] : {
            "default": currentRules["fontWeight"]
        };
        currentRules["fontWeight"]["size === \"L\""] = "normal";
        rules += ' _xa12';
        currentRules["fontWeight"] = typeof currentRules["fontWeight"] === 'object' ? currentRules["fontWeight"] : {
            "default": currentRules["fontWeight"]
        };
        currentRules["fontWeight"]["size === \"L\""] = "normal";
    } else if (props.size === "S") {
        rules += ' xb12';
        currentRules["fontWeight"] = typeof currentRules["fontWeight"] === 'object' ? currentRules["fontWeight"] : {
            "default": currentRules["fontWeight"]
        };
        currentRules["fontWeight"]["size === \"S\""] = "normal";
        rules += ' _xa12';
        currentRules["fontWeight"] = typeof currentRules["fontWeight"] === 'object' ? currentRules["fontWeight"] : {
            "default": currentRules["fontWeight"]
        };
        currentRules["fontWeight"]["size === \"S\""] = "normal";
    } else if (props.size === "XS") {
        rules += ' xb12';
        currentRules["fontWeight"] = typeof currentRules["fontWeight"] === 'object' ? currentRules["fontWeight"] : {
            "default": currentRules["fontWeight"]
        };
        currentRules["fontWeight"]["size === \"XS\""] = "normal";
        rules += ' _xa12';
        currentRules["fontWeight"] = typeof currentRules["fontWeight"] === 'object' ? currentRules["fontWeight"] : {
            "default": currentRules["fontWeight"]
        };
        currentRules["fontWeight"]["size === \"XS\""] = "normal";
    } else {
        rules += ' xb12';
        currentRules["fontWeight"] = "normal";
        rules += ' _xa12';
        currentRules["fontWeight"] = "normal";
    }
    if (props.size === "XL") {
        rules += ' _Fd12';
        currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
            "default": currentRules["lineHeight"]
        };
        currentRules["lineHeight"]["size === \"XL\""] = "ui";
        rules += ' _FezxGHba12';
        currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
            "default": currentRules["lineHeight"]
        };
        currentRules["lineHeight"]["size === \"XL\" && :lang(ar, he)"] = "ui";
        rules += ' _FnuYUweb12';
        currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
            "default": currentRules["lineHeight"]
        };
        currentRules["lineHeight"]["size === \"XL\" && :lang(ja, ko, zh, zh-Hant, zh-Hans, zh-CN, zh-SG)"] = "ui";
    } else if (props.size === "L") {
        rules += ' _Fd12';
        currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
            "default": currentRules["lineHeight"]
        };
        currentRules["lineHeight"]["size === \"L\""] = "ui";
        rules += ' _FezxGHba12';
        currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
            "default": currentRules["lineHeight"]
        };
        currentRules["lineHeight"]["size === \"L\" && :lang(ar, he)"] = "ui";
        rules += ' _FnuYUweb12';
        currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
            "default": currentRules["lineHeight"]
        };
        currentRules["lineHeight"]["size === \"L\" && :lang(ja, ko, zh, zh-Hant, zh-Hans, zh-CN, zh-SG)"] = "ui";
    } else if (props.size === "S") {
        rules += ' _Fd12';
        currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
            "default": currentRules["lineHeight"]
        };
        currentRules["lineHeight"]["size === \"S\""] = "ui";
        rules += ' _FezxGHba12';
        currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
            "default": currentRules["lineHeight"]
        };
        currentRules["lineHeight"]["size === \"S\" && :lang(ar, he)"] = "ui";
        rules += ' _FnuYUweb12';
        currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
            "default": currentRules["lineHeight"]
        };
        currentRules["lineHeight"]["size === \"S\" && :lang(ja, ko, zh, zh-Hant, zh-Hans, zh-CN, zh-SG)"] = "ui";
    } else if (props.size === "XS") {
        rules += ' _Fd12';
        currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
            "default": currentRules["lineHeight"]
        };
        currentRules["lineHeight"]["size === \"XS\""] = "ui";
        rules += ' _FezxGHba12';
        currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
            "default": currentRules["lineHeight"]
        };
        currentRules["lineHeight"]["size === \"XS\" && :lang(ar, he)"] = "ui";
        rules += ' _FnuYUweb12';
        currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
            "default": currentRules["lineHeight"]
        };
        currentRules["lineHeight"]["size === \"XS\" && :lang(ja, ko, zh, zh-Hant, zh-Hans, zh-CN, zh-SG)"] = "ui";
    } else {
        rules += ' _Fd12';
        currentRules["lineHeight"] = "ui";
        rules += ' _FezxGHba12';
        currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
            "default": currentRules["lineHeight"]
        };
        currentRules["lineHeight"][":lang(ar, he)"] = "ui";
        rules += ' _FnuYUweb12';
        currentRules["lineHeight"] = typeof currentRules["lineHeight"] === 'object' ? currentRules["lineHeight"] : {
            "default": currentRules["lineHeight"]
        };
        currentRules["lineHeight"][":lang(ja, ko, zh, zh-Hant, zh-Hans, zh-CN, zh-SG)"] = "ui";
    }
    if (props.isStaticColor) {
        rules += ' pl12';
        currentRules["color"] = typeof currentRules["color"] === 'object' ? currentRules["color"] : {
            "default": currentRules["color"]
        };
        currentRules["color"]["isStaticColor"] = "transparent-overlay-1000";
    } else if (props.isDisabled) {
        rules += ' pp12';
        currentRules["color"] = typeof currentRules["color"] === 'object' ? currentRules["color"] : {
            "default": currentRules["color"]
        };
        currentRules["color"]["isDisabled"] = "disabled";
    } else {
        rules += ' pv12';
        currentRules["color"] = "neutral-subdued";
    }
    rules += ' plb12';
    currentRules["color"] = typeof currentRules["color"] === 'object' ? currentRules["color"] : {
        "default": currentRules["color"]
    };
    currentRules["color"]["forcedColors"] = "ButtonText";
    rules += ' ri12';
    currentRules["cursor"] = "default";
    rules += ' z8bmXs12';
    currentRules["gridColumnStart"] = "value";
    rules += ' y8bmXs12';
    currentRules["gridColumnEnd"] = "value";
    rules += ' B8bmXs12';
    currentRules["gridRowStart"] = "value";
    rules += ' A8bmXs12';
    currentRules["gridRowEnd"] = "value";
    return rules;
};
const trackStyles = function anonymous(props) {
    let rules = " ", currentRules = {};
    rules += ' zMY0fn12';
    currentRules["gridColumnStart"] = "bar";
    rules += ' yMY0fn12';
    currentRules["gridColumnEnd"] = "bar";
    rules += ' BMY0fn12';
    currentRules["gridRowStart"] = "bar";
    rules += ' AMY0fn12';
    currentRules["gridRowEnd"] = "bar";
    if (props.size === "XL") {
        rules += ' Nl12';
        currentRules["minWidth"] = typeof currentRules["minWidth"] === 'object' ? currentRules["minWidth"] : {
            "default": currentRules["minWidth"]
        };
        currentRules["minWidth"]["size === \"XL\""] = 48;
    } else if (props.size === "L") {
        rules += ' Nj12';
        currentRules["minWidth"] = typeof currentRules["minWidth"] === 'object' ? currentRules["minWidth"] : {
            "default": currentRules["minWidth"]
        };
        currentRules["minWidth"]["size === \"L\""] = 40;
    } else if (props.size === "S") {
        rules += ' Nf12';
        currentRules["minWidth"] = typeof currentRules["minWidth"] === 'object' ? currentRules["minWidth"] : {
            "default": currentRules["minWidth"]
        };
        currentRules["minWidth"]["size === \"S\""] = 24;
    } else if (props.size === "XS") {
        rules += ' Ne12';
        currentRules["minWidth"] = typeof currentRules["minWidth"] === 'object' ? currentRules["minWidth"] : {
            "default": currentRules["minWidth"]
        };
        currentRules["minWidth"]["size === \"XS\""] = 20;
    } else {
        rules += ' Nk12';
        currentRules["minWidth"] = 32;
    }
    if (props.isQuiet) {
        rules += ' _qd12';
        currentRules["contain"] = typeof currentRules["contain"] === 'object' ? currentRules["contain"] : {
            "default": currentRules["contain"]
        };
        currentRules["contain"]["isQuiet"] = "none";
    } else {
        rules += ' _qtb12';
        currentRules["contain"] = typeof currentRules["contain"] === 'object' ? currentRules["contain"] : {
            "default": currentRules["contain"]
        };
        currentRules["contain"]["@supports (contain-intrinsic-width: 1px)"] = "inline-size";
    }
    if (props.size === "XL") {
        rules += ' -Anxdcc-Zt12';
        currentRules["--defaultWidth"] = typeof currentRules["--defaultWidth"] === 'object' ? currentRules["--defaultWidth"] : {
            "default": currentRules["--defaultWidth"]
        };
        currentRules["--defaultWidth"]["size === \"XL\""] = 240;
    } else if (props.size === "L") {
        rules += ' -Anxdcc-ZStdtne12';
        currentRules["--defaultWidth"] = typeof currentRules["--defaultWidth"] === 'object' ? currentRules["--defaultWidth"] : {
            "default": currentRules["--defaultWidth"]
        };
        currentRules["--defaultWidth"]["size === \"L\""] = 224;
    } else if (props.size === "S") {
        rules += ' -Anxdcc-Zr12';
        currentRules["--defaultWidth"] = typeof currentRules["--defaultWidth"] === 'object' ? currentRules["--defaultWidth"] : {
            "default": currentRules["--defaultWidth"]
        };
        currentRules["--defaultWidth"]["size === \"S\""] = 192;
    } else {
        rules += ' -Anxdcc-Z3fn9H12';
        currentRules["--defaultWidth"] = 208;
    }
    rules += ' __v6TNLWb12';
    currentRules["containIntrinsicWidth"] = "calc(var(--defaultWidth) - self(paddingStart, 0px) - self(paddingEnd, 0px) - self(borderStartWidth, 0px) - self(borderEndWidth, 0px))";
    rules += ' _Nc12';
    currentRules["overflowX"] = "hidden";
    rules += ' Pc12';
    currentRules["overflowY"] = "hidden";
    rules += ' og12';
    currentRules["borderTopStartRadius"] = "full";
    rules += ' ng12';
    currentRules["borderTopEndRadius"] = "full";
    rules += ' kg12';
    currentRules["borderBottomStartRadius"] = "full";
    rules += ' jg12';
    currentRules["borderBottomEndRadius"] = "full";
    if (props.isStaticColor) {
        rules += ' gh12';
        currentRules["backgroundColor"] = typeof currentRules["backgroundColor"] === 'object' ? currentRules["backgroundColor"] : {
            "default": currentRules["backgroundColor"]
        };
        currentRules["backgroundColor"]["isStaticColor"] = "transparent-overlay-300";
    } else {
        rules += ' gE12';
        currentRules["backgroundColor"] = "gray-300";
    }
    rules += ' glb12';
    currentRules["backgroundColor"] = typeof currentRules["backgroundColor"] === 'object' ? currentRules["backgroundColor"] : {
        "default": currentRules["backgroundColor"]
    };
    currentRules["backgroundColor"]["forcedColors"] = "ButtonFace";
    rules += ' _Ma12';
    currentRules["outlineWidth"] = 0;
    rules += ' _Mlb12';
    currentRules["outlineWidth"] = typeof currentRules["outlineWidth"] === 'object' ? currentRules["outlineWidth"] : {
        "default": currentRules["outlineWidth"]
    };
    currentRules["outlineWidth"]["forcedColors"] = 1;
    rules += ' _Le12';
    currentRules["outlineStyle"] = "none";
    rules += ' _Llf12';
    currentRules["outlineStyle"] = typeof currentRules["outlineStyle"] === 'object' ? currentRules["outlineStyle"] : {
        "default": currentRules["outlineStyle"]
    };
    currentRules["outlineStyle"]["forcedColors"] = "solid";
    rules += ' Oj12';
    currentRules["outlineColor"] = "transparent";
    rules += ' Olb12';
    currentRules["outlineColor"] = typeof currentRules["outlineColor"] === 'object' ? currentRules["outlineColor"] : {
        "default": currentRules["outlineColor"]
    };
    currentRules["outlineColor"]["forcedColors"] = "ButtonText";
    rules += ' _9c12';
    currentRules["zIndex"] = 1;
    if (props.size === "XL") {
        rules += ' Fj12';
        currentRules["height"] = typeof currentRules["height"] === 'object' ? currentRules["height"] : {
            "default": currentRules["height"]
        };
        currentRules["height"]["size === \"XL\""] = 10;
    } else if (props.size === "L") {
        rules += ' Fi12';
        currentRules["height"] = typeof currentRules["height"] === 'object' ? currentRules["height"] : {
            "default": currentRules["height"]
        };
        currentRules["height"]["size === \"L\""] = 8;
    } else if (props.size === "M") {
        rules += ' Fg12';
        currentRules["height"] = typeof currentRules["height"] === 'object' ? currentRules["height"] : {
            "default": currentRules["height"]
        };
        currentRules["height"]["size === \"M\""] = 6;
    } else if (props.size === "S") {
        rules += ' Fe12';
        currentRules["height"] = typeof currentRules["height"] === 'object' ? currentRules["height"] : {
            "default": currentRules["height"]
        };
        currentRules["height"]["size === \"S\""] = 4;
    } else {
        rules += ' Fg12';
        currentRules["height"] = 6;
    }
    return rules;
};
const fillStyles = function anonymous(props) {
    let rules = " ", currentRules = {};
    rules += ' Fb12';
    currentRules["height"] = "full";
    rules += ' _je12';
    currentRules["borderStyle"] = "none";
    rules += ' og12';
    currentRules["borderTopStartRadius"] = "full";
    rules += ' ng12';
    currentRules["borderTopEndRadius"] = "full";
    rules += ' kg12';
    currentRules["borderBottomStartRadius"] = "full";
    rules += ' jg12';
    currentRules["borderBottomEndRadius"] = "full";
    if (props.isStaticColor) {
        rules += ' gj12';
        currentRules["backgroundColor"] = typeof currentRules["backgroundColor"] === 'object' ? currentRules["backgroundColor"] : {
            "default": currentRules["backgroundColor"]
        };
        currentRules["backgroundColor"]["isStaticColor"] = "transparent-overlay-900";
    } else if (props.variant === "negative") {
        rules += ' gFLVMS12';
        currentRules["backgroundColor"] = typeof currentRules["backgroundColor"] === 'object' ? currentRules["backgroundColor"] : {
            "default": currentRules["backgroundColor"]
        };
        currentRules["backgroundColor"]["variant === \"negative\""] = "[light-dark(light-dark(rgb(240, 56, 35), rgb(223, 52, 34)), light-dark(rgb(215, 50, 32), rgb(252, 67, 46)))]";
    } else if (props.variant === "notice") {
        rules += ' g9VrKkd12';
        currentRules["backgroundColor"] = typeof currentRules["backgroundColor"] === 'object' ? currentRules["backgroundColor"] : {
            "default": currentRules["backgroundColor"]
        };
        currentRules["backgroundColor"]["variant === \"notice\""] = "[light-dark(light-dark(rgb(212, 91, 0), rgb(199, 82, 0)), light-dark(rgb(194, 78, 0), rgb(224, 100, 0)))]";
    } else if (props.variant === "positive") {
        rules += ' gp17Jm12';
        currentRules["backgroundColor"] = typeof currentRules["backgroundColor"] === 'object' ? currentRules["backgroundColor"] : {
            "default": currentRules["backgroundColor"]
        };
        currentRules["backgroundColor"]["variant === \"positive\""] = "[light-dark(light-dark(rgb(7, 147, 85), rgb(6, 136, 80)), light-dark(rgb(5, 131, 78), rgb(9, 157, 89)))]";
    } else {
        rules += ' gG1ze4d12';
        currentRules["backgroundColor"] = "[light-dark(light-dark(rgb(75, 117, 255), rgb(64, 105, 253)), light-dark(rgb(59, 99, 251), rgb(86, 129, 255)))]";
    }
    rules += ' glc12';
    currentRules["backgroundColor"] = typeof currentRules["backgroundColor"] === 'object' ? currentRules["backgroundColor"] : {
        "default": currentRules["backgroundColor"]
    };
    currentRules["backgroundColor"]["forcedColors"] = "ButtonText";
    return rules;
};
const Meter = /*#__PURE__*/ (0, _react.forwardRef)(function Meter(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, MeterContext);
    let domRef = (0, _utils.useDOMRef)(ref);
    let { label, size = 'M', staticColor, styles, UNSAFE_className = '', UNSAFE_style, variant = 'informative', labelPosition = 'top', ...groupProps } = props;
    let isStaticColor = !!staticColor;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Meter), {
        ...groupProps,
        ref: domRef,
        style: UNSAFE_style,
        className: UNSAFE_className + wrapper({
            size,
            variant,
            staticColor,
            labelPosition
        }, styles),
        children: ({ percentage, valueText })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    label && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldLabel), {
                        size: size,
                        labelAlign: "start",
                        labelPosition: labelPosition,
                        staticColor: staticColor,
                        children: label
                    }),
                    label && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
                        styles: valueStyles({
                            size,
                            labelAlign: 'end',
                            isStaticColor
                        }),
                        children: valueText
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeleton.SkeletonWrapper), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: trackStyles({
                                isStaticColor,
                                size
                            }),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: fillStyles({
                                    isStaticColor,
                                    variant
                                }),
                                style: {
                                    width: percentage + '%'
                                }
                            })
                        })
                    })
                ]
            })
    });
});

},{"0":"iIncy","1":"i90Hh","2":"1Kvqt","3":"L4jG8","react/jsx-runtime":"2Is6Z","react-aria-components":"4ywiA","react":"a1TxN","./Field":"eI7CE","./Skeleton":"1mUnF","./Content":"10r6w","@react-spectrum/utils":"jqfrX","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"iIncy":[function() {},{}],"i90Hh":[function() {},{}],"1Kvqt":[function() {},{}],"L4jG8":[function() {},{}]},[], null, "parcelRequire7f0c", {}, "./", "https://reactspectrum.blob.core.windows.net/reactspectrum/4bc53f8b97be2c15da535da6f3d8b9f6bbe6728c/s2-docs/")

//# sourceMappingURL=getting-started.fb84bc02.js.map
